(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebe0d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebe0d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8tuDw", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $62b8cbe7b9115b5d$export$ffb0004e005737fa, (v) => $62b8cbe7b9115b5d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $62b8cbe7b9115b5d$export$34b9dba7ce09269b, (v) => $62b8cbe7b9115b5d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $62b8cbe7b9115b5d$export$25062201e9e25d76, (v) => $62b8cbe7b9115b5d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $62b8cbe7b9115b5d$export$ffb0004e005737fa;
var $62b8cbe7b9115b5d$export$34b9dba7ce09269b;
var $62b8cbe7b9115b5d$export$25062201e9e25d76;
'use strict';

var $6umrQ = parcelRequire("6umrQ");
var $62b8cbe7b9115b5d$var$k = Symbol.for("react.element"), $62b8cbe7b9115b5d$var$l = Symbol.for("react.fragment"), $62b8cbe7b9115b5d$var$m = Object.prototype.hasOwnProperty, $62b8cbe7b9115b5d$var$n = $6umrQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $62b8cbe7b9115b5d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $62b8cbe7b9115b5d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$62b8cbe7b9115b5d$var$m.call(a, b) && !$62b8cbe7b9115b5d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $62b8cbe7b9115b5d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $62b8cbe7b9115b5d$var$n.current
    };
}
$62b8cbe7b9115b5d$export$ffb0004e005737fa = $62b8cbe7b9115b5d$var$l;
$62b8cbe7b9115b5d$export$34b9dba7ce09269b = $62b8cbe7b9115b5d$var$q;
$62b8cbe7b9115b5d$export$25062201e9e25d76 = $62b8cbe7b9115b5d$var$q;

});
parcelRegister("6umrQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("enPwP"));

});
parcelRegister("enPwP", function(module, exports) {

$parcel$export(module.exports, "Children", () => $a78b2f2335eed1af$export$dca3b0875bd9a954, (v) => $a78b2f2335eed1af$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $a78b2f2335eed1af$export$16fa2f45be04daa8, (v) => $a78b2f2335eed1af$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $a78b2f2335eed1af$export$ffb0004e005737fa, (v) => $a78b2f2335eed1af$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $a78b2f2335eed1af$export$e2c29f18771995cb, (v) => $a78b2f2335eed1af$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $a78b2f2335eed1af$export$221d75b3f55bb0bd, (v) => $a78b2f2335eed1af$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $a78b2f2335eed1af$export$5f8d39834fd61797, (v) => $a78b2f2335eed1af$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a78b2f2335eed1af$export$74bf444e3cd11ea5, (v) => $a78b2f2335eed1af$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $a78b2f2335eed1af$export$ae55be85d98224ed, (v) => $a78b2f2335eed1af$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $a78b2f2335eed1af$export$3ba232387fd5d6dd, (v) => $a78b2f2335eed1af$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $a78b2f2335eed1af$export$e530037191fcd5d7, (v) => $a78b2f2335eed1af$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $a78b2f2335eed1af$export$fd42f52fd3ae1109, (v) => $a78b2f2335eed1af$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $a78b2f2335eed1af$export$c8a8987d4410bf2d, (v) => $a78b2f2335eed1af$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $a78b2f2335eed1af$export$d38cd72104c1f0e9, (v) => $a78b2f2335eed1af$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $a78b2f2335eed1af$export$7d1e3a5e95ceca43, (v) => $a78b2f2335eed1af$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $a78b2f2335eed1af$export$257a8862b851cb5b, (v) => $a78b2f2335eed1af$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $a78b2f2335eed1af$export$a8257692ac88316c, (v) => $a78b2f2335eed1af$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $a78b2f2335eed1af$export$488013bae63b21da, (v) => $a78b2f2335eed1af$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $a78b2f2335eed1af$export$7c73462e0d25e514, (v) => $a78b2f2335eed1af$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $a78b2f2335eed1af$export$7568632d0d33d16d, (v) => $a78b2f2335eed1af$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $a78b2f2335eed1af$export$88948ce120ea2619, (v) => $a78b2f2335eed1af$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $a78b2f2335eed1af$export$35808ee640e87ca7, (v) => $a78b2f2335eed1af$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $a78b2f2335eed1af$export$fae74005e78b1a27, (v) => $a78b2f2335eed1af$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $a78b2f2335eed1af$export$dc8fbce3eb94dc1e, (v) => $a78b2f2335eed1af$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $a78b2f2335eed1af$export$6a7bc4e911dc01cf, (v) => $a78b2f2335eed1af$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $a78b2f2335eed1af$export$6d9c69b0de29b591, (v) => $a78b2f2335eed1af$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $a78b2f2335eed1af$export$f680877a34711e37, (v) => $a78b2f2335eed1af$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $a78b2f2335eed1af$export$d5a552a76deda3c2, (v) => $a78b2f2335eed1af$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $a78b2f2335eed1af$export$aaabe4eda9ed9969, (v) => $a78b2f2335eed1af$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $a78b2f2335eed1af$export$e5c5a5f917a5871c, (v) => $a78b2f2335eed1af$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $a78b2f2335eed1af$export$1538c33de8887b59, (v) => $a78b2f2335eed1af$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $a78b2f2335eed1af$export$13e3392192263954, (v) => $a78b2f2335eed1af$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $a78b2f2335eed1af$export$b8f5890fc79d6aca, (v) => $a78b2f2335eed1af$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $a78b2f2335eed1af$export$60241385465d0a34, (v) => $a78b2f2335eed1af$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $a78b2f2335eed1af$export$306c0aa65ff9ec16, (v) => $a78b2f2335eed1af$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $a78b2f2335eed1af$export$7b286972b8d8ccbf, (v) => $a78b2f2335eed1af$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $a78b2f2335eed1af$export$83d89fbfd8236492, (v) => $a78b2f2335eed1af$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a78b2f2335eed1af$export$dca3b0875bd9a954;
var $a78b2f2335eed1af$export$16fa2f45be04daa8;
var $a78b2f2335eed1af$export$ffb0004e005737fa;
var $a78b2f2335eed1af$export$e2c29f18771995cb;
var $a78b2f2335eed1af$export$221d75b3f55bb0bd;
var $a78b2f2335eed1af$export$5f8d39834fd61797;
var $a78b2f2335eed1af$export$74bf444e3cd11ea5;
var $a78b2f2335eed1af$export$ae55be85d98224ed;
var $a78b2f2335eed1af$export$3ba232387fd5d6dd;
var $a78b2f2335eed1af$export$e530037191fcd5d7;
var $a78b2f2335eed1af$export$fd42f52fd3ae1109;
var $a78b2f2335eed1af$export$c8a8987d4410bf2d;
var $a78b2f2335eed1af$export$d38cd72104c1f0e9;
var $a78b2f2335eed1af$export$7d1e3a5e95ceca43;
var $a78b2f2335eed1af$export$257a8862b851cb5b;
var $a78b2f2335eed1af$export$a8257692ac88316c;
var $a78b2f2335eed1af$export$488013bae63b21da;
var $a78b2f2335eed1af$export$7c73462e0d25e514;
var $a78b2f2335eed1af$export$7568632d0d33d16d;
var $a78b2f2335eed1af$export$88948ce120ea2619;
var $a78b2f2335eed1af$export$35808ee640e87ca7;
var $a78b2f2335eed1af$export$fae74005e78b1a27;
var $a78b2f2335eed1af$export$dc8fbce3eb94dc1e;
var $a78b2f2335eed1af$export$6a7bc4e911dc01cf;
var $a78b2f2335eed1af$export$6d9c69b0de29b591;
var $a78b2f2335eed1af$export$f680877a34711e37;
var $a78b2f2335eed1af$export$d5a552a76deda3c2;
var $a78b2f2335eed1af$export$aaabe4eda9ed9969;
var $a78b2f2335eed1af$export$e5c5a5f917a5871c;
var $a78b2f2335eed1af$export$1538c33de8887b59;
var $a78b2f2335eed1af$export$13e3392192263954;
var $a78b2f2335eed1af$export$b8f5890fc79d6aca;
var $a78b2f2335eed1af$export$60241385465d0a34;
var $a78b2f2335eed1af$export$306c0aa65ff9ec16;
var $a78b2f2335eed1af$export$7b286972b8d8ccbf;
var $a78b2f2335eed1af$export$83d89fbfd8236492;
'use strict';
var $a78b2f2335eed1af$var$l = Symbol.for("react.element"), $a78b2f2335eed1af$var$n = Symbol.for("react.portal"), $a78b2f2335eed1af$var$p = Symbol.for("react.fragment"), $a78b2f2335eed1af$var$q = Symbol.for("react.strict_mode"), $a78b2f2335eed1af$var$r = Symbol.for("react.profiler"), $a78b2f2335eed1af$var$t = Symbol.for("react.provider"), $a78b2f2335eed1af$var$u = Symbol.for("react.context"), $a78b2f2335eed1af$var$v = Symbol.for("react.forward_ref"), $a78b2f2335eed1af$var$w = Symbol.for("react.suspense"), $a78b2f2335eed1af$var$x = Symbol.for("react.memo"), $a78b2f2335eed1af$var$y = Symbol.for("react.lazy"), $a78b2f2335eed1af$var$z = Symbol.iterator;
function $a78b2f2335eed1af$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a78b2f2335eed1af$var$z && a[$a78b2f2335eed1af$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a78b2f2335eed1af$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a78b2f2335eed1af$var$C = Object.assign, $a78b2f2335eed1af$var$D = {};
function $a78b2f2335eed1af$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a78b2f2335eed1af$var$D;
    this.updater = e || $a78b2f2335eed1af$var$B;
}
$a78b2f2335eed1af$var$E.prototype.isReactComponent = {};
$a78b2f2335eed1af$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$a78b2f2335eed1af$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $a78b2f2335eed1af$var$F() {}
$a78b2f2335eed1af$var$F.prototype = $a78b2f2335eed1af$var$E.prototype;
function $a78b2f2335eed1af$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a78b2f2335eed1af$var$D;
    this.updater = e || $a78b2f2335eed1af$var$B;
}
var $a78b2f2335eed1af$var$H = $a78b2f2335eed1af$var$G.prototype = new $a78b2f2335eed1af$var$F;
$a78b2f2335eed1af$var$H.constructor = $a78b2f2335eed1af$var$G;
$a78b2f2335eed1af$var$C($a78b2f2335eed1af$var$H, $a78b2f2335eed1af$var$E.prototype);
$a78b2f2335eed1af$var$H.isPureReactComponent = !0;
var $a78b2f2335eed1af$var$I = Array.isArray, $a78b2f2335eed1af$var$J = Object.prototype.hasOwnProperty, $a78b2f2335eed1af$var$K = {
    current: null
}, $a78b2f2335eed1af$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a78b2f2335eed1af$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$a78b2f2335eed1af$var$J.call(b, d) && !$a78b2f2335eed1af$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $a78b2f2335eed1af$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $a78b2f2335eed1af$var$K.current
    };
}
function $a78b2f2335eed1af$var$N(a, b) {
    return {
        $$typeof: $a78b2f2335eed1af$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $a78b2f2335eed1af$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a78b2f2335eed1af$var$l;
}
function $a78b2f2335eed1af$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $a78b2f2335eed1af$var$P = /\/+/g;
function $a78b2f2335eed1af$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $a78b2f2335eed1af$var$escape("" + a.key) : b.toString(36);
}
function $a78b2f2335eed1af$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $a78b2f2335eed1af$var$l:
                case $a78b2f2335eed1af$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $a78b2f2335eed1af$var$Q(h, 0) : d, $a78b2f2335eed1af$var$I(c) ? (e = "", null != a && (e = a.replace($a78b2f2335eed1af$var$P, "$&/") + "/"), $a78b2f2335eed1af$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($a78b2f2335eed1af$var$O(c) && (c = $a78b2f2335eed1af$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($a78b2f2335eed1af$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($a78b2f2335eed1af$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $a78b2f2335eed1af$var$Q(k, g);
        h += $a78b2f2335eed1af$var$R(k, b, e, f, c);
    }
    else if (f = $a78b2f2335eed1af$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $a78b2f2335eed1af$var$Q(k, g++), h += $a78b2f2335eed1af$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $a78b2f2335eed1af$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $a78b2f2335eed1af$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $a78b2f2335eed1af$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $a78b2f2335eed1af$var$U = {
    current: null
}, $a78b2f2335eed1af$var$V = {
    transition: null
}, $a78b2f2335eed1af$var$W = {
    ReactCurrentDispatcher: $a78b2f2335eed1af$var$U,
    ReactCurrentBatchConfig: $a78b2f2335eed1af$var$V,
    ReactCurrentOwner: $a78b2f2335eed1af$var$K
};
function $a78b2f2335eed1af$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$a78b2f2335eed1af$export$dca3b0875bd9a954 = {
    map: $a78b2f2335eed1af$var$S,
    forEach: function(a, b, e) {
        $a78b2f2335eed1af$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $a78b2f2335eed1af$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $a78b2f2335eed1af$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$a78b2f2335eed1af$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$a78b2f2335eed1af$export$16fa2f45be04daa8 = $a78b2f2335eed1af$var$E;
$a78b2f2335eed1af$export$ffb0004e005737fa = $a78b2f2335eed1af$var$p;
$a78b2f2335eed1af$export$e2c29f18771995cb = $a78b2f2335eed1af$var$r;
$a78b2f2335eed1af$export$221d75b3f55bb0bd = $a78b2f2335eed1af$var$G;
$a78b2f2335eed1af$export$5f8d39834fd61797 = $a78b2f2335eed1af$var$q;
$a78b2f2335eed1af$export$74bf444e3cd11ea5 = $a78b2f2335eed1af$var$w;
$a78b2f2335eed1af$export$ae55be85d98224ed = $a78b2f2335eed1af$var$W;
$a78b2f2335eed1af$export$3ba232387fd5d6dd = $a78b2f2335eed1af$var$X;
$a78b2f2335eed1af$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $a78b2f2335eed1af$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $a78b2f2335eed1af$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$a78b2f2335eed1af$var$J.call(b, f) && !$a78b2f2335eed1af$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $a78b2f2335eed1af$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$a78b2f2335eed1af$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $a78b2f2335eed1af$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $a78b2f2335eed1af$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$a78b2f2335eed1af$export$c8a8987d4410bf2d = $a78b2f2335eed1af$var$M;
$a78b2f2335eed1af$export$d38cd72104c1f0e9 = function(a) {
    var b = $a78b2f2335eed1af$var$M.bind(null, a);
    b.type = a;
    return b;
};
$a78b2f2335eed1af$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a78b2f2335eed1af$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $a78b2f2335eed1af$var$v,
        render: a
    };
};
$a78b2f2335eed1af$export$a8257692ac88316c = $a78b2f2335eed1af$var$O;
$a78b2f2335eed1af$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $a78b2f2335eed1af$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $a78b2f2335eed1af$var$T
    };
};
$a78b2f2335eed1af$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $a78b2f2335eed1af$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$a78b2f2335eed1af$export$7568632d0d33d16d = function(a) {
    var b = $a78b2f2335eed1af$var$V.transition;
    $a78b2f2335eed1af$var$V.transition = {};
    try {
        a();
    } finally{
        $a78b2f2335eed1af$var$V.transition = b;
    }
};
$a78b2f2335eed1af$export$88948ce120ea2619 = $a78b2f2335eed1af$var$X;
$a78b2f2335eed1af$export$35808ee640e87ca7 = function(a, b) {
    return $a78b2f2335eed1af$var$U.current.useCallback(a, b);
};
$a78b2f2335eed1af$export$fae74005e78b1a27 = function(a) {
    return $a78b2f2335eed1af$var$U.current.useContext(a);
};
$a78b2f2335eed1af$export$dc8fbce3eb94dc1e = function() {};
$a78b2f2335eed1af$export$6a7bc4e911dc01cf = function(a) {
    return $a78b2f2335eed1af$var$U.current.useDeferredValue(a);
};
$a78b2f2335eed1af$export$6d9c69b0de29b591 = function(a, b) {
    return $a78b2f2335eed1af$var$U.current.useEffect(a, b);
};
$a78b2f2335eed1af$export$f680877a34711e37 = function() {
    return $a78b2f2335eed1af$var$U.current.useId();
};
$a78b2f2335eed1af$export$d5a552a76deda3c2 = function(a, b, e) {
    return $a78b2f2335eed1af$var$U.current.useImperativeHandle(a, b, e);
};
$a78b2f2335eed1af$export$aaabe4eda9ed9969 = function(a, b) {
    return $a78b2f2335eed1af$var$U.current.useInsertionEffect(a, b);
};
$a78b2f2335eed1af$export$e5c5a5f917a5871c = function(a, b) {
    return $a78b2f2335eed1af$var$U.current.useLayoutEffect(a, b);
};
$a78b2f2335eed1af$export$1538c33de8887b59 = function(a, b) {
    return $a78b2f2335eed1af$var$U.current.useMemo(a, b);
};
$a78b2f2335eed1af$export$13e3392192263954 = function(a, b, e) {
    return $a78b2f2335eed1af$var$U.current.useReducer(a, b, e);
};
$a78b2f2335eed1af$export$b8f5890fc79d6aca = function(a) {
    return $a78b2f2335eed1af$var$U.current.useRef(a);
};
$a78b2f2335eed1af$export$60241385465d0a34 = function(a) {
    return $a78b2f2335eed1af$var$U.current.useState(a);
};
$a78b2f2335eed1af$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $a78b2f2335eed1af$var$U.current.useSyncExternalStore(a, b, e);
};
$a78b2f2335eed1af$export$7b286972b8d8ccbf = function() {
    return $a78b2f2335eed1af$var$U.current.useTransition();
};
$a78b2f2335eed1af$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("lGLfC", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $fca22c47c90d13d9$export$ae55be85d98224ed, (v) => $fca22c47c90d13d9$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $fca22c47c90d13d9$export$d39a5bbd09211389, (v) => $fca22c47c90d13d9$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $fca22c47c90d13d9$export$882461b6382ed46c, (v) => $fca22c47c90d13d9$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $fca22c47c90d13d9$export$466bfc07425424d5, (v) => $fca22c47c90d13d9$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $fca22c47c90d13d9$export$cd75ccfd720a3cd4, (v) => $fca22c47c90d13d9$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $fca22c47c90d13d9$export$fa8d919ba61d84db, (v) => $fca22c47c90d13d9$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $fca22c47c90d13d9$export$757ceba2d55c277e, (v) => $fca22c47c90d13d9$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $fca22c47c90d13d9$export$b3890eb0ae9dca99, (v) => $fca22c47c90d13d9$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $fca22c47c90d13d9$export$502457920280e6be, (v) => $fca22c47c90d13d9$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $fca22c47c90d13d9$export$c78a37762a8d58e1, (v) => $fca22c47c90d13d9$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $fca22c47c90d13d9$export$dc54d992c10e8a18, (v) => $fca22c47c90d13d9$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $fca22c47c90d13d9$export$83d89fbfd8236492, (v) => $fca22c47c90d13d9$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fca22c47c90d13d9$export$ae55be85d98224ed;
var $fca22c47c90d13d9$export$d39a5bbd09211389;
var $fca22c47c90d13d9$export$882461b6382ed46c;
var $fca22c47c90d13d9$export$466bfc07425424d5;
var $fca22c47c90d13d9$export$cd75ccfd720a3cd4;
var $fca22c47c90d13d9$export$fa8d919ba61d84db;
var $fca22c47c90d13d9$export$757ceba2d55c277e;
var $fca22c47c90d13d9$export$b3890eb0ae9dca99;
var $fca22c47c90d13d9$export$502457920280e6be;
var $fca22c47c90d13d9$export$c78a37762a8d58e1;
var $fca22c47c90d13d9$export$dc54d992c10e8a18;
var $fca22c47c90d13d9$export$83d89fbfd8236492;
'use strict';

var $6umrQ = parcelRequire("6umrQ");

var $lq9zh = parcelRequire("lq9zh");
function $fca22c47c90d13d9$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fca22c47c90d13d9$var$da = new Set, $fca22c47c90d13d9$var$ea = {};
function $fca22c47c90d13d9$var$fa(a, b) {
    $fca22c47c90d13d9$var$ha(a, b);
    $fca22c47c90d13d9$var$ha(a + "Capture", b);
}
function $fca22c47c90d13d9$var$ha(a, b) {
    $fca22c47c90d13d9$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fca22c47c90d13d9$var$da.add(b[a]);
}
var $fca22c47c90d13d9$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fca22c47c90d13d9$var$ja = Object.prototype.hasOwnProperty, $fca22c47c90d13d9$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fca22c47c90d13d9$var$la = {}, $fca22c47c90d13d9$var$ma = {};
function $fca22c47c90d13d9$var$oa(a) {
    if ($fca22c47c90d13d9$var$ja.call($fca22c47c90d13d9$var$ma, a)) return !0;
    if ($fca22c47c90d13d9$var$ja.call($fca22c47c90d13d9$var$la, a)) return !1;
    if ($fca22c47c90d13d9$var$ka.test(a)) return $fca22c47c90d13d9$var$ma[a] = !0;
    $fca22c47c90d13d9$var$la[a] = !0;
    return !1;
}
function $fca22c47c90d13d9$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fca22c47c90d13d9$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fca22c47c90d13d9$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fca22c47c90d13d9$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fca22c47c90d13d9$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fca22c47c90d13d9$var$z[b] = new $fca22c47c90d13d9$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fca22c47c90d13d9$var$ra = /[\-:]([a-z])/g;
function $fca22c47c90d13d9$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fca22c47c90d13d9$var$ra, $fca22c47c90d13d9$var$sa);
    $fca22c47c90d13d9$var$z[b] = new $fca22c47c90d13d9$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fca22c47c90d13d9$var$ra, $fca22c47c90d13d9$var$sa);
    $fca22c47c90d13d9$var$z[b] = new $fca22c47c90d13d9$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fca22c47c90d13d9$var$ra, $fca22c47c90d13d9$var$sa);
    $fca22c47c90d13d9$var$z[b] = new $fca22c47c90d13d9$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fca22c47c90d13d9$var$z.xlinkHref = new $fca22c47c90d13d9$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fca22c47c90d13d9$var$z[a] = new $fca22c47c90d13d9$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fca22c47c90d13d9$var$ta(a, b, c, d) {
    var e = $fca22c47c90d13d9$var$z.hasOwnProperty(b) ? $fca22c47c90d13d9$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fca22c47c90d13d9$var$qa(b, c, e, d) && (c = null), d || null === e ? $fca22c47c90d13d9$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fca22c47c90d13d9$var$ua = $6umrQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fca22c47c90d13d9$var$va = Symbol.for("react.element"), $fca22c47c90d13d9$var$wa = Symbol.for("react.portal"), $fca22c47c90d13d9$var$ya = Symbol.for("react.fragment"), $fca22c47c90d13d9$var$za = Symbol.for("react.strict_mode"), $fca22c47c90d13d9$var$Aa = Symbol.for("react.profiler"), $fca22c47c90d13d9$var$Ba = Symbol.for("react.provider"), $fca22c47c90d13d9$var$Ca = Symbol.for("react.context"), $fca22c47c90d13d9$var$Da = Symbol.for("react.forward_ref"), $fca22c47c90d13d9$var$Ea = Symbol.for("react.suspense"), $fca22c47c90d13d9$var$Fa = Symbol.for("react.suspense_list"), $fca22c47c90d13d9$var$Ga = Symbol.for("react.memo"), $fca22c47c90d13d9$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fca22c47c90d13d9$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fca22c47c90d13d9$var$Ja = Symbol.iterator;
function $fca22c47c90d13d9$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fca22c47c90d13d9$var$Ja && a[$fca22c47c90d13d9$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fca22c47c90d13d9$var$A = Object.assign, $fca22c47c90d13d9$var$La;
function $fca22c47c90d13d9$var$Ma(a) {
    if (void 0 === $fca22c47c90d13d9$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fca22c47c90d13d9$var$La = b && b[1] || "";
    }
    return "\n" + $fca22c47c90d13d9$var$La + a;
}
var $fca22c47c90d13d9$var$Na = !1;
function $fca22c47c90d13d9$var$Oa(a, b) {
    if (!a || $fca22c47c90d13d9$var$Na) return "";
    $fca22c47c90d13d9$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fca22c47c90d13d9$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fca22c47c90d13d9$var$Ma(a) : "";
}
function $fca22c47c90d13d9$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fca22c47c90d13d9$var$Ma(a.type);
        case 16:
            return $fca22c47c90d13d9$var$Ma("Lazy");
        case 13:
            return $fca22c47c90d13d9$var$Ma("Suspense");
        case 19:
            return $fca22c47c90d13d9$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fca22c47c90d13d9$var$Oa(a.type, !1), a;
        case 11:
            return a = $fca22c47c90d13d9$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fca22c47c90d13d9$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fca22c47c90d13d9$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fca22c47c90d13d9$var$ya:
            return "Fragment";
        case $fca22c47c90d13d9$var$wa:
            return "Portal";
        case $fca22c47c90d13d9$var$Aa:
            return "Profiler";
        case $fca22c47c90d13d9$var$za:
            return "StrictMode";
        case $fca22c47c90d13d9$var$Ea:
            return "Suspense";
        case $fca22c47c90d13d9$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fca22c47c90d13d9$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fca22c47c90d13d9$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fca22c47c90d13d9$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fca22c47c90d13d9$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fca22c47c90d13d9$var$Qa(a.type) || "Memo";
        case $fca22c47c90d13d9$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fca22c47c90d13d9$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fca22c47c90d13d9$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fca22c47c90d13d9$var$Qa(b);
        case 8:
            return b === $fca22c47c90d13d9$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fca22c47c90d13d9$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fca22c47c90d13d9$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fca22c47c90d13d9$var$Ua(a) {
    var b = $fca22c47c90d13d9$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fca22c47c90d13d9$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fca22c47c90d13d9$var$Ua(a));
}
function $fca22c47c90d13d9$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fca22c47c90d13d9$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fca22c47c90d13d9$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fca22c47c90d13d9$var$Ya(a, b) {
    var c = b.checked;
    return $fca22c47c90d13d9$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fca22c47c90d13d9$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fca22c47c90d13d9$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fca22c47c90d13d9$var$ab(a, b) {
    b = b.checked;
    null != b && $fca22c47c90d13d9$var$ta(a, "checked", b, !1);
}
function $fca22c47c90d13d9$var$bb(a, b) {
    $fca22c47c90d13d9$var$ab(a, b);
    var c = $fca22c47c90d13d9$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fca22c47c90d13d9$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fca22c47c90d13d9$var$cb(a, b.type, $fca22c47c90d13d9$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fca22c47c90d13d9$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fca22c47c90d13d9$var$cb(a, b, c) {
    if ("number" !== b || $fca22c47c90d13d9$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fca22c47c90d13d9$var$eb = Array.isArray;
function $fca22c47c90d13d9$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fca22c47c90d13d9$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fca22c47c90d13d9$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fca22c47c90d13d9$var$p(91));
    return $fca22c47c90d13d9$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fca22c47c90d13d9$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fca22c47c90d13d9$var$p(92));
            if ($fca22c47c90d13d9$var$eb(c)) {
                if (1 < c.length) throw Error($fca22c47c90d13d9$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fca22c47c90d13d9$var$Sa(c)
    };
}
function $fca22c47c90d13d9$var$ib(a, b) {
    var c = $fca22c47c90d13d9$var$Sa(b.value), d = $fca22c47c90d13d9$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fca22c47c90d13d9$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fca22c47c90d13d9$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fca22c47c90d13d9$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fca22c47c90d13d9$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fca22c47c90d13d9$var$mb, $fca22c47c90d13d9$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fca22c47c90d13d9$var$mb = $fca22c47c90d13d9$var$mb || document.createElement("div");
        $fca22c47c90d13d9$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fca22c47c90d13d9$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fca22c47c90d13d9$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fca22c47c90d13d9$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fca22c47c90d13d9$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fca22c47c90d13d9$var$pb).forEach(function(a) {
    $fca22c47c90d13d9$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fca22c47c90d13d9$var$pb[b] = $fca22c47c90d13d9$var$pb[a];
    });
});
function $fca22c47c90d13d9$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fca22c47c90d13d9$var$pb.hasOwnProperty(a) && $fca22c47c90d13d9$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fca22c47c90d13d9$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fca22c47c90d13d9$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fca22c47c90d13d9$var$tb = $fca22c47c90d13d9$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fca22c47c90d13d9$var$ub(a, b) {
    if (b) {
        if ($fca22c47c90d13d9$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fca22c47c90d13d9$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fca22c47c90d13d9$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fca22c47c90d13d9$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fca22c47c90d13d9$var$p(62));
    }
}
function $fca22c47c90d13d9$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fca22c47c90d13d9$var$wb = null;
function $fca22c47c90d13d9$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fca22c47c90d13d9$var$yb = null, $fca22c47c90d13d9$var$zb = null, $fca22c47c90d13d9$var$Ab = null;
function $fca22c47c90d13d9$var$Bb(a) {
    if (a = $fca22c47c90d13d9$var$Cb(a)) {
        if ("function" !== typeof $fca22c47c90d13d9$var$yb) throw Error($fca22c47c90d13d9$var$p(280));
        var b = a.stateNode;
        b && (b = $fca22c47c90d13d9$var$Db(b), $fca22c47c90d13d9$var$yb(a.stateNode, a.type, b));
    }
}
function $fca22c47c90d13d9$var$Eb(a) {
    $fca22c47c90d13d9$var$zb ? $fca22c47c90d13d9$var$Ab ? $fca22c47c90d13d9$var$Ab.push(a) : $fca22c47c90d13d9$var$Ab = [
        a
    ] : $fca22c47c90d13d9$var$zb = a;
}
function $fca22c47c90d13d9$var$Fb() {
    if ($fca22c47c90d13d9$var$zb) {
        var a = $fca22c47c90d13d9$var$zb, b = $fca22c47c90d13d9$var$Ab;
        $fca22c47c90d13d9$var$Ab = $fca22c47c90d13d9$var$zb = null;
        $fca22c47c90d13d9$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fca22c47c90d13d9$var$Bb(b[a]);
    }
}
function $fca22c47c90d13d9$var$Gb(a, b) {
    return a(b);
}
function $fca22c47c90d13d9$var$Hb() {}
var $fca22c47c90d13d9$var$Ib = !1;
function $fca22c47c90d13d9$var$Jb(a, b, c) {
    if ($fca22c47c90d13d9$var$Ib) return a(b, c);
    $fca22c47c90d13d9$var$Ib = !0;
    try {
        return $fca22c47c90d13d9$var$Gb(a, b, c);
    } finally{
        if ($fca22c47c90d13d9$var$Ib = !1, null !== $fca22c47c90d13d9$var$zb || null !== $fca22c47c90d13d9$var$Ab) $fca22c47c90d13d9$var$Hb(), $fca22c47c90d13d9$var$Fb();
    }
}
function $fca22c47c90d13d9$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fca22c47c90d13d9$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fca22c47c90d13d9$var$p(231, b, typeof c));
    return c;
}
var $fca22c47c90d13d9$var$Lb = !1;
if ($fca22c47c90d13d9$var$ia) try {
    var $fca22c47c90d13d9$var$Mb = {};
    Object.defineProperty($fca22c47c90d13d9$var$Mb, "passive", {
        get: function() {
            $fca22c47c90d13d9$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fca22c47c90d13d9$var$Mb, $fca22c47c90d13d9$var$Mb);
    window.removeEventListener("test", $fca22c47c90d13d9$var$Mb, $fca22c47c90d13d9$var$Mb);
} catch (a) {
    $fca22c47c90d13d9$var$Lb = !1;
}
function $fca22c47c90d13d9$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fca22c47c90d13d9$var$Ob = !1, $fca22c47c90d13d9$var$Pb = null, $fca22c47c90d13d9$var$Qb = !1, $fca22c47c90d13d9$var$Rb = null, $fca22c47c90d13d9$var$Sb = {
    onError: function(a) {
        $fca22c47c90d13d9$var$Ob = !0;
        $fca22c47c90d13d9$var$Pb = a;
    }
};
function $fca22c47c90d13d9$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fca22c47c90d13d9$var$Ob = !1;
    $fca22c47c90d13d9$var$Pb = null;
    $fca22c47c90d13d9$var$Nb.apply($fca22c47c90d13d9$var$Sb, arguments);
}
function $fca22c47c90d13d9$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fca22c47c90d13d9$var$Tb.apply(this, arguments);
    if ($fca22c47c90d13d9$var$Ob) {
        if ($fca22c47c90d13d9$var$Ob) {
            var l = $fca22c47c90d13d9$var$Pb;
            $fca22c47c90d13d9$var$Ob = !1;
            $fca22c47c90d13d9$var$Pb = null;
        } else throw Error($fca22c47c90d13d9$var$p(198));
        $fca22c47c90d13d9$var$Qb || ($fca22c47c90d13d9$var$Qb = !0, $fca22c47c90d13d9$var$Rb = l);
    }
}
function $fca22c47c90d13d9$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fca22c47c90d13d9$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fca22c47c90d13d9$var$Xb(a) {
    if ($fca22c47c90d13d9$var$Vb(a) !== a) throw Error($fca22c47c90d13d9$var$p(188));
}
function $fca22c47c90d13d9$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fca22c47c90d13d9$var$Vb(a);
        if (null === b) throw Error($fca22c47c90d13d9$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fca22c47c90d13d9$var$Xb(e), a;
                if (f === d) return $fca22c47c90d13d9$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fca22c47c90d13d9$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fca22c47c90d13d9$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fca22c47c90d13d9$var$p(190));
    }
    if (3 !== c.tag) throw Error($fca22c47c90d13d9$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fca22c47c90d13d9$var$Zb(a) {
    a = $fca22c47c90d13d9$var$Yb(a);
    return null !== a ? $fca22c47c90d13d9$var$$b(a) : null;
}
function $fca22c47c90d13d9$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fca22c47c90d13d9$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fca22c47c90d13d9$var$ac = $lq9zh.unstable_scheduleCallback, $fca22c47c90d13d9$var$bc = $lq9zh.unstable_cancelCallback, $fca22c47c90d13d9$var$cc = $lq9zh.unstable_shouldYield, $fca22c47c90d13d9$var$dc = $lq9zh.unstable_requestPaint, $fca22c47c90d13d9$var$B = $lq9zh.unstable_now, $fca22c47c90d13d9$var$ec = $lq9zh.unstable_getCurrentPriorityLevel, $fca22c47c90d13d9$var$fc = $lq9zh.unstable_ImmediatePriority, $fca22c47c90d13d9$var$gc = $lq9zh.unstable_UserBlockingPriority, $fca22c47c90d13d9$var$hc = $lq9zh.unstable_NormalPriority, $fca22c47c90d13d9$var$ic = $lq9zh.unstable_LowPriority, $fca22c47c90d13d9$var$jc = $lq9zh.unstable_IdlePriority, $fca22c47c90d13d9$var$kc = null, $fca22c47c90d13d9$var$lc = null;
function $fca22c47c90d13d9$var$mc(a) {
    if ($fca22c47c90d13d9$var$lc && "function" === typeof $fca22c47c90d13d9$var$lc.onCommitFiberRoot) try {
        $fca22c47c90d13d9$var$lc.onCommitFiberRoot($fca22c47c90d13d9$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fca22c47c90d13d9$var$oc = Math.clz32 ? Math.clz32 : $fca22c47c90d13d9$var$nc, $fca22c47c90d13d9$var$pc = Math.log, $fca22c47c90d13d9$var$qc = Math.LN2;
function $fca22c47c90d13d9$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fca22c47c90d13d9$var$pc(a) / $fca22c47c90d13d9$var$qc | 0) | 0;
}
var $fca22c47c90d13d9$var$rc = 64, $fca22c47c90d13d9$var$sc = 4194304;
function $fca22c47c90d13d9$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fca22c47c90d13d9$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fca22c47c90d13d9$var$tc(h) : (f &= g, 0 !== f && (d = $fca22c47c90d13d9$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fca22c47c90d13d9$var$tc(g) : 0 !== f && (d = $fca22c47c90d13d9$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fca22c47c90d13d9$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fca22c47c90d13d9$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fca22c47c90d13d9$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fca22c47c90d13d9$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fca22c47c90d13d9$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fca22c47c90d13d9$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fca22c47c90d13d9$var$yc() {
    var a = $fca22c47c90d13d9$var$rc;
    $fca22c47c90d13d9$var$rc <<= 1;
    0 === ($fca22c47c90d13d9$var$rc & 4194240) && ($fca22c47c90d13d9$var$rc = 64);
    return a;
}
function $fca22c47c90d13d9$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fca22c47c90d13d9$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fca22c47c90d13d9$var$oc(b);
    a[b] = c;
}
function $fca22c47c90d13d9$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fca22c47c90d13d9$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fca22c47c90d13d9$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fca22c47c90d13d9$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fca22c47c90d13d9$var$C = 0;
function $fca22c47c90d13d9$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fca22c47c90d13d9$var$Ec, $fca22c47c90d13d9$var$Fc, $fca22c47c90d13d9$var$Gc, $fca22c47c90d13d9$var$Hc, $fca22c47c90d13d9$var$Ic, $fca22c47c90d13d9$var$Jc = !1, $fca22c47c90d13d9$var$Kc = [], $fca22c47c90d13d9$var$Lc = null, $fca22c47c90d13d9$var$Mc = null, $fca22c47c90d13d9$var$Nc = null, $fca22c47c90d13d9$var$Oc = new Map, $fca22c47c90d13d9$var$Pc = new Map, $fca22c47c90d13d9$var$Qc = [], $fca22c47c90d13d9$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fca22c47c90d13d9$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fca22c47c90d13d9$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fca22c47c90d13d9$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fca22c47c90d13d9$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fca22c47c90d13d9$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fca22c47c90d13d9$var$Pc.delete(b.pointerId);
    }
}
function $fca22c47c90d13d9$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fca22c47c90d13d9$var$Cb(b), null !== b && $fca22c47c90d13d9$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fca22c47c90d13d9$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fca22c47c90d13d9$var$Lc = $fca22c47c90d13d9$var$Tc($fca22c47c90d13d9$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fca22c47c90d13d9$var$Mc = $fca22c47c90d13d9$var$Tc($fca22c47c90d13d9$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fca22c47c90d13d9$var$Nc = $fca22c47c90d13d9$var$Tc($fca22c47c90d13d9$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fca22c47c90d13d9$var$Oc.set(f, $fca22c47c90d13d9$var$Tc($fca22c47c90d13d9$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fca22c47c90d13d9$var$Pc.set(f, $fca22c47c90d13d9$var$Tc($fca22c47c90d13d9$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fca22c47c90d13d9$var$Vc(a) {
    var b = $fca22c47c90d13d9$var$Wc(a.target);
    if (null !== b) {
        var c = $fca22c47c90d13d9$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fca22c47c90d13d9$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fca22c47c90d13d9$var$Ic(a.priority, function() {
                        $fca22c47c90d13d9$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fca22c47c90d13d9$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fca22c47c90d13d9$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fca22c47c90d13d9$var$wb = d;
            c.target.dispatchEvent(d);
            $fca22c47c90d13d9$var$wb = null;
        } else return b = $fca22c47c90d13d9$var$Cb(c), null !== b && $fca22c47c90d13d9$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fca22c47c90d13d9$var$Zc(a, b, c) {
    $fca22c47c90d13d9$var$Xc(a) && c.delete(b);
}
function $fca22c47c90d13d9$var$$c() {
    $fca22c47c90d13d9$var$Jc = !1;
    null !== $fca22c47c90d13d9$var$Lc && $fca22c47c90d13d9$var$Xc($fca22c47c90d13d9$var$Lc) && ($fca22c47c90d13d9$var$Lc = null);
    null !== $fca22c47c90d13d9$var$Mc && $fca22c47c90d13d9$var$Xc($fca22c47c90d13d9$var$Mc) && ($fca22c47c90d13d9$var$Mc = null);
    null !== $fca22c47c90d13d9$var$Nc && $fca22c47c90d13d9$var$Xc($fca22c47c90d13d9$var$Nc) && ($fca22c47c90d13d9$var$Nc = null);
    $fca22c47c90d13d9$var$Oc.forEach($fca22c47c90d13d9$var$Zc);
    $fca22c47c90d13d9$var$Pc.forEach($fca22c47c90d13d9$var$Zc);
}
function $fca22c47c90d13d9$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fca22c47c90d13d9$var$Jc || ($fca22c47c90d13d9$var$Jc = !0, $lq9zh.unstable_scheduleCallback($lq9zh.unstable_NormalPriority, $fca22c47c90d13d9$var$$c)));
}
function $fca22c47c90d13d9$var$bd(a) {
    function b(b) {
        return $fca22c47c90d13d9$var$ad(b, a);
    }
    if (0 < $fca22c47c90d13d9$var$Kc.length) {
        $fca22c47c90d13d9$var$ad($fca22c47c90d13d9$var$Kc[0], a);
        for(var c = 1; c < $fca22c47c90d13d9$var$Kc.length; c++){
            var d = $fca22c47c90d13d9$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fca22c47c90d13d9$var$Lc && $fca22c47c90d13d9$var$ad($fca22c47c90d13d9$var$Lc, a);
    null !== $fca22c47c90d13d9$var$Mc && $fca22c47c90d13d9$var$ad($fca22c47c90d13d9$var$Mc, a);
    null !== $fca22c47c90d13d9$var$Nc && $fca22c47c90d13d9$var$ad($fca22c47c90d13d9$var$Nc, a);
    $fca22c47c90d13d9$var$Oc.forEach(b);
    $fca22c47c90d13d9$var$Pc.forEach(b);
    for(c = 0; c < $fca22c47c90d13d9$var$Qc.length; c++)d = $fca22c47c90d13d9$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fca22c47c90d13d9$var$Qc.length && (c = $fca22c47c90d13d9$var$Qc[0], null === c.blockedOn);)$fca22c47c90d13d9$var$Vc(c), null === c.blockedOn && $fca22c47c90d13d9$var$Qc.shift();
}
var $fca22c47c90d13d9$var$cd = $fca22c47c90d13d9$var$ua.ReactCurrentBatchConfig, $fca22c47c90d13d9$var$dd = !0;
function $fca22c47c90d13d9$var$ed(a, b, c, d) {
    var e = $fca22c47c90d13d9$var$C, f = $fca22c47c90d13d9$var$cd.transition;
    $fca22c47c90d13d9$var$cd.transition = null;
    try {
        $fca22c47c90d13d9$var$C = 1, $fca22c47c90d13d9$var$fd(a, b, c, d);
    } finally{
        $fca22c47c90d13d9$var$C = e, $fca22c47c90d13d9$var$cd.transition = f;
    }
}
function $fca22c47c90d13d9$var$gd(a, b, c, d) {
    var e = $fca22c47c90d13d9$var$C, f = $fca22c47c90d13d9$var$cd.transition;
    $fca22c47c90d13d9$var$cd.transition = null;
    try {
        $fca22c47c90d13d9$var$C = 4, $fca22c47c90d13d9$var$fd(a, b, c, d);
    } finally{
        $fca22c47c90d13d9$var$C = e, $fca22c47c90d13d9$var$cd.transition = f;
    }
}
function $fca22c47c90d13d9$var$fd(a, b, c, d) {
    if ($fca22c47c90d13d9$var$dd) {
        var e = $fca22c47c90d13d9$var$Yc(a, b, c, d);
        if (null === e) $fca22c47c90d13d9$var$hd(a, b, d, $fca22c47c90d13d9$var$id, c), $fca22c47c90d13d9$var$Sc(a, d);
        else if ($fca22c47c90d13d9$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fca22c47c90d13d9$var$Sc(a, d), b & 4 && -1 < $fca22c47c90d13d9$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fca22c47c90d13d9$var$Cb(e);
                null !== f && $fca22c47c90d13d9$var$Ec(f);
                f = $fca22c47c90d13d9$var$Yc(a, b, c, d);
                null === f && $fca22c47c90d13d9$var$hd(a, b, d, $fca22c47c90d13d9$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fca22c47c90d13d9$var$hd(a, b, d, null, c);
    }
}
var $fca22c47c90d13d9$var$id = null;
function $fca22c47c90d13d9$var$Yc(a, b, c, d) {
    $fca22c47c90d13d9$var$id = null;
    a = $fca22c47c90d13d9$var$xb(d);
    a = $fca22c47c90d13d9$var$Wc(a);
    if (null !== a) {
        if (b = $fca22c47c90d13d9$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fca22c47c90d13d9$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fca22c47c90d13d9$var$id = a;
    return null;
}
function $fca22c47c90d13d9$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fca22c47c90d13d9$var$ec()){
                case $fca22c47c90d13d9$var$fc:
                    return 1;
                case $fca22c47c90d13d9$var$gc:
                    return 4;
                case $fca22c47c90d13d9$var$hc:
                case $fca22c47c90d13d9$var$ic:
                    return 16;
                case $fca22c47c90d13d9$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fca22c47c90d13d9$var$kd = null, $fca22c47c90d13d9$var$ld = null, $fca22c47c90d13d9$var$md = null;
function $fca22c47c90d13d9$var$nd() {
    if ($fca22c47c90d13d9$var$md) return $fca22c47c90d13d9$var$md;
    var a, b = $fca22c47c90d13d9$var$ld, c = b.length, d, e = "value" in $fca22c47c90d13d9$var$kd ? $fca22c47c90d13d9$var$kd.value : $fca22c47c90d13d9$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fca22c47c90d13d9$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fca22c47c90d13d9$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fca22c47c90d13d9$var$pd() {
    return !0;
}
function $fca22c47c90d13d9$var$qd() {
    return !1;
}
function $fca22c47c90d13d9$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fca22c47c90d13d9$var$pd : $fca22c47c90d13d9$var$qd;
        this.isPropagationStopped = $fca22c47c90d13d9$var$qd;
        return this;
    }
    $fca22c47c90d13d9$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fca22c47c90d13d9$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fca22c47c90d13d9$var$pd);
        },
        persist: function() {},
        isPersistent: $fca22c47c90d13d9$var$pd
    });
    return b;
}
var $fca22c47c90d13d9$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fca22c47c90d13d9$var$td = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$sd), $fca22c47c90d13d9$var$ud = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$sd, {
    view: 0,
    detail: 0
}), $fca22c47c90d13d9$var$vd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$ud), $fca22c47c90d13d9$var$wd, $fca22c47c90d13d9$var$xd, $fca22c47c90d13d9$var$yd, $fca22c47c90d13d9$var$Ad = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fca22c47c90d13d9$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fca22c47c90d13d9$var$yd && ($fca22c47c90d13d9$var$yd && "mousemove" === a.type ? ($fca22c47c90d13d9$var$wd = a.screenX - $fca22c47c90d13d9$var$yd.screenX, $fca22c47c90d13d9$var$xd = a.screenY - $fca22c47c90d13d9$var$yd.screenY) : $fca22c47c90d13d9$var$xd = $fca22c47c90d13d9$var$wd = 0, $fca22c47c90d13d9$var$yd = a);
        return $fca22c47c90d13d9$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fca22c47c90d13d9$var$xd;
    }
}), $fca22c47c90d13d9$var$Bd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Ad), $fca22c47c90d13d9$var$Cd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$Ad, {
    dataTransfer: 0
}), $fca22c47c90d13d9$var$Dd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Cd), $fca22c47c90d13d9$var$Ed = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$ud, {
    relatedTarget: 0
}), $fca22c47c90d13d9$var$Fd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Ed), $fca22c47c90d13d9$var$Gd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fca22c47c90d13d9$var$Hd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Gd), $fca22c47c90d13d9$var$Id = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fca22c47c90d13d9$var$Jd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Id), $fca22c47c90d13d9$var$Kd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$sd, {
    data: 0
}), $fca22c47c90d13d9$var$Ld = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Kd), $fca22c47c90d13d9$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fca22c47c90d13d9$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fca22c47c90d13d9$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fca22c47c90d13d9$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fca22c47c90d13d9$var$Od[a]) ? !!b[a] : !1;
}
function $fca22c47c90d13d9$var$zd() {
    return $fca22c47c90d13d9$var$Pd;
}
var $fca22c47c90d13d9$var$Qd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fca22c47c90d13d9$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fca22c47c90d13d9$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fca22c47c90d13d9$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fca22c47c90d13d9$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fca22c47c90d13d9$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fca22c47c90d13d9$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fca22c47c90d13d9$var$Rd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Qd), $fca22c47c90d13d9$var$Sd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fca22c47c90d13d9$var$Td = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Sd), $fca22c47c90d13d9$var$Ud = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fca22c47c90d13d9$var$zd
}), $fca22c47c90d13d9$var$Vd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Ud), $fca22c47c90d13d9$var$Wd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fca22c47c90d13d9$var$Xd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Wd), $fca22c47c90d13d9$var$Yd = $fca22c47c90d13d9$var$A({}, $fca22c47c90d13d9$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fca22c47c90d13d9$var$Zd = $fca22c47c90d13d9$var$rd($fca22c47c90d13d9$var$Yd), $fca22c47c90d13d9$var$$d = [
    9,
    13,
    27,
    32
], $fca22c47c90d13d9$var$ae = $fca22c47c90d13d9$var$ia && "CompositionEvent" in window, $fca22c47c90d13d9$var$be = null;
$fca22c47c90d13d9$var$ia && "documentMode" in document && ($fca22c47c90d13d9$var$be = document.documentMode);
var $fca22c47c90d13d9$var$ce = $fca22c47c90d13d9$var$ia && "TextEvent" in window && !$fca22c47c90d13d9$var$be, $fca22c47c90d13d9$var$de = $fca22c47c90d13d9$var$ia && (!$fca22c47c90d13d9$var$ae || $fca22c47c90d13d9$var$be && 8 < $fca22c47c90d13d9$var$be && 11 >= $fca22c47c90d13d9$var$be), $fca22c47c90d13d9$var$ee = String.fromCharCode(32), $fca22c47c90d13d9$var$fe = !1;
function $fca22c47c90d13d9$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fca22c47c90d13d9$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fca22c47c90d13d9$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fca22c47c90d13d9$var$ie = !1;
function $fca22c47c90d13d9$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fca22c47c90d13d9$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fca22c47c90d13d9$var$fe = !0;
            return $fca22c47c90d13d9$var$ee;
        case "textInput":
            return a = b.data, a === $fca22c47c90d13d9$var$ee && $fca22c47c90d13d9$var$fe ? null : a;
        default:
            return null;
    }
}
function $fca22c47c90d13d9$var$ke(a, b) {
    if ($fca22c47c90d13d9$var$ie) return "compositionend" === a || !$fca22c47c90d13d9$var$ae && $fca22c47c90d13d9$var$ge(a, b) ? (a = $fca22c47c90d13d9$var$nd(), $fca22c47c90d13d9$var$md = $fca22c47c90d13d9$var$ld = $fca22c47c90d13d9$var$kd = null, $fca22c47c90d13d9$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fca22c47c90d13d9$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fca22c47c90d13d9$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fca22c47c90d13d9$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fca22c47c90d13d9$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fca22c47c90d13d9$var$ne(a, b, c, d) {
    $fca22c47c90d13d9$var$Eb(d);
    b = $fca22c47c90d13d9$var$oe(b, "onChange");
    0 < b.length && (c = new $fca22c47c90d13d9$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fca22c47c90d13d9$var$pe = null, $fca22c47c90d13d9$var$qe = null;
function $fca22c47c90d13d9$var$re(a) {
    $fca22c47c90d13d9$var$se(a, 0);
}
function $fca22c47c90d13d9$var$te(a) {
    var b = $fca22c47c90d13d9$var$ue(a);
    if ($fca22c47c90d13d9$var$Wa(b)) return a;
}
function $fca22c47c90d13d9$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fca22c47c90d13d9$var$we = !1;
if ($fca22c47c90d13d9$var$ia) {
    var $fca22c47c90d13d9$var$xe;
    if ($fca22c47c90d13d9$var$ia) {
        var $fca22c47c90d13d9$var$ye = "oninput" in document;
        if (!$fca22c47c90d13d9$var$ye) {
            var $fca22c47c90d13d9$var$ze = document.createElement("div");
            $fca22c47c90d13d9$var$ze.setAttribute("oninput", "return;");
            $fca22c47c90d13d9$var$ye = "function" === typeof $fca22c47c90d13d9$var$ze.oninput;
        }
        $fca22c47c90d13d9$var$xe = $fca22c47c90d13d9$var$ye;
    } else $fca22c47c90d13d9$var$xe = !1;
    $fca22c47c90d13d9$var$we = $fca22c47c90d13d9$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fca22c47c90d13d9$var$Ae() {
    $fca22c47c90d13d9$var$pe && ($fca22c47c90d13d9$var$pe.detachEvent("onpropertychange", $fca22c47c90d13d9$var$Be), $fca22c47c90d13d9$var$qe = $fca22c47c90d13d9$var$pe = null);
}
function $fca22c47c90d13d9$var$Be(a) {
    if ("value" === a.propertyName && $fca22c47c90d13d9$var$te($fca22c47c90d13d9$var$qe)) {
        var b = [];
        $fca22c47c90d13d9$var$ne(b, $fca22c47c90d13d9$var$qe, a, $fca22c47c90d13d9$var$xb(a));
        $fca22c47c90d13d9$var$Jb($fca22c47c90d13d9$var$re, b);
    }
}
function $fca22c47c90d13d9$var$Ce(a, b, c) {
    "focusin" === a ? ($fca22c47c90d13d9$var$Ae(), $fca22c47c90d13d9$var$pe = b, $fca22c47c90d13d9$var$qe = c, $fca22c47c90d13d9$var$pe.attachEvent("onpropertychange", $fca22c47c90d13d9$var$Be)) : "focusout" === a && $fca22c47c90d13d9$var$Ae();
}
function $fca22c47c90d13d9$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fca22c47c90d13d9$var$te($fca22c47c90d13d9$var$qe);
}
function $fca22c47c90d13d9$var$Ee(a, b) {
    if ("click" === a) return $fca22c47c90d13d9$var$te(b);
}
function $fca22c47c90d13d9$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fca22c47c90d13d9$var$te(b);
}
function $fca22c47c90d13d9$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fca22c47c90d13d9$var$He = "function" === typeof Object.is ? Object.is : $fca22c47c90d13d9$var$Ge;
function $fca22c47c90d13d9$var$Ie(a, b) {
    if ($fca22c47c90d13d9$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fca22c47c90d13d9$var$ja.call(b, e) || !$fca22c47c90d13d9$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fca22c47c90d13d9$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fca22c47c90d13d9$var$Ke(a, b) {
    var c = $fca22c47c90d13d9$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fca22c47c90d13d9$var$Je(c);
    }
}
function $fca22c47c90d13d9$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fca22c47c90d13d9$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fca22c47c90d13d9$var$Me() {
    for(var a = window, b = $fca22c47c90d13d9$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fca22c47c90d13d9$var$Xa(a.document);
    }
    return b;
}
function $fca22c47c90d13d9$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fca22c47c90d13d9$var$Oe(a) {
    var b = $fca22c47c90d13d9$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fca22c47c90d13d9$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fca22c47c90d13d9$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fca22c47c90d13d9$var$Ke(c, f);
                var g = $fca22c47c90d13d9$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fca22c47c90d13d9$var$Pe = $fca22c47c90d13d9$var$ia && "documentMode" in document && 11 >= document.documentMode, $fca22c47c90d13d9$var$Qe = null, $fca22c47c90d13d9$var$Re = null, $fca22c47c90d13d9$var$Se = null, $fca22c47c90d13d9$var$Te = !1;
function $fca22c47c90d13d9$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fca22c47c90d13d9$var$Te || null == $fca22c47c90d13d9$var$Qe || $fca22c47c90d13d9$var$Qe !== $fca22c47c90d13d9$var$Xa(d) || (d = $fca22c47c90d13d9$var$Qe, "selectionStart" in d && $fca22c47c90d13d9$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fca22c47c90d13d9$var$Se && $fca22c47c90d13d9$var$Ie($fca22c47c90d13d9$var$Se, d) || ($fca22c47c90d13d9$var$Se = d, d = $fca22c47c90d13d9$var$oe($fca22c47c90d13d9$var$Re, "onSelect"), 0 < d.length && (b = new $fca22c47c90d13d9$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fca22c47c90d13d9$var$Qe)));
}
function $fca22c47c90d13d9$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fca22c47c90d13d9$var$We = {
    animationend: $fca22c47c90d13d9$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fca22c47c90d13d9$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fca22c47c90d13d9$var$Ve("Animation", "AnimationStart"),
    transitionend: $fca22c47c90d13d9$var$Ve("Transition", "TransitionEnd")
}, $fca22c47c90d13d9$var$Xe = {}, $fca22c47c90d13d9$var$Ye = {};
$fca22c47c90d13d9$var$ia && ($fca22c47c90d13d9$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fca22c47c90d13d9$var$We.animationend.animation, delete $fca22c47c90d13d9$var$We.animationiteration.animation, delete $fca22c47c90d13d9$var$We.animationstart.animation), "TransitionEvent" in window || delete $fca22c47c90d13d9$var$We.transitionend.transition);
function $fca22c47c90d13d9$var$Ze(a) {
    if ($fca22c47c90d13d9$var$Xe[a]) return $fca22c47c90d13d9$var$Xe[a];
    if (!$fca22c47c90d13d9$var$We[a]) return a;
    var b = $fca22c47c90d13d9$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fca22c47c90d13d9$var$Ye) return $fca22c47c90d13d9$var$Xe[a] = b[c];
    return a;
}
var $fca22c47c90d13d9$var$$e = $fca22c47c90d13d9$var$Ze("animationend"), $fca22c47c90d13d9$var$af = $fca22c47c90d13d9$var$Ze("animationiteration"), $fca22c47c90d13d9$var$bf = $fca22c47c90d13d9$var$Ze("animationstart"), $fca22c47c90d13d9$var$cf = $fca22c47c90d13d9$var$Ze("transitionend"), $fca22c47c90d13d9$var$df = new Map, $fca22c47c90d13d9$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fca22c47c90d13d9$var$ff(a, b) {
    $fca22c47c90d13d9$var$df.set(a, b);
    $fca22c47c90d13d9$var$fa(b, [
        a
    ]);
}
for(var $fca22c47c90d13d9$var$gf = 0; $fca22c47c90d13d9$var$gf < $fca22c47c90d13d9$var$ef.length; $fca22c47c90d13d9$var$gf++){
    var $fca22c47c90d13d9$var$hf = $fca22c47c90d13d9$var$ef[$fca22c47c90d13d9$var$gf], $fca22c47c90d13d9$var$jf = $fca22c47c90d13d9$var$hf.toLowerCase(), $fca22c47c90d13d9$var$kf = $fca22c47c90d13d9$var$hf[0].toUpperCase() + $fca22c47c90d13d9$var$hf.slice(1);
    $fca22c47c90d13d9$var$ff($fca22c47c90d13d9$var$jf, "on" + $fca22c47c90d13d9$var$kf);
}
$fca22c47c90d13d9$var$ff($fca22c47c90d13d9$var$$e, "onAnimationEnd");
$fca22c47c90d13d9$var$ff($fca22c47c90d13d9$var$af, "onAnimationIteration");
$fca22c47c90d13d9$var$ff($fca22c47c90d13d9$var$bf, "onAnimationStart");
$fca22c47c90d13d9$var$ff("dblclick", "onDoubleClick");
$fca22c47c90d13d9$var$ff("focusin", "onFocus");
$fca22c47c90d13d9$var$ff("focusout", "onBlur");
$fca22c47c90d13d9$var$ff($fca22c47c90d13d9$var$cf, "onTransitionEnd");
$fca22c47c90d13d9$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fca22c47c90d13d9$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fca22c47c90d13d9$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fca22c47c90d13d9$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fca22c47c90d13d9$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fca22c47c90d13d9$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fca22c47c90d13d9$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fca22c47c90d13d9$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fca22c47c90d13d9$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fca22c47c90d13d9$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fca22c47c90d13d9$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fca22c47c90d13d9$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fca22c47c90d13d9$var$lf));
function $fca22c47c90d13d9$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fca22c47c90d13d9$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fca22c47c90d13d9$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fca22c47c90d13d9$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fca22c47c90d13d9$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fca22c47c90d13d9$var$Qb) throw a = $fca22c47c90d13d9$var$Rb, $fca22c47c90d13d9$var$Qb = !1, $fca22c47c90d13d9$var$Rb = null, a;
}
function $fca22c47c90d13d9$var$D(a, b) {
    var c = b[$fca22c47c90d13d9$var$of];
    void 0 === c && (c = b[$fca22c47c90d13d9$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fca22c47c90d13d9$var$pf(b, a, 2, !1), c.add(d));
}
function $fca22c47c90d13d9$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fca22c47c90d13d9$var$pf(c, a, d, b);
}
var $fca22c47c90d13d9$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fca22c47c90d13d9$var$sf(a) {
    if (!a[$fca22c47c90d13d9$var$rf]) {
        a[$fca22c47c90d13d9$var$rf] = !0;
        $fca22c47c90d13d9$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fca22c47c90d13d9$var$mf.has(b) || $fca22c47c90d13d9$var$qf(b, !1, a), $fca22c47c90d13d9$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fca22c47c90d13d9$var$rf] || (b[$fca22c47c90d13d9$var$rf] = !0, $fca22c47c90d13d9$var$qf("selectionchange", !1, b));
    }
}
function $fca22c47c90d13d9$var$pf(a, b, c, d) {
    switch($fca22c47c90d13d9$var$jd(b)){
        case 1:
            var e = $fca22c47c90d13d9$var$ed;
            break;
        case 4:
            e = $fca22c47c90d13d9$var$gd;
            break;
        default:
            e = $fca22c47c90d13d9$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fca22c47c90d13d9$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fca22c47c90d13d9$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fca22c47c90d13d9$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fca22c47c90d13d9$var$Jb(function() {
        var d = f, e = $fca22c47c90d13d9$var$xb(c), g = [];
        a: {
            var h = $fca22c47c90d13d9$var$df.get(a);
            if (void 0 !== h) {
                var k = $fca22c47c90d13d9$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fca22c47c90d13d9$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fca22c47c90d13d9$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fca22c47c90d13d9$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fca22c47c90d13d9$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fca22c47c90d13d9$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fca22c47c90d13d9$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fca22c47c90d13d9$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fca22c47c90d13d9$var$Vd;
                        break;
                    case $fca22c47c90d13d9$var$$e:
                    case $fca22c47c90d13d9$var$af:
                    case $fca22c47c90d13d9$var$bf:
                        k = $fca22c47c90d13d9$var$Hd;
                        break;
                    case $fca22c47c90d13d9$var$cf:
                        k = $fca22c47c90d13d9$var$Xd;
                        break;
                    case "scroll":
                        k = $fca22c47c90d13d9$var$vd;
                        break;
                    case "wheel":
                        k = $fca22c47c90d13d9$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fca22c47c90d13d9$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fca22c47c90d13d9$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fca22c47c90d13d9$var$Kb(w, x), null != F && t.push($fca22c47c90d13d9$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fca22c47c90d13d9$var$wb && (n = c.relatedTarget || c.fromElement) && ($fca22c47c90d13d9$var$Wc(n) || n[$fca22c47c90d13d9$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fca22c47c90d13d9$var$Wc(n) : null, null !== n && (J = $fca22c47c90d13d9$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fca22c47c90d13d9$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fca22c47c90d13d9$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fca22c47c90d13d9$var$ue(k);
                        u = null == n ? h : $fca22c47c90d13d9$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fca22c47c90d13d9$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fca22c47c90d13d9$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fca22c47c90d13d9$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fca22c47c90d13d9$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fca22c47c90d13d9$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fca22c47c90d13d9$var$vf(t);
                                x = $fca22c47c90d13d9$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fca22c47c90d13d9$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fca22c47c90d13d9$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fca22c47c90d13d9$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fca22c47c90d13d9$var$ve;
                else if ($fca22c47c90d13d9$var$me(h)) {
                    if ($fca22c47c90d13d9$var$we) na = $fca22c47c90d13d9$var$Fe;
                    else {
                        na = $fca22c47c90d13d9$var$De;
                        var xa = $fca22c47c90d13d9$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fca22c47c90d13d9$var$Ee);
                if (na && (na = na(a, d))) {
                    $fca22c47c90d13d9$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fca22c47c90d13d9$var$cb(h, "number", h.value);
            }
            xa = d ? $fca22c47c90d13d9$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fca22c47c90d13d9$var$me(xa) || "true" === xa.contentEditable) $fca22c47c90d13d9$var$Qe = xa, $fca22c47c90d13d9$var$Re = d, $fca22c47c90d13d9$var$Se = null;
                    break;
                case "focusout":
                    $fca22c47c90d13d9$var$Se = $fca22c47c90d13d9$var$Re = $fca22c47c90d13d9$var$Qe = null;
                    break;
                case "mousedown":
                    $fca22c47c90d13d9$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fca22c47c90d13d9$var$Te = !1;
                    $fca22c47c90d13d9$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fca22c47c90d13d9$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fca22c47c90d13d9$var$Ue(g, c, e);
            }
            var $a;
            if ($fca22c47c90d13d9$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fca22c47c90d13d9$var$ie ? $fca22c47c90d13d9$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fca22c47c90d13d9$var$de && "ko" !== c.locale && ($fca22c47c90d13d9$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fca22c47c90d13d9$var$ie && ($a = $fca22c47c90d13d9$var$nd()) : ($fca22c47c90d13d9$var$kd = e, $fca22c47c90d13d9$var$ld = "value" in $fca22c47c90d13d9$var$kd ? $fca22c47c90d13d9$var$kd.value : $fca22c47c90d13d9$var$kd.textContent, $fca22c47c90d13d9$var$ie = !0)), xa = $fca22c47c90d13d9$var$oe(d, ba), 0 < xa.length && (ba = new $fca22c47c90d13d9$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fca22c47c90d13d9$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fca22c47c90d13d9$var$ce ? $fca22c47c90d13d9$var$je(a, c) : $fca22c47c90d13d9$var$ke(a, c)) d = $fca22c47c90d13d9$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fca22c47c90d13d9$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fca22c47c90d13d9$var$se(g, b);
    });
}
function $fca22c47c90d13d9$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fca22c47c90d13d9$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fca22c47c90d13d9$var$Kb(a, c), null != f && d.unshift($fca22c47c90d13d9$var$tf(a, f, e)), f = $fca22c47c90d13d9$var$Kb(a, b), null != f && d.push($fca22c47c90d13d9$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fca22c47c90d13d9$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fca22c47c90d13d9$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fca22c47c90d13d9$var$Kb(c, f), null != k && g.unshift($fca22c47c90d13d9$var$tf(c, k, h))) : e || (k = $fca22c47c90d13d9$var$Kb(c, f), null != k && g.push($fca22c47c90d13d9$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fca22c47c90d13d9$var$xf = /\r\n?/g, $fca22c47c90d13d9$var$yf = /\u0000|\uFFFD/g;
function $fca22c47c90d13d9$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fca22c47c90d13d9$var$xf, "\n").replace($fca22c47c90d13d9$var$yf, "");
}
function $fca22c47c90d13d9$var$Af(a, b, c) {
    b = $fca22c47c90d13d9$var$zf(b);
    if ($fca22c47c90d13d9$var$zf(a) !== b && c) throw Error($fca22c47c90d13d9$var$p(425));
}
function $fca22c47c90d13d9$var$Bf() {}
var $fca22c47c90d13d9$var$Cf = null, $fca22c47c90d13d9$var$Df = null;
function $fca22c47c90d13d9$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fca22c47c90d13d9$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fca22c47c90d13d9$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fca22c47c90d13d9$var$Hf = "function" === typeof Promise ? Promise : void 0, $fca22c47c90d13d9$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fca22c47c90d13d9$var$Hf ? function(a) {
    return $fca22c47c90d13d9$var$Hf.resolve(null).then(a).catch($fca22c47c90d13d9$var$If);
} : $fca22c47c90d13d9$var$Ff;
function $fca22c47c90d13d9$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fca22c47c90d13d9$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fca22c47c90d13d9$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fca22c47c90d13d9$var$bd(b);
}
function $fca22c47c90d13d9$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fca22c47c90d13d9$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fca22c47c90d13d9$var$Nf = Math.random().toString(36).slice(2), $fca22c47c90d13d9$var$Of = "__reactFiber$" + $fca22c47c90d13d9$var$Nf, $fca22c47c90d13d9$var$Pf = "__reactProps$" + $fca22c47c90d13d9$var$Nf, $fca22c47c90d13d9$var$uf = "__reactContainer$" + $fca22c47c90d13d9$var$Nf, $fca22c47c90d13d9$var$of = "__reactEvents$" + $fca22c47c90d13d9$var$Nf, $fca22c47c90d13d9$var$Qf = "__reactListeners$" + $fca22c47c90d13d9$var$Nf, $fca22c47c90d13d9$var$Rf = "__reactHandles$" + $fca22c47c90d13d9$var$Nf;
function $fca22c47c90d13d9$var$Wc(a) {
    var b = a[$fca22c47c90d13d9$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fca22c47c90d13d9$var$uf] || c[$fca22c47c90d13d9$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fca22c47c90d13d9$var$Mf(a); null !== a;){
                if (c = a[$fca22c47c90d13d9$var$Of]) return c;
                a = $fca22c47c90d13d9$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fca22c47c90d13d9$var$Cb(a) {
    a = a[$fca22c47c90d13d9$var$Of] || a[$fca22c47c90d13d9$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fca22c47c90d13d9$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fca22c47c90d13d9$var$p(33));
}
function $fca22c47c90d13d9$var$Db(a) {
    return a[$fca22c47c90d13d9$var$Pf] || null;
}
var $fca22c47c90d13d9$var$Sf = [], $fca22c47c90d13d9$var$Tf = -1;
function $fca22c47c90d13d9$var$Uf(a) {
    return {
        current: a
    };
}
function $fca22c47c90d13d9$var$E(a) {
    0 > $fca22c47c90d13d9$var$Tf || (a.current = $fca22c47c90d13d9$var$Sf[$fca22c47c90d13d9$var$Tf], $fca22c47c90d13d9$var$Sf[$fca22c47c90d13d9$var$Tf] = null, $fca22c47c90d13d9$var$Tf--);
}
function $fca22c47c90d13d9$var$G(a, b) {
    $fca22c47c90d13d9$var$Tf++;
    $fca22c47c90d13d9$var$Sf[$fca22c47c90d13d9$var$Tf] = a.current;
    a.current = b;
}
var $fca22c47c90d13d9$var$Vf = {}, $fca22c47c90d13d9$var$H = $fca22c47c90d13d9$var$Uf($fca22c47c90d13d9$var$Vf), $fca22c47c90d13d9$var$Wf = $fca22c47c90d13d9$var$Uf(!1), $fca22c47c90d13d9$var$Xf = $fca22c47c90d13d9$var$Vf;
function $fca22c47c90d13d9$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fca22c47c90d13d9$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fca22c47c90d13d9$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fca22c47c90d13d9$var$$f() {
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wf);
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$H);
}
function $fca22c47c90d13d9$var$ag(a, b, c) {
    if ($fca22c47c90d13d9$var$H.current !== $fca22c47c90d13d9$var$Vf) throw Error($fca22c47c90d13d9$var$p(168));
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$H, b);
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$Wf, c);
}
function $fca22c47c90d13d9$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fca22c47c90d13d9$var$p(108, $fca22c47c90d13d9$var$Ra(a) || "Unknown", e));
    return $fca22c47c90d13d9$var$A({}, c, d);
}
function $fca22c47c90d13d9$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fca22c47c90d13d9$var$Vf;
    $fca22c47c90d13d9$var$Xf = $fca22c47c90d13d9$var$H.current;
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$H, a);
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$Wf, $fca22c47c90d13d9$var$Wf.current);
    return !0;
}
function $fca22c47c90d13d9$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fca22c47c90d13d9$var$p(169));
    c ? (a = $fca22c47c90d13d9$var$bg(a, b, $fca22c47c90d13d9$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wf), $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$H), $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$H, a)) : $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wf);
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$Wf, c);
}
var $fca22c47c90d13d9$var$eg = null, $fca22c47c90d13d9$var$fg = !1, $fca22c47c90d13d9$var$gg = !1;
function $fca22c47c90d13d9$var$hg(a) {
    null === $fca22c47c90d13d9$var$eg ? $fca22c47c90d13d9$var$eg = [
        a
    ] : $fca22c47c90d13d9$var$eg.push(a);
}
function $fca22c47c90d13d9$var$ig(a) {
    $fca22c47c90d13d9$var$fg = !0;
    $fca22c47c90d13d9$var$hg(a);
}
function $fca22c47c90d13d9$var$jg() {
    if (!$fca22c47c90d13d9$var$gg && null !== $fca22c47c90d13d9$var$eg) {
        $fca22c47c90d13d9$var$gg = !0;
        var a = 0, b = $fca22c47c90d13d9$var$C;
        try {
            var c = $fca22c47c90d13d9$var$eg;
            for($fca22c47c90d13d9$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fca22c47c90d13d9$var$eg = null;
            $fca22c47c90d13d9$var$fg = !1;
        } catch (e) {
            throw null !== $fca22c47c90d13d9$var$eg && ($fca22c47c90d13d9$var$eg = $fca22c47c90d13d9$var$eg.slice(a + 1)), $fca22c47c90d13d9$var$ac($fca22c47c90d13d9$var$fc, $fca22c47c90d13d9$var$jg), e;
        } finally{
            $fca22c47c90d13d9$var$C = b, $fca22c47c90d13d9$var$gg = !1;
        }
    }
    return null;
}
var $fca22c47c90d13d9$var$kg = [], $fca22c47c90d13d9$var$lg = 0, $fca22c47c90d13d9$var$mg = null, $fca22c47c90d13d9$var$ng = 0, $fca22c47c90d13d9$var$og = [], $fca22c47c90d13d9$var$pg = 0, $fca22c47c90d13d9$var$qg = null, $fca22c47c90d13d9$var$rg = 1, $fca22c47c90d13d9$var$sg = "";
function $fca22c47c90d13d9$var$tg(a, b) {
    $fca22c47c90d13d9$var$kg[$fca22c47c90d13d9$var$lg++] = $fca22c47c90d13d9$var$ng;
    $fca22c47c90d13d9$var$kg[$fca22c47c90d13d9$var$lg++] = $fca22c47c90d13d9$var$mg;
    $fca22c47c90d13d9$var$mg = a;
    $fca22c47c90d13d9$var$ng = b;
}
function $fca22c47c90d13d9$var$ug(a, b, c) {
    $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg++] = $fca22c47c90d13d9$var$rg;
    $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg++] = $fca22c47c90d13d9$var$sg;
    $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg++] = $fca22c47c90d13d9$var$qg;
    $fca22c47c90d13d9$var$qg = a;
    var d = $fca22c47c90d13d9$var$rg;
    a = $fca22c47c90d13d9$var$sg;
    var e = 32 - $fca22c47c90d13d9$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fca22c47c90d13d9$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fca22c47c90d13d9$var$rg = 1 << 32 - $fca22c47c90d13d9$var$oc(b) + e | c << e | d;
        $fca22c47c90d13d9$var$sg = f + a;
    } else $fca22c47c90d13d9$var$rg = 1 << f | c << e | d, $fca22c47c90d13d9$var$sg = a;
}
function $fca22c47c90d13d9$var$vg(a) {
    null !== a.return && ($fca22c47c90d13d9$var$tg(a, 1), $fca22c47c90d13d9$var$ug(a, 1, 0));
}
function $fca22c47c90d13d9$var$wg(a) {
    for(; a === $fca22c47c90d13d9$var$mg;)$fca22c47c90d13d9$var$mg = $fca22c47c90d13d9$var$kg[--$fca22c47c90d13d9$var$lg], $fca22c47c90d13d9$var$kg[$fca22c47c90d13d9$var$lg] = null, $fca22c47c90d13d9$var$ng = $fca22c47c90d13d9$var$kg[--$fca22c47c90d13d9$var$lg], $fca22c47c90d13d9$var$kg[$fca22c47c90d13d9$var$lg] = null;
    for(; a === $fca22c47c90d13d9$var$qg;)$fca22c47c90d13d9$var$qg = $fca22c47c90d13d9$var$og[--$fca22c47c90d13d9$var$pg], $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg] = null, $fca22c47c90d13d9$var$sg = $fca22c47c90d13d9$var$og[--$fca22c47c90d13d9$var$pg], $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg] = null, $fca22c47c90d13d9$var$rg = $fca22c47c90d13d9$var$og[--$fca22c47c90d13d9$var$pg], $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg] = null;
}
var $fca22c47c90d13d9$var$xg = null, $fca22c47c90d13d9$var$yg = null, $fca22c47c90d13d9$var$I = !1, $fca22c47c90d13d9$var$zg = null;
function $fca22c47c90d13d9$var$Ag(a, b) {
    var c = $fca22c47c90d13d9$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fca22c47c90d13d9$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fca22c47c90d13d9$var$xg = a, $fca22c47c90d13d9$var$yg = $fca22c47c90d13d9$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fca22c47c90d13d9$var$xg = a, $fca22c47c90d13d9$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fca22c47c90d13d9$var$qg ? {
                id: $fca22c47c90d13d9$var$rg,
                overflow: $fca22c47c90d13d9$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fca22c47c90d13d9$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fca22c47c90d13d9$var$xg = a, $fca22c47c90d13d9$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fca22c47c90d13d9$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fca22c47c90d13d9$var$Eg(a) {
    if ($fca22c47c90d13d9$var$I) {
        var b = $fca22c47c90d13d9$var$yg;
        if (b) {
            var c = b;
            if (!$fca22c47c90d13d9$var$Cg(a, b)) {
                if ($fca22c47c90d13d9$var$Dg(a)) throw Error($fca22c47c90d13d9$var$p(418));
                b = $fca22c47c90d13d9$var$Lf(c.nextSibling);
                var d = $fca22c47c90d13d9$var$xg;
                b && $fca22c47c90d13d9$var$Cg(a, b) ? $fca22c47c90d13d9$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fca22c47c90d13d9$var$I = !1, $fca22c47c90d13d9$var$xg = a);
            }
        } else {
            if ($fca22c47c90d13d9$var$Dg(a)) throw Error($fca22c47c90d13d9$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fca22c47c90d13d9$var$I = !1;
            $fca22c47c90d13d9$var$xg = a;
        }
    }
}
function $fca22c47c90d13d9$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fca22c47c90d13d9$var$xg = a;
}
function $fca22c47c90d13d9$var$Gg(a) {
    if (a !== $fca22c47c90d13d9$var$xg) return !1;
    if (!$fca22c47c90d13d9$var$I) return $fca22c47c90d13d9$var$Fg(a), $fca22c47c90d13d9$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fca22c47c90d13d9$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fca22c47c90d13d9$var$yg)) {
        if ($fca22c47c90d13d9$var$Dg(a)) throw $fca22c47c90d13d9$var$Hg(), Error($fca22c47c90d13d9$var$p(418));
        for(; b;)$fca22c47c90d13d9$var$Ag(a, b), b = $fca22c47c90d13d9$var$Lf(b.nextSibling);
    }
    $fca22c47c90d13d9$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fca22c47c90d13d9$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fca22c47c90d13d9$var$yg = $fca22c47c90d13d9$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fca22c47c90d13d9$var$yg = null;
        }
    } else $fca22c47c90d13d9$var$yg = $fca22c47c90d13d9$var$xg ? $fca22c47c90d13d9$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fca22c47c90d13d9$var$Hg() {
    for(var a = $fca22c47c90d13d9$var$yg; a;)a = $fca22c47c90d13d9$var$Lf(a.nextSibling);
}
function $fca22c47c90d13d9$var$Ig() {
    $fca22c47c90d13d9$var$yg = $fca22c47c90d13d9$var$xg = null;
    $fca22c47c90d13d9$var$I = !1;
}
function $fca22c47c90d13d9$var$Jg(a) {
    null === $fca22c47c90d13d9$var$zg ? $fca22c47c90d13d9$var$zg = [
        a
    ] : $fca22c47c90d13d9$var$zg.push(a);
}
var $fca22c47c90d13d9$var$Kg = $fca22c47c90d13d9$var$ua.ReactCurrentBatchConfig;
function $fca22c47c90d13d9$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fca22c47c90d13d9$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fca22c47c90d13d9$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fca22c47c90d13d9$var$p(284));
        if (!c._owner) throw Error($fca22c47c90d13d9$var$p(290, a));
    }
    return a;
}
function $fca22c47c90d13d9$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fca22c47c90d13d9$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fca22c47c90d13d9$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $fca22c47c90d13d9$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fca22c47c90d13d9$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fca22c47c90d13d9$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fca22c47c90d13d9$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fca22c47c90d13d9$var$Ha && $fca22c47c90d13d9$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $fca22c47c90d13d9$var$Lg(a, b, c), d.return = a, d;
        d = $fca22c47c90d13d9$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fca22c47c90d13d9$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fca22c47c90d13d9$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fca22c47c90d13d9$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fca22c47c90d13d9$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fca22c47c90d13d9$var$va:
                    return c = $fca22c47c90d13d9$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $fca22c47c90d13d9$var$Lg(a, null, b), c.return = a, c;
                case $fca22c47c90d13d9$var$wa:
                    return b = $fca22c47c90d13d9$var$Sg(b, a.mode, c), b.return = a, b;
                case $fca22c47c90d13d9$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fca22c47c90d13d9$var$eb(b) || $fca22c47c90d13d9$var$Ka(b)) return b = $fca22c47c90d13d9$var$Tg(b, a.mode, c, null), b.return = a, b;
            $fca22c47c90d13d9$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fca22c47c90d13d9$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fca22c47c90d13d9$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fca22c47c90d13d9$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fca22c47c90d13d9$var$eb(c) || $fca22c47c90d13d9$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fca22c47c90d13d9$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fca22c47c90d13d9$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fca22c47c90d13d9$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fca22c47c90d13d9$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fca22c47c90d13d9$var$eb(d) || $fca22c47c90d13d9$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fca22c47c90d13d9$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fca22c47c90d13d9$var$I && $fca22c47c90d13d9$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fca22c47c90d13d9$var$I && $fca22c47c90d13d9$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fca22c47c90d13d9$var$I && $fca22c47c90d13d9$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fca22c47c90d13d9$var$Ka(h);
        if ("function" !== typeof l) throw Error($fca22c47c90d13d9$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fca22c47c90d13d9$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fca22c47c90d13d9$var$I && $fca22c47c90d13d9$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fca22c47c90d13d9$var$I && $fca22c47c90d13d9$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fca22c47c90d13d9$var$I && $fca22c47c90d13d9$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fca22c47c90d13d9$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fca22c47c90d13d9$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fca22c47c90d13d9$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fca22c47c90d13d9$var$Ha && $fca22c47c90d13d9$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fca22c47c90d13d9$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fca22c47c90d13d9$var$ya ? (d = $fca22c47c90d13d9$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fca22c47c90d13d9$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $fca22c47c90d13d9$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fca22c47c90d13d9$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fca22c47c90d13d9$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fca22c47c90d13d9$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fca22c47c90d13d9$var$eb(f)) return n(a, d, f, h);
            if ($fca22c47c90d13d9$var$Ka(f)) return t(a, d, f, h);
            $fca22c47c90d13d9$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fca22c47c90d13d9$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fca22c47c90d13d9$var$Ug = $fca22c47c90d13d9$var$Og(!0), $fca22c47c90d13d9$var$Vg = $fca22c47c90d13d9$var$Og(!1), $fca22c47c90d13d9$var$Wg = $fca22c47c90d13d9$var$Uf(null), $fca22c47c90d13d9$var$Xg = null, $fca22c47c90d13d9$var$Yg = null, $fca22c47c90d13d9$var$Zg = null;
function $fca22c47c90d13d9$var$$g() {
    $fca22c47c90d13d9$var$Zg = $fca22c47c90d13d9$var$Yg = $fca22c47c90d13d9$var$Xg = null;
}
function $fca22c47c90d13d9$var$ah(a) {
    var b = $fca22c47c90d13d9$var$Wg.current;
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wg);
    a._currentValue = b;
}
function $fca22c47c90d13d9$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fca22c47c90d13d9$var$ch(a, b) {
    $fca22c47c90d13d9$var$Xg = a;
    $fca22c47c90d13d9$var$Zg = $fca22c47c90d13d9$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fca22c47c90d13d9$var$dh = !0), a.firstContext = null);
}
function $fca22c47c90d13d9$var$eh(a) {
    var b = a._currentValue;
    if ($fca22c47c90d13d9$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fca22c47c90d13d9$var$Yg) {
            if (null === $fca22c47c90d13d9$var$Xg) throw Error($fca22c47c90d13d9$var$p(308));
            $fca22c47c90d13d9$var$Yg = a;
            $fca22c47c90d13d9$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fca22c47c90d13d9$var$Yg = $fca22c47c90d13d9$var$Yg.next = a;
    }
    return b;
}
var $fca22c47c90d13d9$var$fh = null;
function $fca22c47c90d13d9$var$gh(a) {
    null === $fca22c47c90d13d9$var$fh ? $fca22c47c90d13d9$var$fh = [
        a
    ] : $fca22c47c90d13d9$var$fh.push(a);
}
function $fca22c47c90d13d9$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fca22c47c90d13d9$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fca22c47c90d13d9$var$ih(a, d);
}
function $fca22c47c90d13d9$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fca22c47c90d13d9$var$jh = !1;
function $fca22c47c90d13d9$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fca22c47c90d13d9$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fca22c47c90d13d9$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fca22c47c90d13d9$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fca22c47c90d13d9$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fca22c47c90d13d9$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fca22c47c90d13d9$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fca22c47c90d13d9$var$ih(a, c);
}
function $fca22c47c90d13d9$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fca22c47c90d13d9$var$Cc(a, c);
    }
}
function $fca22c47c90d13d9$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fca22c47c90d13d9$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $fca22c47c90d13d9$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fca22c47c90d13d9$var$A({}, q, r);
                            break a;
                        case 2:
                            $fca22c47c90d13d9$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fca22c47c90d13d9$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fca22c47c90d13d9$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fca22c47c90d13d9$var$p(191, e));
            e.call(d);
        }
    }
}
var $fca22c47c90d13d9$var$th = {}, $fca22c47c90d13d9$var$uh = $fca22c47c90d13d9$var$Uf($fca22c47c90d13d9$var$th), $fca22c47c90d13d9$var$vh = $fca22c47c90d13d9$var$Uf($fca22c47c90d13d9$var$th), $fca22c47c90d13d9$var$wh = $fca22c47c90d13d9$var$Uf($fca22c47c90d13d9$var$th);
function $fca22c47c90d13d9$var$xh(a) {
    if (a === $fca22c47c90d13d9$var$th) throw Error($fca22c47c90d13d9$var$p(174));
    return a;
}
function $fca22c47c90d13d9$var$yh(a, b) {
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$wh, b);
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$vh, a);
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$uh, $fca22c47c90d13d9$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fca22c47c90d13d9$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fca22c47c90d13d9$var$lb(b, a);
    }
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$uh);
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$uh, b);
}
function $fca22c47c90d13d9$var$zh() {
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$uh);
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$vh);
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$wh);
}
function $fca22c47c90d13d9$var$Ah(a) {
    $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$wh.current);
    var b = $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$uh.current);
    var c = $fca22c47c90d13d9$var$lb(b, a.type);
    b !== c && ($fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$vh, a), $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$uh, c));
}
function $fca22c47c90d13d9$var$Bh(a) {
    $fca22c47c90d13d9$var$vh.current === a && ($fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$uh), $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$vh));
}
var $fca22c47c90d13d9$var$L = $fca22c47c90d13d9$var$Uf(0);
function $fca22c47c90d13d9$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fca22c47c90d13d9$var$Dh = [];
function $fca22c47c90d13d9$var$Eh() {
    for(var a = 0; a < $fca22c47c90d13d9$var$Dh.length; a++)$fca22c47c90d13d9$var$Dh[a]._workInProgressVersionPrimary = null;
    $fca22c47c90d13d9$var$Dh.length = 0;
}
var $fca22c47c90d13d9$var$Fh = $fca22c47c90d13d9$var$ua.ReactCurrentDispatcher, $fca22c47c90d13d9$var$Gh = $fca22c47c90d13d9$var$ua.ReactCurrentBatchConfig, $fca22c47c90d13d9$var$Hh = 0, $fca22c47c90d13d9$var$M = null, $fca22c47c90d13d9$var$N = null, $fca22c47c90d13d9$var$O = null, $fca22c47c90d13d9$var$Ih = !1, $fca22c47c90d13d9$var$Jh = !1, $fca22c47c90d13d9$var$Kh = 0, $fca22c47c90d13d9$var$Lh = 0;
function $fca22c47c90d13d9$var$P() {
    throw Error($fca22c47c90d13d9$var$p(321));
}
function $fca22c47c90d13d9$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fca22c47c90d13d9$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fca22c47c90d13d9$var$Nh(a, b, c, d, e, f) {
    $fca22c47c90d13d9$var$Hh = f;
    $fca22c47c90d13d9$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fca22c47c90d13d9$var$Fh.current = null === a || null === a.memoizedState ? $fca22c47c90d13d9$var$Oh : $fca22c47c90d13d9$var$Ph;
    a = c(d, e);
    if ($fca22c47c90d13d9$var$Jh) {
        f = 0;
        do {
            $fca22c47c90d13d9$var$Jh = !1;
            $fca22c47c90d13d9$var$Kh = 0;
            if (25 <= f) throw Error($fca22c47c90d13d9$var$p(301));
            f += 1;
            $fca22c47c90d13d9$var$O = $fca22c47c90d13d9$var$N = null;
            b.updateQueue = null;
            $fca22c47c90d13d9$var$Fh.current = $fca22c47c90d13d9$var$Qh;
            a = c(d, e);
        }while ($fca22c47c90d13d9$var$Jh);
    }
    $fca22c47c90d13d9$var$Fh.current = $fca22c47c90d13d9$var$Rh;
    b = null !== $fca22c47c90d13d9$var$N && null !== $fca22c47c90d13d9$var$N.next;
    $fca22c47c90d13d9$var$Hh = 0;
    $fca22c47c90d13d9$var$O = $fca22c47c90d13d9$var$N = $fca22c47c90d13d9$var$M = null;
    $fca22c47c90d13d9$var$Ih = !1;
    if (b) throw Error($fca22c47c90d13d9$var$p(300));
    return a;
}
function $fca22c47c90d13d9$var$Sh() {
    var a = 0 !== $fca22c47c90d13d9$var$Kh;
    $fca22c47c90d13d9$var$Kh = 0;
    return a;
}
function $fca22c47c90d13d9$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fca22c47c90d13d9$var$O ? $fca22c47c90d13d9$var$M.memoizedState = $fca22c47c90d13d9$var$O = a : $fca22c47c90d13d9$var$O = $fca22c47c90d13d9$var$O.next = a;
    return $fca22c47c90d13d9$var$O;
}
function $fca22c47c90d13d9$var$Uh() {
    if (null === $fca22c47c90d13d9$var$N) {
        var a = $fca22c47c90d13d9$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fca22c47c90d13d9$var$N.next;
    var b = null === $fca22c47c90d13d9$var$O ? $fca22c47c90d13d9$var$M.memoizedState : $fca22c47c90d13d9$var$O.next;
    if (null !== b) $fca22c47c90d13d9$var$O = b, $fca22c47c90d13d9$var$N = a;
    else {
        if (null === a) throw Error($fca22c47c90d13d9$var$p(310));
        $fca22c47c90d13d9$var$N = a;
        a = {
            memoizedState: $fca22c47c90d13d9$var$N.memoizedState,
            baseState: $fca22c47c90d13d9$var$N.baseState,
            baseQueue: $fca22c47c90d13d9$var$N.baseQueue,
            queue: $fca22c47c90d13d9$var$N.queue,
            next: null
        };
        null === $fca22c47c90d13d9$var$O ? $fca22c47c90d13d9$var$M.memoizedState = $fca22c47c90d13d9$var$O = a : $fca22c47c90d13d9$var$O = $fca22c47c90d13d9$var$O.next = a;
    }
    return $fca22c47c90d13d9$var$O;
}
function $fca22c47c90d13d9$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fca22c47c90d13d9$var$Wh(a) {
    var b = $fca22c47c90d13d9$var$Uh(), c = b.queue;
    if (null === c) throw Error($fca22c47c90d13d9$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fca22c47c90d13d9$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fca22c47c90d13d9$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fca22c47c90d13d9$var$M.lanes |= m;
                $fca22c47c90d13d9$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fca22c47c90d13d9$var$He(d, b.memoizedState) || ($fca22c47c90d13d9$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fca22c47c90d13d9$var$M.lanes |= f, $fca22c47c90d13d9$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fca22c47c90d13d9$var$Xh(a) {
    var b = $fca22c47c90d13d9$var$Uh(), c = b.queue;
    if (null === c) throw Error($fca22c47c90d13d9$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fca22c47c90d13d9$var$He(f, b.memoizedState) || ($fca22c47c90d13d9$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fca22c47c90d13d9$var$Yh() {}
function $fca22c47c90d13d9$var$Zh(a, b) {
    var c = $fca22c47c90d13d9$var$M, d = $fca22c47c90d13d9$var$Uh(), e = b(), f = !$fca22c47c90d13d9$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fca22c47c90d13d9$var$dh = !0);
    d = d.queue;
    $fca22c47c90d13d9$var$$h($fca22c47c90d13d9$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fca22c47c90d13d9$var$O && $fca22c47c90d13d9$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fca22c47c90d13d9$var$bi(9, $fca22c47c90d13d9$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $fca22c47c90d13d9$var$Q) throw Error($fca22c47c90d13d9$var$p(349));
        0 !== ($fca22c47c90d13d9$var$Hh & 30) || $fca22c47c90d13d9$var$di(c, b, e);
    }
    return e;
}
function $fca22c47c90d13d9$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fca22c47c90d13d9$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fca22c47c90d13d9$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fca22c47c90d13d9$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fca22c47c90d13d9$var$ei(b) && $fca22c47c90d13d9$var$fi(a);
}
function $fca22c47c90d13d9$var$ai(a, b, c) {
    return c(function() {
        $fca22c47c90d13d9$var$ei(b) && $fca22c47c90d13d9$var$fi(a);
    });
}
function $fca22c47c90d13d9$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fca22c47c90d13d9$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fca22c47c90d13d9$var$fi(a) {
    var b = $fca22c47c90d13d9$var$ih(a, 1);
    null !== b && $fca22c47c90d13d9$var$gi(b, a, 1, -1);
}
function $fca22c47c90d13d9$var$hi(a) {
    var b = $fca22c47c90d13d9$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fca22c47c90d13d9$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fca22c47c90d13d9$var$ii.bind(null, $fca22c47c90d13d9$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fca22c47c90d13d9$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fca22c47c90d13d9$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fca22c47c90d13d9$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fca22c47c90d13d9$var$ji() {
    return $fca22c47c90d13d9$var$Uh().memoizedState;
}
function $fca22c47c90d13d9$var$ki(a, b, c, d) {
    var e = $fca22c47c90d13d9$var$Th();
    $fca22c47c90d13d9$var$M.flags |= a;
    e.memoizedState = $fca22c47c90d13d9$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fca22c47c90d13d9$var$li(a, b, c, d) {
    var e = $fca22c47c90d13d9$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fca22c47c90d13d9$var$N) {
        var g = $fca22c47c90d13d9$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $fca22c47c90d13d9$var$Mh(d, g.deps)) {
            e.memoizedState = $fca22c47c90d13d9$var$bi(b, c, f, d);
            return;
        }
    }
    $fca22c47c90d13d9$var$M.flags |= a;
    e.memoizedState = $fca22c47c90d13d9$var$bi(1 | b, c, f, d);
}
function $fca22c47c90d13d9$var$mi(a, b) {
    return $fca22c47c90d13d9$var$ki(8390656, 8, a, b);
}
function $fca22c47c90d13d9$var$$h(a, b) {
    return $fca22c47c90d13d9$var$li(2048, 8, a, b);
}
function $fca22c47c90d13d9$var$ni(a, b) {
    return $fca22c47c90d13d9$var$li(4, 2, a, b);
}
function $fca22c47c90d13d9$var$oi(a, b) {
    return $fca22c47c90d13d9$var$li(4, 4, a, b);
}
function $fca22c47c90d13d9$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fca22c47c90d13d9$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fca22c47c90d13d9$var$li(4, 4, $fca22c47c90d13d9$var$pi.bind(null, b, a), c);
}
function $fca22c47c90d13d9$var$ri() {}
function $fca22c47c90d13d9$var$si(a, b) {
    var c = $fca22c47c90d13d9$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fca22c47c90d13d9$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fca22c47c90d13d9$var$ti(a, b) {
    var c = $fca22c47c90d13d9$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fca22c47c90d13d9$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fca22c47c90d13d9$var$ui(a, b, c) {
    if (0 === ($fca22c47c90d13d9$var$Hh & 21)) return a.baseState && (a.baseState = !1, $fca22c47c90d13d9$var$dh = !0), a.memoizedState = c;
    $fca22c47c90d13d9$var$He(c, b) || (c = $fca22c47c90d13d9$var$yc(), $fca22c47c90d13d9$var$M.lanes |= c, $fca22c47c90d13d9$var$rh |= c, a.baseState = !0);
    return b;
}
function $fca22c47c90d13d9$var$vi(a, b) {
    var c = $fca22c47c90d13d9$var$C;
    $fca22c47c90d13d9$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fca22c47c90d13d9$var$Gh.transition;
    $fca22c47c90d13d9$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fca22c47c90d13d9$var$C = c, $fca22c47c90d13d9$var$Gh.transition = d;
    }
}
function $fca22c47c90d13d9$var$wi() {
    return $fca22c47c90d13d9$var$Uh().memoizedState;
}
function $fca22c47c90d13d9$var$xi(a, b, c) {
    var d = $fca22c47c90d13d9$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fca22c47c90d13d9$var$zi(a)) $fca22c47c90d13d9$var$Ai(b, c);
    else if (c = $fca22c47c90d13d9$var$hh(a, b, c, d), null !== c) {
        var e = $fca22c47c90d13d9$var$R();
        $fca22c47c90d13d9$var$gi(c, a, d, e);
        $fca22c47c90d13d9$var$Bi(c, b, d);
    }
}
function $fca22c47c90d13d9$var$ii(a, b, c) {
    var d = $fca22c47c90d13d9$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fca22c47c90d13d9$var$zi(a)) $fca22c47c90d13d9$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fca22c47c90d13d9$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fca22c47c90d13d9$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fca22c47c90d13d9$var$hh(a, b, e, d);
        null !== c && (e = $fca22c47c90d13d9$var$R(), $fca22c47c90d13d9$var$gi(c, a, d, e), $fca22c47c90d13d9$var$Bi(c, b, d));
    }
}
function $fca22c47c90d13d9$var$zi(a) {
    var b = a.alternate;
    return a === $fca22c47c90d13d9$var$M || null !== b && b === $fca22c47c90d13d9$var$M;
}
function $fca22c47c90d13d9$var$Ai(a, b) {
    $fca22c47c90d13d9$var$Jh = $fca22c47c90d13d9$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fca22c47c90d13d9$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fca22c47c90d13d9$var$Cc(a, c);
    }
}
var $fca22c47c90d13d9$var$Rh = {
    readContext: $fca22c47c90d13d9$var$eh,
    useCallback: $fca22c47c90d13d9$var$P,
    useContext: $fca22c47c90d13d9$var$P,
    useEffect: $fca22c47c90d13d9$var$P,
    useImperativeHandle: $fca22c47c90d13d9$var$P,
    useInsertionEffect: $fca22c47c90d13d9$var$P,
    useLayoutEffect: $fca22c47c90d13d9$var$P,
    useMemo: $fca22c47c90d13d9$var$P,
    useReducer: $fca22c47c90d13d9$var$P,
    useRef: $fca22c47c90d13d9$var$P,
    useState: $fca22c47c90d13d9$var$P,
    useDebugValue: $fca22c47c90d13d9$var$P,
    useDeferredValue: $fca22c47c90d13d9$var$P,
    useTransition: $fca22c47c90d13d9$var$P,
    useMutableSource: $fca22c47c90d13d9$var$P,
    useSyncExternalStore: $fca22c47c90d13d9$var$P,
    useId: $fca22c47c90d13d9$var$P,
    unstable_isNewReconciler: !1
}, $fca22c47c90d13d9$var$Oh = {
    readContext: $fca22c47c90d13d9$var$eh,
    useCallback: function(a, b) {
        $fca22c47c90d13d9$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fca22c47c90d13d9$var$eh,
    useEffect: $fca22c47c90d13d9$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fca22c47c90d13d9$var$ki(4194308, 4, $fca22c47c90d13d9$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fca22c47c90d13d9$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fca22c47c90d13d9$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fca22c47c90d13d9$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fca22c47c90d13d9$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fca22c47c90d13d9$var$xi.bind(null, $fca22c47c90d13d9$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fca22c47c90d13d9$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fca22c47c90d13d9$var$hi,
    useDebugValue: $fca22c47c90d13d9$var$ri,
    useDeferredValue: function(a) {
        return $fca22c47c90d13d9$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $fca22c47c90d13d9$var$hi(!1), b = a[0];
        a = $fca22c47c90d13d9$var$vi.bind(null, a[1]);
        $fca22c47c90d13d9$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fca22c47c90d13d9$var$M, e = $fca22c47c90d13d9$var$Th();
        if ($fca22c47c90d13d9$var$I) {
            if (void 0 === c) throw Error($fca22c47c90d13d9$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fca22c47c90d13d9$var$Q) throw Error($fca22c47c90d13d9$var$p(349));
            0 !== ($fca22c47c90d13d9$var$Hh & 30) || $fca22c47c90d13d9$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fca22c47c90d13d9$var$mi($fca22c47c90d13d9$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fca22c47c90d13d9$var$bi(9, $fca22c47c90d13d9$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fca22c47c90d13d9$var$Th(), b = $fca22c47c90d13d9$var$Q.identifierPrefix;
        if ($fca22c47c90d13d9$var$I) {
            var c = $fca22c47c90d13d9$var$sg;
            var d = $fca22c47c90d13d9$var$rg;
            c = (d & ~(1 << 32 - $fca22c47c90d13d9$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fca22c47c90d13d9$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fca22c47c90d13d9$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fca22c47c90d13d9$var$Ph = {
    readContext: $fca22c47c90d13d9$var$eh,
    useCallback: $fca22c47c90d13d9$var$si,
    useContext: $fca22c47c90d13d9$var$eh,
    useEffect: $fca22c47c90d13d9$var$$h,
    useImperativeHandle: $fca22c47c90d13d9$var$qi,
    useInsertionEffect: $fca22c47c90d13d9$var$ni,
    useLayoutEffect: $fca22c47c90d13d9$var$oi,
    useMemo: $fca22c47c90d13d9$var$ti,
    useReducer: $fca22c47c90d13d9$var$Wh,
    useRef: $fca22c47c90d13d9$var$ji,
    useState: function() {
        return $fca22c47c90d13d9$var$Wh($fca22c47c90d13d9$var$Vh);
    },
    useDebugValue: $fca22c47c90d13d9$var$ri,
    useDeferredValue: function(a) {
        var b = $fca22c47c90d13d9$var$Uh();
        return $fca22c47c90d13d9$var$ui(b, $fca22c47c90d13d9$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fca22c47c90d13d9$var$Wh($fca22c47c90d13d9$var$Vh)[0], b = $fca22c47c90d13d9$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fca22c47c90d13d9$var$Yh,
    useSyncExternalStore: $fca22c47c90d13d9$var$Zh,
    useId: $fca22c47c90d13d9$var$wi,
    unstable_isNewReconciler: !1
}, $fca22c47c90d13d9$var$Qh = {
    readContext: $fca22c47c90d13d9$var$eh,
    useCallback: $fca22c47c90d13d9$var$si,
    useContext: $fca22c47c90d13d9$var$eh,
    useEffect: $fca22c47c90d13d9$var$$h,
    useImperativeHandle: $fca22c47c90d13d9$var$qi,
    useInsertionEffect: $fca22c47c90d13d9$var$ni,
    useLayoutEffect: $fca22c47c90d13d9$var$oi,
    useMemo: $fca22c47c90d13d9$var$ti,
    useReducer: $fca22c47c90d13d9$var$Xh,
    useRef: $fca22c47c90d13d9$var$ji,
    useState: function() {
        return $fca22c47c90d13d9$var$Xh($fca22c47c90d13d9$var$Vh);
    },
    useDebugValue: $fca22c47c90d13d9$var$ri,
    useDeferredValue: function(a) {
        var b = $fca22c47c90d13d9$var$Uh();
        return null === $fca22c47c90d13d9$var$N ? b.memoizedState = a : $fca22c47c90d13d9$var$ui(b, $fca22c47c90d13d9$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fca22c47c90d13d9$var$Xh($fca22c47c90d13d9$var$Vh)[0], b = $fca22c47c90d13d9$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fca22c47c90d13d9$var$Yh,
    useSyncExternalStore: $fca22c47c90d13d9$var$Zh,
    useId: $fca22c47c90d13d9$var$wi,
    unstable_isNewReconciler: !1
};
function $fca22c47c90d13d9$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $fca22c47c90d13d9$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $fca22c47c90d13d9$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fca22c47c90d13d9$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fca22c47c90d13d9$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fca22c47c90d13d9$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fca22c47c90d13d9$var$R(), e = $fca22c47c90d13d9$var$yi(a), f = $fca22c47c90d13d9$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fca22c47c90d13d9$var$nh(a, f, e);
        null !== b && ($fca22c47c90d13d9$var$gi(b, a, e, d), $fca22c47c90d13d9$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fca22c47c90d13d9$var$R(), e = $fca22c47c90d13d9$var$yi(a), f = $fca22c47c90d13d9$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fca22c47c90d13d9$var$nh(a, f, e);
        null !== b && ($fca22c47c90d13d9$var$gi(b, a, e, d), $fca22c47c90d13d9$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fca22c47c90d13d9$var$R(), d = $fca22c47c90d13d9$var$yi(a), e = $fca22c47c90d13d9$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fca22c47c90d13d9$var$nh(a, e, d);
        null !== b && ($fca22c47c90d13d9$var$gi(b, a, d, c), $fca22c47c90d13d9$var$oh(b, a, d));
    }
};
function $fca22c47c90d13d9$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fca22c47c90d13d9$var$Ie(c, d) || !$fca22c47c90d13d9$var$Ie(e, f) : !0;
}
function $fca22c47c90d13d9$var$Gi(a, b, c) {
    var d = !1, e = $fca22c47c90d13d9$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fca22c47c90d13d9$var$eh(f) : (e = $fca22c47c90d13d9$var$Zf(b) ? $fca22c47c90d13d9$var$Xf : $fca22c47c90d13d9$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fca22c47c90d13d9$var$Yf(a, e) : $fca22c47c90d13d9$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fca22c47c90d13d9$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fca22c47c90d13d9$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fca22c47c90d13d9$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $fca22c47c90d13d9$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $fca22c47c90d13d9$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fca22c47c90d13d9$var$eh(f) : (f = $fca22c47c90d13d9$var$Zf(b) ? $fca22c47c90d13d9$var$Xf : $fca22c47c90d13d9$var$H.current, e.context = $fca22c47c90d13d9$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fca22c47c90d13d9$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fca22c47c90d13d9$var$Ei.enqueueReplaceState(e, e.state, null), $fca22c47c90d13d9$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fca22c47c90d13d9$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $fca22c47c90d13d9$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fca22c47c90d13d9$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fca22c47c90d13d9$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fca22c47c90d13d9$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $fca22c47c90d13d9$var$Ni(a, b, c) {
    c = $fca22c47c90d13d9$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fca22c47c90d13d9$var$Oi || ($fca22c47c90d13d9$var$Oi = !0, $fca22c47c90d13d9$var$Pi = d);
        $fca22c47c90d13d9$var$Li(a, b);
    };
    return c;
}
function $fca22c47c90d13d9$var$Qi(a, b, c) {
    c = $fca22c47c90d13d9$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fca22c47c90d13d9$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fca22c47c90d13d9$var$Li(a, b);
        "function" !== typeof d && (null === $fca22c47c90d13d9$var$Ri ? $fca22c47c90d13d9$var$Ri = new Set([
            this
        ]) : $fca22c47c90d13d9$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fca22c47c90d13d9$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fca22c47c90d13d9$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fca22c47c90d13d9$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $fca22c47c90d13d9$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fca22c47c90d13d9$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fca22c47c90d13d9$var$mh(-1, 1), b.tag = 2, $fca22c47c90d13d9$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fca22c47c90d13d9$var$Wi = $fca22c47c90d13d9$var$ua.ReactCurrentOwner, $fca22c47c90d13d9$var$dh = !1;
function $fca22c47c90d13d9$var$Xi(a, b, c, d) {
    b.child = null === a ? $fca22c47c90d13d9$var$Vg(b, null, c, d) : $fca22c47c90d13d9$var$Ug(b, a.child, c, d);
}
function $fca22c47c90d13d9$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fca22c47c90d13d9$var$ch(b, e);
    d = $fca22c47c90d13d9$var$Nh(a, b, c, d, f, e);
    c = $fca22c47c90d13d9$var$Sh();
    if (null !== a && !$fca22c47c90d13d9$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fca22c47c90d13d9$var$Zi(a, b, e);
    $fca22c47c90d13d9$var$I && c && $fca22c47c90d13d9$var$vg(b);
    b.flags |= 1;
    $fca22c47c90d13d9$var$Xi(a, b, d, e);
    return b.child;
}
function $fca22c47c90d13d9$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fca22c47c90d13d9$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fca22c47c90d13d9$var$bj(a, b, f, d, e);
        a = $fca22c47c90d13d9$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fca22c47c90d13d9$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fca22c47c90d13d9$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $fca22c47c90d13d9$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fca22c47c90d13d9$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fca22c47c90d13d9$var$Ie(f, d) && a.ref === b.ref) {
            if ($fca22c47c90d13d9$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fca22c47c90d13d9$var$dh = !0);
            else return b.lanes = a.lanes, $fca22c47c90d13d9$var$Zi(a, b, e);
        }
    }
    return $fca22c47c90d13d9$var$cj(a, b, c, d, e);
}
function $fca22c47c90d13d9$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$ej, $fca22c47c90d13d9$var$fj), $fca22c47c90d13d9$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$ej, $fca22c47c90d13d9$var$fj), $fca22c47c90d13d9$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$ej, $fca22c47c90d13d9$var$fj);
            $fca22c47c90d13d9$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$ej, $fca22c47c90d13d9$var$fj), $fca22c47c90d13d9$var$fj |= d;
    $fca22c47c90d13d9$var$Xi(a, b, e, c);
    return b.child;
}
function $fca22c47c90d13d9$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fca22c47c90d13d9$var$cj(a, b, c, d, e) {
    var f = $fca22c47c90d13d9$var$Zf(c) ? $fca22c47c90d13d9$var$Xf : $fca22c47c90d13d9$var$H.current;
    f = $fca22c47c90d13d9$var$Yf(b, f);
    $fca22c47c90d13d9$var$ch(b, e);
    c = $fca22c47c90d13d9$var$Nh(a, b, c, d, f, e);
    d = $fca22c47c90d13d9$var$Sh();
    if (null !== a && !$fca22c47c90d13d9$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fca22c47c90d13d9$var$Zi(a, b, e);
    $fca22c47c90d13d9$var$I && d && $fca22c47c90d13d9$var$vg(b);
    b.flags |= 1;
    $fca22c47c90d13d9$var$Xi(a, b, c, e);
    return b.child;
}
function $fca22c47c90d13d9$var$hj(a, b, c, d, e) {
    if ($fca22c47c90d13d9$var$Zf(c)) {
        var f = !0;
        $fca22c47c90d13d9$var$cg(b);
    } else f = !1;
    $fca22c47c90d13d9$var$ch(b, e);
    if (null === b.stateNode) $fca22c47c90d13d9$var$ij(a, b), $fca22c47c90d13d9$var$Gi(b, c, d), $fca22c47c90d13d9$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fca22c47c90d13d9$var$eh(l) : (l = $fca22c47c90d13d9$var$Zf(c) ? $fca22c47c90d13d9$var$Xf : $fca22c47c90d13d9$var$H.current, l = $fca22c47c90d13d9$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fca22c47c90d13d9$var$Hi(b, g, d, l);
        $fca22c47c90d13d9$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $fca22c47c90d13d9$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fca22c47c90d13d9$var$Wf.current || $fca22c47c90d13d9$var$jh ? ("function" === typeof m && ($fca22c47c90d13d9$var$Di(b, c, m, d), k = b.memoizedState), (h = $fca22c47c90d13d9$var$jh || $fca22c47c90d13d9$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fca22c47c90d13d9$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fca22c47c90d13d9$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fca22c47c90d13d9$var$eh(k) : (k = $fca22c47c90d13d9$var$Zf(c) ? $fca22c47c90d13d9$var$Xf : $fca22c47c90d13d9$var$H.current, k = $fca22c47c90d13d9$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fca22c47c90d13d9$var$Hi(b, g, d, k);
        $fca22c47c90d13d9$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $fca22c47c90d13d9$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fca22c47c90d13d9$var$Wf.current || $fca22c47c90d13d9$var$jh ? ("function" === typeof y && ($fca22c47c90d13d9$var$Di(b, c, y, d), n = b.memoizedState), (l = $fca22c47c90d13d9$var$jh || $fca22c47c90d13d9$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fca22c47c90d13d9$var$jj(a, b, c, d, f, e);
}
function $fca22c47c90d13d9$var$jj(a, b, c, d, e, f) {
    $fca22c47c90d13d9$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fca22c47c90d13d9$var$dg(b, c, !1), $fca22c47c90d13d9$var$Zi(a, b, f);
    d = b.stateNode;
    $fca22c47c90d13d9$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fca22c47c90d13d9$var$Ug(b, a.child, null, f), b.child = $fca22c47c90d13d9$var$Ug(b, null, h, f)) : $fca22c47c90d13d9$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fca22c47c90d13d9$var$dg(b, c, !0);
    return b.child;
}
function $fca22c47c90d13d9$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fca22c47c90d13d9$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fca22c47c90d13d9$var$ag(a, b.context, !1);
    $fca22c47c90d13d9$var$yh(a, b.containerInfo);
}
function $fca22c47c90d13d9$var$lj(a, b, c, d, e) {
    $fca22c47c90d13d9$var$Ig();
    $fca22c47c90d13d9$var$Jg(e);
    b.flags |= 256;
    $fca22c47c90d13d9$var$Xi(a, b, c, d);
    return b.child;
}
var $fca22c47c90d13d9$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fca22c47c90d13d9$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fca22c47c90d13d9$var$oj(a, b, c) {
    var d = b.pendingProps, e = $fca22c47c90d13d9$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, e & 1);
    if (null === a) {
        $fca22c47c90d13d9$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fca22c47c90d13d9$var$pj(g, d, 0, null), a = $fca22c47c90d13d9$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fca22c47c90d13d9$var$nj(c), b.memoizedState = $fca22c47c90d13d9$var$mj, a) : $fca22c47c90d13d9$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fca22c47c90d13d9$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fca22c47c90d13d9$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fca22c47c90d13d9$var$Pg(h, f) : (f = $fca22c47c90d13d9$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fca22c47c90d13d9$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fca22c47c90d13d9$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fca22c47c90d13d9$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fca22c47c90d13d9$var$qj(a, b) {
    b = $fca22c47c90d13d9$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fca22c47c90d13d9$var$sj(a, b, c, d) {
    null !== d && $fca22c47c90d13d9$var$Jg(d);
    $fca22c47c90d13d9$var$Ug(b, a.child, null, c);
    a = $fca22c47c90d13d9$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fca22c47c90d13d9$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fca22c47c90d13d9$var$Ki(Error($fca22c47c90d13d9$var$p(422))), $fca22c47c90d13d9$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fca22c47c90d13d9$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fca22c47c90d13d9$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fca22c47c90d13d9$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $fca22c47c90d13d9$var$nj(g);
        b.memoizedState = $fca22c47c90d13d9$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fca22c47c90d13d9$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fca22c47c90d13d9$var$p(419));
        d = $fca22c47c90d13d9$var$Ki(f, d, void 0);
        return $fca22c47c90d13d9$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fca22c47c90d13d9$var$dh || h) {
        d = $fca22c47c90d13d9$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fca22c47c90d13d9$var$ih(a, e), $fca22c47c90d13d9$var$gi(d, a, e, -1));
        }
        $fca22c47c90d13d9$var$tj();
        d = $fca22c47c90d13d9$var$Ki(Error($fca22c47c90d13d9$var$p(421)));
        return $fca22c47c90d13d9$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fca22c47c90d13d9$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fca22c47c90d13d9$var$yg = $fca22c47c90d13d9$var$Lf(e.nextSibling);
    $fca22c47c90d13d9$var$xg = b;
    $fca22c47c90d13d9$var$I = !0;
    $fca22c47c90d13d9$var$zg = null;
    null !== a && ($fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg++] = $fca22c47c90d13d9$var$rg, $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg++] = $fca22c47c90d13d9$var$sg, $fca22c47c90d13d9$var$og[$fca22c47c90d13d9$var$pg++] = $fca22c47c90d13d9$var$qg, $fca22c47c90d13d9$var$rg = a.id, $fca22c47c90d13d9$var$sg = a.overflow, $fca22c47c90d13d9$var$qg = b);
    b = $fca22c47c90d13d9$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fca22c47c90d13d9$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fca22c47c90d13d9$var$bh(a.return, b, c);
}
function $fca22c47c90d13d9$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fca22c47c90d13d9$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fca22c47c90d13d9$var$Xi(a, b, d.children, c);
    d = $fca22c47c90d13d9$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fca22c47c90d13d9$var$vj(a, c, b);
            else if (19 === a.tag) $fca22c47c90d13d9$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fca22c47c90d13d9$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fca22c47c90d13d9$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fca22c47c90d13d9$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fca22c47c90d13d9$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $fca22c47c90d13d9$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fca22c47c90d13d9$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fca22c47c90d13d9$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fca22c47c90d13d9$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fca22c47c90d13d9$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fca22c47c90d13d9$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fca22c47c90d13d9$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fca22c47c90d13d9$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $fca22c47c90d13d9$var$kj(b);
            $fca22c47c90d13d9$var$Ig();
            break;
        case 5:
            $fca22c47c90d13d9$var$Ah(b);
            break;
        case 1:
            $fca22c47c90d13d9$var$Zf(b.type) && $fca22c47c90d13d9$var$cg(b);
            break;
        case 4:
            $fca22c47c90d13d9$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, $fca22c47c90d13d9$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fca22c47c90d13d9$var$oj(a, b, c);
                $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, $fca22c47c90d13d9$var$L.current & 1);
                a = $fca22c47c90d13d9$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, $fca22c47c90d13d9$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fca22c47c90d13d9$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, $fca22c47c90d13d9$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fca22c47c90d13d9$var$dj(a, b, c);
    }
    return $fca22c47c90d13d9$var$Zi(a, b, c);
}
var $fca22c47c90d13d9$var$zj, $fca22c47c90d13d9$var$Aj, $fca22c47c90d13d9$var$Bj, $fca22c47c90d13d9$var$Cj;
$fca22c47c90d13d9$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fca22c47c90d13d9$var$Aj = function() {};
$fca22c47c90d13d9$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fca22c47c90d13d9$var$Ya(a, e);
                d = $fca22c47c90d13d9$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fca22c47c90d13d9$var$A({}, e, {
                    value: void 0
                });
                d = $fca22c47c90d13d9$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fca22c47c90d13d9$var$gb(a, e);
                d = $fca22c47c90d13d9$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fca22c47c90d13d9$var$Bf);
        }
        $fca22c47c90d13d9$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fca22c47c90d13d9$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fca22c47c90d13d9$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fca22c47c90d13d9$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fca22c47c90d13d9$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fca22c47c90d13d9$var$Dj(a, b) {
    if (!$fca22c47c90d13d9$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fca22c47c90d13d9$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fca22c47c90d13d9$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $fca22c47c90d13d9$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fca22c47c90d13d9$var$S(b), null;
        case 1:
            return $fca22c47c90d13d9$var$Zf(b.type) && $fca22c47c90d13d9$var$$f(), $fca22c47c90d13d9$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fca22c47c90d13d9$var$zh();
            $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wf);
            $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$H);
            $fca22c47c90d13d9$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fca22c47c90d13d9$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fca22c47c90d13d9$var$zg && ($fca22c47c90d13d9$var$Fj($fca22c47c90d13d9$var$zg), $fca22c47c90d13d9$var$zg = null));
            $fca22c47c90d13d9$var$Aj(a, b);
            $fca22c47c90d13d9$var$S(b);
            return null;
        case 5:
            $fca22c47c90d13d9$var$Bh(b);
            var e = $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fca22c47c90d13d9$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fca22c47c90d13d9$var$p(166));
                    $fca22c47c90d13d9$var$S(b);
                    return null;
                }
                a = $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$uh.current);
                if ($fca22c47c90d13d9$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fca22c47c90d13d9$var$Of] = b;
                    d[$fca22c47c90d13d9$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fca22c47c90d13d9$var$D("cancel", d);
                            $fca22c47c90d13d9$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fca22c47c90d13d9$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fca22c47c90d13d9$var$lf.length; e++)$fca22c47c90d13d9$var$D($fca22c47c90d13d9$var$lf[e], d);
                            break;
                        case "source":
                            $fca22c47c90d13d9$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fca22c47c90d13d9$var$D("error", d);
                            $fca22c47c90d13d9$var$D("load", d);
                            break;
                        case "details":
                            $fca22c47c90d13d9$var$D("toggle", d);
                            break;
                        case "input":
                            $fca22c47c90d13d9$var$Za(d, f);
                            $fca22c47c90d13d9$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fca22c47c90d13d9$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fca22c47c90d13d9$var$hb(d, f), $fca22c47c90d13d9$var$D("invalid", d);
                    }
                    $fca22c47c90d13d9$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fca22c47c90d13d9$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fca22c47c90d13d9$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fca22c47c90d13d9$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fca22c47c90d13d9$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fca22c47c90d13d9$var$Va(d);
                            $fca22c47c90d13d9$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fca22c47c90d13d9$var$Va(d);
                            $fca22c47c90d13d9$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fca22c47c90d13d9$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fca22c47c90d13d9$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fca22c47c90d13d9$var$Of] = b;
                    a[$fca22c47c90d13d9$var$Pf] = d;
                    $fca22c47c90d13d9$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fca22c47c90d13d9$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fca22c47c90d13d9$var$D("cancel", a);
                                $fca22c47c90d13d9$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fca22c47c90d13d9$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fca22c47c90d13d9$var$lf.length; e++)$fca22c47c90d13d9$var$D($fca22c47c90d13d9$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fca22c47c90d13d9$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fca22c47c90d13d9$var$D("error", a);
                                $fca22c47c90d13d9$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fca22c47c90d13d9$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fca22c47c90d13d9$var$Za(a, d);
                                e = $fca22c47c90d13d9$var$Ya(a, d);
                                $fca22c47c90d13d9$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fca22c47c90d13d9$var$A({}, d, {
                                    value: void 0
                                });
                                $fca22c47c90d13d9$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fca22c47c90d13d9$var$hb(a, d);
                                e = $fca22c47c90d13d9$var$gb(a, d);
                                $fca22c47c90d13d9$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fca22c47c90d13d9$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fca22c47c90d13d9$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fca22c47c90d13d9$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fca22c47c90d13d9$var$ob(a, k) : "number" === typeof k && $fca22c47c90d13d9$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fca22c47c90d13d9$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fca22c47c90d13d9$var$D("scroll", a) : null != k && $fca22c47c90d13d9$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fca22c47c90d13d9$var$Va(a);
                                $fca22c47c90d13d9$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fca22c47c90d13d9$var$Va(a);
                                $fca22c47c90d13d9$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fca22c47c90d13d9$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fca22c47c90d13d9$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fca22c47c90d13d9$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fca22c47c90d13d9$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fca22c47c90d13d9$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fca22c47c90d13d9$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fca22c47c90d13d9$var$p(166));
                c = $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$wh.current);
                $fca22c47c90d13d9$var$xh($fca22c47c90d13d9$var$uh.current);
                if ($fca22c47c90d13d9$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fca22c47c90d13d9$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fca22c47c90d13d9$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fca22c47c90d13d9$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fca22c47c90d13d9$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fca22c47c90d13d9$var$Of] = b, b.stateNode = d;
            }
            $fca22c47c90d13d9$var$S(b);
            return null;
        case 13:
            $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fca22c47c90d13d9$var$I && null !== $fca22c47c90d13d9$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fca22c47c90d13d9$var$Hg(), $fca22c47c90d13d9$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fca22c47c90d13d9$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fca22c47c90d13d9$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fca22c47c90d13d9$var$p(317));
                        f[$fca22c47c90d13d9$var$Of] = b;
                    } else $fca22c47c90d13d9$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fca22c47c90d13d9$var$S(b);
                    f = !1;
                } else null !== $fca22c47c90d13d9$var$zg && ($fca22c47c90d13d9$var$Fj($fca22c47c90d13d9$var$zg), $fca22c47c90d13d9$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fca22c47c90d13d9$var$L.current & 1) ? 0 === $fca22c47c90d13d9$var$T && ($fca22c47c90d13d9$var$T = 3) : $fca22c47c90d13d9$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fca22c47c90d13d9$var$S(b);
            return null;
        case 4:
            return $fca22c47c90d13d9$var$zh(), $fca22c47c90d13d9$var$Aj(a, b), null === a && $fca22c47c90d13d9$var$sf(b.stateNode.containerInfo), $fca22c47c90d13d9$var$S(b), null;
        case 10:
            return $fca22c47c90d13d9$var$ah(b.type._context), $fca22c47c90d13d9$var$S(b), null;
        case 17:
            return $fca22c47c90d13d9$var$Zf(b.type) && $fca22c47c90d13d9$var$$f(), $fca22c47c90d13d9$var$S(b), null;
        case 19:
            $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$L);
            f = b.memoizedState;
            if (null === f) return $fca22c47c90d13d9$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fca22c47c90d13d9$var$Dj(f, !1);
                else {
                    if (0 !== $fca22c47c90d13d9$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fca22c47c90d13d9$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fca22c47c90d13d9$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, $fca22c47c90d13d9$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fca22c47c90d13d9$var$B() > $fca22c47c90d13d9$var$Gj && (b.flags |= 128, d = !0, $fca22c47c90d13d9$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fca22c47c90d13d9$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fca22c47c90d13d9$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fca22c47c90d13d9$var$I) return $fca22c47c90d13d9$var$S(b), null;
                    } else 2 * $fca22c47c90d13d9$var$B() - f.renderingStartTime > $fca22c47c90d13d9$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $fca22c47c90d13d9$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fca22c47c90d13d9$var$B(), b.sibling = null, c = $fca22c47c90d13d9$var$L.current, $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$L, d ? c & 1 | 2 : c & 1), b;
            $fca22c47c90d13d9$var$S(b);
            return null;
        case 22:
        case 23:
            return $fca22c47c90d13d9$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fca22c47c90d13d9$var$fj & 1073741824) && ($fca22c47c90d13d9$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fca22c47c90d13d9$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fca22c47c90d13d9$var$p(156, b.tag));
}
function $fca22c47c90d13d9$var$Ij(a, b) {
    $fca22c47c90d13d9$var$wg(b);
    switch(b.tag){
        case 1:
            return $fca22c47c90d13d9$var$Zf(b.type) && $fca22c47c90d13d9$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fca22c47c90d13d9$var$zh(), $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wf), $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$H), $fca22c47c90d13d9$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fca22c47c90d13d9$var$Bh(b), null;
        case 13:
            $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fca22c47c90d13d9$var$p(340));
                $fca22c47c90d13d9$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$L), null;
        case 4:
            return $fca22c47c90d13d9$var$zh(), null;
        case 10:
            return $fca22c47c90d13d9$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $fca22c47c90d13d9$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fca22c47c90d13d9$var$Jj = !1, $fca22c47c90d13d9$var$U = !1, $fca22c47c90d13d9$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $fca22c47c90d13d9$var$V = null;
function $fca22c47c90d13d9$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fca22c47c90d13d9$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fca22c47c90d13d9$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fca22c47c90d13d9$var$W(a, b, d);
    }
}
var $fca22c47c90d13d9$var$Nj = !1;
function $fca22c47c90d13d9$var$Oj(a, b) {
    $fca22c47c90d13d9$var$Cf = $fca22c47c90d13d9$var$dd;
    a = $fca22c47c90d13d9$var$Me();
    if ($fca22c47c90d13d9$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fca22c47c90d13d9$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fca22c47c90d13d9$var$dd = !1;
    for($fca22c47c90d13d9$var$V = b; null !== $fca22c47c90d13d9$var$V;)if (b = $fca22c47c90d13d9$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fca22c47c90d13d9$var$V = a;
    else for(; null !== $fca22c47c90d13d9$var$V;){
        b = $fca22c47c90d13d9$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fca22c47c90d13d9$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fca22c47c90d13d9$var$p(163));
            }
        } catch (F) {
            $fca22c47c90d13d9$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fca22c47c90d13d9$var$V = a;
            break;
        }
        $fca22c47c90d13d9$var$V = b.return;
    }
    n = $fca22c47c90d13d9$var$Nj;
    $fca22c47c90d13d9$var$Nj = !1;
    return n;
}
function $fca22c47c90d13d9$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fca22c47c90d13d9$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fca22c47c90d13d9$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fca22c47c90d13d9$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fca22c47c90d13d9$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fca22c47c90d13d9$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fca22c47c90d13d9$var$Of], delete b[$fca22c47c90d13d9$var$Pf], delete b[$fca22c47c90d13d9$var$of], delete b[$fca22c47c90d13d9$var$Qf], delete b[$fca22c47c90d13d9$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fca22c47c90d13d9$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fca22c47c90d13d9$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fca22c47c90d13d9$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fca22c47c90d13d9$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fca22c47c90d13d9$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fca22c47c90d13d9$var$Vj(a, b, c), a = a.sibling; null !== a;)$fca22c47c90d13d9$var$Vj(a, b, c), a = a.sibling;
}
function $fca22c47c90d13d9$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fca22c47c90d13d9$var$Wj(a, b, c), a = a.sibling; null !== a;)$fca22c47c90d13d9$var$Wj(a, b, c), a = a.sibling;
}
var $fca22c47c90d13d9$var$X = null, $fca22c47c90d13d9$var$Xj = !1;
function $fca22c47c90d13d9$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$fca22c47c90d13d9$var$Zj(a, b, c), c = c.sibling;
}
function $fca22c47c90d13d9$var$Zj(a, b, c) {
    if ($fca22c47c90d13d9$var$lc && "function" === typeof $fca22c47c90d13d9$var$lc.onCommitFiberUnmount) try {
        $fca22c47c90d13d9$var$lc.onCommitFiberUnmount($fca22c47c90d13d9$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fca22c47c90d13d9$var$U || $fca22c47c90d13d9$var$Lj(c, b);
        case 6:
            var d = $fca22c47c90d13d9$var$X, e = $fca22c47c90d13d9$var$Xj;
            $fca22c47c90d13d9$var$X = null;
            $fca22c47c90d13d9$var$Yj(a, b, c);
            $fca22c47c90d13d9$var$X = d;
            $fca22c47c90d13d9$var$Xj = e;
            null !== $fca22c47c90d13d9$var$X && ($fca22c47c90d13d9$var$Xj ? (a = $fca22c47c90d13d9$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fca22c47c90d13d9$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fca22c47c90d13d9$var$X && ($fca22c47c90d13d9$var$Xj ? (a = $fca22c47c90d13d9$var$X, c = c.stateNode, 8 === a.nodeType ? $fca22c47c90d13d9$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fca22c47c90d13d9$var$Kf(a, c), $fca22c47c90d13d9$var$bd(a)) : $fca22c47c90d13d9$var$Kf($fca22c47c90d13d9$var$X, c.stateNode));
            break;
        case 4:
            d = $fca22c47c90d13d9$var$X;
            e = $fca22c47c90d13d9$var$Xj;
            $fca22c47c90d13d9$var$X = c.stateNode.containerInfo;
            $fca22c47c90d13d9$var$Xj = !0;
            $fca22c47c90d13d9$var$Yj(a, b, c);
            $fca22c47c90d13d9$var$X = d;
            $fca22c47c90d13d9$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fca22c47c90d13d9$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fca22c47c90d13d9$var$Mj(c, b, g) : 0 !== (f & 4) && $fca22c47c90d13d9$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fca22c47c90d13d9$var$Yj(a, b, c);
            break;
        case 1:
            if (!$fca22c47c90d13d9$var$U && ($fca22c47c90d13d9$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fca22c47c90d13d9$var$W(c, b, h);
            }
            $fca22c47c90d13d9$var$Yj(a, b, c);
            break;
        case 21:
            $fca22c47c90d13d9$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fca22c47c90d13d9$var$U = (d = $fca22c47c90d13d9$var$U) || null !== c.memoizedState, $fca22c47c90d13d9$var$Yj(a, b, c), $fca22c47c90d13d9$var$U = d) : $fca22c47c90d13d9$var$Yj(a, b, c);
            break;
        default:
            $fca22c47c90d13d9$var$Yj(a, b, c);
    }
}
function $fca22c47c90d13d9$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fca22c47c90d13d9$var$Kj);
        b.forEach(function(b) {
            var d = $fca22c47c90d13d9$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fca22c47c90d13d9$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fca22c47c90d13d9$var$X = h.stateNode;
                        $fca22c47c90d13d9$var$Xj = !1;
                        break a;
                    case 3:
                        $fca22c47c90d13d9$var$X = h.stateNode.containerInfo;
                        $fca22c47c90d13d9$var$Xj = !0;
                        break a;
                    case 4:
                        $fca22c47c90d13d9$var$X = h.stateNode.containerInfo;
                        $fca22c47c90d13d9$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fca22c47c90d13d9$var$X) throw Error($fca22c47c90d13d9$var$p(160));
            $fca22c47c90d13d9$var$Zj(f, g, e);
            $fca22c47c90d13d9$var$X = null;
            $fca22c47c90d13d9$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fca22c47c90d13d9$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fca22c47c90d13d9$var$dk(b, a), b = b.sibling;
}
function $fca22c47c90d13d9$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            if (d & 4) {
                try {
                    $fca22c47c90d13d9$var$Pj(3, a, a.return), $fca22c47c90d13d9$var$Qj(3, a);
                } catch (t) {
                    $fca22c47c90d13d9$var$W(a, a.return, t);
                }
                try {
                    $fca22c47c90d13d9$var$Pj(5, a, a.return);
                } catch (t) {
                    $fca22c47c90d13d9$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            d & 512 && null !== c && $fca22c47c90d13d9$var$Lj(c, c.return);
            break;
        case 5:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            d & 512 && null !== c && $fca22c47c90d13d9$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fca22c47c90d13d9$var$ob(e, "");
                } catch (t) {
                    $fca22c47c90d13d9$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fca22c47c90d13d9$var$ab(e, f);
                    $fca22c47c90d13d9$var$vb(h, g);
                    var l = $fca22c47c90d13d9$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fca22c47c90d13d9$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fca22c47c90d13d9$var$nb(e, q) : "children" === m ? $fca22c47c90d13d9$var$ob(e, q) : $fca22c47c90d13d9$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fca22c47c90d13d9$var$bb(e, f);
                            break;
                        case "textarea":
                            $fca22c47c90d13d9$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fca22c47c90d13d9$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fca22c47c90d13d9$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fca22c47c90d13d9$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fca22c47c90d13d9$var$Pf] = f;
                } catch (t) {
                    $fca22c47c90d13d9$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fca22c47c90d13d9$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fca22c47c90d13d9$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fca22c47c90d13d9$var$bd(b.containerInfo);
            } catch (t) {
                $fca22c47c90d13d9$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            break;
        case 13:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fca22c47c90d13d9$var$fk = $fca22c47c90d13d9$var$B()));
            d & 4 && $fca22c47c90d13d9$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fca22c47c90d13d9$var$U = (l = $fca22c47c90d13d9$var$U) || m, $fca22c47c90d13d9$var$ck(b, a), $fca22c47c90d13d9$var$U = l) : $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fca22c47c90d13d9$var$V = a, m = a.child; null !== m;){
                    for(q = $fca22c47c90d13d9$var$V = m; null !== $fca22c47c90d13d9$var$V;){
                        r = $fca22c47c90d13d9$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fca22c47c90d13d9$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $fca22c47c90d13d9$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fca22c47c90d13d9$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fca22c47c90d13d9$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fca22c47c90d13d9$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fca22c47c90d13d9$var$V = y) : $fca22c47c90d13d9$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fca22c47c90d13d9$var$rb("display", g));
                            } catch (t) {
                                $fca22c47c90d13d9$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fca22c47c90d13d9$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fca22c47c90d13d9$var$ck(b, a);
            $fca22c47c90d13d9$var$ek(a);
            d & 4 && $fca22c47c90d13d9$var$ak(a);
            break;
        case 21:
            break;
        default:
            $fca22c47c90d13d9$var$ck(b, a), $fca22c47c90d13d9$var$ek(a);
    }
}
function $fca22c47c90d13d9$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fca22c47c90d13d9$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fca22c47c90d13d9$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fca22c47c90d13d9$var$ob(e, ""), d.flags &= -33);
                    var f = $fca22c47c90d13d9$var$Uj(a);
                    $fca22c47c90d13d9$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fca22c47c90d13d9$var$Uj(a);
                    $fca22c47c90d13d9$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($fca22c47c90d13d9$var$p(161));
            }
        } catch (k) {
            $fca22c47c90d13d9$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fca22c47c90d13d9$var$hk(a, b, c) {
    $fca22c47c90d13d9$var$V = a;
    $fca22c47c90d13d9$var$ik(a, b, c);
}
function $fca22c47c90d13d9$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fca22c47c90d13d9$var$V;){
        var e = $fca22c47c90d13d9$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fca22c47c90d13d9$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fca22c47c90d13d9$var$U;
                h = $fca22c47c90d13d9$var$Jj;
                var l = $fca22c47c90d13d9$var$U;
                $fca22c47c90d13d9$var$Jj = g;
                if (($fca22c47c90d13d9$var$U = k) && !l) for($fca22c47c90d13d9$var$V = e; null !== $fca22c47c90d13d9$var$V;)g = $fca22c47c90d13d9$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fca22c47c90d13d9$var$jk(e) : null !== k ? (k.return = g, $fca22c47c90d13d9$var$V = k) : $fca22c47c90d13d9$var$jk(e);
                for(; null !== f;)$fca22c47c90d13d9$var$V = f, $fca22c47c90d13d9$var$ik(f, b, c), f = f.sibling;
                $fca22c47c90d13d9$var$V = e;
                $fca22c47c90d13d9$var$Jj = h;
                $fca22c47c90d13d9$var$U = l;
            }
            $fca22c47c90d13d9$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fca22c47c90d13d9$var$V = f) : $fca22c47c90d13d9$var$kk(a, b, c);
    }
}
function $fca22c47c90d13d9$var$kk(a) {
    for(; null !== $fca22c47c90d13d9$var$V;){
        var b = $fca22c47c90d13d9$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fca22c47c90d13d9$var$U || $fca22c47c90d13d9$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fca22c47c90d13d9$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fca22c47c90d13d9$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fca22c47c90d13d9$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fca22c47c90d13d9$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fca22c47c90d13d9$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fca22c47c90d13d9$var$p(163));
                }
                $fca22c47c90d13d9$var$U || b.flags & 512 && $fca22c47c90d13d9$var$Rj(b);
            } catch (r) {
                $fca22c47c90d13d9$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fca22c47c90d13d9$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fca22c47c90d13d9$var$V = c;
            break;
        }
        $fca22c47c90d13d9$var$V = b.return;
    }
}
function $fca22c47c90d13d9$var$gk(a) {
    for(; null !== $fca22c47c90d13d9$var$V;){
        var b = $fca22c47c90d13d9$var$V;
        if (b === a) {
            $fca22c47c90d13d9$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fca22c47c90d13d9$var$V = c;
            break;
        }
        $fca22c47c90d13d9$var$V = b.return;
    }
}
function $fca22c47c90d13d9$var$jk(a) {
    for(; null !== $fca22c47c90d13d9$var$V;){
        var b = $fca22c47c90d13d9$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fca22c47c90d13d9$var$Qj(4, b);
                    } catch (k) {
                        $fca22c47c90d13d9$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fca22c47c90d13d9$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fca22c47c90d13d9$var$Rj(b);
                    } catch (k) {
                        $fca22c47c90d13d9$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fca22c47c90d13d9$var$Rj(b);
                    } catch (k) {
                        $fca22c47c90d13d9$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fca22c47c90d13d9$var$W(b, b.return, k);
        }
        if (b === a) {
            $fca22c47c90d13d9$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fca22c47c90d13d9$var$V = h;
            break;
        }
        $fca22c47c90d13d9$var$V = b.return;
    }
}
var $fca22c47c90d13d9$var$lk = Math.ceil, $fca22c47c90d13d9$var$mk = $fca22c47c90d13d9$var$ua.ReactCurrentDispatcher, $fca22c47c90d13d9$var$nk = $fca22c47c90d13d9$var$ua.ReactCurrentOwner, $fca22c47c90d13d9$var$ok = $fca22c47c90d13d9$var$ua.ReactCurrentBatchConfig, $fca22c47c90d13d9$var$K = 0, $fca22c47c90d13d9$var$Q = null, $fca22c47c90d13d9$var$Y = null, $fca22c47c90d13d9$var$Z = 0, $fca22c47c90d13d9$var$fj = 0, $fca22c47c90d13d9$var$ej = $fca22c47c90d13d9$var$Uf(0), $fca22c47c90d13d9$var$T = 0, $fca22c47c90d13d9$var$pk = null, $fca22c47c90d13d9$var$rh = 0, $fca22c47c90d13d9$var$qk = 0, $fca22c47c90d13d9$var$rk = 0, $fca22c47c90d13d9$var$sk = null, $fca22c47c90d13d9$var$tk = null, $fca22c47c90d13d9$var$fk = 0, $fca22c47c90d13d9$var$Gj = Infinity, $fca22c47c90d13d9$var$uk = null, $fca22c47c90d13d9$var$Oi = !1, $fca22c47c90d13d9$var$Pi = null, $fca22c47c90d13d9$var$Ri = null, $fca22c47c90d13d9$var$vk = !1, $fca22c47c90d13d9$var$wk = null, $fca22c47c90d13d9$var$xk = 0, $fca22c47c90d13d9$var$yk = 0, $fca22c47c90d13d9$var$zk = null, $fca22c47c90d13d9$var$Ak = -1, $fca22c47c90d13d9$var$Bk = 0;
function $fca22c47c90d13d9$var$R() {
    return 0 !== ($fca22c47c90d13d9$var$K & 6) ? $fca22c47c90d13d9$var$B() : -1 !== $fca22c47c90d13d9$var$Ak ? $fca22c47c90d13d9$var$Ak : $fca22c47c90d13d9$var$Ak = $fca22c47c90d13d9$var$B();
}
function $fca22c47c90d13d9$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fca22c47c90d13d9$var$K & 2) && 0 !== $fca22c47c90d13d9$var$Z) return $fca22c47c90d13d9$var$Z & -$fca22c47c90d13d9$var$Z;
    if (null !== $fca22c47c90d13d9$var$Kg.transition) return 0 === $fca22c47c90d13d9$var$Bk && ($fca22c47c90d13d9$var$Bk = $fca22c47c90d13d9$var$yc()), $fca22c47c90d13d9$var$Bk;
    a = $fca22c47c90d13d9$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fca22c47c90d13d9$var$jd(a.type);
    return a;
}
function $fca22c47c90d13d9$var$gi(a, b, c, d) {
    if (50 < $fca22c47c90d13d9$var$yk) throw $fca22c47c90d13d9$var$yk = 0, $fca22c47c90d13d9$var$zk = null, Error($fca22c47c90d13d9$var$p(185));
    $fca22c47c90d13d9$var$Ac(a, c, d);
    if (0 === ($fca22c47c90d13d9$var$K & 2) || a !== $fca22c47c90d13d9$var$Q) a === $fca22c47c90d13d9$var$Q && (0 === ($fca22c47c90d13d9$var$K & 2) && ($fca22c47c90d13d9$var$qk |= c), 4 === $fca22c47c90d13d9$var$T && $fca22c47c90d13d9$var$Ck(a, $fca22c47c90d13d9$var$Z)), $fca22c47c90d13d9$var$Dk(a, d), 1 === c && 0 === $fca22c47c90d13d9$var$K && 0 === (b.mode & 1) && ($fca22c47c90d13d9$var$Gj = $fca22c47c90d13d9$var$B() + 500, $fca22c47c90d13d9$var$fg && $fca22c47c90d13d9$var$jg());
}
function $fca22c47c90d13d9$var$Dk(a, b) {
    var c = a.callbackNode;
    $fca22c47c90d13d9$var$wc(a, b);
    var d = $fca22c47c90d13d9$var$uc(a, a === $fca22c47c90d13d9$var$Q ? $fca22c47c90d13d9$var$Z : 0);
    if (0 === d) null !== c && $fca22c47c90d13d9$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fca22c47c90d13d9$var$bc(c);
        if (1 === b) 0 === a.tag ? $fca22c47c90d13d9$var$ig($fca22c47c90d13d9$var$Ek.bind(null, a)) : $fca22c47c90d13d9$var$hg($fca22c47c90d13d9$var$Ek.bind(null, a)), $fca22c47c90d13d9$var$Jf(function() {
            0 === ($fca22c47c90d13d9$var$K & 6) && $fca22c47c90d13d9$var$jg();
        }), c = null;
        else {
            switch($fca22c47c90d13d9$var$Dc(d)){
                case 1:
                    c = $fca22c47c90d13d9$var$fc;
                    break;
                case 4:
                    c = $fca22c47c90d13d9$var$gc;
                    break;
                case 16:
                    c = $fca22c47c90d13d9$var$hc;
                    break;
                case 536870912:
                    c = $fca22c47c90d13d9$var$jc;
                    break;
                default:
                    c = $fca22c47c90d13d9$var$hc;
            }
            c = $fca22c47c90d13d9$var$Fk(c, $fca22c47c90d13d9$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fca22c47c90d13d9$var$Gk(a, b) {
    $fca22c47c90d13d9$var$Ak = -1;
    $fca22c47c90d13d9$var$Bk = 0;
    if (0 !== ($fca22c47c90d13d9$var$K & 6)) throw Error($fca22c47c90d13d9$var$p(327));
    var c = a.callbackNode;
    if ($fca22c47c90d13d9$var$Hk() && a.callbackNode !== c) return null;
    var d = $fca22c47c90d13d9$var$uc(a, a === $fca22c47c90d13d9$var$Q ? $fca22c47c90d13d9$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fca22c47c90d13d9$var$Ik(a, d);
    else {
        b = d;
        var e = $fca22c47c90d13d9$var$K;
        $fca22c47c90d13d9$var$K |= 2;
        var f = $fca22c47c90d13d9$var$Jk();
        if ($fca22c47c90d13d9$var$Q !== a || $fca22c47c90d13d9$var$Z !== b) $fca22c47c90d13d9$var$uk = null, $fca22c47c90d13d9$var$Gj = $fca22c47c90d13d9$var$B() + 500, $fca22c47c90d13d9$var$Kk(a, b);
        for(;;)try {
            $fca22c47c90d13d9$var$Lk();
            break;
        } catch (h) {
            $fca22c47c90d13d9$var$Mk(a, h);
        }
        $fca22c47c90d13d9$var$$g();
        $fca22c47c90d13d9$var$mk.current = f;
        $fca22c47c90d13d9$var$K = e;
        null !== $fca22c47c90d13d9$var$Y ? b = 0 : ($fca22c47c90d13d9$var$Q = null, $fca22c47c90d13d9$var$Z = 0, b = $fca22c47c90d13d9$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fca22c47c90d13d9$var$xc(a), 0 !== e && (d = e, b = $fca22c47c90d13d9$var$Nk(a, e)));
        if (1 === b) throw c = $fca22c47c90d13d9$var$pk, $fca22c47c90d13d9$var$Kk(a, 0), $fca22c47c90d13d9$var$Ck(a, d), $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B()), c;
        if (6 === b) $fca22c47c90d13d9$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fca22c47c90d13d9$var$Ok(e) && (b = $fca22c47c90d13d9$var$Ik(a, d), 2 === b && (f = $fca22c47c90d13d9$var$xc(a), 0 !== f && (d = f, b = $fca22c47c90d13d9$var$Nk(a, f))), 1 === b)) throw c = $fca22c47c90d13d9$var$pk, $fca22c47c90d13d9$var$Kk(a, 0), $fca22c47c90d13d9$var$Ck(a, d), $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fca22c47c90d13d9$var$p(345));
                case 2:
                    $fca22c47c90d13d9$var$Pk(a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk);
                    break;
                case 3:
                    $fca22c47c90d13d9$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $fca22c47c90d13d9$var$fk + 500 - $fca22c47c90d13d9$var$B(), 10 < b)) {
                        if (0 !== $fca22c47c90d13d9$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fca22c47c90d13d9$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fca22c47c90d13d9$var$Ff($fca22c47c90d13d9$var$Pk.bind(null, a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk), b);
                        break;
                    }
                    $fca22c47c90d13d9$var$Pk(a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk);
                    break;
                case 4:
                    $fca22c47c90d13d9$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fca22c47c90d13d9$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fca22c47c90d13d9$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fca22c47c90d13d9$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fca22c47c90d13d9$var$Ff($fca22c47c90d13d9$var$Pk.bind(null, a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk), d);
                        break;
                    }
                    $fca22c47c90d13d9$var$Pk(a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk);
                    break;
                case 5:
                    $fca22c47c90d13d9$var$Pk(a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk);
                    break;
                default:
                    throw Error($fca22c47c90d13d9$var$p(329));
            }
        }
    }
    $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B());
    return a.callbackNode === c ? $fca22c47c90d13d9$var$Gk.bind(null, a) : null;
}
function $fca22c47c90d13d9$var$Nk(a, b) {
    var c = $fca22c47c90d13d9$var$sk;
    a.current.memoizedState.isDehydrated && ($fca22c47c90d13d9$var$Kk(a, b).flags |= 256);
    a = $fca22c47c90d13d9$var$Ik(a, b);
    2 !== a && (b = $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$tk = c, null !== b && $fca22c47c90d13d9$var$Fj(b));
    return a;
}
function $fca22c47c90d13d9$var$Fj(a) {
    null === $fca22c47c90d13d9$var$tk ? $fca22c47c90d13d9$var$tk = a : $fca22c47c90d13d9$var$tk.push.apply($fca22c47c90d13d9$var$tk, a);
}
function $fca22c47c90d13d9$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fca22c47c90d13d9$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fca22c47c90d13d9$var$Ck(a, b) {
    b &= ~$fca22c47c90d13d9$var$rk;
    b &= ~$fca22c47c90d13d9$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fca22c47c90d13d9$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fca22c47c90d13d9$var$Ek(a) {
    if (0 !== ($fca22c47c90d13d9$var$K & 6)) throw Error($fca22c47c90d13d9$var$p(327));
    $fca22c47c90d13d9$var$Hk();
    var b = $fca22c47c90d13d9$var$uc(a, 0);
    if (0 === (b & 1)) return $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B()), null;
    var c = $fca22c47c90d13d9$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fca22c47c90d13d9$var$xc(a);
        0 !== d && (b = d, c = $fca22c47c90d13d9$var$Nk(a, d));
    }
    if (1 === c) throw c = $fca22c47c90d13d9$var$pk, $fca22c47c90d13d9$var$Kk(a, 0), $fca22c47c90d13d9$var$Ck(a, b), $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B()), c;
    if (6 === c) throw Error($fca22c47c90d13d9$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fca22c47c90d13d9$var$Pk(a, $fca22c47c90d13d9$var$tk, $fca22c47c90d13d9$var$uk);
    $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B());
    return null;
}
function $fca22c47c90d13d9$var$Qk(a, b) {
    var c = $fca22c47c90d13d9$var$K;
    $fca22c47c90d13d9$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fca22c47c90d13d9$var$K = c, 0 === $fca22c47c90d13d9$var$K && ($fca22c47c90d13d9$var$Gj = $fca22c47c90d13d9$var$B() + 500, $fca22c47c90d13d9$var$fg && $fca22c47c90d13d9$var$jg());
    }
}
function $fca22c47c90d13d9$var$Rk(a) {
    null !== $fca22c47c90d13d9$var$wk && 0 === $fca22c47c90d13d9$var$wk.tag && 0 === ($fca22c47c90d13d9$var$K & 6) && $fca22c47c90d13d9$var$Hk();
    var b = $fca22c47c90d13d9$var$K;
    $fca22c47c90d13d9$var$K |= 1;
    var c = $fca22c47c90d13d9$var$ok.transition, d = $fca22c47c90d13d9$var$C;
    try {
        if ($fca22c47c90d13d9$var$ok.transition = null, $fca22c47c90d13d9$var$C = 1, a) return a();
    } finally{
        $fca22c47c90d13d9$var$C = d, $fca22c47c90d13d9$var$ok.transition = c, $fca22c47c90d13d9$var$K = b, 0 === ($fca22c47c90d13d9$var$K & 6) && $fca22c47c90d13d9$var$jg();
    }
}
function $fca22c47c90d13d9$var$Hj() {
    $fca22c47c90d13d9$var$fj = $fca22c47c90d13d9$var$ej.current;
    $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$ej);
}
function $fca22c47c90d13d9$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fca22c47c90d13d9$var$Gf(c));
    if (null !== $fca22c47c90d13d9$var$Y) for(c = $fca22c47c90d13d9$var$Y.return; null !== c;){
        var d = c;
        $fca22c47c90d13d9$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fca22c47c90d13d9$var$$f();
                break;
            case 3:
                $fca22c47c90d13d9$var$zh();
                $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$Wf);
                $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$H);
                $fca22c47c90d13d9$var$Eh();
                break;
            case 5:
                $fca22c47c90d13d9$var$Bh(d);
                break;
            case 4:
                $fca22c47c90d13d9$var$zh();
                break;
            case 13:
                $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$L);
                break;
            case 19:
                $fca22c47c90d13d9$var$E($fca22c47c90d13d9$var$L);
                break;
            case 10:
                $fca22c47c90d13d9$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $fca22c47c90d13d9$var$Hj();
        }
        c = c.return;
    }
    $fca22c47c90d13d9$var$Q = a;
    $fca22c47c90d13d9$var$Y = a = $fca22c47c90d13d9$var$Pg(a.current, null);
    $fca22c47c90d13d9$var$Z = $fca22c47c90d13d9$var$fj = b;
    $fca22c47c90d13d9$var$T = 0;
    $fca22c47c90d13d9$var$pk = null;
    $fca22c47c90d13d9$var$rk = $fca22c47c90d13d9$var$qk = $fca22c47c90d13d9$var$rh = 0;
    $fca22c47c90d13d9$var$tk = $fca22c47c90d13d9$var$sk = null;
    if (null !== $fca22c47c90d13d9$var$fh) {
        for(b = 0; b < $fca22c47c90d13d9$var$fh.length; b++)if (c = $fca22c47c90d13d9$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fca22c47c90d13d9$var$fh = null;
    }
    return a;
}
function $fca22c47c90d13d9$var$Mk(a, b) {
    do {
        var c = $fca22c47c90d13d9$var$Y;
        try {
            $fca22c47c90d13d9$var$$g();
            $fca22c47c90d13d9$var$Fh.current = $fca22c47c90d13d9$var$Rh;
            if ($fca22c47c90d13d9$var$Ih) {
                for(var d = $fca22c47c90d13d9$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fca22c47c90d13d9$var$Ih = !1;
            }
            $fca22c47c90d13d9$var$Hh = 0;
            $fca22c47c90d13d9$var$O = $fca22c47c90d13d9$var$N = $fca22c47c90d13d9$var$M = null;
            $fca22c47c90d13d9$var$Jh = !1;
            $fca22c47c90d13d9$var$Kh = 0;
            $fca22c47c90d13d9$var$nk.current = null;
            if (null === c || null === c.return) {
                $fca22c47c90d13d9$var$T = 1;
                $fca22c47c90d13d9$var$pk = b;
                $fca22c47c90d13d9$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fca22c47c90d13d9$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fca22c47c90d13d9$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fca22c47c90d13d9$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $fca22c47c90d13d9$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fca22c47c90d13d9$var$Si(f, l, b);
                            $fca22c47c90d13d9$var$tj();
                            break a;
                        }
                        k = Error($fca22c47c90d13d9$var$p(426));
                    }
                } else if ($fca22c47c90d13d9$var$I && h.mode & 1) {
                    var J = $fca22c47c90d13d9$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fca22c47c90d13d9$var$Vi(J, g, h, f, b);
                        $fca22c47c90d13d9$var$Jg($fca22c47c90d13d9$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $fca22c47c90d13d9$var$Ji(k, h);
                4 !== $fca22c47c90d13d9$var$T && ($fca22c47c90d13d9$var$T = 2);
                null === $fca22c47c90d13d9$var$sk ? $fca22c47c90d13d9$var$sk = [
                    f
                ] : $fca22c47c90d13d9$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fca22c47c90d13d9$var$Ni(f, k, b);
                            $fca22c47c90d13d9$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fca22c47c90d13d9$var$Ri || !$fca22c47c90d13d9$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fca22c47c90d13d9$var$Qi(f, h, b);
                                $fca22c47c90d13d9$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fca22c47c90d13d9$var$Sk(c);
        } catch (na) {
            b = na;
            $fca22c47c90d13d9$var$Y === c && null !== c && ($fca22c47c90d13d9$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fca22c47c90d13d9$var$Jk() {
    var a = $fca22c47c90d13d9$var$mk.current;
    $fca22c47c90d13d9$var$mk.current = $fca22c47c90d13d9$var$Rh;
    return null === a ? $fca22c47c90d13d9$var$Rh : a;
}
function $fca22c47c90d13d9$var$tj() {
    if (0 === $fca22c47c90d13d9$var$T || 3 === $fca22c47c90d13d9$var$T || 2 === $fca22c47c90d13d9$var$T) $fca22c47c90d13d9$var$T = 4;
    null === $fca22c47c90d13d9$var$Q || 0 === ($fca22c47c90d13d9$var$rh & 268435455) && 0 === ($fca22c47c90d13d9$var$qk & 268435455) || $fca22c47c90d13d9$var$Ck($fca22c47c90d13d9$var$Q, $fca22c47c90d13d9$var$Z);
}
function $fca22c47c90d13d9$var$Ik(a, b) {
    var c = $fca22c47c90d13d9$var$K;
    $fca22c47c90d13d9$var$K |= 2;
    var d = $fca22c47c90d13d9$var$Jk();
    if ($fca22c47c90d13d9$var$Q !== a || $fca22c47c90d13d9$var$Z !== b) $fca22c47c90d13d9$var$uk = null, $fca22c47c90d13d9$var$Kk(a, b);
    for(;;)try {
        $fca22c47c90d13d9$var$Tk();
        break;
    } catch (e) {
        $fca22c47c90d13d9$var$Mk(a, e);
    }
    $fca22c47c90d13d9$var$$g();
    $fca22c47c90d13d9$var$K = c;
    $fca22c47c90d13d9$var$mk.current = d;
    if (null !== $fca22c47c90d13d9$var$Y) throw Error($fca22c47c90d13d9$var$p(261));
    $fca22c47c90d13d9$var$Q = null;
    $fca22c47c90d13d9$var$Z = 0;
    return $fca22c47c90d13d9$var$T;
}
function $fca22c47c90d13d9$var$Tk() {
    for(; null !== $fca22c47c90d13d9$var$Y;)$fca22c47c90d13d9$var$Uk($fca22c47c90d13d9$var$Y);
}
function $fca22c47c90d13d9$var$Lk() {
    for(; null !== $fca22c47c90d13d9$var$Y && !$fca22c47c90d13d9$var$cc();)$fca22c47c90d13d9$var$Uk($fca22c47c90d13d9$var$Y);
}
function $fca22c47c90d13d9$var$Uk(a) {
    var b = $fca22c47c90d13d9$var$Vk(a.alternate, a, $fca22c47c90d13d9$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fca22c47c90d13d9$var$Sk(a) : $fca22c47c90d13d9$var$Y = b;
    $fca22c47c90d13d9$var$nk.current = null;
}
function $fca22c47c90d13d9$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fca22c47c90d13d9$var$Ej(c, b, $fca22c47c90d13d9$var$fj), null !== c) {
                $fca22c47c90d13d9$var$Y = c;
                return;
            }
        } else {
            c = $fca22c47c90d13d9$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fca22c47c90d13d9$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fca22c47c90d13d9$var$T = 6;
                $fca22c47c90d13d9$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fca22c47c90d13d9$var$Y = b;
            return;
        }
        $fca22c47c90d13d9$var$Y = b = a;
    }while (null !== b);
    0 === $fca22c47c90d13d9$var$T && ($fca22c47c90d13d9$var$T = 5);
}
function $fca22c47c90d13d9$var$Pk(a, b, c) {
    var d = $fca22c47c90d13d9$var$C, e = $fca22c47c90d13d9$var$ok.transition;
    try {
        $fca22c47c90d13d9$var$ok.transition = null, $fca22c47c90d13d9$var$C = 1, $fca22c47c90d13d9$var$Wk(a, b, c, d);
    } finally{
        $fca22c47c90d13d9$var$ok.transition = e, $fca22c47c90d13d9$var$C = d;
    }
    return null;
}
function $fca22c47c90d13d9$var$Wk(a, b, c, d) {
    do $fca22c47c90d13d9$var$Hk();
    while (null !== $fca22c47c90d13d9$var$wk);
    if (0 !== ($fca22c47c90d13d9$var$K & 6)) throw Error($fca22c47c90d13d9$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fca22c47c90d13d9$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fca22c47c90d13d9$var$Bc(a, f);
    a === $fca22c47c90d13d9$var$Q && ($fca22c47c90d13d9$var$Y = $fca22c47c90d13d9$var$Q = null, $fca22c47c90d13d9$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fca22c47c90d13d9$var$vk || ($fca22c47c90d13d9$var$vk = !0, $fca22c47c90d13d9$var$Fk($fca22c47c90d13d9$var$hc, function() {
        $fca22c47c90d13d9$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fca22c47c90d13d9$var$ok.transition;
        $fca22c47c90d13d9$var$ok.transition = null;
        var g = $fca22c47c90d13d9$var$C;
        $fca22c47c90d13d9$var$C = 1;
        var h = $fca22c47c90d13d9$var$K;
        $fca22c47c90d13d9$var$K |= 4;
        $fca22c47c90d13d9$var$nk.current = null;
        $fca22c47c90d13d9$var$Oj(a, c);
        $fca22c47c90d13d9$var$dk(c, a);
        $fca22c47c90d13d9$var$Oe($fca22c47c90d13d9$var$Df);
        $fca22c47c90d13d9$var$dd = !!$fca22c47c90d13d9$var$Cf;
        $fca22c47c90d13d9$var$Df = $fca22c47c90d13d9$var$Cf = null;
        a.current = c;
        $fca22c47c90d13d9$var$hk(c, a, e);
        $fca22c47c90d13d9$var$dc();
        $fca22c47c90d13d9$var$K = h;
        $fca22c47c90d13d9$var$C = g;
        $fca22c47c90d13d9$var$ok.transition = f;
    } else a.current = c;
    $fca22c47c90d13d9$var$vk && ($fca22c47c90d13d9$var$vk = !1, $fca22c47c90d13d9$var$wk = a, $fca22c47c90d13d9$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($fca22c47c90d13d9$var$Ri = null);
    $fca22c47c90d13d9$var$mc(c.stateNode, d);
    $fca22c47c90d13d9$var$Dk(a, $fca22c47c90d13d9$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fca22c47c90d13d9$var$Oi) throw $fca22c47c90d13d9$var$Oi = !1, a = $fca22c47c90d13d9$var$Pi, $fca22c47c90d13d9$var$Pi = null, a;
    0 !== ($fca22c47c90d13d9$var$xk & 1) && 0 !== a.tag && $fca22c47c90d13d9$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fca22c47c90d13d9$var$zk ? $fca22c47c90d13d9$var$yk++ : ($fca22c47c90d13d9$var$yk = 0, $fca22c47c90d13d9$var$zk = a) : $fca22c47c90d13d9$var$yk = 0;
    $fca22c47c90d13d9$var$jg();
    return null;
}
function $fca22c47c90d13d9$var$Hk() {
    if (null !== $fca22c47c90d13d9$var$wk) {
        var a = $fca22c47c90d13d9$var$Dc($fca22c47c90d13d9$var$xk), b = $fca22c47c90d13d9$var$ok.transition, c = $fca22c47c90d13d9$var$C;
        try {
            $fca22c47c90d13d9$var$ok.transition = null;
            $fca22c47c90d13d9$var$C = 16 > a ? 16 : a;
            if (null === $fca22c47c90d13d9$var$wk) var d = !1;
            else {
                a = $fca22c47c90d13d9$var$wk;
                $fca22c47c90d13d9$var$wk = null;
                $fca22c47c90d13d9$var$xk = 0;
                if (0 !== ($fca22c47c90d13d9$var$K & 6)) throw Error($fca22c47c90d13d9$var$p(331));
                var e = $fca22c47c90d13d9$var$K;
                $fca22c47c90d13d9$var$K |= 4;
                for($fca22c47c90d13d9$var$V = a.current; null !== $fca22c47c90d13d9$var$V;){
                    var f = $fca22c47c90d13d9$var$V, g = f.child;
                    if (0 !== ($fca22c47c90d13d9$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fca22c47c90d13d9$var$V = l; null !== $fca22c47c90d13d9$var$V;){
                                    var m = $fca22c47c90d13d9$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fca22c47c90d13d9$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fca22c47c90d13d9$var$V = q;
                                    else for(; null !== $fca22c47c90d13d9$var$V;){
                                        m = $fca22c47c90d13d9$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fca22c47c90d13d9$var$Sj(m);
                                        if (m === l) {
                                            $fca22c47c90d13d9$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fca22c47c90d13d9$var$V = r;
                                            break;
                                        }
                                        $fca22c47c90d13d9$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fca22c47c90d13d9$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fca22c47c90d13d9$var$V = g;
                    else b: for(; null !== $fca22c47c90d13d9$var$V;){
                        f = $fca22c47c90d13d9$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fca22c47c90d13d9$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fca22c47c90d13d9$var$V = x;
                            break b;
                        }
                        $fca22c47c90d13d9$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fca22c47c90d13d9$var$V = w; null !== $fca22c47c90d13d9$var$V;){
                    g = $fca22c47c90d13d9$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fca22c47c90d13d9$var$V = u;
                    else b: for(g = w; null !== $fca22c47c90d13d9$var$V;){
                        h = $fca22c47c90d13d9$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fca22c47c90d13d9$var$Qj(9, h);
                            }
                        } catch (na) {
                            $fca22c47c90d13d9$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fca22c47c90d13d9$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fca22c47c90d13d9$var$V = F;
                            break b;
                        }
                        $fca22c47c90d13d9$var$V = h.return;
                    }
                }
                $fca22c47c90d13d9$var$K = e;
                $fca22c47c90d13d9$var$jg();
                if ($fca22c47c90d13d9$var$lc && "function" === typeof $fca22c47c90d13d9$var$lc.onPostCommitFiberRoot) try {
                    $fca22c47c90d13d9$var$lc.onPostCommitFiberRoot($fca22c47c90d13d9$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fca22c47c90d13d9$var$C = c, $fca22c47c90d13d9$var$ok.transition = b;
        }
    }
    return !1;
}
function $fca22c47c90d13d9$var$Xk(a, b, c) {
    b = $fca22c47c90d13d9$var$Ji(c, b);
    b = $fca22c47c90d13d9$var$Ni(a, b, 1);
    a = $fca22c47c90d13d9$var$nh(a, b, 1);
    b = $fca22c47c90d13d9$var$R();
    null !== a && ($fca22c47c90d13d9$var$Ac(a, 1, b), $fca22c47c90d13d9$var$Dk(a, b));
}
function $fca22c47c90d13d9$var$W(a, b, c) {
    if (3 === a.tag) $fca22c47c90d13d9$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fca22c47c90d13d9$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fca22c47c90d13d9$var$Ri || !$fca22c47c90d13d9$var$Ri.has(d))) {
                a = $fca22c47c90d13d9$var$Ji(c, a);
                a = $fca22c47c90d13d9$var$Qi(b, a, 1);
                b = $fca22c47c90d13d9$var$nh(b, a, 1);
                a = $fca22c47c90d13d9$var$R();
                null !== b && ($fca22c47c90d13d9$var$Ac(b, 1, a), $fca22c47c90d13d9$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fca22c47c90d13d9$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fca22c47c90d13d9$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $fca22c47c90d13d9$var$Q === a && ($fca22c47c90d13d9$var$Z & c) === c && (4 === $fca22c47c90d13d9$var$T || 3 === $fca22c47c90d13d9$var$T && ($fca22c47c90d13d9$var$Z & 130023424) === $fca22c47c90d13d9$var$Z && 500 > $fca22c47c90d13d9$var$B() - $fca22c47c90d13d9$var$fk ? $fca22c47c90d13d9$var$Kk(a, 0) : $fca22c47c90d13d9$var$rk |= c);
    $fca22c47c90d13d9$var$Dk(a, b);
}
function $fca22c47c90d13d9$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fca22c47c90d13d9$var$sc, $fca22c47c90d13d9$var$sc <<= 1, 0 === ($fca22c47c90d13d9$var$sc & 130023424) && ($fca22c47c90d13d9$var$sc = 4194304)));
    var c = $fca22c47c90d13d9$var$R();
    a = $fca22c47c90d13d9$var$ih(a, b);
    null !== a && ($fca22c47c90d13d9$var$Ac(a, b, c), $fca22c47c90d13d9$var$Dk(a, c));
}
function $fca22c47c90d13d9$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fca22c47c90d13d9$var$Yk(a, c);
}
function $fca22c47c90d13d9$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fca22c47c90d13d9$var$p(314));
    }
    null !== d && d.delete(b);
    $fca22c47c90d13d9$var$Yk(a, c);
}
var $fca22c47c90d13d9$var$Vk;
$fca22c47c90d13d9$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fca22c47c90d13d9$var$Wf.current) $fca22c47c90d13d9$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fca22c47c90d13d9$var$dh = !1, $fca22c47c90d13d9$var$yj(a, b, c);
            $fca22c47c90d13d9$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fca22c47c90d13d9$var$dh = !1, $fca22c47c90d13d9$var$I && 0 !== (b.flags & 1048576) && $fca22c47c90d13d9$var$ug(b, $fca22c47c90d13d9$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fca22c47c90d13d9$var$ij(a, b);
            a = b.pendingProps;
            var e = $fca22c47c90d13d9$var$Yf(b, $fca22c47c90d13d9$var$H.current);
            $fca22c47c90d13d9$var$ch(b, c);
            e = $fca22c47c90d13d9$var$Nh(null, b, d, a, e, c);
            var f = $fca22c47c90d13d9$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fca22c47c90d13d9$var$Zf(d) ? (f = !0, $fca22c47c90d13d9$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fca22c47c90d13d9$var$kh(b), e.updater = $fca22c47c90d13d9$var$Ei, b.stateNode = e, e._reactInternals = b, $fca22c47c90d13d9$var$Ii(b, d, a, c), b = $fca22c47c90d13d9$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $fca22c47c90d13d9$var$I && f && $fca22c47c90d13d9$var$vg(b), $fca22c47c90d13d9$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fca22c47c90d13d9$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fca22c47c90d13d9$var$Zk(d);
                a = $fca22c47c90d13d9$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $fca22c47c90d13d9$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fca22c47c90d13d9$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fca22c47c90d13d9$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fca22c47c90d13d9$var$$i(null, b, d, $fca22c47c90d13d9$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($fca22c47c90d13d9$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fca22c47c90d13d9$var$Ci(d, e), $fca22c47c90d13d9$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fca22c47c90d13d9$var$Ci(d, e), $fca22c47c90d13d9$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $fca22c47c90d13d9$var$kj(b);
                if (null === a) throw Error($fca22c47c90d13d9$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fca22c47c90d13d9$var$lh(a, b);
                $fca22c47c90d13d9$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fca22c47c90d13d9$var$Ji(Error($fca22c47c90d13d9$var$p(423)), b);
                        b = $fca22c47c90d13d9$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fca22c47c90d13d9$var$Ji(Error($fca22c47c90d13d9$var$p(424)), b);
                        b = $fca22c47c90d13d9$var$lj(a, b, d, c, e);
                        break a;
                    } else for($fca22c47c90d13d9$var$yg = $fca22c47c90d13d9$var$Lf(b.stateNode.containerInfo.firstChild), $fca22c47c90d13d9$var$xg = b, $fca22c47c90d13d9$var$I = !0, $fca22c47c90d13d9$var$zg = null, c = $fca22c47c90d13d9$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fca22c47c90d13d9$var$Ig();
                    if (d === e) {
                        b = $fca22c47c90d13d9$var$Zi(a, b, c);
                        break a;
                    }
                    $fca22c47c90d13d9$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fca22c47c90d13d9$var$Ah(b), null === a && $fca22c47c90d13d9$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fca22c47c90d13d9$var$Ef(d, e) ? g = null : null !== f && $fca22c47c90d13d9$var$Ef(d, f) && (b.flags |= 32), $fca22c47c90d13d9$var$gj(a, b), $fca22c47c90d13d9$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $fca22c47c90d13d9$var$Eg(b), null;
        case 13:
            return $fca22c47c90d13d9$var$oj(a, b, c);
        case 4:
            return $fca22c47c90d13d9$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fca22c47c90d13d9$var$Ug(b, null, d, c) : $fca22c47c90d13d9$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fca22c47c90d13d9$var$Ci(d, e), $fca22c47c90d13d9$var$Yi(a, b, d, e, c);
        case 7:
            return $fca22c47c90d13d9$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fca22c47c90d13d9$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fca22c47c90d13d9$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fca22c47c90d13d9$var$G($fca22c47c90d13d9$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fca22c47c90d13d9$var$He(f.value, g)) {
                        if (f.children === e.children && !$fca22c47c90d13d9$var$Wf.current) {
                            b = $fca22c47c90d13d9$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fca22c47c90d13d9$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fca22c47c90d13d9$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fca22c47c90d13d9$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fca22c47c90d13d9$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fca22c47c90d13d9$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fca22c47c90d13d9$var$ch(b, c), e = $fca22c47c90d13d9$var$eh(e), d = d(e), b.flags |= 1, $fca22c47c90d13d9$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fca22c47c90d13d9$var$Ci(d, b.pendingProps), e = $fca22c47c90d13d9$var$Ci(d.type, e), $fca22c47c90d13d9$var$$i(a, b, d, e, c);
        case 15:
            return $fca22c47c90d13d9$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fca22c47c90d13d9$var$Ci(d, e), $fca22c47c90d13d9$var$ij(a, b), b.tag = 1, $fca22c47c90d13d9$var$Zf(d) ? (a = !0, $fca22c47c90d13d9$var$cg(b)) : a = !1, $fca22c47c90d13d9$var$ch(b, c), $fca22c47c90d13d9$var$Gi(b, d, e), $fca22c47c90d13d9$var$Ii(b, d, e, c), $fca22c47c90d13d9$var$jj(null, b, d, !0, a, c);
        case 19:
            return $fca22c47c90d13d9$var$xj(a, b, c);
        case 22:
            return $fca22c47c90d13d9$var$dj(a, b, c);
    }
    throw Error($fca22c47c90d13d9$var$p(156, b.tag));
};
function $fca22c47c90d13d9$var$Fk(a, b) {
    return $fca22c47c90d13d9$var$ac(a, b);
}
function $fca22c47c90d13d9$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fca22c47c90d13d9$var$Bg(a, b, c, d) {
    return new $fca22c47c90d13d9$var$$k(a, b, c, d);
}
function $fca22c47c90d13d9$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fca22c47c90d13d9$var$Zk(a) {
    if ("function" === typeof a) return $fca22c47c90d13d9$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fca22c47c90d13d9$var$Da) return 11;
        if (a === $fca22c47c90d13d9$var$Ga) return 14;
    }
    return 2;
}
function $fca22c47c90d13d9$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $fca22c47c90d13d9$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fca22c47c90d13d9$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fca22c47c90d13d9$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fca22c47c90d13d9$var$ya:
            return $fca22c47c90d13d9$var$Tg(c.children, e, f, b);
        case $fca22c47c90d13d9$var$za:
            g = 8;
            e |= 8;
            break;
        case $fca22c47c90d13d9$var$Aa:
            return a = $fca22c47c90d13d9$var$Bg(12, c, b, e | 2), a.elementType = $fca22c47c90d13d9$var$Aa, a.lanes = f, a;
        case $fca22c47c90d13d9$var$Ea:
            return a = $fca22c47c90d13d9$var$Bg(13, c, b, e), a.elementType = $fca22c47c90d13d9$var$Ea, a.lanes = f, a;
        case $fca22c47c90d13d9$var$Fa:
            return a = $fca22c47c90d13d9$var$Bg(19, c, b, e), a.elementType = $fca22c47c90d13d9$var$Fa, a.lanes = f, a;
        case $fca22c47c90d13d9$var$Ia:
            return $fca22c47c90d13d9$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fca22c47c90d13d9$var$Ba:
                    g = 10;
                    break a;
                case $fca22c47c90d13d9$var$Ca:
                    g = 9;
                    break a;
                case $fca22c47c90d13d9$var$Da:
                    g = 11;
                    break a;
                case $fca22c47c90d13d9$var$Ga:
                    g = 14;
                    break a;
                case $fca22c47c90d13d9$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fca22c47c90d13d9$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fca22c47c90d13d9$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fca22c47c90d13d9$var$Tg(a, b, c, d) {
    a = $fca22c47c90d13d9$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fca22c47c90d13d9$var$pj(a, b, c, d) {
    a = $fca22c47c90d13d9$var$Bg(22, a, d, b);
    a.elementType = $fca22c47c90d13d9$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fca22c47c90d13d9$var$Qg(a, b, c) {
    a = $fca22c47c90d13d9$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fca22c47c90d13d9$var$Sg(a, b, c) {
    b = $fca22c47c90d13d9$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fca22c47c90d13d9$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fca22c47c90d13d9$var$zc(0);
    this.expirationTimes = $fca22c47c90d13d9$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fca22c47c90d13d9$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fca22c47c90d13d9$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $fca22c47c90d13d9$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fca22c47c90d13d9$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fca22c47c90d13d9$var$kh(f);
    return a;
}
function $fca22c47c90d13d9$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fca22c47c90d13d9$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fca22c47c90d13d9$var$dl(a) {
    if (!a) return $fca22c47c90d13d9$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fca22c47c90d13d9$var$Vb(a) !== a || 1 !== a.tag) throw Error($fca22c47c90d13d9$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fca22c47c90d13d9$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fca22c47c90d13d9$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fca22c47c90d13d9$var$Zf(c)) return $fca22c47c90d13d9$var$bg(a, c, b);
    }
    return b;
}
function $fca22c47c90d13d9$var$el(a, b, c, d, e, f, g, h, k) {
    a = $fca22c47c90d13d9$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $fca22c47c90d13d9$var$dl(null);
    c = a.current;
    d = $fca22c47c90d13d9$var$R();
    e = $fca22c47c90d13d9$var$yi(c);
    f = $fca22c47c90d13d9$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fca22c47c90d13d9$var$nh(c, f, e);
    a.current.lanes = e;
    $fca22c47c90d13d9$var$Ac(a, e, d);
    $fca22c47c90d13d9$var$Dk(a, d);
    return a;
}
function $fca22c47c90d13d9$var$fl(a, b, c, d) {
    var e = b.current, f = $fca22c47c90d13d9$var$R(), g = $fca22c47c90d13d9$var$yi(e);
    c = $fca22c47c90d13d9$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fca22c47c90d13d9$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fca22c47c90d13d9$var$nh(e, b, g);
    null !== a && ($fca22c47c90d13d9$var$gi(a, e, g, f), $fca22c47c90d13d9$var$oh(a, e, g));
    return g;
}
function $fca22c47c90d13d9$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fca22c47c90d13d9$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fca22c47c90d13d9$var$il(a, b) {
    $fca22c47c90d13d9$var$hl(a, b);
    (a = a.alternate) && $fca22c47c90d13d9$var$hl(a, b);
}
function $fca22c47c90d13d9$var$jl() {
    return null;
}
var $fca22c47c90d13d9$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fca22c47c90d13d9$var$ll(a) {
    this._internalRoot = a;
}
$fca22c47c90d13d9$var$ml.prototype.render = $fca22c47c90d13d9$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fca22c47c90d13d9$var$p(409));
    $fca22c47c90d13d9$var$fl(a, b, null, null);
};
$fca22c47c90d13d9$var$ml.prototype.unmount = $fca22c47c90d13d9$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fca22c47c90d13d9$var$Rk(function() {
            $fca22c47c90d13d9$var$fl(null, a, null, null);
        });
        b[$fca22c47c90d13d9$var$uf] = null;
    }
};
function $fca22c47c90d13d9$var$ml(a) {
    this._internalRoot = a;
}
$fca22c47c90d13d9$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fca22c47c90d13d9$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fca22c47c90d13d9$var$Qc.length && 0 !== b && b < $fca22c47c90d13d9$var$Qc[c].priority; c++);
        $fca22c47c90d13d9$var$Qc.splice(c, 0, a);
        0 === c && $fca22c47c90d13d9$var$Vc(a);
    }
};
function $fca22c47c90d13d9$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fca22c47c90d13d9$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fca22c47c90d13d9$var$pl() {}
function $fca22c47c90d13d9$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fca22c47c90d13d9$var$gl(g);
                f.call(a);
            };
        }
        var g = $fca22c47c90d13d9$var$el(b, d, a, 0, null, !1, !1, "", $fca22c47c90d13d9$var$pl);
        a._reactRootContainer = g;
        a[$fca22c47c90d13d9$var$uf] = g.current;
        $fca22c47c90d13d9$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fca22c47c90d13d9$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fca22c47c90d13d9$var$gl(k);
            h.call(a);
        };
    }
    var k = $fca22c47c90d13d9$var$bl(a, 0, !1, null, null, !1, !1, "", $fca22c47c90d13d9$var$pl);
    a._reactRootContainer = k;
    a[$fca22c47c90d13d9$var$uf] = k.current;
    $fca22c47c90d13d9$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fca22c47c90d13d9$var$Rk(function() {
        $fca22c47c90d13d9$var$fl(b, k, c, d);
    });
    return k;
}
function $fca22c47c90d13d9$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fca22c47c90d13d9$var$gl(g);
                h.call(a);
            };
        }
        $fca22c47c90d13d9$var$fl(b, g, a, e);
    } else g = $fca22c47c90d13d9$var$ql(c, b, a, e, d);
    return $fca22c47c90d13d9$var$gl(g);
}
$fca22c47c90d13d9$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fca22c47c90d13d9$var$tc(b.pendingLanes);
                0 !== c && ($fca22c47c90d13d9$var$Cc(b, c | 1), $fca22c47c90d13d9$var$Dk(b, $fca22c47c90d13d9$var$B()), 0 === ($fca22c47c90d13d9$var$K & 6) && ($fca22c47c90d13d9$var$Gj = $fca22c47c90d13d9$var$B() + 500, $fca22c47c90d13d9$var$jg()));
            }
            break;
        case 13:
            $fca22c47c90d13d9$var$Rk(function() {
                var b = $fca22c47c90d13d9$var$ih(a, 1);
                if (null !== b) {
                    var c = $fca22c47c90d13d9$var$R();
                    $fca22c47c90d13d9$var$gi(b, a, 1, c);
                }
            }), $fca22c47c90d13d9$var$il(a, 1);
    }
};
$fca22c47c90d13d9$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fca22c47c90d13d9$var$ih(a, 134217728);
        if (null !== b) {
            var c = $fca22c47c90d13d9$var$R();
            $fca22c47c90d13d9$var$gi(b, a, 134217728, c);
        }
        $fca22c47c90d13d9$var$il(a, 134217728);
    }
};
$fca22c47c90d13d9$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fca22c47c90d13d9$var$yi(a), c = $fca22c47c90d13d9$var$ih(a, b);
        if (null !== c) {
            var d = $fca22c47c90d13d9$var$R();
            $fca22c47c90d13d9$var$gi(c, a, b, d);
        }
        $fca22c47c90d13d9$var$il(a, b);
    }
};
$fca22c47c90d13d9$var$Hc = function() {
    return $fca22c47c90d13d9$var$C;
};
$fca22c47c90d13d9$var$Ic = function(a, b) {
    var c = $fca22c47c90d13d9$var$C;
    try {
        return $fca22c47c90d13d9$var$C = a, b();
    } finally{
        $fca22c47c90d13d9$var$C = c;
    }
};
$fca22c47c90d13d9$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fca22c47c90d13d9$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fca22c47c90d13d9$var$Db(d);
                        if (!e) throw Error($fca22c47c90d13d9$var$p(90));
                        $fca22c47c90d13d9$var$Wa(d);
                        $fca22c47c90d13d9$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fca22c47c90d13d9$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fca22c47c90d13d9$var$fb(a, !!c.multiple, b, !1);
    }
};
$fca22c47c90d13d9$var$Gb = $fca22c47c90d13d9$var$Qk;
$fca22c47c90d13d9$var$Hb = $fca22c47c90d13d9$var$Rk;
var $fca22c47c90d13d9$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $fca22c47c90d13d9$var$Cb,
        $fca22c47c90d13d9$var$ue,
        $fca22c47c90d13d9$var$Db,
        $fca22c47c90d13d9$var$Eb,
        $fca22c47c90d13d9$var$Fb,
        $fca22c47c90d13d9$var$Qk
    ]
}, $fca22c47c90d13d9$var$tl = {
    findFiberByHostInstance: $fca22c47c90d13d9$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $fca22c47c90d13d9$var$ul = {
    bundleType: $fca22c47c90d13d9$var$tl.bundleType,
    version: $fca22c47c90d13d9$var$tl.version,
    rendererPackageName: $fca22c47c90d13d9$var$tl.rendererPackageName,
    rendererConfig: $fca22c47c90d13d9$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fca22c47c90d13d9$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fca22c47c90d13d9$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fca22c47c90d13d9$var$tl.findFiberByHostInstance || $fca22c47c90d13d9$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fca22c47c90d13d9$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fca22c47c90d13d9$var$vl.isDisabled && $fca22c47c90d13d9$var$vl.supportsFiber) try {
        $fca22c47c90d13d9$var$kc = $fca22c47c90d13d9$var$vl.inject($fca22c47c90d13d9$var$ul), $fca22c47c90d13d9$var$lc = $fca22c47c90d13d9$var$vl;
    } catch (a) {}
}
$fca22c47c90d13d9$export$ae55be85d98224ed = $fca22c47c90d13d9$var$sl;
$fca22c47c90d13d9$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fca22c47c90d13d9$var$nl(b)) throw Error($fca22c47c90d13d9$var$p(200));
    return $fca22c47c90d13d9$var$cl(a, b, null, c);
};
$fca22c47c90d13d9$export$882461b6382ed46c = function(a, b) {
    if (!$fca22c47c90d13d9$var$nl(a)) throw Error($fca22c47c90d13d9$var$p(299));
    var c = !1, d = "", e = $fca22c47c90d13d9$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fca22c47c90d13d9$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$fca22c47c90d13d9$var$uf] = b.current;
    $fca22c47c90d13d9$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fca22c47c90d13d9$var$ll(b);
};
$fca22c47c90d13d9$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fca22c47c90d13d9$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fca22c47c90d13d9$var$p(268, a));
    }
    a = $fca22c47c90d13d9$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fca22c47c90d13d9$export$cd75ccfd720a3cd4 = function(a) {
    return $fca22c47c90d13d9$var$Rk(a);
};
$fca22c47c90d13d9$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fca22c47c90d13d9$var$ol(b)) throw Error($fca22c47c90d13d9$var$p(200));
    return $fca22c47c90d13d9$var$rl(null, a, b, !0, c);
};
$fca22c47c90d13d9$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fca22c47c90d13d9$var$nl(a)) throw Error($fca22c47c90d13d9$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fca22c47c90d13d9$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fca22c47c90d13d9$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fca22c47c90d13d9$var$uf] = b.current;
    $fca22c47c90d13d9$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fca22c47c90d13d9$var$ml(b);
};
$fca22c47c90d13d9$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fca22c47c90d13d9$var$ol(b)) throw Error($fca22c47c90d13d9$var$p(200));
    return $fca22c47c90d13d9$var$rl(null, a, b, !1, c);
};
$fca22c47c90d13d9$export$502457920280e6be = function(a) {
    if (!$fca22c47c90d13d9$var$ol(a)) throw Error($fca22c47c90d13d9$var$p(40));
    return a._reactRootContainer ? ($fca22c47c90d13d9$var$Rk(function() {
        $fca22c47c90d13d9$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fca22c47c90d13d9$var$uf] = null;
        });
    }), !0) : !1;
};
$fca22c47c90d13d9$export$c78a37762a8d58e1 = $fca22c47c90d13d9$var$Qk;
$fca22c47c90d13d9$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fca22c47c90d13d9$var$ol(c)) throw Error($fca22c47c90d13d9$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fca22c47c90d13d9$var$p(38));
    return $fca22c47c90d13d9$var$rl(a, b, c, !1, d);
};
$fca22c47c90d13d9$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lq9zh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("d5W3x"));

});
parcelRegister("d5W3x", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $9888c6bd809591d2$export$c4744153514ff05d, (v) => $9888c6bd809591d2$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $9888c6bd809591d2$export$3e506c1ccc9cc1a7, (v) => $9888c6bd809591d2$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $9888c6bd809591d2$export$e26fe2ed2fa76875, (v) => $9888c6bd809591d2$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $9888c6bd809591d2$export$502329bbf4b505b1, (v) => $9888c6bd809591d2$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $9888c6bd809591d2$export$6e3807111c4874c4, (v) => $9888c6bd809591d2$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $9888c6bd809591d2$export$c27134553091fb3a, (v) => $9888c6bd809591d2$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $9888c6bd809591d2$export$33ee1acdc04fd2a2, (v) => $9888c6bd809591d2$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $9888c6bd809591d2$export$b00a404bbd5edef2, (v) => $9888c6bd809591d2$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $9888c6bd809591d2$export$8352ce38b91d0c62, (v) => $9888c6bd809591d2$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $9888c6bd809591d2$export$d66a1c1c77bd778b, (v) => $9888c6bd809591d2$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $9888c6bd809591d2$export$d3dfb8e4810cb555, (v) => $9888c6bd809591d2$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $9888c6bd809591d2$export$839f9183b0465a69, (v) => $9888c6bd809591d2$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $9888c6bd809591d2$export$72fdf0e06517287b, (v) => $9888c6bd809591d2$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $9888c6bd809591d2$export$4b844e58a3e414b4, (v) => $9888c6bd809591d2$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $9888c6bd809591d2$export$816d2913ae6b83b1, (v) => $9888c6bd809591d2$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $9888c6bd809591d2$export$61bcfe829111a1d0, (v) => $9888c6bd809591d2$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $9888c6bd809591d2$export$7ee8c9beb337bc3f, (v) => $9888c6bd809591d2$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $9888c6bd809591d2$export$b5836b71941fa3ed, (v) => $9888c6bd809591d2$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $9888c6bd809591d2$export$cf845f2c119da08a, (v) => $9888c6bd809591d2$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9888c6bd809591d2$export$c4744153514ff05d;
var $9888c6bd809591d2$export$3e506c1ccc9cc1a7;
var $9888c6bd809591d2$export$e26fe2ed2fa76875;
var $9888c6bd809591d2$export$502329bbf4b505b1;
var $9888c6bd809591d2$export$6e3807111c4874c4;
var $9888c6bd809591d2$export$c27134553091fb3a;
var $9888c6bd809591d2$export$33ee1acdc04fd2a2;
var $9888c6bd809591d2$export$b00a404bbd5edef2;
var $9888c6bd809591d2$export$8352ce38b91d0c62;
var $9888c6bd809591d2$export$d66a1c1c77bd778b;
var $9888c6bd809591d2$export$d3dfb8e4810cb555;
var $9888c6bd809591d2$export$839f9183b0465a69;
var $9888c6bd809591d2$export$72fdf0e06517287b;
var $9888c6bd809591d2$export$4b844e58a3e414b4;
var $9888c6bd809591d2$export$816d2913ae6b83b1;
var $9888c6bd809591d2$export$61bcfe829111a1d0;
var $9888c6bd809591d2$export$7ee8c9beb337bc3f;
var $9888c6bd809591d2$export$b5836b71941fa3ed;
var $9888c6bd809591d2$export$cf845f2c119da08a;
'use strict';
function $9888c6bd809591d2$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9888c6bd809591d2$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9888c6bd809591d2$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9888c6bd809591d2$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9888c6bd809591d2$var$g(C, c)) n < e && 0 > $9888c6bd809591d2$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9888c6bd809591d2$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9888c6bd809591d2$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9888c6bd809591d2$var$l = performance;
    $9888c6bd809591d2$export$c4744153514ff05d = function() {
        return $9888c6bd809591d2$var$l.now();
    };
} else {
    var $9888c6bd809591d2$var$p = Date, $9888c6bd809591d2$var$q = $9888c6bd809591d2$var$p.now();
    $9888c6bd809591d2$export$c4744153514ff05d = function() {
        return $9888c6bd809591d2$var$p.now() - $9888c6bd809591d2$var$q;
    };
}
var $9888c6bd809591d2$var$r = [], $9888c6bd809591d2$var$t = [], $9888c6bd809591d2$var$u = 1, $9888c6bd809591d2$var$v = null, $9888c6bd809591d2$var$y = 3, $9888c6bd809591d2$var$z = !1, $9888c6bd809591d2$var$A = !1, $9888c6bd809591d2$var$B = !1, $9888c6bd809591d2$var$D = "function" === typeof setTimeout ? setTimeout : null, $9888c6bd809591d2$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9888c6bd809591d2$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9888c6bd809591d2$var$G(a) {
    for(var b = $9888c6bd809591d2$var$h($9888c6bd809591d2$var$t); null !== b;){
        if (null === b.callback) $9888c6bd809591d2$var$k($9888c6bd809591d2$var$t);
        else if (b.startTime <= a) $9888c6bd809591d2$var$k($9888c6bd809591d2$var$t), b.sortIndex = b.expirationTime, $9888c6bd809591d2$var$f($9888c6bd809591d2$var$r, b);
        else break;
        b = $9888c6bd809591d2$var$h($9888c6bd809591d2$var$t);
    }
}
function $9888c6bd809591d2$var$H(a) {
    $9888c6bd809591d2$var$B = !1;
    $9888c6bd809591d2$var$G(a);
    if (!$9888c6bd809591d2$var$A) {
        if (null !== $9888c6bd809591d2$var$h($9888c6bd809591d2$var$r)) $9888c6bd809591d2$var$A = !0, $9888c6bd809591d2$var$I($9888c6bd809591d2$var$J);
        else {
            var b = $9888c6bd809591d2$var$h($9888c6bd809591d2$var$t);
            null !== b && $9888c6bd809591d2$var$K($9888c6bd809591d2$var$H, b.startTime - a);
        }
    }
}
function $9888c6bd809591d2$var$J(a, b) {
    $9888c6bd809591d2$var$A = !1;
    $9888c6bd809591d2$var$B && ($9888c6bd809591d2$var$B = !1, $9888c6bd809591d2$var$E($9888c6bd809591d2$var$L), $9888c6bd809591d2$var$L = -1);
    $9888c6bd809591d2$var$z = !0;
    var c = $9888c6bd809591d2$var$y;
    try {
        $9888c6bd809591d2$var$G(b);
        for($9888c6bd809591d2$var$v = $9888c6bd809591d2$var$h($9888c6bd809591d2$var$r); null !== $9888c6bd809591d2$var$v && (!($9888c6bd809591d2$var$v.expirationTime > b) || a && !$9888c6bd809591d2$var$M());){
            var d = $9888c6bd809591d2$var$v.callback;
            if ("function" === typeof d) {
                $9888c6bd809591d2$var$v.callback = null;
                $9888c6bd809591d2$var$y = $9888c6bd809591d2$var$v.priorityLevel;
                var e = d($9888c6bd809591d2$var$v.expirationTime <= b);
                b = $9888c6bd809591d2$export$c4744153514ff05d();
                "function" === typeof e ? $9888c6bd809591d2$var$v.callback = e : $9888c6bd809591d2$var$v === $9888c6bd809591d2$var$h($9888c6bd809591d2$var$r) && $9888c6bd809591d2$var$k($9888c6bd809591d2$var$r);
                $9888c6bd809591d2$var$G(b);
            } else $9888c6bd809591d2$var$k($9888c6bd809591d2$var$r);
            $9888c6bd809591d2$var$v = $9888c6bd809591d2$var$h($9888c6bd809591d2$var$r);
        }
        if (null !== $9888c6bd809591d2$var$v) var w = !0;
        else {
            var m = $9888c6bd809591d2$var$h($9888c6bd809591d2$var$t);
            null !== m && $9888c6bd809591d2$var$K($9888c6bd809591d2$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9888c6bd809591d2$var$v = null, $9888c6bd809591d2$var$y = c, $9888c6bd809591d2$var$z = !1;
    }
}
var $9888c6bd809591d2$var$N = !1, $9888c6bd809591d2$var$O = null, $9888c6bd809591d2$var$L = -1, $9888c6bd809591d2$var$P = 5, $9888c6bd809591d2$var$Q = -1;
function $9888c6bd809591d2$var$M() {
    return $9888c6bd809591d2$export$c4744153514ff05d() - $9888c6bd809591d2$var$Q < $9888c6bd809591d2$var$P ? !1 : !0;
}
function $9888c6bd809591d2$var$R() {
    if (null !== $9888c6bd809591d2$var$O) {
        var a = $9888c6bd809591d2$export$c4744153514ff05d();
        $9888c6bd809591d2$var$Q = a;
        var b = !0;
        try {
            b = $9888c6bd809591d2$var$O(!0, a);
        } finally{
            b ? $9888c6bd809591d2$var$S() : ($9888c6bd809591d2$var$N = !1, $9888c6bd809591d2$var$O = null);
        }
    } else $9888c6bd809591d2$var$N = !1;
}
var $9888c6bd809591d2$var$S;
if ("function" === typeof $9888c6bd809591d2$var$F) $9888c6bd809591d2$var$S = function() {
    $9888c6bd809591d2$var$F($9888c6bd809591d2$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9888c6bd809591d2$var$T = new MessageChannel, $9888c6bd809591d2$var$U = $9888c6bd809591d2$var$T.port2;
    $9888c6bd809591d2$var$T.port1.onmessage = $9888c6bd809591d2$var$R;
    $9888c6bd809591d2$var$S = function() {
        $9888c6bd809591d2$var$U.postMessage(null);
    };
} else $9888c6bd809591d2$var$S = function() {
    $9888c6bd809591d2$var$D($9888c6bd809591d2$var$R, 0);
};
function $9888c6bd809591d2$var$I(a) {
    $9888c6bd809591d2$var$O = a;
    $9888c6bd809591d2$var$N || ($9888c6bd809591d2$var$N = !0, $9888c6bd809591d2$var$S());
}
function $9888c6bd809591d2$var$K(a, b) {
    $9888c6bd809591d2$var$L = $9888c6bd809591d2$var$D(function() {
        a($9888c6bd809591d2$export$c4744153514ff05d());
    }, b);
}
$9888c6bd809591d2$export$3e506c1ccc9cc1a7 = 5;
$9888c6bd809591d2$export$e26fe2ed2fa76875 = 1;
$9888c6bd809591d2$export$502329bbf4b505b1 = 4;
$9888c6bd809591d2$export$6e3807111c4874c4 = 3;
$9888c6bd809591d2$export$c27134553091fb3a = null;
$9888c6bd809591d2$export$33ee1acdc04fd2a2 = 2;
$9888c6bd809591d2$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9888c6bd809591d2$export$8352ce38b91d0c62 = function() {
    $9888c6bd809591d2$var$A || $9888c6bd809591d2$var$z || ($9888c6bd809591d2$var$A = !0, $9888c6bd809591d2$var$I($9888c6bd809591d2$var$J));
};
$9888c6bd809591d2$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9888c6bd809591d2$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9888c6bd809591d2$export$d3dfb8e4810cb555 = function() {
    return $9888c6bd809591d2$var$y;
};
$9888c6bd809591d2$export$839f9183b0465a69 = function() {
    return $9888c6bd809591d2$var$h($9888c6bd809591d2$var$r);
};
$9888c6bd809591d2$export$72fdf0e06517287b = function(a) {
    switch($9888c6bd809591d2$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9888c6bd809591d2$var$y;
    }
    var c = $9888c6bd809591d2$var$y;
    $9888c6bd809591d2$var$y = b;
    try {
        return a();
    } finally{
        $9888c6bd809591d2$var$y = c;
    }
};
$9888c6bd809591d2$export$4b844e58a3e414b4 = function() {};
$9888c6bd809591d2$export$816d2913ae6b83b1 = function() {};
$9888c6bd809591d2$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9888c6bd809591d2$var$y;
    $9888c6bd809591d2$var$y = a;
    try {
        return b();
    } finally{
        $9888c6bd809591d2$var$y = c;
    }
};
$9888c6bd809591d2$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9888c6bd809591d2$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9888c6bd809591d2$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9888c6bd809591d2$var$f($9888c6bd809591d2$var$t, a), null === $9888c6bd809591d2$var$h($9888c6bd809591d2$var$r) && a === $9888c6bd809591d2$var$h($9888c6bd809591d2$var$t) && ($9888c6bd809591d2$var$B ? ($9888c6bd809591d2$var$E($9888c6bd809591d2$var$L), $9888c6bd809591d2$var$L = -1) : $9888c6bd809591d2$var$B = !0, $9888c6bd809591d2$var$K($9888c6bd809591d2$var$H, c - d))) : (a.sortIndex = e, $9888c6bd809591d2$var$f($9888c6bd809591d2$var$r, a), $9888c6bd809591d2$var$A || $9888c6bd809591d2$var$z || ($9888c6bd809591d2$var$A = !0, $9888c6bd809591d2$var$I($9888c6bd809591d2$var$J)));
    return a;
};
$9888c6bd809591d2$export$b5836b71941fa3ed = $9888c6bd809591d2$var$M;
$9888c6bd809591d2$export$cf845f2c119da08a = function(a) {
    var b = $9888c6bd809591d2$var$y;
    return function() {
        var c = $9888c6bd809591d2$var$y;
        $9888c6bd809591d2$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9888c6bd809591d2$var$y = c;
        }
    };
};

});



// packages/alpinejs/src/scheduler.js
var $985235fe3ee13b60$var$flushPending = false;
var $985235fe3ee13b60$var$flushing = false;
var $985235fe3ee13b60$var$queue = [];
var $985235fe3ee13b60$var$lastFlushedIndex = -1;
function $985235fe3ee13b60$var$scheduler(callback) {
    $985235fe3ee13b60$var$queueJob(callback);
}
function $985235fe3ee13b60$var$queueJob(job) {
    if (!$985235fe3ee13b60$var$queue.includes(job)) $985235fe3ee13b60$var$queue.push(job);
    $985235fe3ee13b60$var$queueFlush();
}
function $985235fe3ee13b60$var$dequeueJob(job) {
    let index = $985235fe3ee13b60$var$queue.indexOf(job);
    if (index !== -1 && index > $985235fe3ee13b60$var$lastFlushedIndex) $985235fe3ee13b60$var$queue.splice(index, 1);
}
function $985235fe3ee13b60$var$queueFlush() {
    if (!$985235fe3ee13b60$var$flushing && !$985235fe3ee13b60$var$flushPending) {
        $985235fe3ee13b60$var$flushPending = true;
        queueMicrotask($985235fe3ee13b60$var$flushJobs);
    }
}
function $985235fe3ee13b60$var$flushJobs() {
    $985235fe3ee13b60$var$flushPending = false;
    $985235fe3ee13b60$var$flushing = true;
    for(let i = 0; i < $985235fe3ee13b60$var$queue.length; i++){
        $985235fe3ee13b60$var$queue[i]();
        $985235fe3ee13b60$var$lastFlushedIndex = i;
    }
    $985235fe3ee13b60$var$queue.length = 0;
    $985235fe3ee13b60$var$lastFlushedIndex = -1;
    $985235fe3ee13b60$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $985235fe3ee13b60$var$reactive;
var $985235fe3ee13b60$var$effect;
var $985235fe3ee13b60$var$release;
var $985235fe3ee13b60$var$raw;
var $985235fe3ee13b60$var$shouldSchedule = true;
function $985235fe3ee13b60$var$disableEffectScheduling(callback) {
    $985235fe3ee13b60$var$shouldSchedule = false;
    callback();
    $985235fe3ee13b60$var$shouldSchedule = true;
}
function $985235fe3ee13b60$var$setReactivityEngine(engine) {
    $985235fe3ee13b60$var$reactive = engine.reactive;
    $985235fe3ee13b60$var$release = engine.release;
    $985235fe3ee13b60$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($985235fe3ee13b60$var$shouldSchedule) $985235fe3ee13b60$var$scheduler(task);
                else task();
            }
        });
    $985235fe3ee13b60$var$raw = engine.raw;
}
function $985235fe3ee13b60$var$overrideEffect(override) {
    $985235fe3ee13b60$var$effect = override;
}
function $985235fe3ee13b60$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $985235fe3ee13b60$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $985235fe3ee13b60$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $985235fe3ee13b60$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $985235fe3ee13b60$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$985235fe3ee13b60$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $985235fe3ee13b60$var$onAttributeAddeds = [];
var $985235fe3ee13b60$var$onElRemoveds = [];
var $985235fe3ee13b60$var$onElAddeds = [];
function $985235fe3ee13b60$var$onElAdded(callback) {
    $985235fe3ee13b60$var$onElAddeds.push(callback);
}
function $985235fe3ee13b60$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $985235fe3ee13b60$var$onElRemoveds.push(callback);
    }
}
function $985235fe3ee13b60$var$onAttributesAdded(callback) {
    $985235fe3ee13b60$var$onAttributeAddeds.push(callback);
}
function $985235fe3ee13b60$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $985235fe3ee13b60$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $985235fe3ee13b60$var$cleanupElement(el) {
    el._x_effects?.forEach($985235fe3ee13b60$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $985235fe3ee13b60$var$observer = new MutationObserver($985235fe3ee13b60$var$onMutate);
var $985235fe3ee13b60$var$currentlyObserving = false;
function $985235fe3ee13b60$var$startObservingMutations() {
    $985235fe3ee13b60$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $985235fe3ee13b60$var$currentlyObserving = true;
}
function $985235fe3ee13b60$var$stopObservingMutations() {
    $985235fe3ee13b60$var$flushObserver();
    $985235fe3ee13b60$var$observer.disconnect();
    $985235fe3ee13b60$var$currentlyObserving = false;
}
var $985235fe3ee13b60$var$queuedMutations = [];
function $985235fe3ee13b60$var$flushObserver() {
    let records = $985235fe3ee13b60$var$observer.takeRecords();
    $985235fe3ee13b60$var$queuedMutations.push(()=>records.length > 0 && $985235fe3ee13b60$var$onMutate(records));
    let queueLengthWhenTriggered = $985235fe3ee13b60$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($985235fe3ee13b60$var$queuedMutations.length === queueLengthWhenTriggered) while($985235fe3ee13b60$var$queuedMutations.length > 0)$985235fe3ee13b60$var$queuedMutations.shift()();
    });
}
function $985235fe3ee13b60$var$mutateDom(callback) {
    if (!$985235fe3ee13b60$var$currentlyObserving) return callback();
    $985235fe3ee13b60$var$stopObservingMutations();
    let result = callback();
    $985235fe3ee13b60$var$startObservingMutations();
    return result;
}
var $985235fe3ee13b60$var$isCollecting = false;
var $985235fe3ee13b60$var$deferredMutations = [];
function $985235fe3ee13b60$var$deferMutations() {
    $985235fe3ee13b60$var$isCollecting = true;
}
function $985235fe3ee13b60$var$flushAndStopDeferringMutations() {
    $985235fe3ee13b60$var$isCollecting = false;
    $985235fe3ee13b60$var$onMutate($985235fe3ee13b60$var$deferredMutations);
    $985235fe3ee13b60$var$deferredMutations = [];
}
function $985235fe3ee13b60$var$onMutate(mutations) {
    if ($985235fe3ee13b60$var$isCollecting) {
        $985235fe3ee13b60$var$deferredMutations = $985235fe3ee13b60$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $985235fe3ee13b60$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $985235fe3ee13b60$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $985235fe3ee13b60$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $985235fe3ee13b60$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $985235fe3ee13b60$var$scope(node) {
    return $985235fe3ee13b60$var$mergeProxies($985235fe3ee13b60$var$closestDataStack(node));
}
function $985235fe3ee13b60$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$985235fe3ee13b60$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $985235fe3ee13b60$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $985235fe3ee13b60$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $985235fe3ee13b60$var$closestDataStack(node.parentNode);
}
function $985235fe3ee13b60$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $985235fe3ee13b60$var$mergeProxyTrap);
}
var $985235fe3ee13b60$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $985235fe3ee13b60$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $985235fe3ee13b60$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $985235fe3ee13b60$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $985235fe3ee13b60$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$985235fe3ee13b60$var$get(data2, path), (value)=>$985235fe3ee13b60$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $985235fe3ee13b60$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $985235fe3ee13b60$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $985235fe3ee13b60$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $985235fe3ee13b60$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $985235fe3ee13b60$var$magics = {};
function $985235fe3ee13b60$var$magic(name, callback) {
    $985235fe3ee13b60$var$magics[name] = callback;
}
function $985235fe3ee13b60$var$injectMagics(obj, el) {
    let memoizedUtilities = $985235fe3ee13b60$var$getUtilities(el);
    Object.entries($985235fe3ee13b60$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $985235fe3ee13b60$var$getUtilities(el) {
    let [utilities, cleanup2] = $985235fe3ee13b60$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $985235fe3ee13b60$var$interceptor,
        ...utilities
    };
    $985235fe3ee13b60$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $985235fe3ee13b60$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $985235fe3ee13b60$var$handleError(e, el, expression);
    }
}
function $985235fe3ee13b60$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $985235fe3ee13b60$var$shouldAutoEvaluateFunctions = true;
function $985235fe3ee13b60$var$dontAutoEvaluateFunctions(callback) {
    let cache = $985235fe3ee13b60$var$shouldAutoEvaluateFunctions;
    $985235fe3ee13b60$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $985235fe3ee13b60$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $985235fe3ee13b60$var$evaluate(el, expression, extras = {}) {
    let result;
    $985235fe3ee13b60$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $985235fe3ee13b60$var$evaluateLater(...args) {
    return $985235fe3ee13b60$var$theEvaluatorFunction(...args);
}
var $985235fe3ee13b60$var$theEvaluatorFunction = $985235fe3ee13b60$var$normalEvaluator;
function $985235fe3ee13b60$var$setEvaluator(newEvaluator) {
    $985235fe3ee13b60$var$theEvaluatorFunction = newEvaluator;
}
function $985235fe3ee13b60$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $985235fe3ee13b60$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$985235fe3ee13b60$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $985235fe3ee13b60$var$generateEvaluatorFromFunction(dataStack, expression) : $985235fe3ee13b60$var$generateEvaluatorFromString(dataStack, expression, el);
    return $985235fe3ee13b60$var$tryCatch.bind(null, el, expression, evaluator);
}
function $985235fe3ee13b60$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        let result = func.apply($985235fe3ee13b60$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $985235fe3ee13b60$var$runIfTypeOfFunction(receiver, result);
    };
}
var $985235fe3ee13b60$var$evaluatorMemo = {};
function $985235fe3ee13b60$var$generateFunctionFromString(expression, el) {
    if ($985235fe3ee13b60$var$evaluatorMemo[expression]) return $985235fe3ee13b60$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $985235fe3ee13b60$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $985235fe3ee13b60$var$evaluatorMemo[expression] = func;
    return func;
}
function $985235fe3ee13b60$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $985235fe3ee13b60$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $985235fe3ee13b60$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$985235fe3ee13b60$var$handleError(error2, el, expression));
            if (func.finished) {
                $985235fe3ee13b60$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $985235fe3ee13b60$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$985235fe3ee13b60$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $985235fe3ee13b60$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($985235fe3ee13b60$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$985235fe3ee13b60$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$985235fe3ee13b60$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $985235fe3ee13b60$var$prefixAsString = "x-";
function $985235fe3ee13b60$var$prefix(subject = "") {
    return $985235fe3ee13b60$var$prefixAsString + subject;
}
function $985235fe3ee13b60$var$setPrefix(newPrefix) {
    $985235fe3ee13b60$var$prefixAsString = newPrefix;
}
var $985235fe3ee13b60$var$directiveHandlers = {};
function $985235fe3ee13b60$var$directive(name, callback) {
    $985235fe3ee13b60$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$985235fe3ee13b60$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $985235fe3ee13b60$var$directiveOrder.indexOf(directive2);
            $985235fe3ee13b60$var$directiveOrder.splice(pos >= 0 ? pos : $985235fe3ee13b60$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $985235fe3ee13b60$var$directiveExists(name) {
    return Object.keys($985235fe3ee13b60$var$directiveHandlers).includes(name);
}
function $985235fe3ee13b60$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $985235fe3ee13b60$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($985235fe3ee13b60$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($985235fe3ee13b60$var$outNonAlpineAttributes).map($985235fe3ee13b60$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($985235fe3ee13b60$var$byPriority);
    return directives2.map((directive2)=>{
        return $985235fe3ee13b60$var$getDirectiveHandler(el, directive2);
    });
}
function $985235fe3ee13b60$var$attributesOnly(attributes) {
    return Array.from(attributes).map($985235fe3ee13b60$var$toTransformedAttributes()).filter((attr)=>!$985235fe3ee13b60$var$outNonAlpineAttributes(attr));
}
var $985235fe3ee13b60$var$isDeferringHandlers = false;
var $985235fe3ee13b60$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $985235fe3ee13b60$var$currentHandlerStackKey = Symbol();
function $985235fe3ee13b60$var$deferHandlingDirectives(callback) {
    $985235fe3ee13b60$var$isDeferringHandlers = true;
    let key = Symbol();
    $985235fe3ee13b60$var$currentHandlerStackKey = key;
    $985235fe3ee13b60$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($985235fe3ee13b60$var$directiveHandlerStacks.get(key).length)$985235fe3ee13b60$var$directiveHandlerStacks.get(key).shift()();
        $985235fe3ee13b60$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $985235fe3ee13b60$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $985235fe3ee13b60$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $985235fe3ee13b60$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $985235fe3ee13b60$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $985235fe3ee13b60$var$evaluateLater.bind($985235fe3ee13b60$var$evaluateLater, el),
        evaluate: $985235fe3ee13b60$var$evaluate.bind($985235fe3ee13b60$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $985235fe3ee13b60$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $985235fe3ee13b60$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $985235fe3ee13b60$var$getElementBoundUtilities(el);
    $985235fe3ee13b60$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $985235fe3ee13b60$var$isDeferringHandlers ? $985235fe3ee13b60$var$directiveHandlerStacks.get($985235fe3ee13b60$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $985235fe3ee13b60$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $985235fe3ee13b60$var$into = (i)=>i;
function $985235fe3ee13b60$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $985235fe3ee13b60$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $985235fe3ee13b60$var$attributeTransformers = [];
function $985235fe3ee13b60$var$mapAttributes(callback) {
    $985235fe3ee13b60$var$attributeTransformers.push(callback);
}
function $985235fe3ee13b60$var$outNonAlpineAttributes({ name: name }) {
    return $985235fe3ee13b60$var$alpineAttributeRegex().test(name);
}
var $985235fe3ee13b60$var$alpineAttributeRegex = ()=>new RegExp(`^${$985235fe3ee13b60$var$prefixAsString}([^:^.]+)\\b`);
function $985235fe3ee13b60$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($985235fe3ee13b60$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $985235fe3ee13b60$var$DEFAULT = "DEFAULT";
var $985235fe3ee13b60$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $985235fe3ee13b60$var$DEFAULT,
    "teleport"
];
function $985235fe3ee13b60$var$byPriority(a, b) {
    let typeA = $985235fe3ee13b60$var$directiveOrder.indexOf(a.type) === -1 ? $985235fe3ee13b60$var$DEFAULT : a.type;
    let typeB = $985235fe3ee13b60$var$directiveOrder.indexOf(b.type) === -1 ? $985235fe3ee13b60$var$DEFAULT : b.type;
    return $985235fe3ee13b60$var$directiveOrder.indexOf(typeA) - $985235fe3ee13b60$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $985235fe3ee13b60$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $985235fe3ee13b60$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$985235fe3ee13b60$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $985235fe3ee13b60$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $985235fe3ee13b60$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $985235fe3ee13b60$var$started = false;
function $985235fe3ee13b60$var$start() {
    if ($985235fe3ee13b60$var$started) $985235fe3ee13b60$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $985235fe3ee13b60$var$started = true;
    if (!document.body) $985235fe3ee13b60$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $985235fe3ee13b60$var$dispatch(document, "alpine:init");
    $985235fe3ee13b60$var$dispatch(document, "alpine:initializing");
    $985235fe3ee13b60$var$startObservingMutations();
    $985235fe3ee13b60$var$onElAdded((el)=>$985235fe3ee13b60$var$initTree(el, $985235fe3ee13b60$var$walk));
    $985235fe3ee13b60$var$onElRemoved((el)=>$985235fe3ee13b60$var$destroyTree(el));
    $985235fe3ee13b60$var$onAttributesAdded((el, attrs)=>{
        $985235fe3ee13b60$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$985235fe3ee13b60$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($985235fe3ee13b60$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $985235fe3ee13b60$var$initTree(el);
    });
    $985235fe3ee13b60$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $985235fe3ee13b60$var$warnAboutMissingPlugins();
    });
}
var $985235fe3ee13b60$var$rootSelectorCallbacks = [];
var $985235fe3ee13b60$var$initSelectorCallbacks = [];
function $985235fe3ee13b60$var$rootSelectors() {
    return $985235fe3ee13b60$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $985235fe3ee13b60$var$allSelectors() {
    return $985235fe3ee13b60$var$rootSelectorCallbacks.concat($985235fe3ee13b60$var$initSelectorCallbacks).map((fn)=>fn());
}
function $985235fe3ee13b60$var$addRootSelector(selectorCallback) {
    $985235fe3ee13b60$var$rootSelectorCallbacks.push(selectorCallback);
}
function $985235fe3ee13b60$var$addInitSelector(selectorCallback) {
    $985235fe3ee13b60$var$initSelectorCallbacks.push(selectorCallback);
}
function $985235fe3ee13b60$var$closestRoot(el, includeInitSelectors = false) {
    return $985235fe3ee13b60$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $985235fe3ee13b60$var$allSelectors() : $985235fe3ee13b60$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $985235fe3ee13b60$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $985235fe3ee13b60$var$findClosest(el.parentElement, callback);
}
function $985235fe3ee13b60$var$isRoot(el) {
    return $985235fe3ee13b60$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $985235fe3ee13b60$var$initInterceptors2 = [];
function $985235fe3ee13b60$var$interceptInit(callback) {
    $985235fe3ee13b60$var$initInterceptors2.push(callback);
}
var $985235fe3ee13b60$var$markerDispenser = 1;
function $985235fe3ee13b60$var$initTree(el, walker = $985235fe3ee13b60$var$walk, intercept = ()=>{}) {
    if ($985235fe3ee13b60$var$findClosest(el, (i)=>i._x_ignore)) return;
    $985235fe3ee13b60$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $985235fe3ee13b60$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $985235fe3ee13b60$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $985235fe3ee13b60$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $985235fe3ee13b60$var$destroyTree(root, walker = $985235fe3ee13b60$var$walk) {
    walker(root, (el)=>{
        $985235fe3ee13b60$var$cleanupElement(el);
        $985235fe3ee13b60$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $985235fe3ee13b60$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($985235fe3ee13b60$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $985235fe3ee13b60$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $985235fe3ee13b60$var$tickStack = [];
var $985235fe3ee13b60$var$isHolding = false;
function $985235fe3ee13b60$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $985235fe3ee13b60$var$isHolding || setTimeout(()=>{
            $985235fe3ee13b60$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $985235fe3ee13b60$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $985235fe3ee13b60$var$releaseNextTicks() {
    $985235fe3ee13b60$var$isHolding = false;
    while($985235fe3ee13b60$var$tickStack.length)$985235fe3ee13b60$var$tickStack.shift()();
}
function $985235fe3ee13b60$var$holdNextTicks() {
    $985235fe3ee13b60$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $985235fe3ee13b60$var$setClasses(el, value) {
    if (Array.isArray(value)) return $985235fe3ee13b60$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $985235fe3ee13b60$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $985235fe3ee13b60$var$setClasses(el, value());
    return $985235fe3ee13b60$var$setClassesFromString(el, value);
}
function $985235fe3ee13b60$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $985235fe3ee13b60$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $985235fe3ee13b60$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $985235fe3ee13b60$var$setStylesFromObject(el, value);
    return $985235fe3ee13b60$var$setStylesFromString(el, value);
}
function $985235fe3ee13b60$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $985235fe3ee13b60$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $985235fe3ee13b60$var$setStyles(el, previousStyles);
    };
}
function $985235fe3ee13b60$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $985235fe3ee13b60$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $985235fe3ee13b60$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$985235fe3ee13b60$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $985235fe3ee13b60$var$registerTransitionsFromHelper(el, modifiers, value);
    else $985235fe3ee13b60$var$registerTransitionsFromClassString(el, expression, value);
});
function $985235fe3ee13b60$var$registerTransitionsFromClassString(el, classString, stage) {
    $985235fe3ee13b60$var$registerTransitionObject(el, $985235fe3ee13b60$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $985235fe3ee13b60$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $985235fe3ee13b60$var$registerTransitionObject(el, $985235fe3ee13b60$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $985235fe3ee13b60$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $985235fe3ee13b60$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $985235fe3ee13b60$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $985235fe3ee13b60$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $985235fe3ee13b60$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $985235fe3ee13b60$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $985235fe3ee13b60$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $985235fe3ee13b60$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $985235fe3ee13b60$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $985235fe3ee13b60$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $985235fe3ee13b60$var$closestHide(parent);
}
function $985235fe3ee13b60$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $985235fe3ee13b60$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $985235fe3ee13b60$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $985235fe3ee13b60$var$once(()=>{
        $985235fe3ee13b60$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $985235fe3ee13b60$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $985235fe3ee13b60$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $985235fe3ee13b60$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $985235fe3ee13b60$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $985235fe3ee13b60$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $985235fe3ee13b60$var$mutateDom(()=>{
                stages.end();
            });
            $985235fe3ee13b60$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $985235fe3ee13b60$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $985235fe3ee13b60$var$isCloning = false;
function $985235fe3ee13b60$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$985235fe3ee13b60$var$isCloning ? fallback(...args) : callback(...args);
}
function $985235fe3ee13b60$var$onlyDuringClone(callback) {
    return (...args)=>$985235fe3ee13b60$var$isCloning && callback(...args);
}
var $985235fe3ee13b60$var$interceptors = [];
function $985235fe3ee13b60$var$interceptClone(callback) {
    $985235fe3ee13b60$var$interceptors.push(callback);
}
function $985235fe3ee13b60$var$cloneNode(from, to) {
    $985235fe3ee13b60$var$interceptors.forEach((i)=>i(from, to));
    $985235fe3ee13b60$var$isCloning = true;
    $985235fe3ee13b60$var$dontRegisterReactiveSideEffects(()=>{
        $985235fe3ee13b60$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $985235fe3ee13b60$var$isCloning = false;
}
var $985235fe3ee13b60$var$isCloningLegacy = false;
function $985235fe3ee13b60$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $985235fe3ee13b60$var$isCloning = true;
    $985235fe3ee13b60$var$isCloningLegacy = true;
    $985235fe3ee13b60$var$dontRegisterReactiveSideEffects(()=>{
        $985235fe3ee13b60$var$cloneTree(newEl);
    });
    $985235fe3ee13b60$var$isCloning = false;
    $985235fe3ee13b60$var$isCloningLegacy = false;
}
function $985235fe3ee13b60$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $985235fe3ee13b60$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $985235fe3ee13b60$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $985235fe3ee13b60$var$initTree(el, shallowWalker);
}
function $985235fe3ee13b60$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $985235fe3ee13b60$var$effect;
    $985235fe3ee13b60$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $985235fe3ee13b60$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $985235fe3ee13b60$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $985235fe3ee13b60$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $985235fe3ee13b60$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $985235fe3ee13b60$var$camelCase(name) : name;
    switch(name){
        case "value":
            $985235fe3ee13b60$var$bindInputValue(el, value);
            break;
        case "style":
            $985235fe3ee13b60$var$bindStyles(el, value);
            break;
        case "class":
            $985235fe3ee13b60$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $985235fe3ee13b60$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $985235fe3ee13b60$var$bindAttribute(el, name, value);
            break;
    }
}
function $985235fe3ee13b60$var$bindInputValue(el, value) {
    if ($985235fe3ee13b60$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $985235fe3ee13b60$var$safeParseBoolean(el.value) === value;
            else el.checked = $985235fe3ee13b60$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($985235fe3ee13b60$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$985235fe3ee13b60$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $985235fe3ee13b60$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $985235fe3ee13b60$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $985235fe3ee13b60$var$setClasses(el, value);
}
function $985235fe3ee13b60$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $985235fe3ee13b60$var$setStyles(el, value);
}
function $985235fe3ee13b60$var$bindAttributeAndProperty(el, name, value) {
    $985235fe3ee13b60$var$bindAttribute(el, name, value);
    $985235fe3ee13b60$var$setPropertyIfChanged(el, name, value);
}
function $985235fe3ee13b60$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $985235fe3ee13b60$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($985235fe3ee13b60$var$isBooleanAttr(name)) value = name;
        $985235fe3ee13b60$var$setIfChanged(el, name, value);
    }
}
function $985235fe3ee13b60$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $985235fe3ee13b60$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $985235fe3ee13b60$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $985235fe3ee13b60$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $985235fe3ee13b60$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $985235fe3ee13b60$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $985235fe3ee13b60$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $985235fe3ee13b60$var$isBooleanAttr(attrName) {
    return $985235fe3ee13b60$var$booleanAttributes.has(attrName);
}
function $985235fe3ee13b60$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $985235fe3ee13b60$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $985235fe3ee13b60$var$getAttributeBinding(el, name, fallback);
}
function $985235fe3ee13b60$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $985235fe3ee13b60$var$dontAutoEvaluateFunctions(()=>{
            return $985235fe3ee13b60$var$evaluate(el, binding.expression);
        });
    }
    return $985235fe3ee13b60$var$getAttributeBinding(el, name, fallback);
}
function $985235fe3ee13b60$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($985235fe3ee13b60$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $985235fe3ee13b60$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $985235fe3ee13b60$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $985235fe3ee13b60$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $985235fe3ee13b60$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $985235fe3ee13b60$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $985235fe3ee13b60$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($985235fe3ee13b60$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($985235fe3ee13b60$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($985235fe3ee13b60$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $985235fe3ee13b60$var$release(reference);
    };
}
function $985235fe3ee13b60$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $985235fe3ee13b60$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($985235fe3ee13b60$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $985235fe3ee13b60$var$stores = {};
var $985235fe3ee13b60$var$isReactive = false;
function $985235fe3ee13b60$var$store(name, value) {
    if (!$985235fe3ee13b60$var$isReactive) {
        $985235fe3ee13b60$var$stores = $985235fe3ee13b60$var$reactive($985235fe3ee13b60$var$stores);
        $985235fe3ee13b60$var$isReactive = true;
    }
    if (value === void 0) return $985235fe3ee13b60$var$stores[name];
    $985235fe3ee13b60$var$stores[name] = value;
    $985235fe3ee13b60$var$initInterceptors($985235fe3ee13b60$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $985235fe3ee13b60$var$stores[name].init();
}
function $985235fe3ee13b60$var$getStores() {
    return $985235fe3ee13b60$var$stores;
}
// packages/alpinejs/src/binds.js
var $985235fe3ee13b60$var$binds = {};
function $985235fe3ee13b60$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $985235fe3ee13b60$var$applyBindingsObject(name, getBindings());
    else $985235fe3ee13b60$var$binds[name] = getBindings;
    return ()=>{};
}
function $985235fe3ee13b60$var$injectBindingProviders(obj) {
    Object.entries($985235fe3ee13b60$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $985235fe3ee13b60$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $985235fe3ee13b60$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $985235fe3ee13b60$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $985235fe3ee13b60$var$datas = {};
function $985235fe3ee13b60$var$data(name, callback) {
    $985235fe3ee13b60$var$datas[name] = callback;
}
function $985235fe3ee13b60$var$injectDataProviders(obj, context) {
    Object.entries($985235fe3ee13b60$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $985235fe3ee13b60$var$Alpine = {
    get reactive () {
        return $985235fe3ee13b60$var$reactive;
    },
    get release () {
        return $985235fe3ee13b60$var$release;
    },
    get effect () {
        return $985235fe3ee13b60$var$effect;
    },
    get raw () {
        return $985235fe3ee13b60$var$raw;
    },
    version: "3.15.1",
    flushAndStopDeferringMutations: $985235fe3ee13b60$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $985235fe3ee13b60$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $985235fe3ee13b60$var$disableEffectScheduling,
    startObservingMutations: $985235fe3ee13b60$var$startObservingMutations,
    stopObservingMutations: $985235fe3ee13b60$var$stopObservingMutations,
    setReactivityEngine: $985235fe3ee13b60$var$setReactivityEngine,
    onAttributeRemoved: $985235fe3ee13b60$var$onAttributeRemoved,
    onAttributesAdded: $985235fe3ee13b60$var$onAttributesAdded,
    closestDataStack: $985235fe3ee13b60$var$closestDataStack,
    skipDuringClone: $985235fe3ee13b60$var$skipDuringClone,
    onlyDuringClone: $985235fe3ee13b60$var$onlyDuringClone,
    addRootSelector: $985235fe3ee13b60$var$addRootSelector,
    addInitSelector: $985235fe3ee13b60$var$addInitSelector,
    interceptClone: $985235fe3ee13b60$var$interceptClone,
    addScopeToNode: $985235fe3ee13b60$var$addScopeToNode,
    deferMutations: $985235fe3ee13b60$var$deferMutations,
    mapAttributes: $985235fe3ee13b60$var$mapAttributes,
    evaluateLater: $985235fe3ee13b60$var$evaluateLater,
    interceptInit: $985235fe3ee13b60$var$interceptInit,
    setEvaluator: $985235fe3ee13b60$var$setEvaluator,
    mergeProxies: $985235fe3ee13b60$var$mergeProxies,
    extractProp: $985235fe3ee13b60$var$extractProp,
    findClosest: $985235fe3ee13b60$var$findClosest,
    onElRemoved: $985235fe3ee13b60$var$onElRemoved,
    closestRoot: $985235fe3ee13b60$var$closestRoot,
    destroyTree: $985235fe3ee13b60$var$destroyTree,
    interceptor: $985235fe3ee13b60$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $985235fe3ee13b60$var$transition,
    setStyles: // INTERNAL
    $985235fe3ee13b60$var$setStyles,
    mutateDom: // INTERNAL
    $985235fe3ee13b60$var$mutateDom,
    directive: $985235fe3ee13b60$var$directive,
    entangle: $985235fe3ee13b60$var$entangle,
    throttle: $985235fe3ee13b60$var$throttle,
    debounce: $985235fe3ee13b60$var$debounce,
    evaluate: $985235fe3ee13b60$var$evaluate,
    initTree: $985235fe3ee13b60$var$initTree,
    nextTick: $985235fe3ee13b60$var$nextTick,
    prefixed: $985235fe3ee13b60$var$prefix,
    prefix: $985235fe3ee13b60$var$setPrefix,
    plugin: $985235fe3ee13b60$var$plugin,
    magic: $985235fe3ee13b60$var$magic,
    store: $985235fe3ee13b60$var$store,
    start: $985235fe3ee13b60$var$start,
    clone: $985235fe3ee13b60$var$clone,
    cloneNode: // INTERNAL
    $985235fe3ee13b60$var$cloneNode,
    // INTERNAL
    bound: $985235fe3ee13b60$var$getBinding,
    $data: $985235fe3ee13b60$var$scope,
    watch: $985235fe3ee13b60$var$watch,
    walk: $985235fe3ee13b60$var$walk,
    data: $985235fe3ee13b60$var$data,
    bind: $985235fe3ee13b60$var$bind2
};
var $985235fe3ee13b60$var$alpine_default = $985235fe3ee13b60$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $985235fe3ee13b60$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $985235fe3ee13b60$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $985235fe3ee13b60$var$isBooleanAttr2 = /* @__PURE__ */ $985235fe3ee13b60$var$makeMap($985235fe3ee13b60$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $985235fe3ee13b60$var$EMPTY_OBJ = Object.freeze({});
var $985235fe3ee13b60$var$EMPTY_ARR = Object.freeze([]);
var $985235fe3ee13b60$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $985235fe3ee13b60$var$hasOwn = (val, key)=>$985235fe3ee13b60$var$hasOwnProperty.call(val, key);
var $985235fe3ee13b60$var$isArray = Array.isArray;
var $985235fe3ee13b60$var$isMap = (val)=>$985235fe3ee13b60$var$toTypeString(val) === "[object Map]";
var $985235fe3ee13b60$var$isString = (val)=>typeof val === "string";
var $985235fe3ee13b60$var$isSymbol = (val)=>typeof val === "symbol";
var $985235fe3ee13b60$var$isObject = (val)=>val !== null && typeof val === "object";
var $985235fe3ee13b60$var$objectToString = Object.prototype.toString;
var $985235fe3ee13b60$var$toTypeString = (value)=>$985235fe3ee13b60$var$objectToString.call(value);
var $985235fe3ee13b60$var$toRawType = (value)=>{
    return $985235fe3ee13b60$var$toTypeString(value).slice(8, -1);
};
var $985235fe3ee13b60$var$isIntegerKey = (key)=>$985235fe3ee13b60$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $985235fe3ee13b60$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $985235fe3ee13b60$var$camelizeRE = /-(\w)/g;
var $985235fe3ee13b60$var$camelize = $985235fe3ee13b60$var$cacheStringFunction((str)=>{
    return str.replace($985235fe3ee13b60$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $985235fe3ee13b60$var$hyphenateRE = /\B([A-Z])/g;
var $985235fe3ee13b60$var$hyphenate = $985235fe3ee13b60$var$cacheStringFunction((str)=>str.replace($985235fe3ee13b60$var$hyphenateRE, "-$1").toLowerCase());
var $985235fe3ee13b60$var$capitalize = $985235fe3ee13b60$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $985235fe3ee13b60$var$toHandlerKey = $985235fe3ee13b60$var$cacheStringFunction((str)=>str ? `on${$985235fe3ee13b60$var$capitalize(str)}` : ``);
var $985235fe3ee13b60$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $985235fe3ee13b60$var$targetMap = /* @__PURE__ */ new WeakMap();
var $985235fe3ee13b60$var$effectStack = [];
var $985235fe3ee13b60$var$activeEffect;
var $985235fe3ee13b60$var$ITERATE_KEY = Symbol("iterate");
var $985235fe3ee13b60$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $985235fe3ee13b60$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $985235fe3ee13b60$var$effect2(fn, options = $985235fe3ee13b60$var$EMPTY_OBJ) {
    if ($985235fe3ee13b60$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $985235fe3ee13b60$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $985235fe3ee13b60$var$stop(effect3) {
    if (effect3.active) {
        $985235fe3ee13b60$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $985235fe3ee13b60$var$uid = 0;
function $985235fe3ee13b60$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$985235fe3ee13b60$var$effectStack.includes(effect3)) {
            $985235fe3ee13b60$var$cleanup(effect3);
            try {
                $985235fe3ee13b60$var$enableTracking();
                $985235fe3ee13b60$var$effectStack.push(effect3);
                $985235fe3ee13b60$var$activeEffect = effect3;
                return fn();
            } finally{
                $985235fe3ee13b60$var$effectStack.pop();
                $985235fe3ee13b60$var$resetTracking();
                $985235fe3ee13b60$var$activeEffect = $985235fe3ee13b60$var$effectStack[$985235fe3ee13b60$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $985235fe3ee13b60$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $985235fe3ee13b60$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $985235fe3ee13b60$var$shouldTrack = true;
var $985235fe3ee13b60$var$trackStack = [];
function $985235fe3ee13b60$var$pauseTracking() {
    $985235fe3ee13b60$var$trackStack.push($985235fe3ee13b60$var$shouldTrack);
    $985235fe3ee13b60$var$shouldTrack = false;
}
function $985235fe3ee13b60$var$enableTracking() {
    $985235fe3ee13b60$var$trackStack.push($985235fe3ee13b60$var$shouldTrack);
    $985235fe3ee13b60$var$shouldTrack = true;
}
function $985235fe3ee13b60$var$resetTracking() {
    const last = $985235fe3ee13b60$var$trackStack.pop();
    $985235fe3ee13b60$var$shouldTrack = last === void 0 ? true : last;
}
function $985235fe3ee13b60$var$track(target, type, key) {
    if (!$985235fe3ee13b60$var$shouldTrack || $985235fe3ee13b60$var$activeEffect === void 0) return;
    let depsMap = $985235fe3ee13b60$var$targetMap.get(target);
    if (!depsMap) $985235fe3ee13b60$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($985235fe3ee13b60$var$activeEffect)) {
        dep.add($985235fe3ee13b60$var$activeEffect);
        $985235fe3ee13b60$var$activeEffect.deps.push(dep);
        if ($985235fe3ee13b60$var$activeEffect.options.onTrack) $985235fe3ee13b60$var$activeEffect.options.onTrack({
            effect: $985235fe3ee13b60$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $985235fe3ee13b60$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $985235fe3ee13b60$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $985235fe3ee13b60$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $985235fe3ee13b60$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$985235fe3ee13b60$var$isArray(target)) {
                    add2(depsMap.get($985235fe3ee13b60$var$ITERATE_KEY));
                    if ($985235fe3ee13b60$var$isMap(target)) add2(depsMap.get($985235fe3ee13b60$var$MAP_KEY_ITERATE_KEY));
                } else if ($985235fe3ee13b60$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$985235fe3ee13b60$var$isArray(target)) {
                    add2(depsMap.get($985235fe3ee13b60$var$ITERATE_KEY));
                    if ($985235fe3ee13b60$var$isMap(target)) add2(depsMap.get($985235fe3ee13b60$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($985235fe3ee13b60$var$isMap(target)) add2(depsMap.get($985235fe3ee13b60$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $985235fe3ee13b60$var$isNonTrackableKeys = /* @__PURE__ */ $985235fe3ee13b60$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $985235fe3ee13b60$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($985235fe3ee13b60$var$isSymbol));
var $985235fe3ee13b60$var$get2 = /* @__PURE__ */ $985235fe3ee13b60$var$createGetter();
var $985235fe3ee13b60$var$readonlyGet = /* @__PURE__ */ $985235fe3ee13b60$var$createGetter(true);
var $985235fe3ee13b60$var$arrayInstrumentations = /* @__PURE__ */ $985235fe3ee13b60$var$createArrayInstrumentations();
function $985235fe3ee13b60$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $985235fe3ee13b60$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$985235fe3ee13b60$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($985235fe3ee13b60$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $985235fe3ee13b60$var$pauseTracking();
            const res = $985235fe3ee13b60$var$toRaw(this)[key].apply(this, args);
            $985235fe3ee13b60$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $985235fe3ee13b60$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $985235fe3ee13b60$var$shallowReadonlyMap : $985235fe3ee13b60$var$readonlyMap : shallow ? $985235fe3ee13b60$var$shallowReactiveMap : $985235fe3ee13b60$var$reactiveMap).get(target)) return target;
        const targetIsArray = $985235fe3ee13b60$var$isArray(target);
        if (!isReadonly && targetIsArray && $985235fe3ee13b60$var$hasOwn($985235fe3ee13b60$var$arrayInstrumentations, key)) return Reflect.get($985235fe3ee13b60$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($985235fe3ee13b60$var$isSymbol(key) ? $985235fe3ee13b60$var$builtInSymbols.has(key) : $985235fe3ee13b60$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $985235fe3ee13b60$var$track(target, "get", key);
        if (shallow) return res;
        if ($985235fe3ee13b60$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$985235fe3ee13b60$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($985235fe3ee13b60$var$isObject(res)) return isReadonly ? $985235fe3ee13b60$var$readonly(res) : $985235fe3ee13b60$var$reactive2(res);
        return res;
    };
}
var $985235fe3ee13b60$var$set2 = /* @__PURE__ */ $985235fe3ee13b60$var$createSetter();
function $985235fe3ee13b60$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $985235fe3ee13b60$var$toRaw(value);
            oldValue = $985235fe3ee13b60$var$toRaw(oldValue);
            if (!$985235fe3ee13b60$var$isArray(target) && $985235fe3ee13b60$var$isRef(oldValue) && !$985235fe3ee13b60$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $985235fe3ee13b60$var$isArray(target) && $985235fe3ee13b60$var$isIntegerKey(key) ? Number(key) < target.length : $985235fe3ee13b60$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $985235fe3ee13b60$var$toRaw(receiver)) {
            if (!hadKey) $985235fe3ee13b60$var$trigger(target, "add", key, value);
            else if ($985235fe3ee13b60$var$hasChanged(value, oldValue)) $985235fe3ee13b60$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $985235fe3ee13b60$var$deleteProperty(target, key) {
    const hadKey = $985235fe3ee13b60$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $985235fe3ee13b60$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $985235fe3ee13b60$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$985235fe3ee13b60$var$isSymbol(key) || !$985235fe3ee13b60$var$builtInSymbols.has(key)) $985235fe3ee13b60$var$track(target, "has", key);
    return result;
}
function $985235fe3ee13b60$var$ownKeys(target) {
    $985235fe3ee13b60$var$track(target, "iterate", $985235fe3ee13b60$var$isArray(target) ? "length" : $985235fe3ee13b60$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $985235fe3ee13b60$var$mutableHandlers = {
    get: $985235fe3ee13b60$var$get2,
    set: $985235fe3ee13b60$var$set2,
    deleteProperty: $985235fe3ee13b60$var$deleteProperty,
    has: $985235fe3ee13b60$var$has,
    ownKeys: $985235fe3ee13b60$var$ownKeys
};
var $985235fe3ee13b60$var$readonlyHandlers = {
    get: $985235fe3ee13b60$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $985235fe3ee13b60$var$toReactive = (value)=>$985235fe3ee13b60$var$isObject(value) ? $985235fe3ee13b60$var$reactive2(value) : value;
var $985235fe3ee13b60$var$toReadonly = (value)=>$985235fe3ee13b60$var$isObject(value) ? $985235fe3ee13b60$var$readonly(value) : value;
var $985235fe3ee13b60$var$toShallow = (value)=>value;
var $985235fe3ee13b60$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $985235fe3ee13b60$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $985235fe3ee13b60$var$toRaw(target);
    const rawKey = $985235fe3ee13b60$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $985235fe3ee13b60$var$track(rawTarget, "get", key);
    !isReadonly && $985235fe3ee13b60$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $985235fe3ee13b60$var$getProto(rawTarget);
    const wrap = isShallow ? $985235fe3ee13b60$var$toShallow : isReadonly ? $985235fe3ee13b60$var$toReadonly : $985235fe3ee13b60$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $985235fe3ee13b60$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $985235fe3ee13b60$var$toRaw(target);
    const rawKey = $985235fe3ee13b60$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $985235fe3ee13b60$var$track(rawTarget, "has", key);
    !isReadonly && $985235fe3ee13b60$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $985235fe3ee13b60$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $985235fe3ee13b60$var$track($985235fe3ee13b60$var$toRaw(target), "iterate", $985235fe3ee13b60$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $985235fe3ee13b60$var$add(value) {
    value = $985235fe3ee13b60$var$toRaw(value);
    const target = $985235fe3ee13b60$var$toRaw(this);
    const proto = $985235fe3ee13b60$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $985235fe3ee13b60$var$trigger(target, "add", value, value);
    }
    return this;
}
function $985235fe3ee13b60$var$set$1(key, value) {
    value = $985235fe3ee13b60$var$toRaw(value);
    const target = $985235fe3ee13b60$var$toRaw(this);
    const { has: has2, get: get3 } = $985235fe3ee13b60$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $985235fe3ee13b60$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $985235fe3ee13b60$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $985235fe3ee13b60$var$trigger(target, "add", key, value);
    else if ($985235fe3ee13b60$var$hasChanged(value, oldValue)) $985235fe3ee13b60$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $985235fe3ee13b60$var$deleteEntry(key) {
    const target = $985235fe3ee13b60$var$toRaw(this);
    const { has: has2, get: get3 } = $985235fe3ee13b60$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $985235fe3ee13b60$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $985235fe3ee13b60$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $985235fe3ee13b60$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $985235fe3ee13b60$var$clear() {
    const target = $985235fe3ee13b60$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $985235fe3ee13b60$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $985235fe3ee13b60$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $985235fe3ee13b60$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $985235fe3ee13b60$var$toRaw(target);
        const wrap = isShallow ? $985235fe3ee13b60$var$toShallow : isReadonly ? $985235fe3ee13b60$var$toReadonly : $985235fe3ee13b60$var$toReactive;
        !isReadonly && $985235fe3ee13b60$var$track(rawTarget, "iterate", $985235fe3ee13b60$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $985235fe3ee13b60$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $985235fe3ee13b60$var$toRaw(target);
        const targetIsMap = $985235fe3ee13b60$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $985235fe3ee13b60$var$toShallow : isReadonly ? $985235fe3ee13b60$var$toReadonly : $985235fe3ee13b60$var$toReactive;
        !isReadonly && $985235fe3ee13b60$var$track(rawTarget, "iterate", isKeyOnly ? $985235fe3ee13b60$var$MAP_KEY_ITERATE_KEY : $985235fe3ee13b60$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $985235fe3ee13b60$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$985235fe3ee13b60$var$capitalize(type)} operation ${key}failed: target is readonly.`, $985235fe3ee13b60$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $985235fe3ee13b60$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $985235fe3ee13b60$var$get$1(this, key);
        },
        get size () {
            return $985235fe3ee13b60$var$size(this);
        },
        has: $985235fe3ee13b60$var$has$1,
        add: $985235fe3ee13b60$var$add,
        set: $985235fe3ee13b60$var$set$1,
        delete: $985235fe3ee13b60$var$deleteEntry,
        clear: $985235fe3ee13b60$var$clear,
        forEach: $985235fe3ee13b60$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $985235fe3ee13b60$var$get$1(this, key, false, true);
        },
        get size () {
            return $985235fe3ee13b60$var$size(this);
        },
        has: $985235fe3ee13b60$var$has$1,
        add: $985235fe3ee13b60$var$add,
        set: $985235fe3ee13b60$var$set$1,
        delete: $985235fe3ee13b60$var$deleteEntry,
        clear: $985235fe3ee13b60$var$clear,
        forEach: $985235fe3ee13b60$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $985235fe3ee13b60$var$get$1(this, key, true);
        },
        get size () {
            return $985235fe3ee13b60$var$size(this, true);
        },
        has (key) {
            return $985235fe3ee13b60$var$has$1.call(this, key, true);
        },
        add: $985235fe3ee13b60$var$createReadonlyMethod("add"),
        set: $985235fe3ee13b60$var$createReadonlyMethod("set"),
        delete: $985235fe3ee13b60$var$createReadonlyMethod("delete"),
        clear: $985235fe3ee13b60$var$createReadonlyMethod("clear"),
        forEach: $985235fe3ee13b60$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $985235fe3ee13b60$var$get$1(this, key, true, true);
        },
        get size () {
            return $985235fe3ee13b60$var$size(this, true);
        },
        has (key) {
            return $985235fe3ee13b60$var$has$1.call(this, key, true);
        },
        add: $985235fe3ee13b60$var$createReadonlyMethod("add"),
        set: $985235fe3ee13b60$var$createReadonlyMethod("set"),
        delete: $985235fe3ee13b60$var$createReadonlyMethod("delete"),
        clear: $985235fe3ee13b60$var$createReadonlyMethod("clear"),
        forEach: $985235fe3ee13b60$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $985235fe3ee13b60$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $985235fe3ee13b60$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $985235fe3ee13b60$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $985235fe3ee13b60$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$985235fe3ee13b60$var$mutableInstrumentations, $985235fe3ee13b60$var$readonlyInstrumentations, $985235fe3ee13b60$var$shallowInstrumentations, $985235fe3ee13b60$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $985235fe3ee13b60$var$createInstrumentations();
function $985235fe3ee13b60$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $985235fe3ee13b60$var$shallowReadonlyInstrumentations : $985235fe3ee13b60$var$shallowInstrumentations : isReadonly ? $985235fe3ee13b60$var$readonlyInstrumentations : $985235fe3ee13b60$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($985235fe3ee13b60$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $985235fe3ee13b60$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $985235fe3ee13b60$var$createInstrumentationGetter(false, false)
};
var $985235fe3ee13b60$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $985235fe3ee13b60$var$createInstrumentationGetter(true, false)
};
function $985235fe3ee13b60$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $985235fe3ee13b60$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $985235fe3ee13b60$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $985235fe3ee13b60$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $985235fe3ee13b60$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $985235fe3ee13b60$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $985235fe3ee13b60$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $985235fe3ee13b60$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $985235fe3ee13b60$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $985235fe3ee13b60$var$targetTypeMap($985235fe3ee13b60$var$toRawType(value));
}
function $985235fe3ee13b60$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $985235fe3ee13b60$var$createReactiveObject(target, false, $985235fe3ee13b60$var$mutableHandlers, $985235fe3ee13b60$var$mutableCollectionHandlers, $985235fe3ee13b60$var$reactiveMap);
}
function $985235fe3ee13b60$var$readonly(target) {
    return $985235fe3ee13b60$var$createReactiveObject(target, true, $985235fe3ee13b60$var$readonlyHandlers, $985235fe3ee13b60$var$readonlyCollectionHandlers, $985235fe3ee13b60$var$readonlyMap);
}
function $985235fe3ee13b60$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$985235fe3ee13b60$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $985235fe3ee13b60$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $985235fe3ee13b60$var$toRaw(observed) {
    return observed && $985235fe3ee13b60$var$toRaw(observed["__v_raw"]) || observed;
}
function $985235fe3ee13b60$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$985235fe3ee13b60$var$magic("nextTick", ()=>$985235fe3ee13b60$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$985235fe3ee13b60$var$magic("dispatch", (el)=>$985235fe3ee13b60$var$dispatch.bind($985235fe3ee13b60$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$985235fe3ee13b60$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $985235fe3ee13b60$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$985235fe3ee13b60$var$magic("store", $985235fe3ee13b60$var$getStores);
// packages/alpinejs/src/magics/$data.js
$985235fe3ee13b60$var$magic("data", (el)=>$985235fe3ee13b60$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$985235fe3ee13b60$var$magic("root", (el)=>$985235fe3ee13b60$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$985235fe3ee13b60$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $985235fe3ee13b60$var$mergeProxies($985235fe3ee13b60$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $985235fe3ee13b60$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $985235fe3ee13b60$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $985235fe3ee13b60$var$globalIdMemo = {};
function $985235fe3ee13b60$var$findAndIncrementId(name) {
    if (!$985235fe3ee13b60$var$globalIdMemo[name]) $985235fe3ee13b60$var$globalIdMemo[name] = 0;
    return ++$985235fe3ee13b60$var$globalIdMemo[name];
}
function $985235fe3ee13b60$var$closestIdRoot(el, name) {
    return $985235fe3ee13b60$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $985235fe3ee13b60$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $985235fe3ee13b60$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$985235fe3ee13b60$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $985235fe3ee13b60$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $985235fe3ee13b60$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $985235fe3ee13b60$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$985235fe3ee13b60$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $985235fe3ee13b60$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$985235fe3ee13b60$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$985235fe3ee13b60$var$warnMissingPluginMagic("Focus", "focus", "focus");
$985235fe3ee13b60$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $985235fe3ee13b60$var$warnMissingPluginMagic(name, magicName, slug) {
    $985235fe3ee13b60$var$magic(magicName, (el)=>$985235fe3ee13b60$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$985235fe3ee13b60$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $985235fe3ee13b60$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$985235fe3ee13b60$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $985235fe3ee13b60$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $985235fe3ee13b60$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $985235fe3ee13b60$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $985235fe3ee13b60$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $985235fe3ee13b60$var$skipDuringClone(()=>{
            $985235fe3ee13b60$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $985235fe3ee13b60$var$getTarget(expression);
        $985235fe3ee13b60$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$985235fe3ee13b60$var$mutateDom(()=>{
            clone2.remove();
            $985235fe3ee13b60$var$destroyTree(clone2);
        }));
});
var $985235fe3ee13b60$var$teleportContainerDuringClone = document.createElement("div");
function $985235fe3ee13b60$var$getTarget(expression) {
    let target = $985235fe3ee13b60$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $985235fe3ee13b60$var$teleportContainerDuringClone;
    })();
    if (!target) $985235fe3ee13b60$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $985235fe3ee13b60$var$handler = ()=>{};
$985235fe3ee13b60$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$985235fe3ee13b60$var$directive("ignore", $985235fe3ee13b60$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$985235fe3ee13b60$var$directive("effect", $985235fe3ee13b60$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($985235fe3ee13b60$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $985235fe3ee13b60$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $985235fe3ee13b60$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $985235fe3ee13b60$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $985235fe3ee13b60$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $985235fe3ee13b60$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $985235fe3ee13b60$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $985235fe3ee13b60$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($985235fe3ee13b60$var$isKeyEvent(event) || $985235fe3ee13b60$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($985235fe3ee13b60$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $985235fe3ee13b60$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $985235fe3ee13b60$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $985235fe3ee13b60$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $985235fe3ee13b60$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $985235fe3ee13b60$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $985235fe3ee13b60$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $985235fe3ee13b60$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $985235fe3ee13b60$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $985235fe3ee13b60$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $985235fe3ee13b60$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($985235fe3ee13b60$var$isClickEvent(e.type)) return false;
            if ($985235fe3ee13b60$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $985235fe3ee13b60$var$keyToModifiers(key) {
    if (!key) return [];
    key = $985235fe3ee13b60$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$985235fe3ee13b60$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $985235fe3ee13b60$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $985235fe3ee13b60$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $985235fe3ee13b60$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $985235fe3ee13b60$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($985235fe3ee13b60$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $985235fe3ee13b60$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $985235fe3ee13b60$var$isCloning ? ()=>{} : $985235fe3ee13b60$var$on(el, event, modifiers, (e)=>{
        setValue($985235fe3ee13b60$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $985235fe3ee13b60$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($985235fe3ee13b60$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $985235fe3ee13b60$var$on(el.form, "reset", [], (e)=>{
            $985235fe3ee13b60$var$nextTick(()=>el._x_model && el._x_model.set($985235fe3ee13b60$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $985235fe3ee13b60$var$mutateDom(()=>$985235fe3ee13b60$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $985235fe3ee13b60$var$getInputValue(el, modifiers, event, currentValue) {
    return $985235fe3ee13b60$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($985235fe3ee13b60$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $985235fe3ee13b60$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $985235fe3ee13b60$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$985235fe3ee13b60$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $985235fe3ee13b60$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $985235fe3ee13b60$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($985235fe3ee13b60$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $985235fe3ee13b60$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $985235fe3ee13b60$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $985235fe3ee13b60$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $985235fe3ee13b60$var$isNumeric2(number) ? number : rawValue;
}
function $985235fe3ee13b60$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $985235fe3ee13b60$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $985235fe3ee13b60$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$985235fe3ee13b60$var$directive("cloak", (el)=>queueMicrotask(()=>$985235fe3ee13b60$var$mutateDom(()=>el.removeAttribute($985235fe3ee13b60$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$985235fe3ee13b60$var$addInitSelector(()=>`[${$985235fe3ee13b60$var$prefix("init")}]`);
$985235fe3ee13b60$var$directive("init", $985235fe3ee13b60$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$985235fe3ee13b60$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $985235fe3ee13b60$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$985235fe3ee13b60$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $985235fe3ee13b60$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $985235fe3ee13b60$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$985235fe3ee13b60$var$mapAttributes($985235fe3ee13b60$var$startingWith(":", $985235fe3ee13b60$var$into($985235fe3ee13b60$var$prefix("bind:"))));
var $985235fe3ee13b60$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $985235fe3ee13b60$var$injectBindingProviders(bindingProviders);
        let getBindings = $985235fe3ee13b60$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $985235fe3ee13b60$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $985235fe3ee13b60$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $985235fe3ee13b60$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $985235fe3ee13b60$var$mutateDom(()=>$985235fe3ee13b60$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$985235fe3ee13b60$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$985235fe3ee13b60$var$directive("bind", $985235fe3ee13b60$var$handler2);
function $985235fe3ee13b60$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$985235fe3ee13b60$var$addRootSelector(()=>`[${$985235fe3ee13b60$var$prefix("data")}]`);
$985235fe3ee13b60$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($985235fe3ee13b60$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $985235fe3ee13b60$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $985235fe3ee13b60$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $985235fe3ee13b60$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $985235fe3ee13b60$var$injectMagics(data2, el);
    let reactiveData = $985235fe3ee13b60$var$reactive(data2);
    $985235fe3ee13b60$var$initInterceptors(reactiveData);
    let undo = $985235fe3ee13b60$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $985235fe3ee13b60$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $985235fe3ee13b60$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$985235fe3ee13b60$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $985235fe3ee13b60$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$985235fe3ee13b60$var$isCloning) return false;
    if ($985235fe3ee13b60$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$985235fe3ee13b60$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $985235fe3ee13b60$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $985235fe3ee13b60$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $985235fe3ee13b60$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $985235fe3ee13b60$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$985235fe3ee13b60$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $985235fe3ee13b60$var$parseForExpression(expression);
    let evaluateItems = $985235fe3ee13b60$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $985235fe3ee13b60$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$985235fe3ee13b60$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$985235fe3ee13b60$var$mutateDom(()=>{
                $985235fe3ee13b60$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $985235fe3ee13b60$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($985235fe3ee13b60$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $985235fe3ee13b60$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $985235fe3ee13b60$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $985235fe3ee13b60$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $985235fe3ee13b60$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $985235fe3ee13b60$var$mutateDom(()=>{
                $985235fe3ee13b60$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $985235fe3ee13b60$var$mutateDom(()=>{
                if (!elForSpot) $985235fe3ee13b60$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $985235fe3ee13b60$var$reactive(scope2);
            $985235fe3ee13b60$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $985235fe3ee13b60$var$mutateDom(()=>{
                lastEl.after(clone2);
                $985235fe3ee13b60$var$skipDuringClone(()=>$985235fe3ee13b60$var$initTree(clone2))();
            });
            if (typeof key === "object") $985235fe3ee13b60$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $985235fe3ee13b60$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $985235fe3ee13b60$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $985235fe3ee13b60$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $985235fe3ee13b60$var$handler3() {}
$985235fe3ee13b60$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $985235fe3ee13b60$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$985235fe3ee13b60$var$directive("ref", $985235fe3ee13b60$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$985235fe3ee13b60$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $985235fe3ee13b60$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $985235fe3ee13b60$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $985235fe3ee13b60$var$addScopeToNode(clone2, {}, el);
        $985235fe3ee13b60$var$mutateDom(()=>{
            el.after(clone2);
            $985235fe3ee13b60$var$skipDuringClone(()=>$985235fe3ee13b60$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $985235fe3ee13b60$var$mutateDom(()=>{
                $985235fe3ee13b60$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$985235fe3ee13b60$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$985235fe3ee13b60$var$setIdRoot(el, name));
});
$985235fe3ee13b60$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$985235fe3ee13b60$var$mapAttributes($985235fe3ee13b60$var$startingWith("@", $985235fe3ee13b60$var$into($985235fe3ee13b60$var$prefix("on:"))));
$985235fe3ee13b60$var$directive("on", $985235fe3ee13b60$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $985235fe3ee13b60$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $985235fe3ee13b60$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$985235fe3ee13b60$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$985235fe3ee13b60$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$985235fe3ee13b60$var$warnMissingPluginDirective("Focus", "trap", "focus");
$985235fe3ee13b60$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $985235fe3ee13b60$var$warnMissingPluginDirective(name, directiveName, slug) {
    $985235fe3ee13b60$var$directive(directiveName, (el)=>$985235fe3ee13b60$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$985235fe3ee13b60$var$alpine_default.setEvaluator($985235fe3ee13b60$var$normalEvaluator);
$985235fe3ee13b60$var$alpine_default.setReactivityEngine({
    reactive: $985235fe3ee13b60$var$reactive2,
    effect: $985235fe3ee13b60$var$effect2,
    release: $985235fe3ee13b60$var$stop,
    raw: $985235fe3ee13b60$var$toRaw
});
var $985235fe3ee13b60$export$b7ee041e4ad2afec = $985235fe3ee13b60$var$alpine_default;
// packages/alpinejs/builds/module.js
var $985235fe3ee13b60$export$2e2bcd8739ae039 = $985235fe3ee13b60$export$b7ee041e4ad2afec;


// packages/collapse/src/index.js
function $efd831ae0e89bdcc$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $efd831ae0e89bdcc$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $efd831ae0e89bdcc$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $efd831ae0e89bdcc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $efd831ae0e89bdcc$export$2e2bcd8739ae039 = $efd831ae0e89bdcc$export$ec45920981e0ca9b;


// packages/persist/src/index.js
function $5bec53e4c755da35$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $5bec53e4c755da35$var$storageHas(lookup, storage) ? $5bec53e4c755da35$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $5bec53e4c755da35$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $5bec53e4c755da35$var$storageHas(key, storage) ? $5bec53e4c755da35$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $5bec53e4c755da35$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $5bec53e4c755da35$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $5bec53e4c755da35$var$storageGet(key, storage) {
    let value = storage.getItem(key);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $5bec53e4c755da35$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $5bec53e4c755da35$export$2e2bcd8739ae039 = $5bec53e4c755da35$export$9a6132153fba2e0;


(0, $985235fe3ee13b60$export$2e2bcd8739ae039).plugin((0, $efd831ae0e89bdcc$export$2e2bcd8739ae039));
(0, $985235fe3ee13b60$export$2e2bcd8739ae039).plugin((0, $5bec53e4c755da35$export$2e2bcd8739ae039));
// @ts-ignore // pycharm not working with global.d.ts
window.Alpine = (0, $985235fe3ee13b60$export$2e2bcd8739ae039);
function $be705c950a3ea687$export$3b91788629d8849d() {
    (0, $985235fe3ee13b60$export$2e2bcd8739ae039).start();
}


class $1a6bf193a660dd82$export$2e2bcd8739ae039 {
    constructor(){
        this.widgetClasses = {};
    // private to prevent direct instantiation
    }
    static getInstance() {
        if (!$1a6bf193a660dd82$export$2e2bcd8739ae039.instance) $1a6bf193a660dd82$export$2e2bcd8739ae039.instance = new $1a6bf193a660dd82$export$2e2bcd8739ae039();
        return $1a6bf193a660dd82$export$2e2bcd8739ae039.instance;
    }
    registerWidgetClass(widgetName, widgetClass) {
        this.widgetClasses[widgetName] = widgetClass;
    }
    getWidgetClass(widgetName) {
        if (!this.widgetClasses[widgetName]) throw new Error(`Widget ${widgetName} not registered`);
        return this.widgetClasses[widgetName];
    }
    initializeWidget(element) {
        const widgetName = element.getAttribute('data-react-widget');
        if (!widgetName) throw new Error('Widget name attribute (data-react-widget) is missing.');
        const WidgetClass = this.getWidgetClass(widgetName);
        new WidgetClass(element).initialize();
    }
    initializeWidgets() {
        const elements = document.querySelectorAll('[data-react-widget]');
        elements.forEach((element)=>{
            this.initializeWidget(element);
        });
    }
    destroyWidget(element) {
        const widgetName = element.getAttribute('data-react-widget');
        if (!widgetName) throw new Error('Widget name attribute (data-react-widget) is missing.');
        const WidgetClass = this.getWidgetClass(widgetName);
        const widgetInstance = new WidgetClass(element);
        widgetInstance.destroy(element);
    }
    destroyWidgets() {
        const elements = document.querySelectorAll('[data-react-widget]');
        elements.forEach((element)=>{
            this.destroyWidget(element);
        });
    }
}


var $fb2efc226cb4f9dd$exports = {};
'use strict';

$fb2efc226cb4f9dd$exports = (parcelRequire("8tuDw"));


parcelRequire("6umrQ");
var $c5f61bb6d82acefb$export$882461b6382ed46c;
var $c5f61bb6d82acefb$export$757ceba2d55c277e;
'use strict';
var $62f595d6588897d8$exports = {};
'use strict';
function $62f595d6588897d8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($62f595d6588897d8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$62f595d6588897d8$var$checkDCE();

$62f595d6588897d8$exports = (parcelRequire("lGLfC"));


var $c5f61bb6d82acefb$var$i;
$c5f61bb6d82acefb$export$882461b6382ed46c = $62f595d6588897d8$exports.createRoot;
$c5f61bb6d82acefb$export$757ceba2d55c277e = $62f595d6588897d8$exports.hydrateRoot;


class $febaba8661e870e3$export$ce623d3cb93cc651 {
    constructor(element){
        this.element = element;
        this.root = null;
        this.element = element;
        this._config = this.getConfig();
        this.initialize();
    }
    getDefaultConfig() {
        return {};
    }
    getConfig() {
        const parsedConfig = JSON.parse(this.element.getAttribute('data-react-widget-config') || '{}');
        return {
            ...this.getDefaultConfig(),
            ...parsedConfig
        };
    }
    get UIComponentProps() {
        return this._config;
    }
    initialize() {
        console.log('Initializing widget');
        const UIComponent = this.UIComponent;
        // If root already exists, just re-render the component
        if (this.root) this.root.render(/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)(UIComponent, {
            ...this.UIComponentProps
        }));
        else {
            // Otherwise, create a new root
            this.root = (0, $c5f61bb6d82acefb$export$882461b6382ed46c)(this.element);
            this.root.render(/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)(UIComponent, {
                ...this.UIComponentProps
            }));
        }
    }
    destroy() {
        if (this.root) {
            this.root.unmount();
            this.root = null; // Reset root to avoid re-using an unmounted instance
        }
    }
}




var $6umrQ = parcelRequire("6umrQ");

parcelRequire("6umrQ");
var $19a25a6d0fad3f5f$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($19a25a6d0fad3f5f$exports) {
        classNames.default = classNames;
        $19a25a6d0fad3f5f$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $db660a598ce0c4a9$var$Spaces = ({ spaces: spaces, activeRoom: activeRoom, setActiveRoom: setActiveRoom, selectedData: selectedData, recommendations: recommendations })=>{
    const checkIfAllSelected = (spaceCode, counter)=>{
        const roomCode = `${spaceCode}${counter}`;
        const roomRecommendations = recommendations[spaceCode];
        const selectedRoomData = selectedData[roomCode];
        if (!selectedRoomData || !selectedRoomData.selectedProducts && !selectedRoomData.rejectedProducts) return false;
        const selectedRating = selectedRoomData.rating;
        let articles = roomRecommendations.articles || roomRecommendations.tabs[roomCode].articles;
        const recommendedArticlesCount = articles[selectedRating].length;
        const selectedArticlesCount = Object.keys(selectedRoomData.selectedProducts).length;
        const rejectedArticlesCount = Object.keys(selectedRoomData.rejectedProducts).length;
        // @ts-ignore
        const selectedArticles = Object.values(selectedRoomData.selectedProducts);
        const rejectedArticles = Object.values(selectedRoomData.rejectedProducts);
        return selectedArticlesCount + rejectedArticlesCount === recommendedArticlesCount && selectedArticles.every((article)=>article) && rejectedArticles.every((article)=>article);
    };
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("ul", {
        className: "flex flex-wrap sm:flex sm:flex-wrap gap-[8px] justify-center pb-3 pt-5 md:pt-1",
        children: Object.keys(spaces).map((spaceCode)=>{
            const space = spaces[spaceCode];
            return [
                ...Array(space.count)
            ].map((_, counter)=>{
                const roomCode = `${spaceCode}${counter}`;
                const isSelected = checkIfAllSelected(spaceCode, counter);
                const isActive = activeRoom === roomCode;
                return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("li", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($19a25a6d0fad3f5f$exports)))('align-middle rounded-lg border-[#CBD1D7] border py-[6px] px-[10px] text-center text-[14px] text-[#1D1F22]', {
                        'bg-fxgreen-light': isSelected
                    }, {
                        'border-3 border-fxgreen-dark ring-2 ring-lime-400': isActive
                    } // thick border for active room
                    ),
                    title: isSelected ? 'All selections have been made for this room' : 'Please select products for the room',
                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                        type: "button",
                        className: "button-small",
                        onClick: ()=>setActiveRoom(roomCode),
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("span", {
                            children: [
                                space.label,
                                " ",
                                counter + 1
                            ]
                        })
                    })
                }, roomCode);
            });
        })
    });
};
var $db660a598ce0c4a9$export$2e2bcd8739ae039 = $db660a598ce0c4a9$var$Spaces;



parcelRequire("6umrQ");


var $6umrQ = parcelRequire("6umrQ");


var $6umrQ = parcelRequire("6umrQ");

parcelRequire("6umrQ");


var $6umrQ = parcelRequire("6umrQ");
const $306da584449c7cdc$var$ImageGallery = ({ images: images })=>{
    const [activeImage, setActiveImage] = (0, $6umrQ.useState)(images[0]);
    const [fullScreen, setFullScreen] = (0, $6umrQ.useState)(false);
    const handleImageClick = (image)=>{
        setActiveImage(image);
    };
    const handlePrev = ()=>{
        const currentIndex = images.findIndex((img)=>img.media_code === activeImage.media_code);
        const prevIndex = (currentIndex - 1 + images.length) % images.length;
        setActiveImage(images[prevIndex]);
    };
    const handleNext = ()=>{
        const currentIndex = images.findIndex((img)=>img.media_code === activeImage.media_code);
        const nextIndex = (currentIndex + 1) % images.length;
        setActiveImage(images[nextIndex]);
    };
    const handleKeyDown = (event)=>{
        if (!fullScreen) return;
        switch(event.key){
            case 'Escape':
                setFullScreen(false);
                break;
            case 'ArrowLeft':
                handlePrev();
                break;
            case 'ArrowRight':
                handleNext();
                break;
            default:
                break;
        }
    };
    (0, $6umrQ.useEffect)(()=>{
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        fullScreen,
        activeImage
    ]);
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        className: "image_gallery row-start-2 md:col-start-2 md:row-span-full flex flex-col-reverse relative max-w-2xl",
        children: [
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                className: "mt-6 w-full max-w-2xl mx-auto lg:max-w-none",
                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                    className: "flex flex-row flex-wrap @container",
                    "aria-orientation": "horizontal",
                    children: images.map((image, index)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                            className: "p-2 basis-1/4 md:basis-1/2 lg:basis-1/4 @sm:basis-1/4 aspect-square",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                                className: "w-full h-full relative bg-white rounded-md flex items-center justify-center text-sm font-medium uppercase text-gray-900 cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring focus:ring-offset-4 focus:ring-opacity-50",
                                onClick: ()=>handleImageClick(image),
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                                    className: "absolute inset-0 rounded-md overflow-hidden",
                                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                        src: image.small_thumbnail_url,
                                        alt: "",
                                        className: "w-full h-full object-center object-contain"
                                    })
                                })
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                className: "w-full h-full aspect-square relative",
                children: !activeImage.is_video && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("button", {
                    onClick: ()=>setFullScreen(true),
                    className: "grid grid-cols-1 grid-rows-1 place-content-center place-items-center w-full h-full",
                    children: [
                        /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                            src: activeImage.image_url,
                            alt: "",
                            className: "w-full h-full object-center object-contain sm:rounded-lg col-start-1 row-start-1"
                        }),
                        /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                            src: activeImage.thumbnail_url,
                            alt: "",
                            className: "w-full h-full object-center object-contain sm:rounded-lg col-start-1 row-start-1"
                        })
                    ]
                })
            }),
            fullScreen && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "fixed inset-0 z-50 bg-gray-800/90 p-10 px-40 py-24 flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "h-full flex items-center",
                        children: [
                            !activeImage.is_video && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                src: activeImage.image_url,
                                alt: "",
                                className: "w-full h-full object-center object-contain rounded-lg",
                                onClick: ()=>setFullScreen(false)
                            }),
                            activeImage.is_video && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "w-full h-full flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("iframe", {
                                    src: `${activeImage.original_url}?autoplay=1`,
                                    width: "800",
                                    className: "aspect-video rounded-lg",
                                    allow: "autoplay",
                                    title: activeImage.media_code
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                        href: activeImage.original_url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "absolute top-0 left-0 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg",
                        children: window.gettext('Open Full Image')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                        className: "absolute top-0 right-0 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg",
                        onClick: ()=>setFullScreen(false),
                        children: window.gettext('Close')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                        className: "absolute left-0 top-1/2 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg",
                        onClick: handlePrev,
                        children: window.gettext('Previous')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                        className: "absolute right-0 top-1/2 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg",
                        onClick: handleNext,
                        children: window.gettext('Next')
                    })
                ]
            })
        ]
    });
};
var $306da584449c7cdc$export$2e2bcd8739ae039 = $306da584449c7cdc$var$ImageGallery;


const $d8e936d8cdfc6ce2$var$ProductModal = ({ productData: productData, closeModal: closeModal })=>{
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
        onClick: closeModal,
        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            className: "bg-white rounded-lg p-8 mx-4 my-4 overflow-y-auto max-h-[calc(100vh-4rem)]",
            onClick: (e)=>e.stopPropagation(),
            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "grid grid-cols-1 grid-rows-[repeat(4,_auto)] md:grid-rows-[repeat(3, auto)]  md:grid-cols-[1fr_25%] lg:grid-cols-[1fr_33%] gap-x-8 lg:items-start gap-y-2",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                className: "col-start-1 text-left",
                                children: [
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h1", {
                                        className: "text-2xl font-semibold tracking-tight text-gray-900 mt-2",
                                        children: productData.name
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                        className: "relative bg-white rounded-md -space-y-px max-w-4xl col-start-1 mt-4",
                                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                            className: "relative group border p-4 md:pl-4 md:pr-6 focus:outline-none border-gray-200",
                                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                                className: "text-gray-600 md:flex md:flex-row md:items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                                        children: [
                                                            "Art. nr: ",
                                                            productData.product_number
                                                        ]
                                                    }),
                                                    productData.gtin && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)((0, $fb2efc226cb4f9dd$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                                                className: "mx-2 hidden md:block",
                                                                children: "|"
                                                            }),
                                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                                                children: [
                                                                    "GTIN: ",
                                                                    productData.gtin
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    productData.nobb_nr && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)((0, $fb2efc226cb4f9dd$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                                                className: "mx-2 hidden md:block",
                                                                children: "|"
                                                            }),
                                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                                                children: [
                                                                    "NOBB: ",
                                                                    productData.nobb_nr
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                        className: "prose max-w-4xl space-y-3 text-sm col-start-1 product-description",
                                        children: [
                                            productData.description && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)((0, $fb2efc226cb4f9dd$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h3", {
                                                        className: "sr-only",
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                                        className: "text-gray-700",
                                                        children: productData.description
                                                    })
                                                ]
                                            }),
                                            productData.features && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: productData.features
                                                }
                                            })
                                        ]
                                    }),
                                    productData.svanemerke_certificates && productData.svanemerke_certificates.length > 0 && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                        className: "mt-3",
                                        children: productData.svanemerke_certificates.map((cert)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                                                href: cert.url,
                                                target: "_blank",
                                                className: "link text-sm text-sky-500 hover:text-sky-800",
                                                children: cert.label
                                            }, cert.label))
                                    }),
                                    productData.airfow_certificates && productData.airfow_certificates.length > 0 && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                        className: "col-start-1",
                                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                            className: "flex flex-row gap-2 lg:gap-6 flex-wrap gap-y-3 pt-3",
                                            children: productData.airfow_certificates.map((cert)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                                                    href: cert.url || cert.document_url,
                                                    target: "_blank",
                                                    title: cert.label,
                                                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                                        className: "h-16",
                                                        src: cert.image_url,
                                                        alt: cert.label
                                                    })
                                                }, cert.label))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $306da584449c7cdc$export$2e2bcd8739ae039), {
                                images: productData.product_images_urls
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                        href: productData.url,
                        rel: "noopener noreferrer",
                        target: "_blank",
                        className: "block mt-4 text-blue-500 hover:underline",
                        children: window.gettext('Go to full product details page')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                        onClick: closeModal,
                        className: "block mt-4 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg",
                        children: window.gettext('Close')
                    })
                ]
            })
        })
    });
};
var $d8e936d8cdfc6ce2$export$2e2bcd8739ae039 = $d8e936d8cdfc6ce2$var$ProductModal;



parcelRequire("6umrQ");
// Functional Component: Currency Formatted for Norwegians

parcelRequire("6umrQ");
const $e34931c0b8a5da03$var$FxCurrencyFormat = (amount)=>{
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
        className: "",
        children: $e34931c0b8a5da03$var$formatCurrency(amount)
    });
};
const $e34931c0b8a5da03$var$formatCurrency = (amount)=>{
    return new Intl.NumberFormat('nb-NO', {
        style: 'decimal',
        minimumFractionDigits: 2
    }).format(amount);
};
var $e34931c0b8a5da03$export$2e2bcd8739ae039 = $e34931c0b8a5da03$var$FxCurrencyFormat;


const $b17e7c0e7c8af9d8$var$OptionsModal = ({ article: article, productData: productData, roomCode: roomCode, rating: rating, itemIndex: itemIndex, setRoomSelection: setRoomSelection, getPrice: getPrice, closeModal: closeModal })=>{
    const handleSelect = (productCode, quantity)=>{
        setRoomSelection(roomCode, rating, productCode, itemIndex, quantity);
        closeModal();
    };
    const handleModalClick = (e)=>{
        e.stopPropagation(); // Prevent clicks on the modal content from closing the modal
    };
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        className: "absolute top-0 left-0 pt-20 md:mt-0 w-full h-full z-50 bg-black bg-opacity-50 flex justify-center items-center",
        onClick: closeModal,
        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
            className: "bg-white rounded-lg p-4 max-w-2xl w-full border",
            onClick: handleModalClick,
            children: [
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h2", {
                    className: "text-xl font-semibold mb-4",
                    children: "Alternativer"
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                    className: "grid gap-4",
                    children: article.value.map((option, index)=>{
                        const productInfo = productData.find((product)=>product.product_number === option.product_code);
                        const price = getPrice(option.product_code);
                        const discountedPrice = price.price * (1 - price.discount / 100);
                        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                            className: "border p-4 rounded-lg flex items-center justify-between cursor-pointer hover:bg-gray-100",
                            onClick: ()=>handleSelect(option.product_code, option.quantity),
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                        src: productInfo.product_images_urls?.[0]?.small_thumbnail_url,
                                        alt: productInfo.name,
                                        className: "w-16 h-16 object-contain"
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                        className: "text-left",
                                        children: [
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h3", {
                                                className: "text-md text-black font-semibold",
                                                children: productInfo.name
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600",
                                                children: [
                                                    option.quantity,
                                                    " stk."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600",
                                                children: [
                                                    "Pris hos Megaflis: ",
                                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                                                        className: "font-extrabold",
                                                        children: (0, $e34931c0b8a5da03$export$2e2bcd8739ae039)(discountedPrice)
                                                    }),
                                                    price.discount > 0 && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                                                        className: "line-through ml-2",
                                                        children: (0, $e34931c0b8a5da03$export$2e2bcd8739ae039)(price.price)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                    className: "mt-3 w-full bg-gray-100 text-gray-600 font-semibold py-3 px-5 rounded-lg hover:bg-gray-200 hover:text-gray-800  transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500",
                    onClick: closeModal,
                    children: "Close"
                })
            ]
        })
    });
};
var $b17e7c0e7c8af9d8$export$2e2bcd8739ae039 = $b17e7c0e7c8af9d8$var$OptionsModal;



class $128978ea80bc4437$var$ProductCard extends (0, $6umrQ.Component) {
    constructor(props){
        super(props), this.openModal = ()=>{
            this.setState({
                modalOpen: true
            });
        }, this.closeModal = ()=>{
            this.setState({
                modalOpen: false
            });
        }, this.setOptionsModalOpen = (open)=>{
            this.setState({
                optionsModalOpen: open
            });
        }, this.closeOptionsModal = ()=>{
            this.setState({
                optionsModalOpen: false
            });
        }, this.handleSelect = (reject = false)=>{
            const { roomCode: roomCode, rating: rating, setRoomSelection: setRoomSelection, itemIndex: itemIndex } = this.props;
            const { spaceProductData: spaceProductData, spaceArticleData: spaceArticleData } = this.getSpaceData();
            if (spaceProductData) setRoomSelection(roomCode, rating, spaceProductData.product_number, itemIndex, spaceArticleData.quantity, reject);
        }, this.renderImageSection = (spaceProductData)=>{
            return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                        src: spaceProductData.product_images_urls?.[0]?.small_thumbnail_url,
                        alt: "",
                        className: "w-[80px] md:w-[100px] lg:w-[120px] h-[80px] md:h-[100px] lg:h-[120px] object-center object-contain cursor-pointer",
                        onClick: this.openModal
                    }),
                    spaceProductData.airfow_certificates && spaceProductData.airfow_certificates.length > 0 && spaceProductData.airfow_certificates.map((cert)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                            className: "w-[36px] sm:w-[44px] h-[36px] sm:h-[44px] mt-2 grid place-content-center text-[#1D1F22] text-[16px] rounded-[8px] font-semibold",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                src: cert.image_url,
                                alt: cert.label
                            })
                        }, cert.label))
                ]
            });
        }, this.renderButtons = (selectedProductCode, spaceArticleData, articleType)=>{
            const rejected = selectedProductCode === 'rejected';
            const selectButtonLabel = selectedProductCode ? rejected ? window.gettext('Rejected. Click to select') : window.gettext('Selected. Click to deselect') : ngettext('Select this', 'Select these', spaceArticleData.quantity);
            const buttonList = [];
            buttonList.push(/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                type: "button",
                className: `text-sm text-${selectedProductCode ? 'fxgreen-dark' : '[#217CBF]'} font-semibold mr-3 mt-0`,
                onClick: ()=>this.handleSelect(),
                children: selectButtonLabel
            }));
            if (articleType === 'multi_choice' && (!selectedProductCode || rejected)) buttonList.push(/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                type: "button",
                className: `text-sm text-${selectedProductCode ? 'fxgreen-dark' : '[#217CBF]'} font-semibold mr-3 mt-0`,
                onClick: ()=>this.setOptionsModalOpen(true),
                children: window.gettext('View options')
            }));
            if (!selectedProductCode) buttonList.push(/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                type: "button",
                className: "text-sm text-[#217CBF] mt-0",
                onClick: ()=>this.handleSelect(true),
                children: window.gettext("Thank you, don't need this")
            }));
            return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                className: "flex flex-col items-start md:flex-row md:space-x-4 space-y-2 md:space-y-0",
                children: buttonList
            });
        }, this.renderProductInfoSection = ()=>{
            const { spaceArticleData: spaceArticleData, spaceProductData: spaceProductData, selectedProductCode: selectedProductCode } = this.getSpaceData();
            const { idx: idx, article: article, getPrice: getPrice } = this.props;
            const price = getPrice(spaceProductData.product_number);
            const discountedPrice = (price ? price.price : 0) * (1 - price.discount / 100);
            return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "pl-0 pt-[12px] lg:pl-[40px] sm:pt-0 text-left",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("p", {
                        className: "font-semibold text-[#1D1F22] text-[16px]",
                        children: [
                            spaceArticleData.quantity,
                            " stk. ",
                            spaceProductData.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "prose max-w-4xl space-y-3 text-sm col-start-1 product-description",
                        children: [
                            spaceProductData.features && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: spaceProductData.features
                                }
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("p", {
                                className: "text-sm text-gray-600",
                                children: [
                                    "Pris hos Megaflis: ",
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                                        className: "ml-2 font-extrabold",
                                        children: (0, $e34931c0b8a5da03$export$2e2bcd8739ae039)(discountedPrice)
                                    }),
                                    price.discount > 0 && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                                        className: "line-through ml-2",
                                        children: (0, $e34931c0b8a5da03$export$2e2bcd8739ae039)(price.price)
                                    })
                                ]
                            }),
                            this.renderButtons(selectedProductCode, spaceArticleData, article.type)
                        ]
                    })
                ]
            });
        };
        this.state = {
            modalOpen: false,
            optionsModalOpen: false
        };
    }
    getSpaceData() {
        const { article: article, suggestedArticles: suggestedArticles, roomCode: roomCode, rating: rating, itemIndex: itemIndex, productData: productData, getSelectedProductCode: getSelectedProductCode } = this.props;
        const selectedProductCode = getSelectedProductCode(roomCode, rating, itemIndex);
        const articleData = suggestedArticles[rating]?.[itemIndex];
        let spaceArticleData;
        const articleType = article.type;
        if (articleType === 'multi_choice') spaceArticleData = selectedProductCode && selectedProductCode !== 'rejected' ? articleData.value.find((product)=>product.product_code === selectedProductCode) : articleData.value[0];
        else spaceArticleData = articleData.value;
        const spaceProductData = productData.find((product)=>product.product_number === spaceArticleData?.product_code);
        return {
            spaceArticleData: spaceArticleData,
            spaceProductData: spaceProductData,
            selectedProductCode: selectedProductCode
        };
    }
    render() {
        const { idx: idx, article: article } = this.props;
        const { modalOpen: modalOpen, optionsModalOpen: optionsModalOpen } = this.state;
        const { spaceArticleData: spaceArticleData, spaceProductData: spaceProductData, selectedProductCode: selectedProductCode } = this.getSpaceData();
        if (article.type === 'text') return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                className: "border-[#EBEBF0] border rounded-[12px] w-full relative bg-white mb-4 transform transition duration-500 hover:scale-100",
                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                    className: "prose max-w-4xl p-[20px] text-gray-700 text-lg text-left",
                    dangerouslySetInnerHTML: {
                        __html: article.value
                    }
                })
            })
        }, `pcard${idx}`);
        if (!spaceProductData) return null;
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                    className: "border-[#EBEBF0] border rounded-[12px] w-full relative bg-white mb-4 transform transition duration-500 hover:scale-105",
                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                        type: "button",
                        className: "grid sm:flex w-full p-[20px]",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                            className: "flex justify-between w-full",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    this.renderImageSection(spaceProductData),
                                    this.renderProductInfoSection()
                                ]
                            })
                        })
                    })
                }),
                modalOpen && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $d8e936d8cdfc6ce2$export$2e2bcd8739ae039), {
                    productData: spaceProductData,
                    closeModal: this.closeModal
                }),
                optionsModalOpen && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $b17e7c0e7c8af9d8$export$2e2bcd8739ae039), {
                    article: this.props.suggestedArticles[this.props.rating]?.[this.props.itemIndex],
                    productData: this.props.productData,
                    roomCode: this.props.roomCode,
                    rating: this.props.rating,
                    itemIndex: this.props.itemIndex,
                    setRoomSelection: this.props.setRoomSelection,
                    getPrice: this.props.getPrice,
                    closeModal: this.closeOptionsModal
                })
            ]
        }, `pcard${idx}`);
    }
}
var $128978ea80bc4437$export$2e2bcd8739ae039 = $128978ea80bc4437$var$ProductCard;


const $dae17188ec902a7c$var$ProductList = ({ roomCode: roomCode, spaceData: spaceData, suggestedArticles: suggestedArticles, rating: rating, getSelectedProductCode: getSelectedProductCode, setRoomSelection: setRoomSelection, productData: productData, getPrice: getPrice })=>{
    const [visible, setVisible] = (0, $6umrQ.useState)(false);
    (0, $6umrQ.useEffect)(()=>{
        setVisible(false); // Start fade out
        const timeoutId = setTimeout(()=>setVisible(true), 60); // Wait for fade-out to complete before showing new content
        return ()=>clearTimeout(timeoutId);
    }, [
        roomCode,
        rating
    ]);
    const articles = suggestedArticles[rating] || [];
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        className: `grid sm:flex gap-[40px] transition-opacity duration-300 ${visible ? 'opacity-100' : 'opacity-0'}`,
        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            className: "w-full sm:print:w-full",
            children: articles.map((article, idx)=>{
                return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                    className: "pb-4 break-inside-avoid-page",
                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $128978ea80bc4437$export$2e2bcd8739ae039), {
                        idx: idx,
                        productData: productData,
                        spaceData: spaceData,
                        suggestedArticles: suggestedArticles,
                        roomCode: roomCode,
                        rating: rating,
                        article: article,
                        setRoomSelection: setRoomSelection,
                        itemIndex: idx,
                        getSelectedProductCode: getSelectedProductCode,
                        getPrice: getPrice
                    })
                }, idx);
            })
        })
    });
};
var $dae17188ec902a7c$export$2e2bcd8739ae039 = $dae17188ec902a7c$var$ProductList;


function $b978c5f41a14016f$var$areGoodAndBetterSame(data) {
    // Check if the data structure has the expected properties
    // This is legacy code that checks if the 'good' and 'better' choices are the same
    // This is redundant in the new version of the code, but kept for reference
    const goodItems = data.good[0].value;
    const betterItems = data.better[0].value;
    // Check if both item lists are arrays and return false if not
    if (!Array.isArray(goodItems) || !Array.isArray(betterItems)) return false;
    // Sort the arrays by product_code to ensure consistent comparison
    goodItems.sort((a, b)=>a.product_code.localeCompare(b.product_code));
    betterItems.sort((a, b)=>a.product_code.localeCompare(b.product_code));
    // Check if the lengths are the same
    if (goodItems.length !== betterItems.length) return false;
    // Compare each item in the sorted arrays
    for(let i = 0; i < goodItems.length; i++){
        if (goodItems[i].product_code !== betterItems[i].product_code || goodItems[i].quantity !== betterItems[i].quantity) return false;
    }
    return true;
}
const $b978c5f41a14016f$var$RoomRecommendations = ({ roomCode: roomCode, spaceData: spaceData, selectedRating: selectedRating, setRating: setRating, getSelectedProductCode: getSelectedProductCode, setRoomSelection: setRoomSelection, productData: productData, getPrice: getPrice })=>{
    let articles = spaceData.articles;
    if (!articles && spaceData.tabs) articles = spaceData.tabs[roomCode].articles;
    if (!articles) return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        children: window.gettext("No recommendations available for this room.")
    });
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("ul", {
                className: "flex rounded-xl align-middle bg-[#F5F7F9] text-[#1D1F22] mb-4",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("li", {
                        className: `w-full h-full text-center ${selectedRating === 'good' ? 'bg-gray-800 text-white rounded-l-[12px]' : 'rounded-l-[12px] bg-white print:hidden'}`,
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                            type: "button",
                            className: "w-full h-full p-[8px]",
                            onClick: ()=>setRating(roomCode, 'good'),
                            children: window.gettext("Good")
                        })
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("li", {
                        className: `w-full h-full text-center ${selectedRating === 'better' ? 'bg-gray-800 text-white' : 'bg-white print:hidden'}`,
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                            type: "button",
                            className: "w-full h-full p-[8px]",
                            onClick: ()=>setRating(roomCode, 'better'),
                            children: window.gettext("Better")
                        })
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("li", {
                        className: `w-full h-full text-center ${selectedRating === 'best' ? 'bg-gray-800 text-white rounded-r-[12px]' : 'rounded-r-[12px] bg-white print:hidden'}`,
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                            type: "button",
                            className: "w-full h-full p-[8px]",
                            onClick: ()=>setRating(roomCode, 'best'),
                            children: window.gettext("Best")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $dae17188ec902a7c$export$2e2bcd8739ae039), {
                roomCode: roomCode,
                spaceData: spaceData,
                suggestedArticles: articles,
                rating: selectedRating,
                getSelectedProductCode: getSelectedProductCode,
                setRoomSelection: setRoomSelection,
                productData: productData,
                getPrice: getPrice
            })
        ]
    });
};
var $b978c5f41a14016f$export$2e2bcd8739ae039 = $b978c5f41a14016f$var$RoomRecommendations;



parcelRequire("6umrQ");
// Functional Component: Spinner

parcelRequire("6umrQ");
const $bfe0d791e2414e08$var$Spinner = ({ size: size })=>{
    const sizeClasses = {
        'sm': 'w-4 h-4',
        'md': 'w-6 h-6',
        'lg': 'w-8 h-8',
        'xl': 'w-12 h-12'
    };
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("span", {
        role: "status",
        children: [
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("svg", {
                "aria-hidden": "true",
                className: `${sizeClasses[size]} text-gray-200 animate-spin dark:text-gray-600 fill-blue-600`,
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            })
        ]
    });
};
var $bfe0d791e2414e08$export$2e2bcd8739ae039 = $bfe0d791e2414e08$var$Spinner;



const $eeef6325048dcac6$var$CartModal = ({ selectedData: selectedData, products: products, spaces: spaces, price_list: price_list, closeModal: closeModal, handleProceedToCart: handleProceedToCart, populatingCart: populatingCart, populatingCartError: populatingCartError })=>{
    const getPrice = (productCode)=>{
        const priceData = price_list[productCode];
        if (priceData) return priceData;
        // Generate random price if not available in price_list
        return {
            price: 0,
            discount: 0
        };
    };
    const groupedProducts = Object.entries(selectedData).flatMap(([roomCode, roomData])=>{
        return Object.entries(roomData.selectedProducts).map(([index, product])=>{
            if (product) {
                const productData = products.find((p)=>p.product_number === product.productCode);
                const roomType = roomCode.replace(/[0-9]/g, '');
                const roomLabel = spaces[roomType].label;
                const roomNumber = roomCode.match(/[0-9]+$/) ? parseInt(roomCode.match(/[0-9]+$/)[0], 10) + 1 : 1; // Extract room number
                return {
                    productCode: product.productCode,
                    productName: productData.name,
                    quantity: parseInt(product.quantity, 10),
                    roomLabel: `${roomLabel} ${roomNumber}`,
                    imageUrl: productData.product_images_urls[0]?.small_thumbnail_url,
                    price: getPrice(product.productCode)
                };
            }
        });
    }).reduce((acc, product)=>{
        const existingProduct = acc.find((p)=>p.productCode === product?.productCode);
        if (existingProduct) {
            existingProduct.totalQuantity += product.quantity;
            existingProduct.rooms.push({
                roomLabel: product.roomLabel,
                quantity: product.quantity
            });
        } else if (product) acc.push({
            productCode: product.productCode,
            productName: product.productName,
            totalQuantity: product.quantity,
            rooms: [
                {
                    roomLabel: product.roomLabel,
                    quantity: product.quantity
                }
            ],
            imageUrl: product.imageUrl,
            price: product.price
        });
        return acc;
    }, []);
    const grandTotal = groupedProducts.reduce((total, product)=>{
        return total + product.price.price * (1 - product.price.discount / 100) * product.totalQuantity;
    }, 0);
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2",
        onClick: closeModal,
        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
            className: "bg-white rounded-lg px-3 py-4 mx-0 my-4 overflow-y-auto max-h-[calc(100vh-4rem)] w-full ",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h2", {
                    className: "text-xl font-semibold mb-4",
                    children: window.gettext('Selected Products')
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("ul", {
                    children: groupedProducts.map((product, index)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("li", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                        src: product.imageUrl,
                                        alt: product.productName,
                                        className: "object-top w-16 h-16 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h3", {
                                                className: "font-semibold",
                                                children: product.productName
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                                                children: (0, $e34931c0b8a5da03$export$2e2bcd8739ae039)(product.totalQuantity * product.price.price * (1 - product.price.discount / 100))
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("ul", {
                                                className: "inline-flex flex-wrap space-x-1",
                                                children: product.rooms.map((room, roomIndex)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("li", {
                                                        className: "text-sm",
                                                        children: [
                                                            room.quantity,
                                                            " for ",
                                                            room.roomLabel,
                                                            roomIndex < product.rooms.length - 1 ? ', ' : '.'
                                                        ]
                                                    }, roomIndex))
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index))
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                    className: " font-semibold mt-4",
                    children: [
                        window.gettext('Grand Total'),
                        ": ",
                        (0, $e34931c0b8a5da03$export$2e2bcd8739ae039)(grandTotal)
                    ]
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                    onClick: handleProceedToCart,
                    disabled: populatingCart,
                    className: "mt-4 w-full bg-fxblue hover:bg-gray-300 px-4 py-2 rounded-lg text-white",
                    children: populatingCart ? /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $bfe0d791e2414e08$export$2e2bcd8739ae039), {
                        size: "md"
                    }) : window.gettext('Proceed to Megaflis cart')
                }),
                populatingCartError && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                    className: "text-red-500 text-sm mt-2",
                    children: populatingCartError
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                    className: "mt-5",
                    children: window.gettext('Want to change something? Close and redo selections!')
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                    onClick: closeModal,
                    className: "w-full mt-4 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg",
                    children: window.gettext('Close')
                })
            ]
        })
    });
};
var $eeef6325048dcac6$export$2e2bcd8739ae039 = $eeef6325048dcac6$var$CartModal;


'use strict';
function $919a45f98c361aa5$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $42f8c60b5c2dc418$var$toString } = Object.prototype;
const { getPrototypeOf: $42f8c60b5c2dc418$var$getPrototypeOf } = Object;
const { iterator: $42f8c60b5c2dc418$var$iterator, toStringTag: $42f8c60b5c2dc418$var$toStringTag } = Symbol;
const $42f8c60b5c2dc418$var$kindOf = ((cache)=>(thing)=>{
        const str = $42f8c60b5c2dc418$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $42f8c60b5c2dc418$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$42f8c60b5c2dc418$var$kindOf(thing) === type;
};
const $42f8c60b5c2dc418$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $42f8c60b5c2dc418$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $42f8c60b5c2dc418$var$isUndefined = $42f8c60b5c2dc418$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $42f8c60b5c2dc418$var$isBuffer(val) {
    return val !== null && !$42f8c60b5c2dc418$var$isUndefined(val) && val.constructor !== null && !$42f8c60b5c2dc418$var$isUndefined(val.constructor) && $42f8c60b5c2dc418$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $42f8c60b5c2dc418$var$isArrayBuffer = $42f8c60b5c2dc418$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $42f8c60b5c2dc418$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $42f8c60b5c2dc418$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $42f8c60b5c2dc418$var$isString = $42f8c60b5c2dc418$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $42f8c60b5c2dc418$var$isFunction = $42f8c60b5c2dc418$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $42f8c60b5c2dc418$var$isNumber = $42f8c60b5c2dc418$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $42f8c60b5c2dc418$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $42f8c60b5c2dc418$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $42f8c60b5c2dc418$var$isPlainObject = (val)=>{
    if ($42f8c60b5c2dc418$var$kindOf(val) !== 'object') return false;
    const prototype = $42f8c60b5c2dc418$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($42f8c60b5c2dc418$var$toStringTag in val) && !($42f8c60b5c2dc418$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $42f8c60b5c2dc418$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$42f8c60b5c2dc418$var$isObject(val) || $42f8c60b5c2dc418$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $42f8c60b5c2dc418$var$isDate = $42f8c60b5c2dc418$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $42f8c60b5c2dc418$var$isFile = $42f8c60b5c2dc418$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $42f8c60b5c2dc418$var$isBlob = $42f8c60b5c2dc418$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $42f8c60b5c2dc418$var$isFileList = $42f8c60b5c2dc418$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $42f8c60b5c2dc418$var$isStream = (val)=>$42f8c60b5c2dc418$var$isObject(val) && $42f8c60b5c2dc418$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $42f8c60b5c2dc418$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $42f8c60b5c2dc418$var$isFunction(thing.append) && ((kind = $42f8c60b5c2dc418$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $42f8c60b5c2dc418$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $42f8c60b5c2dc418$var$isURLSearchParams = $42f8c60b5c2dc418$var$kindOfTest('URLSearchParams');
const [$42f8c60b5c2dc418$var$isReadableStream, $42f8c60b5c2dc418$var$isRequest, $42f8c60b5c2dc418$var$isResponse, $42f8c60b5c2dc418$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($42f8c60b5c2dc418$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $42f8c60b5c2dc418$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $42f8c60b5c2dc418$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($42f8c60b5c2dc418$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($42f8c60b5c2dc418$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $42f8c60b5c2dc418$var$findKey(obj, key) {
    if ($42f8c60b5c2dc418$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $42f8c60b5c2dc418$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $42f8c60b5c2dc418$var$isContextDefined = (context)=>!$42f8c60b5c2dc418$var$isUndefined(context) && context !== $42f8c60b5c2dc418$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $42f8c60b5c2dc418$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $42f8c60b5c2dc418$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $42f8c60b5c2dc418$var$findKey(result, key) || key;
        if ($42f8c60b5c2dc418$var$isPlainObject(result[targetKey]) && $42f8c60b5c2dc418$var$isPlainObject(val)) result[targetKey] = $42f8c60b5c2dc418$var$merge(result[targetKey], val);
        else if ($42f8c60b5c2dc418$var$isPlainObject(val)) result[targetKey] = $42f8c60b5c2dc418$var$merge({}, val);
        else if ($42f8c60b5c2dc418$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$42f8c60b5c2dc418$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $42f8c60b5c2dc418$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $42f8c60b5c2dc418$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $42f8c60b5c2dc418$var$forEach(b, (val, key)=>{
        if (thisArg && $42f8c60b5c2dc418$var$isFunction(val)) a[key] = (0, $919a45f98c361aa5$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $42f8c60b5c2dc418$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $42f8c60b5c2dc418$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $42f8c60b5c2dc418$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $42f8c60b5c2dc418$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $42f8c60b5c2dc418$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $42f8c60b5c2dc418$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($42f8c60b5c2dc418$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$42f8c60b5c2dc418$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $42f8c60b5c2dc418$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $42f8c60b5c2dc418$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $42f8c60b5c2dc418$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$42f8c60b5c2dc418$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $42f8c60b5c2dc418$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $42f8c60b5c2dc418$var$isHTMLForm = $42f8c60b5c2dc418$var$kindOfTest('HTMLFormElement');
const $42f8c60b5c2dc418$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $42f8c60b5c2dc418$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $42f8c60b5c2dc418$var$isRegExp = $42f8c60b5c2dc418$var$kindOfTest('RegExp');
const $42f8c60b5c2dc418$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $42f8c60b5c2dc418$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $42f8c60b5c2dc418$var$freezeMethods = (obj)=>{
    $42f8c60b5c2dc418$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($42f8c60b5c2dc418$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$42f8c60b5c2dc418$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $42f8c60b5c2dc418$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $42f8c60b5c2dc418$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $42f8c60b5c2dc418$var$noop = ()=>{};
const $42f8c60b5c2dc418$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $42f8c60b5c2dc418$var$isSpecCompliantForm(thing) {
    return !!(thing && $42f8c60b5c2dc418$var$isFunction(thing.append) && thing[$42f8c60b5c2dc418$var$toStringTag] === 'FormData' && thing[$42f8c60b5c2dc418$var$iterator]);
}
const $42f8c60b5c2dc418$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($42f8c60b5c2dc418$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($42f8c60b5c2dc418$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $42f8c60b5c2dc418$var$isArray(source) ? [] : {};
                $42f8c60b5c2dc418$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$42f8c60b5c2dc418$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $42f8c60b5c2dc418$var$isAsyncFn = $42f8c60b5c2dc418$var$kindOfTest('AsyncFunction');
const $42f8c60b5c2dc418$var$isThenable = (thing)=>thing && ($42f8c60b5c2dc418$var$isObject(thing) || $42f8c60b5c2dc418$var$isFunction(thing)) && $42f8c60b5c2dc418$var$isFunction(thing.then) && $42f8c60b5c2dc418$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $42f8c60b5c2dc418$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $42f8c60b5c2dc418$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $42f8c60b5c2dc418$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $42f8c60b5c2dc418$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $42f8c60b5c2dc418$var$isFunction($42f8c60b5c2dc418$var$_global.postMessage));
const $42f8c60b5c2dc418$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($42f8c60b5c2dc418$var$_global) : $42f8c60b5c2dc418$var$_setImmediate;
// *********************
const $42f8c60b5c2dc418$var$isIterable = (thing)=>thing != null && $42f8c60b5c2dc418$var$isFunction(thing[$42f8c60b5c2dc418$var$iterator]);
var $42f8c60b5c2dc418$export$2e2bcd8739ae039 = {
    isArray: $42f8c60b5c2dc418$var$isArray,
    isArrayBuffer: $42f8c60b5c2dc418$var$isArrayBuffer,
    isBuffer: $42f8c60b5c2dc418$var$isBuffer,
    isFormData: $42f8c60b5c2dc418$var$isFormData,
    isArrayBufferView: $42f8c60b5c2dc418$var$isArrayBufferView,
    isString: $42f8c60b5c2dc418$var$isString,
    isNumber: $42f8c60b5c2dc418$var$isNumber,
    isBoolean: $42f8c60b5c2dc418$var$isBoolean,
    isObject: $42f8c60b5c2dc418$var$isObject,
    isPlainObject: $42f8c60b5c2dc418$var$isPlainObject,
    isEmptyObject: $42f8c60b5c2dc418$var$isEmptyObject,
    isReadableStream: $42f8c60b5c2dc418$var$isReadableStream,
    isRequest: $42f8c60b5c2dc418$var$isRequest,
    isResponse: $42f8c60b5c2dc418$var$isResponse,
    isHeaders: $42f8c60b5c2dc418$var$isHeaders,
    isUndefined: $42f8c60b5c2dc418$var$isUndefined,
    isDate: $42f8c60b5c2dc418$var$isDate,
    isFile: $42f8c60b5c2dc418$var$isFile,
    isBlob: $42f8c60b5c2dc418$var$isBlob,
    isRegExp: $42f8c60b5c2dc418$var$isRegExp,
    isFunction: $42f8c60b5c2dc418$var$isFunction,
    isStream: $42f8c60b5c2dc418$var$isStream,
    isURLSearchParams: $42f8c60b5c2dc418$var$isURLSearchParams,
    isTypedArray: $42f8c60b5c2dc418$var$isTypedArray,
    isFileList: $42f8c60b5c2dc418$var$isFileList,
    forEach: $42f8c60b5c2dc418$var$forEach,
    merge: $42f8c60b5c2dc418$var$merge,
    extend: $42f8c60b5c2dc418$var$extend,
    trim: $42f8c60b5c2dc418$var$trim,
    stripBOM: $42f8c60b5c2dc418$var$stripBOM,
    inherits: $42f8c60b5c2dc418$var$inherits,
    toFlatObject: $42f8c60b5c2dc418$var$toFlatObject,
    kindOf: $42f8c60b5c2dc418$var$kindOf,
    kindOfTest: $42f8c60b5c2dc418$var$kindOfTest,
    endsWith: $42f8c60b5c2dc418$var$endsWith,
    toArray: $42f8c60b5c2dc418$var$toArray,
    forEachEntry: $42f8c60b5c2dc418$var$forEachEntry,
    matchAll: $42f8c60b5c2dc418$var$matchAll,
    isHTMLForm: $42f8c60b5c2dc418$var$isHTMLForm,
    hasOwnProperty: $42f8c60b5c2dc418$var$hasOwnProperty,
    hasOwnProp: $42f8c60b5c2dc418$var$hasOwnProperty,
    reduceDescriptors: $42f8c60b5c2dc418$var$reduceDescriptors,
    freezeMethods: $42f8c60b5c2dc418$var$freezeMethods,
    toObjectSet: $42f8c60b5c2dc418$var$toObjectSet,
    toCamelCase: $42f8c60b5c2dc418$var$toCamelCase,
    noop: $42f8c60b5c2dc418$var$noop,
    toFiniteNumber: $42f8c60b5c2dc418$var$toFiniteNumber,
    findKey: $42f8c60b5c2dc418$var$findKey,
    global: $42f8c60b5c2dc418$var$_global,
    isContextDefined: $42f8c60b5c2dc418$var$isContextDefined,
    isSpecCompliantForm: $42f8c60b5c2dc418$var$isSpecCompliantForm,
    toJSONObject: $42f8c60b5c2dc418$var$toJSONObject,
    isAsyncFn: $42f8c60b5c2dc418$var$isAsyncFn,
    isThenable: $42f8c60b5c2dc418$var$isThenable,
    setImmediate: $42f8c60b5c2dc418$var$_setImmediate,
    asap: $42f8c60b5c2dc418$var$asap,
    isIterable: $42f8c60b5c2dc418$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $417caf3b768da6eb$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).inherits($417caf3b768da6eb$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $417caf3b768da6eb$var$prototype = $417caf3b768da6eb$var$AxiosError.prototype;
const $417caf3b768da6eb$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $417caf3b768da6eb$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($417caf3b768da6eb$var$AxiosError, $417caf3b768da6eb$var$descriptors);
Object.defineProperty($417caf3b768da6eb$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$417caf3b768da6eb$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($417caf3b768da6eb$var$prototype);
    (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $417caf3b768da6eb$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $417caf3b768da6eb$export$2e2bcd8739ae039 = $417caf3b768da6eb$var$AxiosError;


// eslint-disable-next-line strict
var $4515b8adc749a7dd$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82eb346aae1ddb15$export$a143d493d941bafc;
var $82eb346aae1ddb15$export$e4cf37d7f6fb9e0a;
var $82eb346aae1ddb15$export$f99ded8fe4b79145;
var $82eb346aae1ddb15$export$599f31c3813fae4d;
'use strict';
var $524b9eb98c4354ad$export$a48f0734ac7c2329;
var $524b9eb98c4354ad$export$d622b2ad8d90c771;
var $524b9eb98c4354ad$export$6100ba28696e12de;
'use strict';
$524b9eb98c4354ad$export$a48f0734ac7c2329 = $524b9eb98c4354ad$var$byteLength;
$524b9eb98c4354ad$export$d622b2ad8d90c771 = $524b9eb98c4354ad$var$toByteArray;
$524b9eb98c4354ad$export$6100ba28696e12de = $524b9eb98c4354ad$var$fromByteArray;
var $524b9eb98c4354ad$var$lookup = [];
var $524b9eb98c4354ad$var$revLookup = [];
var $524b9eb98c4354ad$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $524b9eb98c4354ad$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $524b9eb98c4354ad$var$i = 0, $524b9eb98c4354ad$var$len = $524b9eb98c4354ad$var$code.length; $524b9eb98c4354ad$var$i < $524b9eb98c4354ad$var$len; ++$524b9eb98c4354ad$var$i){
    $524b9eb98c4354ad$var$lookup[$524b9eb98c4354ad$var$i] = $524b9eb98c4354ad$var$code[$524b9eb98c4354ad$var$i];
    $524b9eb98c4354ad$var$revLookup[$524b9eb98c4354ad$var$code.charCodeAt($524b9eb98c4354ad$var$i)] = $524b9eb98c4354ad$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$524b9eb98c4354ad$var$revLookup['-'.charCodeAt(0)] = 62;
$524b9eb98c4354ad$var$revLookup['_'.charCodeAt(0)] = 63;
function $524b9eb98c4354ad$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $524b9eb98c4354ad$var$byteLength(b64) {
    var lens = $524b9eb98c4354ad$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $524b9eb98c4354ad$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $524b9eb98c4354ad$var$toByteArray(b64) {
    var tmp;
    var lens = $524b9eb98c4354ad$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $524b9eb98c4354ad$var$Arr($524b9eb98c4354ad$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i)] << 18 | $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i)] << 2 | $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i)] << 10 | $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $524b9eb98c4354ad$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $524b9eb98c4354ad$var$tripletToBase64(num) {
    return $524b9eb98c4354ad$var$lookup[num >> 18 & 0x3F] + $524b9eb98c4354ad$var$lookup[num >> 12 & 0x3F] + $524b9eb98c4354ad$var$lookup[num >> 6 & 0x3F] + $524b9eb98c4354ad$var$lookup[num & 0x3F];
}
function $524b9eb98c4354ad$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($524b9eb98c4354ad$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $524b9eb98c4354ad$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($524b9eb98c4354ad$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($524b9eb98c4354ad$var$lookup[tmp >> 2] + $524b9eb98c4354ad$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($524b9eb98c4354ad$var$lookup[tmp >> 10] + $524b9eb98c4354ad$var$lookup[tmp >> 4 & 0x3F] + $524b9eb98c4354ad$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f0664005d9c84ca8$export$aafa59e2e03f2942;
var $f0664005d9c84ca8$export$68d8715fc104d294;
$f0664005d9c84ca8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f0664005d9c84ca8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $82eb346aae1ddb15$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82eb346aae1ddb15$export$a143d493d941bafc = $82eb346aae1ddb15$var$Buffer;
$82eb346aae1ddb15$export$e4cf37d7f6fb9e0a = $82eb346aae1ddb15$var$SlowBuffer;
$82eb346aae1ddb15$export$f99ded8fe4b79145 = 50;
const $82eb346aae1ddb15$var$K_MAX_LENGTH = 0x7fffffff;
$82eb346aae1ddb15$export$599f31c3813fae4d = $82eb346aae1ddb15$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82eb346aae1ddb15$var$Buffer.TYPED_ARRAY_SUPPORT = $82eb346aae1ddb15$var$typedArraySupport();
if (!$82eb346aae1ddb15$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82eb346aae1ddb15$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82eb346aae1ddb15$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82eb346aae1ddb15$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82eb346aae1ddb15$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82eb346aae1ddb15$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82eb346aae1ddb15$var$createBuffer(length) {
    if (length > $82eb346aae1ddb15$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82eb346aae1ddb15$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82eb346aae1ddb15$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82eb346aae1ddb15$var$allocUnsafe(arg);
    }
    return $82eb346aae1ddb15$var$from(arg, encodingOrOffset, length);
}
$82eb346aae1ddb15$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82eb346aae1ddb15$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82eb346aae1ddb15$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82eb346aae1ddb15$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82eb346aae1ddb15$var$isInstance(value, ArrayBuffer) || value && $82eb346aae1ddb15$var$isInstance(value.buffer, ArrayBuffer)) return $82eb346aae1ddb15$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82eb346aae1ddb15$var$isInstance(value, SharedArrayBuffer) || value && $82eb346aae1ddb15$var$isInstance(value.buffer, SharedArrayBuffer))) return $82eb346aae1ddb15$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82eb346aae1ddb15$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82eb346aae1ddb15$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82eb346aae1ddb15$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82eb346aae1ddb15$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82eb346aae1ddb15$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82eb346aae1ddb15$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82eb346aae1ddb15$var$Buffer, Uint8Array);
function $82eb346aae1ddb15$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82eb346aae1ddb15$var$alloc(size, fill, encoding) {
    $82eb346aae1ddb15$var$assertSize(size);
    if (size <= 0) return $82eb346aae1ddb15$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82eb346aae1ddb15$var$createBuffer(size).fill(fill, encoding) : $82eb346aae1ddb15$var$createBuffer(size).fill(fill);
    return $82eb346aae1ddb15$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82eb346aae1ddb15$var$Buffer.alloc = function(size, fill, encoding) {
    return $82eb346aae1ddb15$var$alloc(size, fill, encoding);
};
function $82eb346aae1ddb15$var$allocUnsafe(size) {
    $82eb346aae1ddb15$var$assertSize(size);
    return $82eb346aae1ddb15$var$createBuffer(size < 0 ? 0 : $82eb346aae1ddb15$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82eb346aae1ddb15$var$Buffer.allocUnsafe = function(size) {
    return $82eb346aae1ddb15$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82eb346aae1ddb15$var$Buffer.allocUnsafeSlow = function(size) {
    return $82eb346aae1ddb15$var$allocUnsafe(size);
};
function $82eb346aae1ddb15$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82eb346aae1ddb15$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82eb346aae1ddb15$var$byteLength(string, encoding) | 0;
    let buf = $82eb346aae1ddb15$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82eb346aae1ddb15$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82eb346aae1ddb15$var$checked(array.length) | 0;
    const buf = $82eb346aae1ddb15$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82eb346aae1ddb15$var$fromArrayView(arrayView) {
    if ($82eb346aae1ddb15$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82eb346aae1ddb15$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82eb346aae1ddb15$var$fromArrayLike(arrayView);
}
function $82eb346aae1ddb15$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82eb346aae1ddb15$var$Buffer.prototype);
    return buf;
}
function $82eb346aae1ddb15$var$fromObject(obj) {
    if ($82eb346aae1ddb15$var$Buffer.isBuffer(obj)) {
        const len = $82eb346aae1ddb15$var$checked(obj.length) | 0;
        const buf = $82eb346aae1ddb15$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82eb346aae1ddb15$var$numberIsNaN(obj.length)) return $82eb346aae1ddb15$var$createBuffer(0);
        return $82eb346aae1ddb15$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82eb346aae1ddb15$var$fromArrayLike(obj.data);
}
function $82eb346aae1ddb15$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82eb346aae1ddb15$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82eb346aae1ddb15$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82eb346aae1ddb15$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82eb346aae1ddb15$var$Buffer.alloc(+length);
}
$82eb346aae1ddb15$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82eb346aae1ddb15$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82eb346aae1ddb15$var$Buffer.compare = function compare(a, b) {
    if ($82eb346aae1ddb15$var$isInstance(a, Uint8Array)) a = $82eb346aae1ddb15$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82eb346aae1ddb15$var$isInstance(b, Uint8Array)) b = $82eb346aae1ddb15$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82eb346aae1ddb15$var$Buffer.isBuffer(a) || !$82eb346aae1ddb15$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82eb346aae1ddb15$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82eb346aae1ddb15$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82eb346aae1ddb15$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82eb346aae1ddb15$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82eb346aae1ddb15$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82eb346aae1ddb15$var$Buffer.isBuffer(buf)) buf = $82eb346aae1ddb15$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82eb346aae1ddb15$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82eb346aae1ddb15$var$byteLength(string, encoding) {
    if ($82eb346aae1ddb15$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82eb346aae1ddb15$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82eb346aae1ddb15$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82eb346aae1ddb15$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82eb346aae1ddb15$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82eb346aae1ddb15$var$Buffer.byteLength = $82eb346aae1ddb15$var$byteLength;
function $82eb346aae1ddb15$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82eb346aae1ddb15$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82eb346aae1ddb15$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82eb346aae1ddb15$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82eb346aae1ddb15$var$latin1Slice(this, start, end);
        case 'base64':
            return $82eb346aae1ddb15$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82eb346aae1ddb15$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82eb346aae1ddb15$var$Buffer.prototype._isBuffer = true;
function $82eb346aae1ddb15$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82eb346aae1ddb15$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82eb346aae1ddb15$var$swap(this, i, i + 1);
    return this;
};
$82eb346aae1ddb15$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82eb346aae1ddb15$var$swap(this, i, i + 3);
        $82eb346aae1ddb15$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82eb346aae1ddb15$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82eb346aae1ddb15$var$swap(this, i, i + 7);
        $82eb346aae1ddb15$var$swap(this, i + 1, i + 6);
        $82eb346aae1ddb15$var$swap(this, i + 2, i + 5);
        $82eb346aae1ddb15$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82eb346aae1ddb15$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82eb346aae1ddb15$var$utf8Slice(this, 0, length);
    return $82eb346aae1ddb15$var$slowToString.apply(this, arguments);
};
$82eb346aae1ddb15$var$Buffer.prototype.toLocaleString = $82eb346aae1ddb15$var$Buffer.prototype.toString;
$82eb346aae1ddb15$var$Buffer.prototype.equals = function equals(b) {
    if (!$82eb346aae1ddb15$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82eb346aae1ddb15$var$Buffer.compare(this, b) === 0;
};
$82eb346aae1ddb15$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82eb346aae1ddb15$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82eb346aae1ddb15$var$customInspectSymbol) $82eb346aae1ddb15$var$Buffer.prototype[$82eb346aae1ddb15$var$customInspectSymbol] = $82eb346aae1ddb15$var$Buffer.prototype.inspect;
$82eb346aae1ddb15$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82eb346aae1ddb15$var$isInstance(target, Uint8Array)) target = $82eb346aae1ddb15$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82eb346aae1ddb15$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82eb346aae1ddb15$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82eb346aae1ddb15$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82eb346aae1ddb15$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82eb346aae1ddb15$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82eb346aae1ddb15$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82eb346aae1ddb15$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82eb346aae1ddb15$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82eb346aae1ddb15$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82eb346aae1ddb15$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82eb346aae1ddb15$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82eb346aae1ddb15$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82eb346aae1ddb15$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82eb346aae1ddb15$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82eb346aae1ddb15$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82eb346aae1ddb15$var$utf8Write(buf, string, offset, length) {
    return $82eb346aae1ddb15$var$blitBuffer($82eb346aae1ddb15$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82eb346aae1ddb15$var$asciiWrite(buf, string, offset, length) {
    return $82eb346aae1ddb15$var$blitBuffer($82eb346aae1ddb15$var$asciiToBytes(string), buf, offset, length);
}
function $82eb346aae1ddb15$var$base64Write(buf, string, offset, length) {
    return $82eb346aae1ddb15$var$blitBuffer($82eb346aae1ddb15$var$base64ToBytes(string), buf, offset, length);
}
function $82eb346aae1ddb15$var$ucs2Write(buf, string, offset, length) {
    return $82eb346aae1ddb15$var$blitBuffer($82eb346aae1ddb15$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82eb346aae1ddb15$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82eb346aae1ddb15$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82eb346aae1ddb15$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82eb346aae1ddb15$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82eb346aae1ddb15$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82eb346aae1ddb15$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82eb346aae1ddb15$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82eb346aae1ddb15$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $524b9eb98c4354ad$export$6100ba28696e12de(buf);
    else return $524b9eb98c4354ad$export$6100ba28696e12de(buf.slice(start, end));
}
function $82eb346aae1ddb15$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82eb346aae1ddb15$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82eb346aae1ddb15$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82eb346aae1ddb15$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82eb346aae1ddb15$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82eb346aae1ddb15$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82eb346aae1ddb15$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82eb346aae1ddb15$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82eb346aae1ddb15$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82eb346aae1ddb15$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82eb346aae1ddb15$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82eb346aae1ddb15$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82eb346aae1ddb15$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82eb346aae1ddb15$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82eb346aae1ddb15$var$Buffer.prototype.readUintLE = $82eb346aae1ddb15$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82eb346aae1ddb15$var$Buffer.prototype.readUintBE = $82eb346aae1ddb15$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82eb346aae1ddb15$var$Buffer.prototype.readUint8 = $82eb346aae1ddb15$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82eb346aae1ddb15$var$Buffer.prototype.readUint16LE = $82eb346aae1ddb15$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82eb346aae1ddb15$var$Buffer.prototype.readUint16BE = $82eb346aae1ddb15$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82eb346aae1ddb15$var$Buffer.prototype.readUint32LE = $82eb346aae1ddb15$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82eb346aae1ddb15$var$Buffer.prototype.readUint32BE = $82eb346aae1ddb15$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82eb346aae1ddb15$var$Buffer.prototype.readBigUInt64LE = $82eb346aae1ddb15$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82eb346aae1ddb15$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82eb346aae1ddb15$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82eb346aae1ddb15$var$Buffer.prototype.readBigUInt64BE = $82eb346aae1ddb15$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82eb346aae1ddb15$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82eb346aae1ddb15$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82eb346aae1ddb15$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82eb346aae1ddb15$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82eb346aae1ddb15$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82eb346aae1ddb15$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82eb346aae1ddb15$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82eb346aae1ddb15$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82eb346aae1ddb15$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82eb346aae1ddb15$var$Buffer.prototype.readBigInt64LE = $82eb346aae1ddb15$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82eb346aae1ddb15$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82eb346aae1ddb15$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82eb346aae1ddb15$var$Buffer.prototype.readBigInt64BE = $82eb346aae1ddb15$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82eb346aae1ddb15$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82eb346aae1ddb15$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82eb346aae1ddb15$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 4, this.length);
    return $f0664005d9c84ca8$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$82eb346aae1ddb15$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 4, this.length);
    return $f0664005d9c84ca8$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$82eb346aae1ddb15$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 8, this.length);
    return $f0664005d9c84ca8$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$82eb346aae1ddb15$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkOffset(offset, 8, this.length);
    return $f0664005d9c84ca8$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $82eb346aae1ddb15$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82eb346aae1ddb15$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82eb346aae1ddb15$var$Buffer.prototype.writeUintLE = $82eb346aae1ddb15$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82eb346aae1ddb15$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeUintBE = $82eb346aae1ddb15$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82eb346aae1ddb15$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeUint8 = $82eb346aae1ddb15$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeUint16LE = $82eb346aae1ddb15$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeUint16BE = $82eb346aae1ddb15$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeUint32LE = $82eb346aae1ddb15$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeUint32BE = $82eb346aae1ddb15$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82eb346aae1ddb15$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82eb346aae1ddb15$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82eb346aae1ddb15$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82eb346aae1ddb15$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82eb346aae1ddb15$var$Buffer.prototype.writeBigUInt64LE = $82eb346aae1ddb15$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82eb346aae1ddb15$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82eb346aae1ddb15$var$Buffer.prototype.writeBigUInt64BE = $82eb346aae1ddb15$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82eb346aae1ddb15$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82eb346aae1ddb15$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82eb346aae1ddb15$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82eb346aae1ddb15$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82eb346aae1ddb15$var$Buffer.prototype.writeBigInt64LE = $82eb346aae1ddb15$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82eb346aae1ddb15$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82eb346aae1ddb15$var$Buffer.prototype.writeBigInt64BE = $82eb346aae1ddb15$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82eb346aae1ddb15$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82eb346aae1ddb15$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82eb346aae1ddb15$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $f0664005d9c84ca8$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82eb346aae1ddb15$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82eb346aae1ddb15$var$writeFloat(this, value, offset, true, noAssert);
};
$82eb346aae1ddb15$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82eb346aae1ddb15$var$writeFloat(this, value, offset, false, noAssert);
};
function $82eb346aae1ddb15$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82eb346aae1ddb15$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $f0664005d9c84ca8$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82eb346aae1ddb15$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82eb346aae1ddb15$var$writeDouble(this, value, offset, true, noAssert);
};
$82eb346aae1ddb15$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82eb346aae1ddb15$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82eb346aae1ddb15$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82eb346aae1ddb15$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82eb346aae1ddb15$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82eb346aae1ddb15$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82eb346aae1ddb15$var$Buffer.isBuffer(val) ? val : $82eb346aae1ddb15$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82eb346aae1ddb15$var$errors = {};
function $82eb346aae1ddb15$var$E(sym, getMessage, Base) {
    $82eb346aae1ddb15$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$82eb346aae1ddb15$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82eb346aae1ddb15$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82eb346aae1ddb15$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82eb346aae1ddb15$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82eb346aae1ddb15$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82eb346aae1ddb15$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82eb346aae1ddb15$var$checkBounds(buf, offset, byteLength) {
    $82eb346aae1ddb15$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82eb346aae1ddb15$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82eb346aae1ddb15$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82eb346aae1ddb15$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82eb346aae1ddb15$var$checkBounds(buf, offset, byteLength);
}
function $82eb346aae1ddb15$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82eb346aae1ddb15$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82eb346aae1ddb15$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82eb346aae1ddb15$var$validateNumber(value, type);
        throw new $82eb346aae1ddb15$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82eb346aae1ddb15$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82eb346aae1ddb15$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82eb346aae1ddb15$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82eb346aae1ddb15$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82eb346aae1ddb15$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82eb346aae1ddb15$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82eb346aae1ddb15$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82eb346aae1ddb15$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82eb346aae1ddb15$var$base64ToBytes(str) {
    return $524b9eb98c4354ad$export$d622b2ad8d90c771($82eb346aae1ddb15$var$base64clean(str));
}
function $82eb346aae1ddb15$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82eb346aae1ddb15$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82eb346aae1ddb15$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82eb346aae1ddb15$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82eb346aae1ddb15$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82eb346aae1ddb15$var$BufferBigIntNotDefined : fn;
}
function $82eb346aae1ddb15$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $bea96998a4c18069$require$Buffer = $82eb346aae1ddb15$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $bea96998a4c18069$var$isVisitable(thing) {
    return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $bea96998a4c18069$var$removeBrackets(key) {
    return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $bea96998a4c18069$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $bea96998a4c18069$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $bea96998a4c18069$var$isFlatArray(arr) {
    return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(arr) && !arr.some($bea96998a4c18069$var$isVisitable);
}
const $bea96998a4c18069$var$predicates = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toFlatObject((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $bea96998a4c18069$var$toFormData(obj, formData, options) {
    if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4515b8adc749a7dd$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $bea96998a4c18069$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(value) && $bea96998a4c18069$var$isFlatArray(value) || ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFileList(value) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $bea96998a4c18069$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $bea96998a4c18069$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($bea96998a4c18069$var$isVisitable(value)) return true;
        formData.append($bea96998a4c18069$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($bea96998a4c18069$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $bea96998a4c18069$var$isVisitable
    });
    function build(value, path) {
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $bea96998a4c18069$export$2e2bcd8739ae039 = $bea96998a4c18069$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $542a90fd98b19394$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $542a90fd98b19394$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $bea96998a4c18069$export$2e2bcd8739ae039)(params, this, options);
}
const $542a90fd98b19394$var$prototype = $542a90fd98b19394$var$AxiosURLSearchParams.prototype;
$542a90fd98b19394$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$542a90fd98b19394$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $542a90fd98b19394$var$encode);
    } : $542a90fd98b19394$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $542a90fd98b19394$export$2e2bcd8739ae039 = $542a90fd98b19394$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $fda4a1e7511f784a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $fda4a1e7511f784a$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $fda4a1e7511f784a$var$encode;
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $542a90fd98b19394$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $fda56df71375924c$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $fda56df71375924c$export$2e2bcd8739ae039 = $fda56df71375924c$var$InterceptorManager;





'use strict';
var $8e0d8c6a5b916dc3$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $dd115b7603c23793$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $542a90fd98b19394$export$2e2bcd8739ae039);


'use strict';
var $b325c2d902878105$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $5fe516768f77e561$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $4fc2ce845ebdc344$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $dd115b7603c23793$export$2e2bcd8739ae039,
        FormData: $b325c2d902878105$export$2e2bcd8739ae039,
        Blob: $5fe516768f77e561$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $069f5989325020f2$exports = {};

$parcel$export($069f5989325020f2$exports, "hasBrowserEnv", () => $069f5989325020f2$export$c4996c4b7b93b0bf);
$parcel$export($069f5989325020f2$exports, "navigator", () => $069f5989325020f2$export$ec7c8efa7f5790ae);
$parcel$export($069f5989325020f2$exports, "hasStandardBrowserEnv", () => $069f5989325020f2$export$c0bcc9250309d66);
$parcel$export($069f5989325020f2$exports, "hasStandardBrowserWebWorkerEnv", () => $069f5989325020f2$export$c81692cf5af97dac);
$parcel$export($069f5989325020f2$exports, "origin", () => $069f5989325020f2$export$f710a83a91838a36);
const $069f5989325020f2$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $069f5989325020f2$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $069f5989325020f2$export$c0bcc9250309d66 = $069f5989325020f2$export$c4996c4b7b93b0bf && (!$069f5989325020f2$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($069f5989325020f2$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $069f5989325020f2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $069f5989325020f2$export$f710a83a91838a36 = $069f5989325020f2$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $f1a106c1d8243f32$export$2e2bcd8739ae039 = {
    ...$069f5989325020f2$exports,
    ...(0, $4fc2ce845ebdc344$export$2e2bcd8739ae039)
};


'use strict';
function $00f69fcbeef4c199$export$2e2bcd8739ae039(data, options) {
    return (0, $bea96998a4c18069$export$2e2bcd8739ae039)(data, new (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).isNode && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a36fd3d04e252d2f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a36fd3d04e252d2f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a36fd3d04e252d2f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a36fd3d04e252d2f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFormData(formData) && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a36fd3d04e252d2f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a36fd3d04e252d2f$export$2e2bcd8739ae039 = $a36fd3d04e252d2f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $bf0e6d361c01542c$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $bf0e6d361c01542c$var$defaults = {
    transitional: (0, $8e0d8c6a5b916dc3$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a36fd3d04e252d2f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isBuffer(data) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isStream(data) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFile(data) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isBlob(data) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $00f69fcbeef4c199$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $bea96998a4c18069$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $bf0e6d361c01542c$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $bf0e6d361c01542c$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isResponse(data) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $417caf3b768da6eb$export$2e2bcd8739ae039).from(e, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $bf0e6d361c01542c$var$defaults.headers[method] = {};
});
var $bf0e6d361c01542c$export$2e2bcd8739ae039 = $bf0e6d361c01542c$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $4d70628e2416bece$var$ignoreDuplicateOf = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $4d70628e2416bece$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $4d70628e2416bece$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $61fe332487b1b853$var$$internals = Symbol('internals');
function $61fe332487b1b853$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $61fe332487b1b853$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(value) ? value.map($61fe332487b1b853$var$normalizeValue) : String(value);
}
function $61fe332487b1b853$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $61fe332487b1b853$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $61fe332487b1b853$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $61fe332487b1b853$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $61fe332487b1b853$var$buildAccessors(obj, header) {
    const accessorName = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $61fe332487b1b853$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $61fe332487b1b853$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $61fe332487b1b853$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$61fe332487b1b853$var$isValidHeaderName(header)) setHeaders((0, $4d70628e2416bece$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isObject(header) && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $61fe332487b1b853$var$normalizeHeader(header);
        if (header) {
            const key = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $61fe332487b1b853$var$parseTokens(value);
                if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $61fe332487b1b853$var$normalizeHeader(header);
        if (header) {
            const key = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $61fe332487b1b853$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $61fe332487b1b853$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $61fe332487b1b853$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $61fe332487b1b853$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $61fe332487b1b853$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $61fe332487b1b853$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $61fe332487b1b853$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$61fe332487b1b853$var$$internals] = this[$61fe332487b1b853$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $61fe332487b1b853$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $61fe332487b1b853$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$61fe332487b1b853$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).reduceDescriptors($61fe332487b1b853$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).freezeMethods($61fe332487b1b853$var$AxiosHeaders);
var $61fe332487b1b853$export$2e2bcd8739ae039 = $61fe332487b1b853$var$AxiosHeaders;


'use strict';
function $32a2ff676f55f391$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $bf0e6d361c01542c$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $2dd5e68098c8f4f8$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $c49da19fe0b3c1d3$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $417caf3b768da6eb$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).inherits($c49da19fe0b3c1d3$var$CanceledError, (0, $417caf3b768da6eb$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $c49da19fe0b3c1d3$export$2e2bcd8739ae039 = $c49da19fe0b3c1d3$var$CanceledError;







'use strict';
function $ad40f2729db9bf44$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $44bf5805ea923301$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $b9fd88864fcf21d4$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $b9fd88864fcf21d4$export$2e2bcd8739ae039 = $b9fd88864fcf21d4$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $8752bf8886d7ef4a$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $8752bf8886d7ef4a$export$2e2bcd8739ae039 = $8752bf8886d7ef4a$var$throttle;



const $3c87b397999eacaa$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $b9fd88864fcf21d4$export$2e2bcd8739ae039)(50, 250);
    return (0, $8752bf8886d7ef4a$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $3c87b397999eacaa$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $3c87b397999eacaa$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $11a71f5f59a62b86$export$2e2bcd8739ae039 = (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).origin), (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $c786e54cec31f2b7$export$2e2bcd8739ae039 = (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $7670a947570954fb$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $9996e4a4aff77109$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $6c126254a52685cb$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $7670a947570954fb$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $9996e4a4aff77109$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $d06375d10d36ddff$var$headersToObject = (thing)=>thing instanceof (0, $61fe332487b1b853$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $d06375d10d36ddff$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isPlainObject(target) && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($d06375d10d36ddff$var$headersToObject(a), $d06375d10d36ddff$var$headersToObject(b), prop, true)
    };
    (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $161ddf018ced4d02$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $d06375d10d36ddff$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $fda4a1e7511f784a$export$2e2bcd8739ae039)((0, $6c126254a52685cb$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $11a71f5f59a62b86$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $c786e54cec31f2b7$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $15b48fe76a63ab8b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $15b48fe76a63ab8b$export$2e2bcd8739ae039 = $15b48fe76a63ab8b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $161ddf018ced4d02$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ad40f2729db9bf44$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('Request aborted', (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(msg, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $8e0d8c6a5b916dc3$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ETIMEDOUT : (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $3c87b397999eacaa$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $3c87b397999eacaa$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $c49da19fe0b3c1d3$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $44bf5805ea923301$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $f1a106c1d8243f32$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $931394beb9226014$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $417caf3b768da6eb$export$2e2bcd8739ae039) ? err : new (0, $c49da19fe0b3c1d3$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $931394beb9226014$export$2e2bcd8739ae039 = $931394beb9226014$var$composeSignals;


const $ada36cf0665e85ac$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ada36cf0665e85ac$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ada36cf0665e85ac$var$readStream(iterable))yield* $ada36cf0665e85ac$export$71b051935044bd5d(chunk, chunkSize);
};
const $ada36cf0665e85ac$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ada36cf0665e85ac$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ada36cf0665e85ac$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $b653aa64a865e4b5$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $b653aa64a865e4b5$var$isFunction } = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039);
const $b653aa64a865e4b5$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).global);
const { ReadableStream: $b653aa64a865e4b5$var$ReadableStream, TextEncoder: $b653aa64a865e4b5$var$TextEncoder } = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).global;
const $b653aa64a865e4b5$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $b653aa64a865e4b5$var$factory = (env)=>{
    env = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $b653aa64a865e4b5$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $b653aa64a865e4b5$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $b653aa64a865e4b5$var$isFunction(Request);
    const isResponseSupported = $b653aa64a865e4b5$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $b653aa64a865e4b5$var$isFunction($b653aa64a865e4b5$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $b653aa64a865e4b5$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $b653aa64a865e4b5$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $b653aa64a865e4b5$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).origin, {
            body: new $b653aa64a865e4b5$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $b653aa64a865e4b5$var$test(()=>(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $f1a106c1d8243f32$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $161ddf018ced4d02$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $931394beb9226014$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $3c87b397999eacaa$export$d9fadd12586c18d6)(requestContentLength, (0, $3c87b397999eacaa$export$c1b28109d46c3592)((0, $3c87b397999eacaa$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $ada36cf0665e85ac$export$b0119225647bd83)(_request.body, $b653aa64a865e4b5$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $3c87b397999eacaa$export$d9fadd12586c18d6)(responseContentLength, (0, $3c87b397999eacaa$export$c1b28109d46c3592)((0, $3c87b397999eacaa$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $ada36cf0665e85ac$export$b0119225647bd83)(response.body, $b653aa64a865e4b5$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ad40f2729db9bf44$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('Network Error', (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $417caf3b768da6eb$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $b653aa64a865e4b5$var$seedCache = new Map();
const $b653aa64a865e4b5$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $b653aa64a865e4b5$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $b653aa64a865e4b5$var$factory(env));
        map = target;
    }
    return target;
};
const $b653aa64a865e4b5$var$adapter = $b653aa64a865e4b5$export$3105c6651375d4fa();
var $b653aa64a865e4b5$export$2e2bcd8739ae039 = $b653aa64a865e4b5$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $f1e44fdb2365110a$var$knownAdapters = {
    http: (0, $4515b8adc749a7dd$export$2e2bcd8739ae039),
    xhr: (0, $15b48fe76a63ab8b$export$2e2bcd8739ae039),
    fetch: {
        get: $b653aa64a865e4b5$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach($f1e44fdb2365110a$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $f1e44fdb2365110a$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $f1e44fdb2365110a$var$isResolvedHandle = (adapter)=>(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $f1e44fdb2365110a$var$getAdapter(adapters, config) {
    adapters = (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$f1e44fdb2365110a$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $f1e44fdb2365110a$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($f1e44fdb2365110a$var$renderReason).join('\n') : ' ' + $f1e44fdb2365110a$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $f1e44fdb2365110a$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $f1e44fdb2365110a$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $f1e44fdb2365110a$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f68b42101812678e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $c49da19fe0b3c1d3$export$2e2bcd8739ae039)(null, config);
}
function $f68b42101812678e$export$2e2bcd8739ae039(config) {
    $f68b42101812678e$var$throwIfCancellationRequested(config);
    config.headers = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $32a2ff676f55f391$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $f1e44fdb2365110a$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $bf0e6d361c01542c$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f68b42101812678e$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $32a2ff676f55f391$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $2dd5e68098c8f4f8$export$2e2bcd8739ae039)(reason)) {
            $f68b42101812678e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $32a2ff676f55f391$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $61fe332487b1b853$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $3c638c95520c37b6$export$a4ad2735b021c132 = "1.13.1";



'use strict';
const $0ee30e169d4d5401$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $0ee30e169d4d5401$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $0ee30e169d4d5401$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $0ee30e169d4d5401$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $3c638c95520c37b6$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$0ee30e169d4d5401$var$deprecatedWarnings[opt]) {
            $0ee30e169d4d5401$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$0ee30e169d4d5401$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $0ee30e169d4d5401$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('options must be an object', (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $417caf3b768da6eb$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $417caf3b768da6eb$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $0ee30e169d4d5401$export$2e2bcd8739ae039 = {
    assertOptions: $0ee30e169d4d5401$var$assertOptions,
    validators: $0ee30e169d4d5401$var$validators
};



'use strict';
const $a3bd56febde1e086$var$validators = (0, $0ee30e169d4d5401$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a3bd56febde1e086$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $fda56df71375924c$export$2e2bcd8739ae039)(),
            response: new (0, $fda56df71375924c$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $d06375d10d36ddff$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $0ee30e169d4d5401$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a3bd56febde1e086$var$validators.transitional($a3bd56febde1e086$var$validators.boolean),
            forcedJSONParsing: $a3bd56febde1e086$var$validators.transitional($a3bd56febde1e086$var$validators.boolean),
            clarifyTimeoutError: $a3bd56febde1e086$var$validators.transitional($a3bd56febde1e086$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $0ee30e169d4d5401$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a3bd56febde1e086$var$validators.function,
                serialize: $a3bd56febde1e086$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $0ee30e169d4d5401$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a3bd56febde1e086$var$validators.spelling('baseURL'),
            withXsrfToken: $a3bd56febde1e086$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $61fe332487b1b853$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f68b42101812678e$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f68b42101812678e$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $d06375d10d36ddff$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $6c126254a52685cb$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $fda4a1e7511f784a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a3bd56febde1e086$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $d06375d10d36ddff$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $d06375d10d36ddff$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a3bd56febde1e086$var$Axios.prototype[method] = generateHTTPMethod();
    $a3bd56febde1e086$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a3bd56febde1e086$export$2e2bcd8739ae039 = $a3bd56febde1e086$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $b55e45aea492210a$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $c49da19fe0b3c1d3$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $b55e45aea492210a$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $b55e45aea492210a$export$2e2bcd8739ae039 = $b55e45aea492210a$var$CancelToken;






'use strict';
function $465294a695933508$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $bbe83bc34c64eff3$export$2e2bcd8739ae039(payload) {
    return (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $1daa9b481d2acacb$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($1daa9b481d2acacb$var$HttpStatusCode).forEach(([key, value])=>{
    $1daa9b481d2acacb$var$HttpStatusCode[value] = key;
});
var $1daa9b481d2acacb$export$2e2bcd8739ae039 = $1daa9b481d2acacb$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $6328de73d05995eb$var$createInstance(defaultConfig) {
    const context = new (0, $a3bd56febde1e086$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $919a45f98c361aa5$export$2e2bcd8739ae039)((0, $a3bd56febde1e086$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).extend(instance, (0, $a3bd56febde1e086$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $6328de73d05995eb$var$createInstance((0, $d06375d10d36ddff$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $6328de73d05995eb$var$axios = $6328de73d05995eb$var$createInstance((0, $bf0e6d361c01542c$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$6328de73d05995eb$var$axios.Axios = (0, $a3bd56febde1e086$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$6328de73d05995eb$var$axios.CanceledError = (0, $c49da19fe0b3c1d3$export$2e2bcd8739ae039);
$6328de73d05995eb$var$axios.CancelToken = (0, $b55e45aea492210a$export$2e2bcd8739ae039);
$6328de73d05995eb$var$axios.isCancel = (0, $2dd5e68098c8f4f8$export$2e2bcd8739ae039);
$6328de73d05995eb$var$axios.VERSION = (0, $3c638c95520c37b6$export$a4ad2735b021c132);
$6328de73d05995eb$var$axios.toFormData = (0, $bea96998a4c18069$export$2e2bcd8739ae039);
// Expose AxiosError class
$6328de73d05995eb$var$axios.AxiosError = (0, $417caf3b768da6eb$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$6328de73d05995eb$var$axios.Cancel = $6328de73d05995eb$var$axios.CanceledError;
// Expose all/spread
$6328de73d05995eb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$6328de73d05995eb$var$axios.spread = (0, $465294a695933508$export$2e2bcd8739ae039);
// Expose isAxiosError
$6328de73d05995eb$var$axios.isAxiosError = (0, $bbe83bc34c64eff3$export$2e2bcd8739ae039);
// Expose mergeConfig
$6328de73d05995eb$var$axios.mergeConfig = (0, $d06375d10d36ddff$export$2e2bcd8739ae039);
$6328de73d05995eb$var$axios.AxiosHeaders = (0, $61fe332487b1b853$export$2e2bcd8739ae039);
$6328de73d05995eb$var$axios.formToJSON = (thing)=>(0, $a36fd3d04e252d2f$export$2e2bcd8739ae039)((0, $42f8c60b5c2dc418$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$6328de73d05995eb$var$axios.getAdapter = (0, $f1e44fdb2365110a$export$2e2bcd8739ae039).getAdapter;
$6328de73d05995eb$var$axios.HttpStatusCode = (0, $1daa9b481d2acacb$export$2e2bcd8739ae039);
$6328de73d05995eb$var$axios.default = $6328de73d05995eb$var$axios;
var // this module should only have a default export
$6328de73d05995eb$export$2e2bcd8739ae039 = $6328de73d05995eb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $a23a393a2e9e3f66$export$1c00760e9e5a4e95, AxiosError: $a23a393a2e9e3f66$export$c1fbed17c2f6a328, CanceledError: $a23a393a2e9e3f66$export$1ab0c6b20d94fa14, isCancel: $a23a393a2e9e3f66$export$3b22524397b493c6, CancelToken: $a23a393a2e9e3f66$export$fd08e3cb425f0d61, VERSION: $a23a393a2e9e3f66$export$a4ad2735b021c132, all: $a23a393a2e9e3f66$export$84bf76cd7afc7469, Cancel: $a23a393a2e9e3f66$export$848c9b7ead0df967, isAxiosError: $a23a393a2e9e3f66$export$fbafdbe06a5b5a9a, spread: $a23a393a2e9e3f66$export$3ae0fd4797ed47c8, toFormData: $a23a393a2e9e3f66$export$10ae0d317ea97f8b, AxiosHeaders: $a23a393a2e9e3f66$export$4e7d6ff0f3e6520, HttpStatusCode: $a23a393a2e9e3f66$export$a972f69c851492b3, formToJSON: $a23a393a2e9e3f66$export$86d7c59254d6a2c9, getAdapter: $a23a393a2e9e3f66$export$17ddc20a97d669e2, mergeConfig: $a23a393a2e9e3f66$export$7ec1ebcfa9d8bd6a } = (0, $6328de73d05995eb$export$2e2bcd8739ae039);


class $a5edf8e98aea046e$var$WizardResultPage extends (0, (/*@__PURE__*/$parcel$interopDefault($6umrQ))).Component {
    constructor(props){
        super(props), this.setRoomSelection = (roomCode, rating, productCode, index, quantity, reject = false)=>{
            this.setState((prevState)=>{
                const changedDataKey = reject ? 'rejectedProducts' : 'selectedProducts';
                const ignoredDataKey = reject ? 'selectedProducts' : 'rejectedProducts';
                const prevRoomData = prevState.selectedData[roomCode] || {};
                const prevChangedProducts = prevRoomData[changedDataKey] || {};
                const prevIgnoredProducts = prevRoomData[ignoredDataKey] || {};
                // Update changedDataKey (either selectedProducts or rejectedProducts)
                const updatedChangedProducts = {
                    ...prevChangedProducts,
                    [index]: prevChangedProducts[index]?.productCode === productCode ? undefined : {
                        productCode: productCode,
                        quantity: quantity.toString()
                    }
                };
                // Remove the product from ignoredDataKey (either selectedProducts or rejectedProducts)
                const { [index]: ignoredProduct, ...updatedIgnoredProducts } = prevIgnoredProducts;
                return {
                    selectedData: {
                        ...prevState.selectedData,
                        [roomCode]: {
                            ...prevRoomData,
                            rating: rating,
                            [changedDataKey]: updatedChangedProducts,
                            [ignoredDataKey]: updatedIgnoredProducts
                        }
                    }
                };
            });
        }, this.getSelectedProductCode = (roomCode, rating, idx)=>{
            try {
                if (this.state.selectedData[roomCode] && this.state.selectedData[roomCode].rating === rating) {
                    const selectedCode = this.state.selectedData[roomCode].selectedProducts[idx]?.productCode;
                    if (selectedCode) return selectedCode;
                    const rejected = this.state.selectedData[roomCode].rejectedProducts[idx]?.productCode;
                    if (rejected) return "rejected";
                }
                return null;
            } catch (e) {
                console.error(e);
                console.log(roomCode, rating, idx, this.state.selectedData[roomCode]);
                return null;
            }
        }, this.getSelectedRatingForRoom = (roomCode)=>{
            return this.state.activeRoomRatings[roomCode] || 'better';
        }, this.setRating = (roomCode, rating)=>{
            this.setState((prevState)=>({
                    activeRoomRatings: {
                        ...prevState.activeRoomRatings,
                        [roomCode]: rating
                    }
                }));
        }, this.toggleCartModal = ()=>{
            this.setState((prevState)=>({
                    isCartModalOpen: !prevState.isCartModalOpen
                }));
        }, this.proceedToCartCallBack = ()=>{
            debugger;
            this.setState({
                populatingCart: true,
                populatingCartError: ''
            });
            // transform selectedData to object with productCode as key and quantity as value
            const selectedProducts = Object.values(this.state.selectedData).flatMap((room)=>Object.values(room.selectedProducts)).filter((product)=>product).reduce((acc, product)=>{
                const productCode = product.productCode;
                const quantity = parseInt(product.quantity, 10);
                if (acc[productCode]) acc[productCode] += quantity;
                else acc[productCode] = quantity;
                return acc;
            }, {});
            // make api request to add products to cart and get cart id in response
            (0, $6328de73d05995eb$export$2e2bcd8739ae039).post(this.props.populate_cart_url, {
                config_key: this.props.config_key,
                products: selectedProducts
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': window.csrfToken
                }
            }).then((response)=>{
                // redirect to cart page
                console.log(response);
                window.location.href = response.data.redirect_url;
            }).catch((error)=>{
                console.error('Error adding products to cart', error);
                this.setState({
                    populatingCart: false,
                    populatingCartError: error.response?.data?.error || 'An error occurred while adding products to cart'
                });
            });
        }, this.getPrice = (productCode)=>{
            const priceData = this.props.price_list[productCode];
            if (priceData) return priceData;
            // Generate random price if not available in price_list
            return {
                price: 0,
                discount: 0,
                currency: ''
            };
        };
        this.state = this.makeInitialState(props);
    }
    makeInitialState(props) {
        return {
            activeRoom: Object.keys(props.spaces)[0] + '0',
            activeRoomRatings: {},
            selectedData: {},
            isCartModalOpen: false,
            populatingCart: false,
            populatingCartError: ''
        };
    }
    get companyLogoUrl() {
        return this.props.company_logo_url || "https://res.cloudinary.com/flexit/image/upload/v1718123789/climat_wizard/example_logo_alt";
    }
    get inneklimaLogoUrl() {
        return "https://res.cloudinary.com/flexit/image/upload/v1692686239/flexitkt_bilder/inneklima_no_muf9ss.png";
    }
    get footerLogoUrl() {
        return "https://res.cloudinary.com/flexit/image/upload/v1736933943/climat_wizard/thumbnail_Megaflis_Logo_RGB_01_aicotd.png";
    }
    renderNavBar() {
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            className: "flex justify-center px-4 py-3",
            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                src: this.inneklimaLogoUrl,
                alt: "Left Logo",
                className: "h-8 w-auto"
            })
        });
    }
    renderSpaceBreadcrumbs() {
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $db660a598ce0c4a9$export$2e2bcd8739ae039), {
            spaces: this.props.spaces,
            activeRoom: this.state.activeRoom,
            setActiveRoom: (roomType)=>{
                this.setState({
                    activeRoom: roomType
                });
            },
            selectedData: this.state.selectedData,
            recommendations: this.props.recommendations
        });
    }
    renderRecommendations() {
        const { recommendations: recommendations } = this.props;
        const { activeRoom: activeRoom } = this.state;
        const roomType = activeRoom.replace(/[0-9]/g, ''); // Extract the room type without the index
        const selectedRating = this.getSelectedRatingForRoom(activeRoom);
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $b978c5f41a14016f$export$2e2bcd8739ae039), {
            roomCode: activeRoom,
            spaceData: recommendations[roomType],
            selectedRating: selectedRating,
            setRating: this.setRating,
            getSelectedProductCode: this.getSelectedProductCode,
            setRoomSelection: this.setRoomSelection,
            productData: this.props.products,
            getPrice: this.getPrice
        });
    }
    renderSelectedProductInfo() {
        const { selectedData: selectedData } = this.state;
        let selectedInfo = null;
        const selected = Object.keys(selectedData).length > 0 && Object.keys(selectedData).some((key)=>Object.keys(selectedData[key].selectedProducts).length > 0 && Object.keys(selectedData[key].selectedProducts).some((idx)=>!!selectedData[key].selectedProducts[idx]));
        if (!selected) selectedInfo = /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            className: "inline-block bg-yellow-100 text-yellow-800 py-2 px-4 my-2 rounded-md",
            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                className: "font-bold",
                children: window.gettext("Click on room and select a product!")
            })
        });
        else {
            const totalSelectedProducts = Object.values(selectedData).reduce((sum, room)=>{
                return sum + Object.values(room.selectedProducts).reduce((roomSum, product)=>{
                    return roomSum + parseInt(product?.quantity || "0", 10);
                }, 0);
            }, 0);
            const roomsWithProducts = Object.values(selectedData).reduce((count, room)=>{
                const hasProductWithQuantity = Object.values(room.selectedProducts).some((product)=>parseInt(product?.quantity || "0", 10) > 0);
                return hasProductWithQuantity ? count + 1 : count;
            }, 0);
            selectedInfo = /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                className: "inline-block bg-fxblue py-2 px-4 my-2 rounded-md",
                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("p", {
                    className: "text-white cursor-pointer",
                    onClick: this.toggleCartModal,
                    children: [
                        window.interpolate(ngettext('%(nproducts)s product selected', '%(nproducts)s products selected', totalSelectedProducts), {
                            nproducts: totalSelectedProducts
                        }, true),
                        "\xa0",
                        window.interpolate(ngettext('for %(nrooms)s room', 'for %(nrooms)s rooms', roomsWithProducts), {
                            nrooms: roomsWithProducts
                        }, true)
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            className: "text-center pb-4",
            children: selectedInfo
        });
    }
    renderMainContent() {
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)((0, $fb2efc226cb4f9dd$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("section", {
                    className: "bg-white",
                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h2", {
                                className: "hidden sm:block leading-snug tracking-tight text-xl md:text-2xl lg:text-3xl font-semibold mt-5 mb-0 text-center",
                                children: window.gettext("Select products for rooms")
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                                className: "hidden md:block leading-7 text-gray-700 py-6 lg:text-center mx-auto ",
                                children: window.gettext('We have now found suggestions for your project. Click on the room and select a product for each. Note that for some rooms, you can choose between a "good" and "better" solution.')
                            }),
                            this.renderSpaceBreadcrumbs(),
                            this.renderSelectedProductInfo()
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("section", {
                    className: "bg-[#F7F7F7]",
                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "container max-w-5xl",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                            className: "text-center grid pt-5 pb-10 gap-10 my-0 mx-auto px-0 sm:px-2 md:px-4 2xl:px-6 print:max-w-none",
                            children: this.renderRecommendations()
                        })
                    })
                })
            ]
        });
    }
    renderFooter() {
        const handleBackClick = (e)=>{
            e.preventDefault();
            const confirmation = window.confirm("All selected data in the form will be lost. Do you want to continue?");
            if (confirmation) window.location.href = this.props.back_url;
        };
        const handleLogoClick = (e)=>{
            e.preventDefault();
            const confirmation = window.confirm("Are you sure you want to leave without completing the form?");
            if (confirmation) window.location.href = this.props.referrer_url;
        };
        return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            className: "fixed bottom-0 left-0 w-full bg-white border-t border-gray-300",
            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "max-w-5xl mx-auto flex justify-between items-center px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "w-1/3 text-left",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                            href: "#",
                            onClick: handleBackClick,
                            className: "text-blue-500",
                            children: "Tilbake"
                        })
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "w-1/3 flex justify-center",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                            onClick: handleLogoClick,
                            className: "focus:outline-none",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("img", {
                                src: this.footerLogoUrl,
                                alt: "Logo",
                                className: "h-8 w-auto"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "w-1/3 text-right",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                            href: "#",
                            className: "text-blue-500",
                            onClick: this.toggleCartModal,
                            children: "Fortsett"
                        })
                    })
                ]
            })
        });
    }
    render() {
        return [
            this.renderNavBar(),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                id: "scroll_to_this_place",
                className: "bg-[#00aeef] h-[2px] w-100"
            }, "scrollto"),
            this.renderMainContent(),
            this.renderFooter(),
            this.state.isCartModalOpen && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $eeef6325048dcac6$export$2e2bcd8739ae039), {
                selectedData: this.state.selectedData,
                products: this.props.products,
                spaces: this.props.spaces,
                price_list: this.props.price_list,
                closeModal: this.toggleCartModal,
                handleProceedToCart: this.proceedToCartCallBack,
                populatingCart: this.state.populatingCart,
                populatingCartError: this.state.populatingCartError
            })
        ];
    }
}
var $a5edf8e98aea046e$export$2e2bcd8739ae039 = $a5edf8e98aea046e$var$WizardResultPage;


class $4fddd96a6fb67814$export$2e2bcd8739ae039 extends (0, $febaba8661e870e3$export$ce623d3cb93cc651) {
    get UIComponent() {
        return 0, $a5edf8e98aea046e$export$2e2bcd8739ae039;
    }
}



// src/widgets/ServicePartnerFinder.tsx


var $6umrQ = parcelRequire("6umrQ");


var $6umrQ = parcelRequire("6umrQ");

function $356d0adb4c3ddad5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $356d0adb4c3ddad5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $356d0adb4c3ddad5$var$_typeof(o);
}
function $356d0adb4c3ddad5$var$toPrimitive(t, r) {
    if ("object" != $356d0adb4c3ddad5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $356d0adb4c3ddad5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $356d0adb4c3ddad5$var$toPropertyKey(t) {
    var i = $356d0adb4c3ddad5$var$toPrimitive(t, "string");
    return "symbol" == $356d0adb4c3ddad5$var$_typeof(i) ? i : i + "";
}
function $356d0adb4c3ddad5$var$_defineProperty(e, r, t) {
    return (r = $356d0adb4c3ddad5$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $356d0adb4c3ddad5$var$getDefaultExportFromCjs$1(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $356d0adb4c3ddad5$var$invariant_1;
var $356d0adb4c3ddad5$var$hasRequiredInvariant;
function $356d0adb4c3ddad5$var$requireInvariant() {
    if ($356d0adb4c3ddad5$var$hasRequiredInvariant) return $356d0adb4c3ddad5$var$invariant_1;
    $356d0adb4c3ddad5$var$hasRequiredInvariant = 1;
    /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */ var NODE_ENV = "production";
    var invariant = function invariant(condition, format, a, b, c, d, e, f) {
        if (NODE_ENV !== 'production') {
            if (format === undefined) throw new Error('invariant requires an error message argument');
        }
        if (!condition) {
            var error;
            if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                error = new Error(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
                error.name = 'Invariant Violation';
            }
            error.framesToPop = 1; // we don't care about invariant's own frame
            throw error;
        }
    };
    $356d0adb4c3ddad5$var$invariant_1 = invariant;
    return $356d0adb4c3ddad5$var$invariant_1;
}
var $356d0adb4c3ddad5$var$invariantExports = $356d0adb4c3ddad5$var$requireInvariant();
var $356d0adb4c3ddad5$var$invariant = /*@__PURE__*/ $356d0adb4c3ddad5$var$getDefaultExportFromCjs$1($356d0adb4c3ddad5$var$invariantExports);
var $356d0adb4c3ddad5$export$dc7344301ae78f85 = (0, $6umrQ.createContext)(null);
function $356d0adb4c3ddad5$export$7105827ad5b8fcc3() {
    $356d0adb4c3ddad5$var$invariant(!!(0, $6umrQ.useContext), 'useGoogleMap is React hook and requires React version 16.8+');
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    $356d0adb4c3ddad5$var$invariant(!!map, 'useGoogleMap needs a GoogleMap available up in the tree');
    return map;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $356d0adb4c3ddad5$var$reduce(obj, fn, acc) {
    return Object.keys(obj).reduce(function reducer(newAcc, key) {
        return fn(newAcc, obj[key], key);
    }, acc);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $356d0adb4c3ddad5$var$forEach(obj, fn) {
    Object.keys(obj).forEach((key)=>{
        return fn(obj[key], key);
    });
}
/* global google */ /* eslint-disable filenames/match-regex */ function $356d0adb4c3ddad5$var$applyUpdaterToNextProps(// eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var iter = (fn, key)=>{
        var nextValue = nextProps[key];
        if (nextValue !== prevProps[key]) {
            map[key] = nextValue;
            fn(instance, nextValue);
        }
    };
    $356d0adb4c3ddad5$var$forEach(updaterMap, iter);
    return map;
}
function $356d0adb4c3ddad5$var$registerEvents(// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
    var registeredList = $356d0adb4c3ddad5$var$reduce(eventMap, function reducer(acc, googleEventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onEventName) {
        if (typeof props[onEventName] === 'function') acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
        return acc;
    }, []);
    return registeredList;
}
function $356d0adb4c3ddad5$var$unregisterEvent(registered) {
    google.maps.event.removeListener(registered);
}
function $356d0adb4c3ddad5$var$unregisterEvents() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    events.forEach($356d0adb4c3ddad5$var$unregisterEvent);
}
function $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents(_ref) {
    var { updaterMap: updaterMap, eventMap: eventMap, prevProps: prevProps, nextProps: nextProps, instance: instance } = _ref;
    var registeredEvents = $356d0adb4c3ddad5$var$registerEvents(nextProps, instance, eventMap);
    $356d0adb4c3ddad5$var$applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
    return registeredEvents;
}
var $356d0adb4c3ddad5$var$eventMap$i = {
    onDblClick: 'dblclick',
    onDragEnd: 'dragend',
    onDragStart: 'dragstart',
    onMapTypeIdChanged: 'maptypeid_changed',
    onMouseMove: 'mousemove',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseDown: 'mousedown',
    onMouseUp: 'mouseup',
    onRightClick: 'rightclick',
    onTilesLoaded: 'tilesloaded',
    onBoundsChanged: 'bounds_changed',
    onCenterChanged: 'center_changed',
    onClick: 'click',
    onDrag: 'drag',
    onHeadingChanged: 'heading_changed',
    onIdle: 'idle',
    onProjectionChanged: 'projection_changed',
    onResize: 'resize',
    onTiltChanged: 'tilt_changed',
    onZoomChanged: 'zoom_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$i = {
    extraMapTypes (map, extra) {
        extra.forEach(function forEachExtra(it, i) {
            map.mapTypes.set(String(i), it);
        });
    },
    center (map, center) {
        map.setCenter(center);
    },
    clickableIcons (map, clickable) {
        map.setClickableIcons(clickable);
    },
    heading (map, heading) {
        map.setHeading(heading);
    },
    mapTypeId (map, mapTypeId) {
        map.setMapTypeId(mapTypeId);
    },
    options (map, options) {
        map.setOptions(options);
    },
    streetView (map, streetView) {
        map.setStreetView(streetView);
    },
    tilt (map, tilt) {
        map.setTilt(tilt);
    },
    zoom (map, zoom) {
        map.setZoom(zoom);
    }
};
// TODO: unfinished!
function $356d0adb4c3ddad5$var$GoogleMapFunctional(_ref) {
    var { children: children, options: options, id: id, mapContainerStyle: mapContainerStyle, mapContainerClassName: mapContainerClassName, center: center, onClick: // clickableIcons,
    // extraMapTypes,
    // heading,
    // mapTypeId,
    onClick, onDblClick: onDblClick, onDrag: onDrag, onDragEnd: onDragEnd, onDragStart: onDragStart, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onRightClick: onRightClick, onCenterChanged: // onMapTypeIdChanged,
    // onTilesLoaded,
    // onBoundsChanged,
    onCenterChanged, onLoad: // onHeadingChanged,
    // onIdle,
    // onProjectionChanged,
    // onResize,
    // onTiltChanged,
    // onZoomChanged,
    onLoad, onUnmount: onUnmount } = _ref;
    var [map, setMap] = (0, $6umrQ.useState)(null);
    var ref = (0, $6umrQ.useRef)(null);
    // const [extraMapTypesListener, setExtraMapTypesListener] = useState<google.maps.MapsEventListener | null>(null)
    var [centerChangedListener, setCenterChangedListener] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [dragendListener, setDragendListener] = (0, $6umrQ.useState)(null);
    var [dragstartListener, setDragstartListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mousemoveListener, setMousemoveListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightclickListener, setRightclickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [dragListener, setDragListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (options && map !== null) map.setOptions(options);
    }, [
        map,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map !== null && typeof center !== 'undefined') map.setCenter(center);
    }, [
        map,
        center
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(map, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(map, 'dragend', onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(map, 'dragstart', onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(map, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(map, 'mousemove', onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(map, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(map, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(map, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(map, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(map, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(map, 'drag', onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map && onCenterChanged) {
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            setCenterChangedListener(google.maps.event.addListener(map, 'center_changed', onCenterChanged));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var map = ref.current === null ? null : new google.maps.Map(ref.current, options);
        setMap(map);
        if (map !== null && onLoad) onLoad(map);
        return ()=>{
            if (map !== null) {
                if (onUnmount) onUnmount(map);
            }
        };
    }, []);
    return (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        id: id,
        ref: ref,
        style: mapContainerStyle,
        className: mapContainerClassName,
        children: (0, $fb2efc226cb4f9dd$exports.jsx)($356d0adb4c3ddad5$export$dc7344301ae78f85.Provider, {
            value: map,
            children: map !== null ? children : null
        })
    });
}
(0, $6umrQ.memo)($356d0adb4c3ddad5$var$GoogleMapFunctional);
class $356d0adb4c3ddad5$export$4ad1bae46276c5ce extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            map: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "mapRef", null);
        $356d0adb4c3ddad5$var$_defineProperty(this, "getInstance", ()=>{
            if (this.mapRef === null) return null;
            return new google.maps.Map(this.mapRef, this.props.options);
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "panTo", (latLng)=>{
            var map = this.getInstance();
            if (map) map.panTo(latLng);
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setMapCallback", ()=>{
            if (this.state.map !== null) {
                if (this.props.onLoad) this.props.onLoad(this.state.map);
            }
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "getRef", (ref)=>{
            this.mapRef = ref;
        });
    }
    componentDidMount() {
        var map = this.getInstance();
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$i,
            eventMap: $356d0adb4c3ddad5$var$eventMap$i,
            prevProps: {},
            nextProps: this.props,
            instance: map
        });
        this.setState(function setMap() {
            return {
                map: map
            };
        }, this.setMapCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.map !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$i,
                eventMap: $356d0adb4c3ddad5$var$eventMap$i,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.map
            });
        }
    }
    componentWillUnmount() {
        if (this.state.map !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.map);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
        }
    }
    render() {
        return (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            id: this.props.id,
            ref: this.getRef,
            style: this.props.mapContainerStyle,
            className: this.props.mapContainerClassName,
            children: (0, $fb2efc226cb4f9dd$exports.jsx)($356d0adb4c3ddad5$export$dc7344301ae78f85.Provider, {
                value: this.state.map,
                children: this.state.map !== null ? this.props.children : null
            })
        });
    }
}
function $356d0adb4c3ddad5$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $356d0adb4c3ddad5$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $356d0adb4c3ddad5$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $356d0adb4c3ddad5$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $356d0adb4c3ddad5$var$makeLoadScriptUrl(_ref) {
    var { googleMapsApiKey: googleMapsApiKey, googleMapsClientId: googleMapsClientId, version: version = 'weekly', language: language, region: region, libraries: libraries, channel: channel, mapIds: mapIds, authReferrerPolicy: authReferrerPolicy, apiUrl: apiUrl = 'https://maps.googleapis.com' } = _ref;
    var params = [];
    $356d0adb4c3ddad5$var$invariant(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.');
    if (googleMapsApiKey) params.push("key=".concat(googleMapsApiKey));
    else if (googleMapsClientId) params.push("client=".concat(googleMapsClientId));
    if (version) params.push("v=".concat(version));
    if (language) params.push("language=".concat(language));
    if (region) params.push("region=".concat(region));
    if (libraries && libraries.length) params.push("libraries=".concat(libraries.sort().join(',')));
    if (channel) params.push("channel=".concat(channel));
    if (mapIds && mapIds.length) params.push("map_ids=".concat(mapIds.join(',')));
    if (authReferrerPolicy) params.push("auth_referrer_policy=".concat(authReferrerPolicy));
    params.push('loading=async');
    params.push('callback=initMap');
    return "".concat(apiUrl, "/maps/api/js?").concat(params.join('&'));
}
var $356d0adb4c3ddad5$var$isBrowser = typeof document !== 'undefined';
function $356d0adb4c3ddad5$var$injectScript(_ref) {
    var { url: url, id: id, nonce: nonce } = _ref;
    if (!$356d0adb4c3ddad5$var$isBrowser) return Promise.reject(new Error('document is undefined'));
    return new Promise(function injectScriptCallback(resolve, reject) {
        var existingScript = document.getElementById(id);
        var windowWithGoogleMap = window;
        if (existingScript) {
            // Same script id/url: keep same script
            var dataStateAttribute = existingScript.getAttribute('data-state');
            if (existingScript.src === url && dataStateAttribute !== 'error') {
                if (dataStateAttribute === 'ready') return resolve(id);
                else {
                    var originalInitMap = windowWithGoogleMap.initMap;
                    var originalErrorCallback = existingScript.onerror;
                    windowWithGoogleMap.initMap = function initMap() {
                        if (originalInitMap) originalInitMap();
                        resolve(id);
                    };
                    existingScript.onerror = function(err) {
                        if (originalErrorCallback) originalErrorCallback(err);
                        reject(err);
                    };
                    return;
                }
            } else existingScript.remove();
        }
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.async = true;
        script.nonce = nonce || '';
        script.onerror = function onerror(err) {
            script.setAttribute('data-state', 'error');
            reject(err);
        };
        windowWithGoogleMap.initMap = function onload() {
            script.setAttribute('data-state', 'ready');
            resolve(id);
        };
        document.head.appendChild(script);
    }).catch((err)=>{
        console.error('injectScript error: ', err);
        throw err;
    });
}
function $356d0adb4c3ddad5$var$isGoogleFontStyle(element) {
    // 'Roboto' or 'Google Sans Text' font download
    var href = element.href;
    if (href && (href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0 || href.indexOf('https://fonts.googleapis.com/css?family=Google+Sans+Text') === 0)) return true;
    // font style elements
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === 'style' && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        element.styleSheet.cssText = '';
        return true;
    }
    // font style elements for other browsers
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === 'style' && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        element.innerHTML = '';
        return true;
    }
    // when google tries to add empty style
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === 'style' && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !element.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !element.innerHTML) return true;
    return false;
}
// Preventing the Google Maps library from downloading an extra font
function $356d0adb4c3ddad5$var$preventGoogleFonts() {
    // we override these methods only for one particular head element
    // default methods for other elements are not affected
    var head = document.getElementsByTagName('head')[0];
    if (head) {
        var trueInsertBefore = head.insertBefore.bind(head);
        // TODO: adding return before reflect solves the TS issue
        head.insertBefore = function insertBefore(newElement, referenceElement) {
            if (!$356d0adb4c3ddad5$var$isGoogleFontStyle(newElement)) Reflect.apply(trueInsertBefore, head, [
                newElement,
                referenceElement
            ]);
            return newElement;
        };
        var trueAppend = head.appendChild.bind(head);
        // TODO: adding return before reflect solves the TS issue
        head.appendChild = function appendChild(textNode) {
            if (!$356d0adb4c3ddad5$var$isGoogleFontStyle(textNode)) Reflect.apply(trueAppend, head, [
                textNode
            ]);
            return textNode;
        };
    }
}
var $356d0adb4c3ddad5$var$cleaningUp = false;
function $356d0adb4c3ddad5$var$DefaultLoadingElement() {
    return (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        children: "Loading..."
    });
}
var $356d0adb4c3ddad5$var$defaultLoadScriptProps = {
    id: 'script-loader',
    version: 'weekly'
};
class $356d0adb4c3ddad5$export$cd712c6fb2ecba2b extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "check", null);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            loaded: false
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "cleanupCallback", ()=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete window.google.maps;
            this.injectScript();
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "isCleaningUp", /*#__PURE__*/ $356d0adb4c3ddad5$var$_asyncToGenerator(function*() {
            function promiseCallback(resolve) {
                if (!$356d0adb4c3ddad5$var$cleaningUp) resolve();
                else if ($356d0adb4c3ddad5$var$isBrowser) var timer = window.setInterval(function interval() {
                    if (!$356d0adb4c3ddad5$var$cleaningUp) {
                        window.clearInterval(timer);
                        resolve();
                    }
                }, 1);
                return;
            }
            return new Promise(promiseCallback);
        }));
        $356d0adb4c3ddad5$var$_defineProperty(this, "cleanup", ()=>{
            $356d0adb4c3ddad5$var$cleaningUp = true;
            var script = document.getElementById(this.props.id);
            if (script && script.parentNode) script.parentNode.removeChild(script);
            Array.prototype.slice.call(document.getElementsByTagName('script')).filter(function filter(script) {
                return typeof script.src === 'string' && script.src.includes('maps.googleapis');
            }).forEach(function forEach(script) {
                if (script.parentNode) script.parentNode.removeChild(script);
            });
            Array.prototype.slice.call(document.getElementsByTagName('link')).filter(function filter(link) {
                return link.href === 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans';
            }).forEach(function forEach(link) {
                if (link.parentNode) link.parentNode.removeChild(link);
            });
            Array.prototype.slice.call(document.getElementsByTagName('style')).filter(function filter(style) {
                return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes('.gm-');
            }).forEach(function forEach(style) {
                if (style.parentNode) style.parentNode.removeChild(style);
            });
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "injectScript", ()=>{
            if (this.props.preventGoogleFontsLoading) $356d0adb4c3ddad5$var$preventGoogleFonts();
            $356d0adb4c3ddad5$var$invariant(!!this.props.id, 'LoadScript requires "id" prop to be a string: %s', this.props.id);
            var injectScriptOptions = {
                id: this.props.id,
                nonce: this.props.nonce,
                url: $356d0adb4c3ddad5$var$makeLoadScriptUrl(this.props)
            };
            $356d0adb4c3ddad5$var$injectScript(injectScriptOptions).then(()=>{
                if (this.props.onLoad) this.props.onLoad();
                this.setState(function setLoaded() {
                    return {
                        loaded: true
                    };
                });
                return;
            }).catch((err)=>{
                if (this.props.onError) this.props.onError(err);
                console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(this.props.googleMapsApiKey || '-', ") or Client ID (").concat(this.props.googleMapsClientId || '-', ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
            });
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "getRef", (el)=>{
            this.check = el;
        });
    }
    componentDidMount() {
        if ($356d0adb4c3ddad5$var$isBrowser) {
            if (window.google && window.google.maps && !$356d0adb4c3ddad5$var$cleaningUp) {
                console.error('google api is already presented');
                return;
            }
            this.isCleaningUp().then(this.injectScript).catch(function error(err) {
                console.error('Error at injecting script after cleaning up: ', err);
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.libraries !== prevProps.libraries) console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
        if ($356d0adb4c3ddad5$var$isBrowser && prevProps.language !== this.props.language) {
            this.cleanup();
            // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
            this.setState(function setLoaded() {
                return {
                    loaded: false
                };
            }, this.cleanupCallback);
        }
    }
    componentWillUnmount() {
        if ($356d0adb4c3ddad5$var$isBrowser) {
            this.cleanup();
            var timeoutCallback = ()=>{
                if (!this.check) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    delete window.google;
                    $356d0adb4c3ddad5$var$cleaningUp = false;
                }
            };
            window.setTimeout(timeoutCallback, 1);
            if (this.props.onUnmount) this.props.onUnmount();
        }
    }
    render() {
        return (0, $fb2efc226cb4f9dd$exports.jsxs)((0, $fb2efc226cb4f9dd$exports.Fragment), {
            children: [
                (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                    ref: this.getRef
                }),
                this.state.loaded ? this.props.children : this.props.loadingElement || (0, $fb2efc226cb4f9dd$exports.jsx)($356d0adb4c3ddad5$var$DefaultLoadingElement, {})
            ]
        });
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$cd712c6fb2ecba2b, "defaultProps", $356d0adb4c3ddad5$var$defaultLoadScriptProps);
function $356d0adb4c3ddad5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $356d0adb4c3ddad5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
/* eslint-disable filenames/match-regex */ var $356d0adb4c3ddad5$var$previouslyLoadedUrl;
function $356d0adb4c3ddad5$export$4a4360ced6c2c728(_ref) {
    var { id: id = $356d0adb4c3ddad5$var$defaultLoadScriptProps.id, version: version = $356d0adb4c3ddad5$var$defaultLoadScriptProps.version, nonce: nonce, googleMapsApiKey: googleMapsApiKey, googleMapsClientId: googleMapsClientId, language: language, region: region, libraries: libraries, preventGoogleFontsLoading: preventGoogleFontsLoading, channel: channel, mapIds: mapIds, authReferrerPolicy: authReferrerPolicy, apiUrl: apiUrl = "https://maps.googleapis.com" } = _ref;
    var isMounted = (0, $6umrQ.useRef)(false);
    var [isLoaded, setLoaded] = (0, $6umrQ.useState)(false);
    var [loadError, setLoadError] = (0, $6umrQ.useState)(undefined);
    (0, $6umrQ.useEffect)(function trackMountedState() {
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    (0, $6umrQ.useEffect)(function applyPreventGoogleFonts() {
        if ($356d0adb4c3ddad5$var$isBrowser && preventGoogleFontsLoading) $356d0adb4c3ddad5$var$preventGoogleFonts();
    }, [
        preventGoogleFontsLoading
    ]);
    (0, $6umrQ.useEffect)(function validateLoadedState() {
        if (isLoaded) $356d0adb4c3ddad5$var$invariant(!!window.google, 'useLoadScript was marked as loaded, but window.google is not present. Something went wrong.');
    }, [
        isLoaded
    ]);
    var url = $356d0adb4c3ddad5$var$makeLoadScriptUrl({
        version: version,
        googleMapsApiKey: googleMapsApiKey,
        googleMapsClientId: googleMapsClientId,
        language: language,
        region: region,
        libraries: libraries,
        channel: channel,
        mapIds: mapIds,
        authReferrerPolicy: authReferrerPolicy,
        apiUrl: apiUrl
    });
    (0, $6umrQ.useEffect)(function loadScriptAndModifyLoadedState() {
        if (!$356d0adb4c3ddad5$var$isBrowser) return;
        function setLoadedIfMounted() {
            if (isMounted.current) {
                setLoaded(true);
                $356d0adb4c3ddad5$var$previouslyLoadedUrl = url;
            }
        }
        if (window.google && window.google.maps && $356d0adb4c3ddad5$var$previouslyLoadedUrl === url) {
            setLoadedIfMounted();
            return;
        }
        $356d0adb4c3ddad5$var$injectScript({
            id: id,
            url: url,
            nonce: nonce
        }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
            if (isMounted.current) setLoadError(err);
            console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || '-', ") or Client ID (").concat(googleMapsClientId || '-', ")\n        Otherwise it is a Network issue.\n      "));
            console.error(err);
        });
    }, [
        id,
        url,
        nonce
    ]);
    var prevLibraries = (0, $6umrQ.useRef)(undefined);
    (0, $6umrQ.useEffect)(function checkPerformance() {
        if (prevLibraries.current && libraries !== prevLibraries.current) console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
        prevLibraries.current = libraries;
    }, [
        libraries
    ]);
    return {
        isLoaded: isLoaded,
        loadError: loadError,
        url: url
    };
}
var $356d0adb4c3ddad5$var$_excluded$1 = [
    "loadingElement",
    "onLoad",
    "onError",
    "onUnmount",
    "children"
];
var $356d0adb4c3ddad5$var$defaultLoadingElement = (0, $fb2efc226cb4f9dd$exports.jsx)($356d0adb4c3ddad5$var$DefaultLoadingElement, {});
function $356d0adb4c3ddad5$var$LoadScriptNext(_ref) {
    var { loadingElement: loadingElement, onLoad: onLoad, onError: onError, onUnmount: onUnmount, children: children } = _ref, hookOptions = $356d0adb4c3ddad5$var$_objectWithoutProperties(_ref, $356d0adb4c3ddad5$var$_excluded$1);
    var { isLoaded: isLoaded, loadError: loadError } = $356d0adb4c3ddad5$export$4a4360ced6c2c728(hookOptions);
    (0, $6umrQ.useEffect)(function handleOnLoad() {
        if (isLoaded && typeof onLoad === 'function') onLoad();
    }, [
        isLoaded,
        onLoad
    ]);
    (0, $6umrQ.useEffect)(function handleOnError() {
        if (loadError && typeof onError === 'function') onError(loadError);
    }, [
        loadError,
        onError
    ]);
    (0, $6umrQ.useEffect)(function handleOnUnmount() {
        return ()=>{
            if (onUnmount) onUnmount();
        };
    }, [
        onUnmount
    ]);
    return isLoaded ? children : loadingElement || $356d0adb4c3ddad5$var$defaultLoadingElement;
}
var $356d0adb4c3ddad5$export$1c36d3a2ee49585b = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$LoadScriptNext);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $356d0adb4c3ddad5$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $356d0adb4c3ddad5$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
// do not edit .js files directly - edit src/index.jst
var $356d0adb4c3ddad5$var$fastDeepEqual$1 = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $356d0adb4c3ddad5$var$isEqual = /*@__PURE__*/ $356d0adb4c3ddad5$var$getDefaultExportFromCjs($356d0adb4c3ddad5$var$fastDeepEqual$1);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $356d0adb4c3ddad5$var$DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $356d0adb4c3ddad5$var$LoaderStatus;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($356d0adb4c3ddad5$var$LoaderStatus || ($356d0adb4c3ddad5$var$LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $356d0adb4c3ddad5$var$Loader {
    /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */ constructor(_ref){
        var { apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $356d0adb4c3ddad5$var$DEFAULT_ID, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version } = _ref;
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $356d0adb4c3ddad5$var$DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($356d0adb4c3ddad5$var$Loader.instance) {
            if (!$356d0adb4c3ddad5$var$isEqual(this.options, $356d0adb4c3ddad5$var$Loader.instance.options)) throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify($356d0adb4c3ddad5$var$Loader.instance.options)));
            return $356d0adb4c3ddad5$var$Loader.instance;
        }
        $356d0adb4c3ddad5$var$Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $356d0adb4c3ddad5$var$LoaderStatus.FAILURE;
        if (this.done) return $356d0adb4c3ddad5$var$LoaderStatus.SUCCESS;
        if (this.loading) return $356d0adb4c3ddad5$var$LoaderStatus.LOADING;
        return $356d0adb4c3ddad5$var$LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */ createUrl() {
        var url = this.url;
        url += "?callback=__googleMapsCallback&loading=async";
        if (this.apiKey) url += "&key=".concat(this.apiKey);
        if (this.channel) url += "&channel=".concat(this.channel);
        if (this.client) url += "&client=".concat(this.client);
        if (this.libraries.length > 0) url += "&libraries=".concat(this.libraries.join(","));
        if (this.language) url += "&language=".concat(this.language);
        if (this.region) url += "&region=".concat(this.region);
        if (this.version) url += "&v=".concat(this.version);
        if (this.mapIds) url += "&map_ids=".concat(this.mapIds.join(","));
        if (this.authReferrerPolicy) url += "&auth_referrer_policy=".concat(this.authReferrerPolicy);
        return url;
    }
    deleteScript() {
        var script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */ load() {
        return this.loadPromise();
    }
    /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
   * Set the script on document.
   */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        var params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$356d0adb4c3ddad5$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + "?" + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = function(f) {
                for(var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)n[_key - 1] = arguments[_key];
                return r.add(f) && u().then(()=>d[l](f, ...n));
            };
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        var libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            var event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
   * Reset the loader state.
   */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            var delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error("Failed to load Google Maps script, retrying in ".concat(delay, " ms."));
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.loading) // do nothing but wait
        return;
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            this.loading = true;
            this.setScript();
        }
    }
}
var $356d0adb4c3ddad5$var$defaultLibraries = [
    'maps'
];
function $356d0adb4c3ddad5$export$d444e954fd08ae7a(_ref) {
    var { id: id = $356d0adb4c3ddad5$var$defaultLoadScriptProps.id, version: version = $356d0adb4c3ddad5$var$defaultLoadScriptProps.version, nonce: nonce, googleMapsApiKey: googleMapsApiKey, language: // googleMapsClientId,
    language, region: region, libraries: libraries = $356d0adb4c3ddad5$var$defaultLibraries, preventGoogleFontsLoading: preventGoogleFontsLoading, mapIds: // channel,
    mapIds, authReferrerPolicy: authReferrerPolicy } = _ref;
    var isMounted = (0, $6umrQ.useRef)(false);
    var [isLoaded, setLoaded] = (0, $6umrQ.useState)(false);
    var [loadError, setLoadError] = (0, $6umrQ.useState)(undefined);
    (0, $6umrQ.useEffect)(function trackMountedState() {
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    var loader = (0, $6umrQ.useMemo)(()=>{
        return new $356d0adb4c3ddad5$var$Loader({
            id: id,
            apiKey: googleMapsApiKey,
            version: version,
            libraries: libraries,
            language: language || 'en',
            region: region || 'US',
            mapIds: mapIds || [],
            nonce: nonce || '',
            authReferrerPolicy: authReferrerPolicy || 'origin'
        });
    }, [
        id,
        googleMapsApiKey,
        version,
        libraries,
        language,
        region,
        mapIds,
        nonce,
        authReferrerPolicy
    ]);
    (0, $6umrQ.useEffect)(function effect() {
        if (isLoaded) return;
        else loader.load().then(()=>{
            if (isMounted.current) setLoaded(true);
            return;
        }).catch((error)=>{
            setLoadError(error);
        });
    }, []);
    (0, $6umrQ.useEffect)(()=>{
        if ($356d0adb4c3ddad5$var$isBrowser && preventGoogleFontsLoading) $356d0adb4c3ddad5$var$preventGoogleFonts();
    }, [
        preventGoogleFontsLoading
    ]);
    var prevLibraries = (0, $6umrQ.useRef)();
    (0, $6umrQ.useEffect)(()=>{
        if (prevLibraries.current && libraries !== prevLibraries.current) console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
        prevLibraries.current = libraries;
    }, [
        libraries
    ]);
    return {
        isLoaded: isLoaded,
        loadError: loadError
    };
}
function $356d0adb4c3ddad5$var$ownKeys$f(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$f(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$f(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$f(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$h = {};
var $356d0adb4c3ddad5$var$updaterMap$h = {
    options (instance, options) {
        instance.setOptions(options);
    }
};
function $356d0adb4c3ddad5$var$TrafficLayerFunctional(_ref) {
    var { options: options, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var trafficLayer = new google.maps.TrafficLayer($356d0adb4c3ddad5$var$_objectSpread$f($356d0adb4c3ddad5$var$_objectSpread$f({}, options), {}, {
            map: map
        }));
        setInstance(trafficLayer);
        if (onLoad) onLoad(trafficLayer);
        return ()=>{
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$f1d332bd2ca31f57 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$TrafficLayerFunctional);
class $356d0adb4c3ddad5$export$aa8252582de0b23e extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            trafficLayer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setTrafficLayerCallback", ()=>{
            if (this.state.trafficLayer !== null && this.props.onLoad) this.props.onLoad(this.state.trafficLayer);
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
    }
    componentDidMount() {
        var trafficLayer = new google.maps.TrafficLayer($356d0adb4c3ddad5$var$_objectSpread$f($356d0adb4c3ddad5$var$_objectSpread$f({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$h,
            eventMap: $356d0adb4c3ddad5$var$eventMap$h,
            prevProps: {},
            nextProps: this.props,
            instance: trafficLayer
        });
        this.setState(function setTrafficLayer() {
            return {
                trafficLayer: trafficLayer
            };
        }, this.setTrafficLayerCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.trafficLayer !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$h,
                eventMap: $356d0adb4c3ddad5$var$eventMap$h,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.trafficLayer
            });
        }
    }
    componentWillUnmount() {
        if (this.state.trafficLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.trafficLayer);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.state.trafficLayer.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$aa8252582de0b23e, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$BicyclingLayerFunctional(_ref) {
    var { onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var bicyclingLayer = new google.maps.BicyclingLayer();
        setInstance(bicyclingLayer);
        bicyclingLayer.setMap(map);
        if (onLoad) onLoad(bicyclingLayer);
        return ()=>{
            if (bicyclingLayer !== null) {
                if (onUnmount) onUnmount(bicyclingLayer);
                bicyclingLayer.setMap(null);
            }
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$47993550aec06aef = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$BicyclingLayerFunctional);
class $356d0adb4c3ddad5$export$9f9b3b888f86b05e extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            bicyclingLayer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setBicyclingLayerCallback", ()=>{
            if (this.state.bicyclingLayer !== null) {
                this.state.bicyclingLayer.setMap(this.context);
                if (this.props.onLoad) this.props.onLoad(this.state.bicyclingLayer);
            }
        });
    }
    componentDidMount() {
        var bicyclingLayer = new google.maps.BicyclingLayer();
        this.setState(()=>{
            return {
                bicyclingLayer: bicyclingLayer
            };
        }, this.setBicyclingLayerCallback);
    }
    componentWillUnmount() {
        if (this.state.bicyclingLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.bicyclingLayer);
            this.state.bicyclingLayer.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$9f9b3b888f86b05e, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$TransitLayerFunctional(_ref) {
    var { onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var transitLayer = new google.maps.TransitLayer();
        setInstance(transitLayer);
        transitLayer.setMap(map);
        if (onLoad) onLoad(transitLayer);
        return ()=>{
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$9fd3cf155641015f = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$TransitLayerFunctional);
class $356d0adb4c3ddad5$export$b4f2ddd6a5af2fbd extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            transitLayer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setTransitLayerCallback", ()=>{
            if (this.state.transitLayer !== null) {
                this.state.transitLayer.setMap(this.context);
                if (this.props.onLoad) this.props.onLoad(this.state.transitLayer);
            }
        });
    }
    componentDidMount() {
        var transitLayer = new google.maps.TransitLayer();
        this.setState(function setTransitLayer() {
            return {
                transitLayer: transitLayer
            };
        }, this.setTransitLayerCallback);
    }
    componentWillUnmount() {
        if (this.state.transitLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.transitLayer);
            this.state.transitLayer.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$b4f2ddd6a5af2fbd, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$e(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$e(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$e(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$e(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$g = {
    onCircleComplete: 'circlecomplete',
    onMarkerComplete: 'markercomplete',
    onOverlayComplete: 'overlaycomplete',
    onPolygonComplete: 'polygoncomplete',
    onPolylineComplete: 'polylinecomplete',
    onRectangleComplete: 'rectanglecomplete'
};
var $356d0adb4c3ddad5$var$updaterMap$g = {
    drawingMode (instance, drawingMode) {
        instance.setDrawingMode(drawingMode);
    },
    options (instance, options) {
        instance.setOptions(options);
    }
};
function $356d0adb4c3ddad5$var$DrawingManagerFunctional(_ref) {
    var { options: options, drawingMode: drawingMode, onCircleComplete: onCircleComplete, onMarkerComplete: onMarkerComplete, onOverlayComplete: onOverlayComplete, onPolygonComplete: onPolygonComplete, onPolylineComplete: onPolylineComplete, onRectangleComplete: onRectangleComplete, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [circlecompleteListener, setCircleCompleteListener] = (0, $6umrQ.useState)(null);
    var [markercompleteListener, setMarkerCompleteListener] = (0, $6umrQ.useState)(null);
    var [overlaycompleteListener, setOverlayCompleteListener] = (0, $6umrQ.useState)(null);
    var [polygoncompleteListener, setPolygonCompleteListener] = (0, $6umrQ.useState)(null);
    var [polylinecompleteListener, setPolylineCompleteListener] = (0, $6umrQ.useState)(null);
    var [rectanglecompleteListener, setRectangleCompleteListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setDrawingMode(drawingMode !== null && drawingMode !== void 0 ? drawingMode : null);
    }, [
        instance,
        drawingMode
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onCircleComplete) {
            if (circlecompleteListener !== null) google.maps.event.removeListener(circlecompleteListener);
            setCircleCompleteListener(google.maps.event.addListener(instance, 'circlecomplete', onCircleComplete));
        }
    }, [
        instance,
        onCircleComplete
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMarkerComplete) {
            if (markercompleteListener !== null) google.maps.event.removeListener(markercompleteListener);
            setMarkerCompleteListener(google.maps.event.addListener(instance, 'markercomplete', onMarkerComplete));
        }
    }, [
        instance,
        onMarkerComplete
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onOverlayComplete) {
            if (overlaycompleteListener !== null) google.maps.event.removeListener(overlaycompleteListener);
            setOverlayCompleteListener(google.maps.event.addListener(instance, 'overlaycomplete', onOverlayComplete));
        }
    }, [
        instance,
        onOverlayComplete
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onPolygonComplete) {
            if (polygoncompleteListener !== null) google.maps.event.removeListener(polygoncompleteListener);
            setPolygonCompleteListener(google.maps.event.addListener(instance, 'polygoncomplete', onPolygonComplete));
        }
    }, [
        instance,
        onPolygonComplete
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onPolylineComplete) {
            if (polylinecompleteListener !== null) google.maps.event.removeListener(polylinecompleteListener);
            setPolylineCompleteListener(google.maps.event.addListener(instance, 'polylinecomplete', onPolylineComplete));
        }
    }, [
        instance,
        onPolylineComplete
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRectangleComplete) {
            if (rectanglecompleteListener !== null) google.maps.event.removeListener(rectanglecompleteListener);
            setRectangleCompleteListener(google.maps.event.addListener(instance, 'rectanglecomplete', onRectangleComplete));
        }
    }, [
        instance,
        onRectangleComplete
    ]);
    (0, $6umrQ.useEffect)(()=>{
        $356d0adb4c3ddad5$var$invariant(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
        var drawingManager = new google.maps.drawing.DrawingManager($356d0adb4c3ddad5$var$_objectSpread$e($356d0adb4c3ddad5$var$_objectSpread$e({}, options), {}, {
            map: map
        }));
        if (drawingMode) drawingManager.setDrawingMode(drawingMode);
        if (onCircleComplete) setCircleCompleteListener(google.maps.event.addListener(drawingManager, 'circlecomplete', onCircleComplete));
        if (onMarkerComplete) setMarkerCompleteListener(google.maps.event.addListener(drawingManager, 'markercomplete', onMarkerComplete));
        if (onOverlayComplete) setOverlayCompleteListener(google.maps.event.addListener(drawingManager, 'overlaycomplete', onOverlayComplete));
        if (onPolygonComplete) setPolygonCompleteListener(google.maps.event.addListener(drawingManager, 'polygoncomplete', onPolygonComplete));
        if (onPolylineComplete) setPolylineCompleteListener(google.maps.event.addListener(drawingManager, 'polylinecomplete', onPolylineComplete));
        if (onRectangleComplete) setRectangleCompleteListener(google.maps.event.addListener(drawingManager, 'rectanglecomplete', onRectangleComplete));
        setInstance(drawingManager);
        if (onLoad) onLoad(drawingManager);
        return ()=>{
            if (instance !== null) {
                if (circlecompleteListener) google.maps.event.removeListener(circlecompleteListener);
                if (markercompleteListener) google.maps.event.removeListener(markercompleteListener);
                if (overlaycompleteListener) google.maps.event.removeListener(overlaycompleteListener);
                if (polygoncompleteListener) google.maps.event.removeListener(polygoncompleteListener);
                if (polylinecompleteListener) google.maps.event.removeListener(polylinecompleteListener);
                if (rectanglecompleteListener) google.maps.event.removeListener(rectanglecompleteListener);
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$5943163edd351e32 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$DrawingManagerFunctional);
class $356d0adb4c3ddad5$export$d35043b1ff2dc71 extends (0, $6umrQ.PureComponent) {
    constructor(props){
        super(props);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            drawingManager: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setDrawingManagerCallback", ()=>{
            if (this.state.drawingManager !== null && this.props.onLoad) this.props.onLoad(this.state.drawingManager);
        });
        $356d0adb4c3ddad5$var$invariant(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    }
    componentDidMount() {
        var drawingManager = new google.maps.drawing.DrawingManager($356d0adb4c3ddad5$var$_objectSpread$e($356d0adb4c3ddad5$var$_objectSpread$e({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$g,
            eventMap: $356d0adb4c3ddad5$var$eventMap$g,
            prevProps: {},
            nextProps: this.props,
            instance: drawingManager
        });
        this.setState(function setDrawingManager() {
            return {
                drawingManager: drawingManager
            };
        }, this.setDrawingManagerCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.drawingManager !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$g,
                eventMap: $356d0adb4c3ddad5$var$eventMap$g,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.drawingManager
            });
        }
    }
    componentWillUnmount() {
        if (this.state.drawingManager !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.drawingManager);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.state.drawingManager.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$d35043b1ff2dc71, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$d(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$d(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$d(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$d(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$f = {
    onAnimationChanged: 'animation_changed',
    onClick: 'click',
    onClickableChanged: 'clickable_changed',
    onCursorChanged: 'cursor_changed',
    onDblClick: 'dblclick',
    onDrag: 'drag',
    onDragEnd: 'dragend',
    onDraggableChanged: 'draggable_changed',
    onDragStart: 'dragstart',
    onFlatChanged: 'flat_changed',
    onIconChanged: 'icon_changed',
    onMouseDown: 'mousedown',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseUp: 'mouseup',
    onPositionChanged: 'position_changed',
    onRightClick: 'rightclick',
    onShapeChanged: 'shape_changed',
    onTitleChanged: 'title_changed',
    onVisibleChanged: 'visible_changed',
    onZindexChanged: 'zindex_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$f = {
    animation (instance, animation) {
        instance.setAnimation(animation);
    },
    clickable (instance, clickable) {
        instance.setClickable(clickable);
    },
    cursor (instance, cursor) {
        instance.setCursor(cursor);
    },
    draggable (instance, draggable) {
        instance.setDraggable(draggable);
    },
    icon (instance, icon) {
        instance.setIcon(icon);
    },
    label (instance, label) {
        instance.setLabel(label);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    opacity (instance, opacity) {
        instance.setOpacity(opacity);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    position (instance, position) {
        instance.setPosition(position);
    },
    shape (instance, shape) {
        instance.setShape(shape);
    },
    title (instance, title) {
        instance.setTitle(title);
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    },
    zIndex (instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var $356d0adb4c3ddad5$var$defaultOptions$5 = {};
function $356d0adb4c3ddad5$var$MarkerFunctional(_ref) {
    var { position: position, options: options, clusterer: clusterer, noClustererRedraw: noClustererRedraw, children: children, draggable: draggable, visible: visible, animation: animation, clickable: clickable, cursor: cursor, icon: icon, label: label, opacity: opacity, shape: shape, title: title, zIndex: zIndex, onClick: onClick, onDblClick: onDblClick, onDrag: onDrag, onDragEnd: onDragEnd, onDragStart: onDragStart, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseUp: onMouseUp, onMouseDown: onMouseDown, onRightClick: onRightClick, onClickableChanged: onClickableChanged, onCursorChanged: onCursorChanged, onAnimationChanged: onAnimationChanged, onDraggableChanged: onDraggableChanged, onFlatChanged: onFlatChanged, onIconChanged: onIconChanged, onPositionChanged: onPositionChanged, onShapeChanged: onShapeChanged, onTitleChanged: onTitleChanged, onVisibleChanged: onVisibleChanged, onZindexChanged: onZindexChanged, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [dragendListener, setDragendListener] = (0, $6umrQ.useState)(null);
    var [dragstartListener, setDragstartListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightclickListener, setRightclickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [dragListener, setDragListener] = (0, $6umrQ.useState)(null);
    var [clickableChangedListener, setClickableChangedListener] = (0, $6umrQ.useState)(null);
    var [cursorChangedListener, setCursorChangedListener] = (0, $6umrQ.useState)(null);
    var [animationChangedListener, setAnimationChangedListener] = (0, $6umrQ.useState)(null);
    var [draggableChangedListener, setDraggableChangedListener] = (0, $6umrQ.useState)(null);
    var [flatChangedListener, setFlatChangedListener] = (0, $6umrQ.useState)(null);
    var [iconChangedListener, setIconChangedListener] = (0, $6umrQ.useState)(null);
    var [positionChangedListener, setPositionChangedListener] = (0, $6umrQ.useState)(null);
    var [shapeChangedListener, setShapeChangedListener] = (0, $6umrQ.useState)(null);
    var [titleChangedListener, setTitleChangedListener] = (0, $6umrQ.useState)(null);
    var [visibleChangedListener, setVisibleChangedListener] = (0, $6umrQ.useState)(null);
    var [zIndexChangedListener, setZindexChangedListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof options !== 'undefined' && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof draggable !== 'undefined' && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (position && instance !== null) instance.setPosition(position);
    }, [
        instance,
        position
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof visible !== 'undefined' && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $6umrQ.useEffect)(()=>{
        instance === null || instance === void 0 || instance.setAnimation(animation);
    }, [
        instance,
        animation
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && clickable !== undefined) instance.setClickable(clickable);
    }, [
        instance,
        clickable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && cursor !== undefined) instance.setCursor(cursor);
    }, [
        instance,
        cursor
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && icon !== undefined) instance.setIcon(icon);
    }, [
        instance,
        icon
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && label !== undefined) instance.setLabel(label);
    }, [
        instance,
        label
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && opacity !== undefined) instance.setOpacity(opacity);
    }, [
        instance,
        opacity
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && shape !== undefined) instance.setShape(shape);
    }, [
        instance,
        shape
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && title !== undefined) instance.setTitle(title);
    }, [
        instance,
        title
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && zIndex !== undefined) instance.setZIndex(zIndex);
    }, [
        instance,
        zIndex
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClickableChanged) {
            if (clickableChangedListener !== null) google.maps.event.removeListener(clickableChangedListener);
            setClickableChangedListener(google.maps.event.addListener(instance, 'clickable_changed', onClickableChanged));
        }
    }, [
        onClickableChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onCursorChanged) {
            if (cursorChangedListener !== null) google.maps.event.removeListener(cursorChangedListener);
            setCursorChangedListener(google.maps.event.addListener(instance, 'cursor_changed', onCursorChanged));
        }
    }, [
        onCursorChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onAnimationChanged) {
            if (animationChangedListener !== null) google.maps.event.removeListener(animationChangedListener);
            setAnimationChangedListener(google.maps.event.addListener(instance, 'animation_changed', onAnimationChanged));
        }
    }, [
        onAnimationChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDraggableChanged) {
            if (draggableChangedListener !== null) google.maps.event.removeListener(draggableChangedListener);
            setDraggableChangedListener(google.maps.event.addListener(instance, 'draggable_changed', onDraggableChanged));
        }
    }, [
        onDraggableChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onFlatChanged) {
            if (flatChangedListener !== null) google.maps.event.removeListener(flatChangedListener);
            setFlatChangedListener(google.maps.event.addListener(instance, 'flat_changed', onFlatChanged));
        }
    }, [
        onFlatChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onIconChanged) {
            if (iconChangedListener !== null) google.maps.event.removeListener(iconChangedListener);
            setIconChangedListener(google.maps.event.addListener(instance, 'icon_changed', onIconChanged));
        }
    }, [
        onIconChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onPositionChanged) {
            if (positionChangedListener !== null) google.maps.event.removeListener(positionChangedListener);
            setPositionChangedListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onShapeChanged) {
            if (shapeChangedListener !== null) google.maps.event.removeListener(shapeChangedListener);
            setShapeChangedListener(google.maps.event.addListener(instance, 'shape_changed', onShapeChanged));
        }
    }, [
        onShapeChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onTitleChanged) {
            if (titleChangedListener !== null) google.maps.event.removeListener(titleChangedListener);
            setTitleChangedListener(google.maps.event.addListener(instance, 'title_changed', onTitleChanged));
        }
    }, [
        onTitleChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onVisibleChanged) {
            if (visibleChangedListener !== null) google.maps.event.removeListener(visibleChangedListener);
            setVisibleChangedListener(google.maps.event.addListener(instance, 'visible_changed', onVisibleChanged));
        }
    }, [
        onVisibleChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onZindexChanged) {
            if (zIndexChangedListener !== null) google.maps.event.removeListener(zIndexChangedListener);
            setZindexChangedListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var markerOptions = $356d0adb4c3ddad5$var$_objectSpread$d($356d0adb4c3ddad5$var$_objectSpread$d($356d0adb4c3ddad5$var$_objectSpread$d({}, options || $356d0adb4c3ddad5$var$defaultOptions$5), clusterer ? $356d0adb4c3ddad5$var$defaultOptions$5 : {
            map: map
        }), {}, {
            position: position
        });
        var marker = new google.maps.Marker(markerOptions);
        if (clusterer) clusterer.addMarker(marker, !!noClustererRedraw);
        else marker.setMap(map);
        if (position) marker.setPosition(position);
        if (typeof visible !== 'undefined') marker.setVisible(visible);
        if (typeof draggable !== 'undefined') marker.setDraggable(draggable);
        if (typeof clickable !== 'undefined') marker.setClickable(clickable);
        if (typeof cursor === 'string') marker.setCursor(cursor);
        if (icon) marker.setIcon(icon);
        if (typeof label !== 'undefined') marker.setLabel(label);
        if (typeof opacity !== 'undefined') marker.setOpacity(opacity);
        if (shape) marker.setShape(shape);
        if (typeof title === 'string') marker.setTitle(title);
        if (typeof zIndex === 'number') marker.setZIndex(zIndex);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(marker, 'dblclick', onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(marker, 'dragend', onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(marker, 'dragstart', onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(marker, 'mousedown', onMouseDown));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(marker, 'mouseout', onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(marker, 'mouseover', onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(marker, 'mouseup', onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(marker, 'rightclick', onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(marker, 'click', onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(marker, 'drag', onDrag));
        if (onClickableChanged) setClickableChangedListener(google.maps.event.addListener(marker, 'clickable_changed', onClickableChanged));
        if (onCursorChanged) setCursorChangedListener(google.maps.event.addListener(marker, 'cursor_changed', onCursorChanged));
        if (onAnimationChanged) setAnimationChangedListener(google.maps.event.addListener(marker, 'animation_changed', onAnimationChanged));
        if (onDraggableChanged) setDraggableChangedListener(google.maps.event.addListener(marker, 'draggable_changed', onDraggableChanged));
        if (onFlatChanged) setFlatChangedListener(google.maps.event.addListener(marker, 'flat_changed', onFlatChanged));
        if (onIconChanged) setIconChangedListener(google.maps.event.addListener(marker, 'icon_changed', onIconChanged));
        if (onPositionChanged) setPositionChangedListener(google.maps.event.addListener(marker, 'position_changed', onPositionChanged));
        if (onShapeChanged) setShapeChangedListener(google.maps.event.addListener(marker, 'shape_changed', onShapeChanged));
        if (onTitleChanged) setTitleChangedListener(google.maps.event.addListener(marker, 'title_changed', onTitleChanged));
        if (onVisibleChanged) setVisibleChangedListener(google.maps.event.addListener(marker, 'visible_changed', onVisibleChanged));
        if (onZindexChanged) setZindexChangedListener(google.maps.event.addListener(marker, 'zindex_changed', onZindexChanged));
        setInstance(marker);
        if (onLoad) onLoad(marker);
        return ()=>{
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (clickableChangedListener !== null) google.maps.event.removeListener(clickableChangedListener);
            if (cursorChangedListener !== null) google.maps.event.removeListener(cursorChangedListener);
            if (animationChangedListener !== null) google.maps.event.removeListener(animationChangedListener);
            if (draggableChangedListener !== null) google.maps.event.removeListener(draggableChangedListener);
            if (flatChangedListener !== null) google.maps.event.removeListener(flatChangedListener);
            if (iconChangedListener !== null) google.maps.event.removeListener(iconChangedListener);
            if (positionChangedListener !== null) google.maps.event.removeListener(positionChangedListener);
            if (titleChangedListener !== null) google.maps.event.removeListener(titleChangedListener);
            if (visibleChangedListener !== null) google.maps.event.removeListener(visibleChangedListener);
            if (zIndexChangedListener !== null) google.maps.event.removeListener(zIndexChangedListener);
            if (onUnmount) onUnmount(marker);
            if (clusterer) clusterer.removeMarker(marker, !!noClustererRedraw);
            else if (marker) marker.setMap(null);
        };
    }, []);
    var chx = (0, $6umrQ.useMemo)(()=>{
        return children ? (0, $6umrQ.Children).map(children, (child)=>{
            if (!(0, $6umrQ.isValidElement)(child)) return child;
            var elementChild = child;
            return (0, $6umrQ.cloneElement)(elementChild, {
                anchor: instance
            });
        }) : null;
    }, [
        children,
        instance
    ]);
    return (0, $fb2efc226cb4f9dd$exports.jsx)((0, $fb2efc226cb4f9dd$exports.Fragment), {
        children: chx
    }) || null;
}
var $356d0adb4c3ddad5$export$45d474b1d7219d91 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$MarkerFunctional);
class $356d0adb4c3ddad5$export$e98856a975cab58e extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
    }
    componentDidMount() {
        var _this = this;
        return $356d0adb4c3ddad5$var$_asyncToGenerator(function*() {
            var markerOptions = $356d0adb4c3ddad5$var$_objectSpread$d($356d0adb4c3ddad5$var$_objectSpread$d($356d0adb4c3ddad5$var$_objectSpread$d({}, _this.props.options || $356d0adb4c3ddad5$var$defaultOptions$5), _this.props.clusterer ? $356d0adb4c3ddad5$var$defaultOptions$5 : {
                map: _this.context
            }), {}, {
                position: _this.props.position
            });
            // Unfortunately we can't just do this in the contstructor, because the
            // `MapContext` might not be filled in yet.
            _this.marker = new google.maps.Marker(markerOptions);
            if (_this.props.clusterer) _this.props.clusterer.addMarker(_this.marker, !!_this.props.noClustererRedraw);
            else _this.marker.setMap(_this.context);
            _this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$f,
                eventMap: $356d0adb4c3ddad5$var$eventMap$f,
                prevProps: {},
                nextProps: _this.props,
                instance: _this.marker
            });
            if (_this.props.onLoad) _this.props.onLoad(_this.marker);
        })();
    }
    componentDidUpdate(prevProps) {
        if (this.marker) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$f,
                eventMap: $356d0adb4c3ddad5$var$eventMap$f,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.marker
            });
        }
    }
    componentWillUnmount() {
        if (!this.marker) return;
        if (this.props.onUnmount) this.props.onUnmount(this.marker);
        $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
        if (this.props.clusterer) this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
        else if (this.marker) this.marker.setMap(null);
    }
    render() {
        var children = this.props.children ? (0, $6umrQ.Children).map(this.props.children, (child)=>{
            if (!(0, $6umrQ.isValidElement)(child)) return child;
            var elementChild = child;
            return (0, $6umrQ.cloneElement)(elementChild, {
                anchor: this.marker
            });
        }) : null;
        return children || null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$e98856a975cab58e, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
var $356d0adb4c3ddad5$var$ClusterIcon = /** @class */ function() {
    function ClusterIcon(cluster, styles) {
        cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
        this.cluster = cluster;
        this.clusterClassName = this.cluster.getClusterer().getClusterClass();
        this.className = this.clusterClassName;
        this.styles = styles;
        this.center = undefined;
        this.div = null;
        this.sums = null;
        this.visible = false;
        this.boundsChangedListener = null;
        this.url = '';
        this.height = 0;
        this.width = 0;
        this.anchorText = [
            0,
            0
        ];
        this.anchorIcon = [
            0,
            0
        ];
        this.textColor = 'black';
        this.textSize = 11;
        this.textDecoration = 'none';
        this.fontWeight = 'bold';
        this.fontStyle = 'normal';
        this.fontFamily = 'Arial,sans-serif';
        this.backgroundPosition = '0 0';
        this.cMouseDownInCluster = null;
        this.cDraggingMapByCluster = null;
        this.timeOut = null;
        this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
        this.onBoundsChanged = this.onBoundsChanged.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.draw = this.draw.bind(this);
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.useStyle = this.useStyle.bind(this);
        this.setCenter = this.setCenter.bind(this);
        this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
    }
    ClusterIcon.prototype.onBoundsChanged = function() {
        this.cDraggingMapByCluster = this.cMouseDownInCluster;
    };
    ClusterIcon.prototype.onMouseDown = function() {
        this.cMouseDownInCluster = true;
        this.cDraggingMapByCluster = false;
    };
    ClusterIcon.prototype.onClick = function(event) {
        this.cMouseDownInCluster = false;
        if (!this.cDraggingMapByCluster) {
            var markerClusterer_1 = this.cluster.getClusterer();
            /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */ google.maps.event.trigger(markerClusterer_1, 'click', this.cluster);
            google.maps.event.trigger(markerClusterer_1, 'clusterclick', this.cluster); // deprecated name
            // The default click handler follows. Disable it by setting
            // the zoomOnClick property to false.
            if (markerClusterer_1.getZoomOnClick()) {
                // Zoom into the cluster.
                var maxZoom_1 = markerClusterer_1.getMaxZoom();
                var bounds_1 = this.cluster.getBounds();
                var map = markerClusterer_1.getMap();
                if (map !== null && 'fitBounds' in map) map.fitBounds(bounds_1);
                // There is a fix for Issue 170 here:
                this.timeOut = window.setTimeout(function() {
                    var map = markerClusterer_1.getMap();
                    if (map !== null) {
                        if ('fitBounds' in map) map.fitBounds(bounds_1);
                        var zoom = map.getZoom() || 0;
                        // Don't zoom beyond the max zoom level
                        if (maxZoom_1 !== null && zoom > maxZoom_1) map.setZoom(maxZoom_1 + 1);
                    }
                }, 100);
            }
            // Prevent event propagation to the map:
            event.cancelBubble = true;
            if (event.stopPropagation) event.stopPropagation();
        }
    };
    ClusterIcon.prototype.onMouseOver = function() {
        /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */ google.maps.event.trigger(this.cluster.getClusterer(), 'mouseover', this.cluster);
    };
    ClusterIcon.prototype.onMouseOut = function() {
        /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */ google.maps.event.trigger(this.cluster.getClusterer(), 'mouseout', this.cluster);
    };
    ClusterIcon.prototype.onAdd = function() {
        var _a;
        this.div = document.createElement('div');
        this.div.className = this.className;
        if (this.visible) this.show();
        (_a = this.getPanes()) === null || _a === void 0 || _a.overlayMouseTarget.appendChild(this.div);
        var map = this.getMap();
        if (map !== null) {
            // Fix for Issue 157
            this.boundsChangedListener = google.maps.event.addListener(map, 'bounds_changed', this.onBoundsChanged);
            this.div.addEventListener('mousedown', this.onMouseDown);
            this.div.addEventListener('click', this.onClick);
            this.div.addEventListener('mouseover', this.onMouseOver);
            this.div.addEventListener('mouseout', this.onMouseOut);
        }
    };
    ClusterIcon.prototype.onRemove = function() {
        if (this.div && this.div.parentNode) {
            this.hide();
            if (this.boundsChangedListener !== null) google.maps.event.removeListener(this.boundsChangedListener);
            this.div.removeEventListener('mousedown', this.onMouseDown);
            this.div.removeEventListener('click', this.onClick);
            this.div.removeEventListener('mouseover', this.onMouseOver);
            this.div.removeEventListener('mouseout', this.onMouseOut);
            this.div.parentNode.removeChild(this.div);
            if (this.timeOut !== null) {
                window.clearTimeout(this.timeOut);
                this.timeOut = null;
            }
            this.div = null;
        }
    };
    ClusterIcon.prototype.draw = function() {
        if (this.visible && this.div !== null && this.center) {
            var pos = this.getPosFromLatLng(this.center);
            this.div.style.top = pos !== null ? "".concat(pos.y, "px") : '0';
            this.div.style.left = pos !== null ? "".concat(pos.x, "px") : '0';
        }
    };
    ClusterIcon.prototype.hide = function() {
        if (this.div) this.div.style.display = 'none';
        this.visible = false;
    };
    ClusterIcon.prototype.show = function() {
        var _a, _b, _c, _d, _e, _f;
        if (this.div && this.center) {
            var divTitle = this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '' ? this.cluster.getClusterer().getTitle() : this.sums.title;
            // NOTE: values must be specified in px units
            var bp = this.backgroundPosition.split(' ');
            var spriteH = parseInt(((_a = bp[0]) === null || _a === void 0 ? void 0 : _a.replace(/^\s+|\s+$/g, '')) || '0', 10);
            var spriteV = parseInt(((_b = bp[1]) === null || _b === void 0 ? void 0 : _b.replace(/^\s+|\s+$/g, '')) || '0', 10);
            var pos = this.getPosFromLatLng(this.center);
            this.div.className = this.className;
            this.div.setAttribute('style', "cursor: pointer; position: absolute; top: ".concat(pos !== null ? "".concat(pos.y, "px") : '0', "; left: ").concat(pos !== null ? "".concat(pos.x, "px") : '0', "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
            var img = document.createElement('img');
            img.alt = divTitle;
            img.src = this.url;
            img.width = this.width;
            img.height = this.height;
            img.setAttribute('style', "position: absolute; top: ".concat(spriteV, "px; left: ").concat(spriteH, "px"));
            if (!this.cluster.getClusterer().enableRetinaIcons) img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
            var textElm = document.createElement('div');
            textElm.setAttribute('style', "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px"));
            if ((_c = this.sums) === null || _c === void 0 ? void 0 : _c.text) textElm.innerText = "".concat((_d = this.sums) === null || _d === void 0 ? void 0 : _d.text);
            if ((_e = this.sums) === null || _e === void 0 ? void 0 : _e.html) textElm.innerHTML = "".concat((_f = this.sums) === null || _f === void 0 ? void 0 : _f.html);
            this.div.innerHTML = '';
            this.div.appendChild(img);
            this.div.appendChild(textElm);
            this.div.title = divTitle;
            this.div.style.display = '';
        }
        this.visible = true;
    };
    ClusterIcon.prototype.useStyle = function(sums) {
        this.sums = sums;
        var styles = this.cluster.getClusterer().getStyles();
        var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
        if (style) {
            this.url = style.url;
            this.height = style.height;
            this.width = style.width;
            if (style.className) this.className = "".concat(this.clusterClassName, " ").concat(style.className);
            this.anchorText = style.anchorText || [
                0,
                0
            ];
            this.anchorIcon = style.anchorIcon || [
                this.height / 2,
                this.width / 2
            ];
            this.textColor = style.textColor || 'black';
            this.textSize = style.textSize || 11;
            this.textDecoration = style.textDecoration || 'none';
            this.fontWeight = style.fontWeight || 'bold';
            this.fontStyle = style.fontStyle || 'normal';
            this.fontFamily = style.fontFamily || 'Arial,sans-serif';
            this.backgroundPosition = style.backgroundPosition || '0 0';
        }
    };
    ClusterIcon.prototype.setCenter = function(center) {
        this.center = center;
    };
    ClusterIcon.prototype.getPosFromLatLng = function(latlng) {
        var pos = this.getProjection().fromLatLngToDivPixel(latlng);
        if (pos !== null) {
            pos.x -= this.anchorIcon[1];
            pos.y -= this.anchorIcon[0];
        }
        return pos;
    };
    return ClusterIcon;
}();
/* global google */ var $356d0adb4c3ddad5$var$Cluster$1 = /** @class */ function() {
    function Cluster(markerClusterer) {
        this.markerClusterer = markerClusterer;
        this.map = this.markerClusterer.getMap();
        this.gridSize = this.markerClusterer.getGridSize();
        this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
        this.averageCenter = this.markerClusterer.getAverageCenter();
        this.markers = [];
        this.center = undefined;
        this.bounds = null;
        this.clusterIcon = new $356d0adb4c3ddad5$var$ClusterIcon(this, this.markerClusterer.getStyles());
        this.getSize = this.getSize.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
        this.getCenter = this.getCenter.bind(this);
        this.getMap = this.getMap.bind(this);
        this.getClusterer = this.getClusterer.bind(this);
        this.getBounds = this.getBounds.bind(this);
        this.remove = this.remove.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
        this.calculateBounds = this.calculateBounds.bind(this);
        this.updateIcon = this.updateIcon.bind(this);
        this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
    }
    Cluster.prototype.getSize = function() {
        return this.markers.length;
    };
    Cluster.prototype.getMarkers = function() {
        return this.markers;
    };
    Cluster.prototype.getCenter = function() {
        return this.center;
    };
    Cluster.prototype.getMap = function() {
        return this.map;
    };
    Cluster.prototype.getClusterer = function() {
        return this.markerClusterer;
    };
    Cluster.prototype.getBounds = function() {
        var bounds = new google.maps.LatLngBounds(this.center, this.center);
        var markers = this.getMarkers();
        for(var _i = 0, markers_1 = markers; _i < markers_1.length; _i++){
            var marker = markers_1[_i];
            var position = marker.getPosition();
            if (position) bounds.extend(position);
        }
        return bounds;
    };
    Cluster.prototype.remove = function() {
        this.clusterIcon.setMap(null);
        this.markers = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete this.markers;
    };
    Cluster.prototype.addMarker = function(marker) {
        var _a;
        if (this.isMarkerAlreadyAdded(marker)) return false;
        if (!this.center) {
            var position = marker.getPosition();
            if (position) {
                this.center = position;
                this.calculateBounds();
            }
        } else if (this.averageCenter) {
            var position = marker.getPosition();
            if (position) {
                var length_1 = this.markers.length + 1;
                this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
                this.calculateBounds();
            }
        }
        marker.isAdded = true;
        this.markers.push(marker);
        var mCount = this.markers.length;
        var maxZoom = this.markerClusterer.getMaxZoom();
        var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
        if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) // Zoomed in past max zoom, so show the marker.
        {
            if (marker.getMap() !== this.map) marker.setMap(this.map);
        } else if (mCount < this.minClusterSize) // Min cluster size not reached so show the marker.
        {
            if (marker.getMap() !== this.map) marker.setMap(this.map);
        } else if (mCount === this.minClusterSize) // Hide the markers that were showing.
        for(var _i = 0, _b = this.markers; _i < _b.length; _i++){
            var markerElement = _b[_i];
            markerElement.setMap(null);
        }
        else marker.setMap(null);
        return true;
    };
    Cluster.prototype.isMarkerInClusterBounds = function(marker) {
        if (this.bounds !== null) {
            var position = marker.getPosition();
            if (position) return this.bounds.contains(position);
        }
        return false;
    };
    Cluster.prototype.calculateBounds = function() {
        this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
    };
    Cluster.prototype.updateIcon = function() {
        var _a;
        var mCount = this.markers.length;
        var maxZoom = this.markerClusterer.getMaxZoom();
        var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
        if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
            this.clusterIcon.hide();
            return;
        }
        if (mCount < this.minClusterSize) {
            // Min cluster size not yet reached.
            this.clusterIcon.hide();
            return;
        }
        if (this.center) this.clusterIcon.setCenter(this.center);
        this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
        this.clusterIcon.show();
    };
    Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
        if (this.markers.includes) return this.markers.includes(marker);
        for(var i = 0; i < this.markers.length; i++){
            if (marker === this.markers[i]) return true;
        }
        return false;
    };
    return Cluster;
}();
/* global google */ /* eslint-disable filenames/match-regex */ /**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */ function $356d0adb4c3ddad5$var$CALCULATOR(markers, numStyles) {
    var count = markers.length;
    var numberOfDigits = count.toString().length;
    var index = Math.min(numberOfDigits, numStyles);
    return {
        text: count.toString(),
        index: index,
        title: ''
    };
}
var $356d0adb4c3ddad5$var$BATCH_SIZE = 2000;
var $356d0adb4c3ddad5$var$BATCH_SIZE_IE = 500;
var $356d0adb4c3ddad5$var$IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var $356d0adb4c3ddad5$var$IMAGE_EXTENSION = 'png';
var $356d0adb4c3ddad5$var$IMAGE_SIZES = [
    53,
    56,
    66,
    78,
    90
];
var $356d0adb4c3ddad5$var$CLUSTERER_CLASS = 'cluster';
var $356d0adb4c3ddad5$var$Clusterer = /** @class */ function() {
    function Clusterer(map, optMarkers, optOptions) {
        if (optMarkers === void 0) optMarkers = [];
        if (optOptions === void 0) optOptions = {};
        this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
        this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
        this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
        this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
        this.addToClosestCluster = this.addToClosestCluster.bind(this);
        this.getImageExtension = this.getImageExtension.bind(this);
        this.setImageExtension = this.setImageExtension.bind(this);
        this.getExtendedBounds = this.getExtendedBounds.bind(this);
        this.getAverageCenter = this.getAverageCenter.bind(this);
        this.setAverageCenter = this.setAverageCenter.bind(this);
        this.getTotalClusters = this.getTotalClusters.bind(this);
        this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
        this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
        this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
        this.getClusterClass = this.getClusterClass.bind(this);
        this.setClusterClass = this.setClusterClass.bind(this);
        this.getTotalMarkers = this.getTotalMarkers.bind(this);
        this.getZoomOnClick = this.getZoomOnClick.bind(this);
        this.setZoomOnClick = this.setZoomOnClick.bind(this);
        this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
        this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
        this.createClusters = this.createClusters.bind(this);
        this.onZoomChanged = this.onZoomChanged.bind(this);
        this.getImageSizes = this.getImageSizes.bind(this);
        this.setImageSizes = this.setImageSizes.bind(this);
        this.getCalculator = this.getCalculator.bind(this);
        this.setCalculator = this.setCalculator.bind(this);
        this.removeMarkers = this.removeMarkers.bind(this);
        this.resetViewport = this.resetViewport.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setImagePath = this.setImagePath.bind(this);
        this.pushMarkerTo = this.pushMarkerTo.bind(this);
        this.removeMarker = this.removeMarker.bind(this);
        this.clearMarkers = this.clearMarkers.bind(this);
        this.setupStyles = this.setupStyles.bind(this);
        this.getGridSize = this.getGridSize.bind(this);
        this.setGridSize = this.setGridSize.bind(this);
        this.getClusters = this.getClusters.bind(this);
        this.getMaxZoom = this.getMaxZoom.bind(this);
        this.setMaxZoom = this.setMaxZoom.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
        this.addMarkers = this.addMarkers.bind(this);
        this.getStyles = this.getStyles.bind(this);
        this.setStyles = this.setStyles.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.setTitle = this.setTitle.bind(this);
        this.repaint = this.repaint.bind(this);
        this.onIdle = this.onIdle.bind(this);
        this.redraw = this.redraw.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.draw = this.draw.bind(this);
        this.extend = this.extend.bind(this);
        this.extend(Clusterer, google.maps.OverlayView);
        this.markers = [];
        this.clusters = [];
        this.listeners = [];
        this.activeMap = null;
        this.ready = false;
        this.gridSize = optOptions.gridSize || 60;
        this.minClusterSize = optOptions.minimumClusterSize || 2;
        this.maxZoom = optOptions.maxZoom || null;
        this.styles = optOptions.styles || [];
        this.title = optOptions.title || '';
        this.zoomOnClick = true;
        if (optOptions.zoomOnClick !== undefined) this.zoomOnClick = optOptions.zoomOnClick;
        this.averageCenter = false;
        if (optOptions.averageCenter !== undefined) this.averageCenter = optOptions.averageCenter;
        this.ignoreHidden = false;
        if (optOptions.ignoreHidden !== undefined) this.ignoreHidden = optOptions.ignoreHidden;
        this.enableRetinaIcons = false;
        if (optOptions.enableRetinaIcons !== undefined) this.enableRetinaIcons = optOptions.enableRetinaIcons;
        this.imagePath = optOptions.imagePath || $356d0adb4c3ddad5$var$IMAGE_PATH;
        this.imageExtension = optOptions.imageExtension || $356d0adb4c3ddad5$var$IMAGE_EXTENSION;
        this.imageSizes = optOptions.imageSizes || $356d0adb4c3ddad5$var$IMAGE_SIZES;
        this.calculator = optOptions.calculator || $356d0adb4c3ddad5$var$CALCULATOR;
        this.batchSize = optOptions.batchSize || $356d0adb4c3ddad5$var$BATCH_SIZE;
        this.batchSizeIE = optOptions.batchSizeIE || $356d0adb4c3ddad5$var$BATCH_SIZE_IE;
        this.clusterClass = optOptions.clusterClass || $356d0adb4c3ddad5$var$CLUSTERER_CLASS;
        if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) // Try to avoid IE timeout when processing a huge number of markers:
        this.batchSize = this.batchSizeIE;
        this.timerRefStatic = null;
        this.setupStyles();
        this.addMarkers(optMarkers, true);
        this.setMap(map); // Note: this causes onAdd to be called
    }
    Clusterer.prototype.onZoomChanged = function() {
        var _a, _b;
        this.resetViewport(false);
        // Workaround for this Google bug: when map is at level 0 and "-" of
        // zoom slider is clicked, a "zoom_changed" event is fired even though
        // the map doesn't zoom out any further. In this situation, no "idle"
        // event is triggered so the cluster markers that have been removed
        // do not get redrawn. Same goes for a zoom in at maxZoom.
        if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get('minZoom') || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get('maxZoom')) google.maps.event.trigger(this, 'idle');
    };
    Clusterer.prototype.onIdle = function() {
        this.redraw();
    };
    Clusterer.prototype.onAdd = function() {
        var map = this.getMap();
        this.activeMap = map;
        this.ready = true;
        this.repaint();
        if (map !== null) // Add the map event listeners
        this.listeners = [
            google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged),
            google.maps.event.addListener(map, 'idle', this.onIdle)
        ];
    };
    Clusterer.prototype.onRemove = function() {
        // Put all the managed markers back on the map:
        for(var _i = 0, _a = this.markers; _i < _a.length; _i++){
            var marker = _a[_i];
            if (marker.getMap() !== this.activeMap) marker.setMap(this.activeMap);
        }
        // Remove all clusters:
        for(var _b = 0, _c = this.clusters; _b < _c.length; _b++){
            var cluster = _c[_b];
            cluster.remove();
        }
        this.clusters = [];
        // Remove map event listeners:
        for(var _d = 0, _e = this.listeners; _d < _e.length; _d++){
            var listener = _e[_d];
            google.maps.event.removeListener(listener);
        }
        this.listeners = [];
        this.activeMap = null;
        this.ready = false;
    };
    Clusterer.prototype.draw = function() {
        return;
    };
    Clusterer.prototype.getMap = function() {
        return null;
    };
    Clusterer.prototype.getPanes = function() {
        return null;
    };
    Clusterer.prototype.getProjection = function() {
        return {
            fromContainerPixelToLatLng: function fromContainerPixelToLatLng() {
                return null;
            },
            fromDivPixelToLatLng: function fromDivPixelToLatLng() {
                return null;
            },
            fromLatLngToContainerPixel: function fromLatLngToContainerPixel() {
                return null;
            },
            fromLatLngToDivPixel: function fromLatLngToDivPixel() {
                return null;
            },
            getVisibleRegion: function getVisibleRegion() {
                return null;
            },
            getWorldWidth: function getWorldWidth() {
                return 0;
            }
        };
    };
    Clusterer.prototype.setMap = function() {
        return;
    };
    Clusterer.prototype.addListener = function() {
        return {
            remove: function remove() {
                return;
            }
        };
    };
    Clusterer.prototype.bindTo = function() {
        return;
    };
    Clusterer.prototype.get = function() {
        return;
    };
    Clusterer.prototype.notify = function() {
        return;
    };
    Clusterer.prototype.set = function() {
        return;
    };
    Clusterer.prototype.setValues = function() {
        return;
    };
    Clusterer.prototype.unbind = function() {
        return;
    };
    Clusterer.prototype.unbindAll = function() {
        return;
    };
    Clusterer.prototype.setupStyles = function() {
        if (this.styles.length > 0) return;
        for(var i = 0; i < this.imageSizes.length; i++)this.styles.push({
            url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
            height: this.imageSizes[i] || 0,
            width: this.imageSizes[i] || 0
        });
    };
    Clusterer.prototype.fitMapToMarkers = function() {
        var markers = this.getMarkers();
        var bounds = new google.maps.LatLngBounds();
        for(var _i = 0, markers_1 = markers; _i < markers_1.length; _i++){
            var marker = markers_1[_i];
            var position = marker.getPosition();
            if (position) bounds.extend(position);
        }
        var map = this.getMap();
        if (map !== null && 'fitBounds' in map) map.fitBounds(bounds);
    };
    Clusterer.prototype.getGridSize = function() {
        return this.gridSize;
    };
    Clusterer.prototype.setGridSize = function(gridSize) {
        this.gridSize = gridSize;
    };
    Clusterer.prototype.getMinimumClusterSize = function() {
        return this.minClusterSize;
    };
    Clusterer.prototype.setMinimumClusterSize = function(minimumClusterSize) {
        this.minClusterSize = minimumClusterSize;
    };
    Clusterer.prototype.getMaxZoom = function() {
        return this.maxZoom;
    };
    Clusterer.prototype.setMaxZoom = function(maxZoom) {
        this.maxZoom = maxZoom;
    };
    Clusterer.prototype.getStyles = function() {
        return this.styles;
    };
    Clusterer.prototype.setStyles = function(styles) {
        this.styles = styles;
    };
    Clusterer.prototype.getTitle = function() {
        return this.title;
    };
    Clusterer.prototype.setTitle = function(title) {
        this.title = title;
    };
    Clusterer.prototype.getZoomOnClick = function() {
        return this.zoomOnClick;
    };
    Clusterer.prototype.setZoomOnClick = function(zoomOnClick) {
        this.zoomOnClick = zoomOnClick;
    };
    Clusterer.prototype.getAverageCenter = function() {
        return this.averageCenter;
    };
    Clusterer.prototype.setAverageCenter = function(averageCenter) {
        this.averageCenter = averageCenter;
    };
    Clusterer.prototype.getIgnoreHidden = function() {
        return this.ignoreHidden;
    };
    Clusterer.prototype.setIgnoreHidden = function(ignoreHidden) {
        this.ignoreHidden = ignoreHidden;
    };
    Clusterer.prototype.getEnableRetinaIcons = function() {
        return this.enableRetinaIcons;
    };
    Clusterer.prototype.setEnableRetinaIcons = function(enableRetinaIcons) {
        this.enableRetinaIcons = enableRetinaIcons;
    };
    Clusterer.prototype.getImageExtension = function() {
        return this.imageExtension;
    };
    Clusterer.prototype.setImageExtension = function(imageExtension) {
        this.imageExtension = imageExtension;
    };
    Clusterer.prototype.getImagePath = function() {
        return this.imagePath;
    };
    Clusterer.prototype.setImagePath = function(imagePath) {
        this.imagePath = imagePath;
    };
    Clusterer.prototype.getImageSizes = function() {
        return this.imageSizes;
    };
    Clusterer.prototype.setImageSizes = function(imageSizes) {
        this.imageSizes = imageSizes;
    };
    Clusterer.prototype.getCalculator = function() {
        return this.calculator;
    };
    Clusterer.prototype.setCalculator = function(calculator) {
        this.calculator = calculator;
    };
    Clusterer.prototype.getBatchSizeIE = function() {
        return this.batchSizeIE;
    };
    Clusterer.prototype.setBatchSizeIE = function(batchSizeIE) {
        this.batchSizeIE = batchSizeIE;
    };
    Clusterer.prototype.getClusterClass = function() {
        return this.clusterClass;
    };
    Clusterer.prototype.setClusterClass = function(clusterClass) {
        this.clusterClass = clusterClass;
    };
    Clusterer.prototype.getMarkers = function() {
        return this.markers;
    };
    Clusterer.prototype.getTotalMarkers = function() {
        return this.markers.length;
    };
    Clusterer.prototype.getClusters = function() {
        return this.clusters;
    };
    Clusterer.prototype.getTotalClusters = function() {
        return this.clusters.length;
    };
    Clusterer.prototype.addMarker = function(marker, optNoDraw) {
        this.pushMarkerTo(marker);
        if (!optNoDraw) this.redraw();
    };
    Clusterer.prototype.addMarkers = function(markers, optNoDraw) {
        for(var key in markers)if (Object.prototype.hasOwnProperty.call(markers, key)) {
            var marker = markers[key];
            if (marker) this.pushMarkerTo(marker);
        }
        if (!optNoDraw) this.redraw();
    };
    Clusterer.prototype.pushMarkerTo = function(marker) {
        var _this = this;
        // If the marker is draggable add a listener so we can update the clusters on the dragend:
        if (marker.getDraggable()) google.maps.event.addListener(marker, 'dragend', function() {
            if (_this.ready) {
                marker.isAdded = false;
                _this.repaint();
            }
        });
        marker.isAdded = false;
        this.markers.push(marker);
    };
    Clusterer.prototype.removeMarker_ = function(marker) {
        var index = -1;
        if (this.markers.indexOf) index = this.markers.indexOf(marker);
        else {
            for(var i = 0; i < this.markers.length; i++)if (marker === this.markers[i]) {
                index = i;
                break;
            }
        }
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        marker.setMap(null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        return true;
    };
    Clusterer.prototype.removeMarker = function(marker, optNoDraw) {
        var removed = this.removeMarker_(marker);
        if (!optNoDraw && removed) this.repaint();
        return removed;
    };
    Clusterer.prototype.removeMarkers = function(markers, optNoDraw) {
        var removed = false;
        for(var _i = 0, markers_2 = markers; _i < markers_2.length; _i++){
            var marker = markers_2[_i];
            removed = removed || this.removeMarker_(marker);
        }
        if (!optNoDraw && removed) this.repaint();
        return removed;
    };
    Clusterer.prototype.clearMarkers = function() {
        this.resetViewport(true);
        this.markers = [];
    };
    Clusterer.prototype.repaint = function() {
        var oldClusters = this.clusters.slice();
        this.clusters = [];
        this.resetViewport(false);
        this.redraw();
        // Remove the old clusters.
        // Do it in a timeout to prevent blinking effect.
        setTimeout(function timeout() {
            for(var _i = 0, oldClusters_1 = oldClusters; _i < oldClusters_1.length; _i++){
                var oldCluster = oldClusters_1[_i];
                oldCluster.remove();
            }
        }, 0);
    };
    Clusterer.prototype.getExtendedBounds = function(bounds) {
        var projection = this.getProjection();
        // Convert the points to pixels and the extend out by the grid size.
        var trPix = projection.fromLatLngToDivPixel(// Turn the bounds into latlng.
        new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
        if (trPix !== null) {
            trPix.x += this.gridSize;
            trPix.y -= this.gridSize;
        }
        var blPix = projection.fromLatLngToDivPixel(// Turn the bounds into latlng.
        new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
        if (blPix !== null) {
            blPix.x -= this.gridSize;
            blPix.y += this.gridSize;
        }
        // Extend the bounds to contain the new bounds.
        if (trPix !== null) {
            // Convert the pixel points back to LatLng nw
            var point1 = projection.fromDivPixelToLatLng(trPix);
            if (point1 !== null) bounds.extend(point1);
        }
        if (blPix !== null) {
            // Convert the pixel points back to LatLng sw
            var point2 = projection.fromDivPixelToLatLng(blPix);
            if (point2 !== null) bounds.extend(point2);
        }
        return bounds;
    };
    Clusterer.prototype.redraw = function() {
        // Redraws all the clusters.
        this.createClusters(0);
    };
    Clusterer.prototype.resetViewport = function(optHide) {
        // Remove all the clusters
        for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
            var cluster = _a[_i];
            cluster.remove();
        }
        this.clusters = [];
        // Reset the markers to not be added and to be removed from the map.
        for(var _b = 0, _c = this.markers; _b < _c.length; _b++){
            var marker = _c[_b];
            marker.isAdded = false;
            if (optHide) marker.setMap(null);
        }
    };
    Clusterer.prototype.distanceBetweenPoints = function(p1, p2) {
        var R = 6371; // Radius of the Earth in km
        var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
        var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    };
    Clusterer.prototype.isMarkerInBounds = function(marker, bounds) {
        var position = marker.getPosition();
        if (position) return bounds.contains(position);
        return false;
    };
    Clusterer.prototype.addToClosestCluster = function(marker) {
        var cluster;
        var distance = 40000; // Some large number
        var clusterToAddTo = null;
        for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
            var clusterElement = _a[_i];
            cluster = clusterElement;
            var center = cluster.getCenter();
            var position = marker.getPosition();
            if (center && position) {
                var d = this.distanceBetweenPoints(center, position);
                if (d < distance) {
                    distance = d;
                    clusterToAddTo = cluster;
                }
            }
        }
        if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) clusterToAddTo.addMarker(marker);
        else {
            cluster = new $356d0adb4c3ddad5$var$Cluster$1(this);
            cluster.addMarker(marker);
            this.clusters.push(cluster);
        }
    };
    Clusterer.prototype.createClusters = function(iFirst) {
        var _this = this;
        if (!this.ready) return;
        // Cancel previous batch processing if we're working on the first batch:
        if (iFirst === 0) {
            /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */ google.maps.event.trigger(this, 'clusteringbegin', this);
            if (this.timerRefStatic !== null) {
                window.clearTimeout(this.timerRefStatic);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                delete this.timerRefStatic;
            }
        }
        var map = this.getMap();
        var bounds = map !== null && 'getBounds' in map ? map.getBounds() : null;
        var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0;
        // Get our current map view bounds.
        // Create a new bounds object so we don't affect the map.
        //
        // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
        var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
        var extendedMapBounds = this.getExtendedBounds(mapBounds);
        var iLast = Math.min(iFirst + this.batchSize, this.markers.length);
        for(var i = iFirst; i < iLast; i++){
            var marker = this.markers[i];
            if (marker && !marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) this.addToClosestCluster(marker);
        }
        if (iLast < this.markers.length) this.timerRefStatic = window.setTimeout(function() {
            _this.createClusters(iLast);
        }, 0);
        else {
            this.timerRefStatic = null;
            /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */ google.maps.event.trigger(this, 'clusteringend', this);
            for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
                var cluster = _a[_i];
                cluster.updateIcon();
            }
        }
    };
    Clusterer.prototype.extend = function(obj1, obj2) {
        return (function applyExtend(object) {
            for(var property in object.prototype){
                // eslint-disable-next-line @typescript-eslint/ban-types
                var prop = property;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.prototype[prop] = object.prototype[prop];
            }
            return this;
        }).apply(obj1, [
            obj2
        ]);
    };
    return Clusterer;
}();
function $356d0adb4c3ddad5$var$ownKeys$c(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$c(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$c(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$c(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$e = {
    onClick: 'click',
    onClusteringBegin: 'clusteringbegin',
    onClusteringEnd: 'clusteringend',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover'
};
var $356d0adb4c3ddad5$var$updaterMap$e = {
    averageCenter (instance, averageCenter) {
        instance.setAverageCenter(averageCenter);
    },
    batchSizeIE (instance, batchSizeIE) {
        instance.setBatchSizeIE(batchSizeIE);
    },
    calculator (instance, calculator) {
        instance.setCalculator(calculator);
    },
    clusterClass (instance, clusterClass) {
        instance.setClusterClass(clusterClass);
    },
    enableRetinaIcons (instance, enableRetinaIcons) {
        instance.setEnableRetinaIcons(enableRetinaIcons);
    },
    gridSize (instance, gridSize) {
        instance.setGridSize(gridSize);
    },
    ignoreHidden (instance, ignoreHidden) {
        instance.setIgnoreHidden(ignoreHidden);
    },
    imageExtension (instance, imageExtension) {
        instance.setImageExtension(imageExtension);
    },
    imagePath (instance, imagePath) {
        instance.setImagePath(imagePath);
    },
    imageSizes (instance, imageSizes) {
        instance.setImageSizes(imageSizes);
    },
    maxZoom (instance, maxZoom) {
        instance.setMaxZoom(maxZoom);
    },
    minimumClusterSize (instance, minimumClusterSize) {
        instance.setMinimumClusterSize(minimumClusterSize);
    },
    styles (instance, styles) {
        instance.setStyles(styles);
    },
    title (instance, title) {
        instance.setTitle(title);
    },
    zoomOnClick (instance, zoomOnClick) {
        instance.setZoomOnClick(zoomOnClick);
    }
};
var $356d0adb4c3ddad5$var$defaultOptions$4 = {};
function $356d0adb4c3ddad5$var$MarkerClustererFunctional(props) {
    var { children: children, options: options, averageCenter: averageCenter, batchSizeIE: batchSizeIE, calculator: calculator, clusterClass: clusterClass, enableRetinaIcons: enableRetinaIcons, gridSize: gridSize, ignoreHidden: ignoreHidden, imageExtension: imageExtension, imagePath: imagePath, imageSizes: imageSizes, maxZoom: maxZoom, minimumClusterSize: minimumClusterSize, styles: styles, title: title, zoomOnClick: zoomOnClick, onClick: onClick, onClusteringBegin: onClusteringBegin, onClusteringEnd: onClusteringEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onLoad: onLoad, onUnmount: onUnmount } = props;
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [clusteringBeginListener, setClusteringBeginListener] = (0, $6umrQ.useState)(null);
    var [clusteringEndListener, setClusteringEndListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, $356d0adb4c3ddad5$var$eventMap$e.onMouseOut, onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, $356d0adb4c3ddad5$var$eventMap$e.onMouseOver, onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, $356d0adb4c3ddad5$var$eventMap$e.onClick, onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClusteringBegin) {
            if (clusteringBeginListener !== null) google.maps.event.removeListener(clusteringBeginListener);
            setClusteringBeginListener(google.maps.event.addListener(instance, $356d0adb4c3ddad5$var$eventMap$e.onClusteringBegin, onClusteringBegin));
        }
    }, [
        onClusteringBegin
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClusteringEnd) {
            if (clusteringEndListener !== null) google.maps.event.removeListener(clusteringEndListener);
            setClusteringBeginListener(google.maps.event.addListener(instance, $356d0adb4c3ddad5$var$eventMap$e.onClusteringEnd, onClusteringEnd));
        }
    }, [
        onClusteringEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof averageCenter !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.averageCenter(instance, averageCenter);
    }, [
        instance,
        averageCenter
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof batchSizeIE !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.batchSizeIE(instance, batchSizeIE);
    }, [
        instance,
        batchSizeIE
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof calculator !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.calculator(instance, calculator);
    }, [
        instance,
        calculator
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof clusterClass !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.clusterClass(instance, clusterClass);
    }, [
        instance,
        clusterClass
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof enableRetinaIcons !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.enableRetinaIcons(instance, enableRetinaIcons);
    }, [
        instance,
        enableRetinaIcons
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof gridSize !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.gridSize(instance, gridSize);
    }, [
        instance,
        gridSize
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof ignoreHidden !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.ignoreHidden(instance, ignoreHidden);
    }, [
        instance,
        ignoreHidden
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof imageExtension !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.imageExtension(instance, imageExtension);
    }, [
        instance,
        imageExtension
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof imagePath !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.imagePath(instance, imagePath);
    }, [
        instance,
        imagePath
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof imageSizes !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.imageSizes(instance, imageSizes);
    }, [
        instance,
        imageSizes
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof maxZoom !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.maxZoom(instance, maxZoom);
    }, [
        instance,
        maxZoom
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof minimumClusterSize !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.minimumClusterSize(instance, minimumClusterSize);
    }, [
        instance,
        minimumClusterSize
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof styles !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.styles(instance, styles);
    }, [
        instance,
        styles
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof title !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.title(instance, title);
    }, [
        instance,
        title
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof zoomOnClick !== 'undefined' && instance !== null) $356d0adb4c3ddad5$var$updaterMap$e.zoomOnClick(instance, zoomOnClick);
    }, [
        instance,
        zoomOnClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (!map) return;
        var clustererOptions = $356d0adb4c3ddad5$var$_objectSpread$c({}, options || $356d0adb4c3ddad5$var$defaultOptions$4);
        var clusterer = new $356d0adb4c3ddad5$var$Clusterer(map, [], clustererOptions);
        if (averageCenter) $356d0adb4c3ddad5$var$updaterMap$e.averageCenter(clusterer, averageCenter);
        if (batchSizeIE) $356d0adb4c3ddad5$var$updaterMap$e.batchSizeIE(clusterer, batchSizeIE);
        if (calculator) $356d0adb4c3ddad5$var$updaterMap$e.calculator(clusterer, calculator);
        if (clusterClass) $356d0adb4c3ddad5$var$updaterMap$e.clusterClass(clusterer, clusterClass);
        if (enableRetinaIcons) $356d0adb4c3ddad5$var$updaterMap$e.enableRetinaIcons(clusterer, enableRetinaIcons);
        if (gridSize) $356d0adb4c3ddad5$var$updaterMap$e.gridSize(clusterer, gridSize);
        if (ignoreHidden) $356d0adb4c3ddad5$var$updaterMap$e.ignoreHidden(clusterer, ignoreHidden);
        if (imageExtension) $356d0adb4c3ddad5$var$updaterMap$e.imageExtension(clusterer, imageExtension);
        if (imagePath) $356d0adb4c3ddad5$var$updaterMap$e.imagePath(clusterer, imagePath);
        if (imageSizes) $356d0adb4c3ddad5$var$updaterMap$e.imageSizes(clusterer, imageSizes);
        if (maxZoom) $356d0adb4c3ddad5$var$updaterMap$e.maxZoom(clusterer, maxZoom);
        if (minimumClusterSize) $356d0adb4c3ddad5$var$updaterMap$e.minimumClusterSize(clusterer, minimumClusterSize);
        if (styles) $356d0adb4c3ddad5$var$updaterMap$e.styles(clusterer, styles);
        if (title) $356d0adb4c3ddad5$var$updaterMap$e.title(clusterer, title);
        if (zoomOnClick) $356d0adb4c3ddad5$var$updaterMap$e.zoomOnClick(clusterer, zoomOnClick);
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(clusterer, $356d0adb4c3ddad5$var$eventMap$e.onMouseOut, onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(clusterer, $356d0adb4c3ddad5$var$eventMap$e.onMouseOver, onMouseOver));
        if (onClick) setClickListener(google.maps.event.addListener(clusterer, $356d0adb4c3ddad5$var$eventMap$e.onClick, onClick));
        if (onClusteringBegin) setClusteringBeginListener(google.maps.event.addListener(clusterer, $356d0adb4c3ddad5$var$eventMap$e.onClusteringBegin, onClusteringBegin));
        if (onClusteringEnd) setClusteringEndListener(google.maps.event.addListener(clusterer, $356d0adb4c3ddad5$var$eventMap$e.onClusteringEnd, onClusteringEnd));
        setInstance(clusterer);
        if (onLoad) onLoad(clusterer);
        return ()=>{
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (clusteringBeginListener !== null) google.maps.event.removeListener(clusteringBeginListener);
            if (clusteringEndListener !== null) google.maps.event.removeListener(clusteringEndListener);
            if (onUnmount) onUnmount(clusterer);
        };
    }, []);
    return instance !== null ? children(instance) || null : null;
}
var $356d0adb4c3ddad5$export$1b336c0de6a39582 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$MarkerClustererFunctional);
class $356d0adb4c3ddad5$export$58bd9bb9fcf3dd4f extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            markerClusterer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setClustererCallback", ()=>{
            if (this.state.markerClusterer !== null && this.props.onLoad) this.props.onLoad(this.state.markerClusterer);
        });
    }
    componentDidMount() {
        if (this.context) {
            var markerClusterer = new $356d0adb4c3ddad5$var$Clusterer(this.context, [], this.props.options);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$e,
                eventMap: $356d0adb4c3ddad5$var$eventMap$e,
                prevProps: {},
                nextProps: this.props,
                instance: markerClusterer
            });
            this.setState(()=>{
                return {
                    markerClusterer: markerClusterer
                };
            }, this.setClustererCallback);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.state.markerClusterer) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$e,
                eventMap: $356d0adb4c3ddad5$var$eventMap$e,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.markerClusterer
            });
        }
    }
    componentWillUnmount() {
        if (this.state.markerClusterer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.markerClusterer);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.state.markerClusterer.setMap(null);
        }
    }
    render() {
        return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$58bd9bb9fcf3dd4f, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
// This handler prevents an event in the InfoBox from being passed on to the map.
function $356d0adb4c3ddad5$var$cancelHandler(event) {
    event.cancelBubble = true;
    if (event.stopPropagation) event.stopPropagation();
}
var $356d0adb4c3ddad5$var$InfoBox = /** @class */ function() {
    function InfoBox(options) {
        if (options === void 0) options = {};
        this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
        this.closeClickHandler = this.closeClickHandler.bind(this);
        this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
        this.addClickHandler = this.addClickHandler.bind(this);
        this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
        this.getBoxWidths = this.getBoxWidths.bind(this);
        this.setBoxStyle = this.setBoxStyle.bind(this);
        this.setPosition = this.setPosition.bind(this);
        this.getPosition = this.getPosition.bind(this);
        this.setOptions = this.setOptions.bind(this);
        this.setContent = this.setContent.bind(this);
        this.setVisible = this.setVisible.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getVisible = this.getVisible.bind(this);
        this.setZIndex = this.setZIndex.bind(this);
        this.getZIndex = this.getZIndex.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.panBox = this.panBox.bind(this);
        this.extend = this.extend.bind(this);
        this.close = this.close.bind(this);
        this.draw = this.draw.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.open = this.open.bind(this);
        this.extend(InfoBox, google.maps.OverlayView);
        // Standard options (in common with google.maps.InfoWindow):
        this.content = options.content || '';
        this.disableAutoPan = options.disableAutoPan || false;
        this.maxWidth = options.maxWidth || 0;
        this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
        this.position = options.position || new google.maps.LatLng(0, 0);
        this.zIndex = options.zIndex || null;
        // Additional options (unique to InfoBox):
        this.boxClass = options.boxClass || 'infoBox';
        this.boxStyle = options.boxStyle || {};
        this.closeBoxMargin = options.closeBoxMargin || '2px';
        this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';
        if (options.closeBoxURL === '') this.closeBoxURL = '';
        this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);
        if (typeof options.visible === 'undefined') {
            if (typeof options.isHidden === 'undefined') options.visible = true;
            else options.visible = !options.isHidden;
        }
        this.isHidden = !options.visible;
        this.alignBottom = options.alignBottom || false;
        this.pane = options.pane || 'floatPane';
        this.enableEventPropagation = options.enableEventPropagation || false;
        this.div = null;
        this.closeListener = null;
        this.moveListener = null;
        this.mapListener = null;
        this.contextListener = null;
        this.eventListeners = null;
        this.fixedWidthSet = null;
    }
    InfoBox.prototype.createInfoBoxDiv = function() {
        var _this = this;
        // This handler ignores the current event in the InfoBox and conditionally prevents
        // the event from being passed on to the map. It is used for the contextmenu event.
        var ignoreHandler = function ignoreHandler(event) {
            event.returnValue = false;
            if (event.preventDefault) event.preventDefault();
            if (!_this.enableEventPropagation) $356d0adb4c3ddad5$var$cancelHandler(event);
        };
        if (!this.div) {
            this.div = document.createElement('div');
            this.setBoxStyle();
            if (typeof this.content === 'string') this.div.innerHTML = this.getCloseBoxImg() + this.content;
            else {
                this.div.innerHTML = this.getCloseBoxImg();
                this.div.appendChild(this.content);
            }
            var panes = this.getPanes();
            if (panes !== null) panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
            this.addClickHandler();
            if (this.div.style.width) this.fixedWidthSet = true;
            else if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
                this.div.style.width = this.maxWidth + 'px';
                this.fixedWidthSet = true;
            } else {
                // The following code is needed to overcome problems with MSIE
                var bw = this.getBoxWidths();
                this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
                this.fixedWidthSet = false;
            }
            this.panBox(this.disableAutoPan);
            if (!this.enableEventPropagation) {
                this.eventListeners = [];
                // Cancel event propagation.
                // Note: mousemove not included (to resolve Issue 152)
                var events = [
                    'mousedown',
                    'mouseover',
                    'mouseout',
                    'mouseup',
                    'click',
                    'dblclick',
                    'touchstart',
                    'touchend',
                    'touchmove'
                ];
                for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
                    var event_1 = events_1[_i];
                    this.eventListeners.push(google.maps.event.addListener(this.div, event_1, $356d0adb4c3ddad5$var$cancelHandler));
                }
                // Workaround for Google bug that causes the cursor to change to a pointer
                // when the mouse moves over a marker underneath InfoBox.
                this.eventListeners.push(google.maps.event.addListener(this.div, 'mouseover', function() {
                    if (_this.div) _this.div.style.cursor = 'default';
                }));
            }
            this.contextListener = google.maps.event.addListener(this.div, 'contextmenu', ignoreHandler);
            /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */ google.maps.event.trigger(this, 'domready');
        }
    };
    InfoBox.prototype.getCloseBoxImg = function() {
        var img = '';
        if (this.closeBoxURL !== '') {
            img = '<img alt=""';
            img += ' aria-hidden="true"';
            img += " src='" + this.closeBoxURL + "'";
            img += ' align=right'; // Do this because Opera chokes on style='float: right;'
            img += " style='";
            img += ' position: relative;'; // Required by MSIE
            img += ' cursor: pointer;';
            img += ' margin: ' + this.closeBoxMargin + ';';
            img += "'>";
        }
        return img;
    };
    InfoBox.prototype.addClickHandler = function() {
        this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== '' ? google.maps.event.addListener(this.div.firstChild, 'click', this.getCloseClickHandler()) : null;
    };
    InfoBox.prototype.closeClickHandler = function(event) {
        // 1.0.3 fix: Always prevent propagation of a close box click to the map:
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */ google.maps.event.trigger(this, 'closeclick');
        this.close();
    };
    InfoBox.prototype.getCloseClickHandler = function() {
        return this.closeClickHandler;
    };
    InfoBox.prototype.panBox = function(disablePan) {
        if (this.div && !disablePan) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var map = this.getMap();
            // Only pan if attached to map, not panorama
            if (map instanceof google.maps.Map) {
                var xOffset = 0;
                var yOffset = 0;
                var bounds = map.getBounds();
                if (bounds && !bounds.contains(this.position)) // Marker not in visible area of map, so set center
                // of map to the marker position first.
                map.setCenter(this.position);
                var mapDiv = map.getDiv();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var mapWidth = mapDiv.offsetWidth;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var mapHeight = mapDiv.offsetHeight;
                var iwOffsetX = this.pixelOffset.width;
                var iwOffsetY = this.pixelOffset.height;
                var iwWidth = this.div.offsetWidth;
                var iwHeight = this.div.offsetHeight;
                var padX = this.infoBoxClearance.width;
                var padY = this.infoBoxClearance.height;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var projection = this.getProjection();
                var pixPosition = projection.fromLatLngToContainerPixel(this.position);
                if (pixPosition !== null) {
                    if (pixPosition.x < -iwOffsetX + padX) xOffset = pixPosition.x + iwOffsetX - padX;
                    else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
                    if (this.alignBottom) {
                        if (pixPosition.y < -iwOffsetY + padY + iwHeight) yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
                        else if (pixPosition.y + iwOffsetY + padY > mapHeight) yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
                    } else {
                        if (pixPosition.y < -iwOffsetY + padY) yOffset = pixPosition.y + iwOffsetY - padY;
                        else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
                    }
                }
                if (!(xOffset === 0 && yOffset === 0)) // Move the map to the shifted center.
                map.panBy(xOffset, yOffset);
            }
        }
    };
    InfoBox.prototype.setBoxStyle = function() {
        if (this.div) {
            // Apply style values from the style sheet defined in the boxClass parameter:
            this.div.className = this.boxClass;
            // Clear existing inline style values:
            this.div.style.cssText = '';
            // Apply style values defined in the boxStyle parameter:
            var boxStyle = this.boxStyle;
            for(var i in boxStyle)if (Object.prototype.hasOwnProperty.call(boxStyle, i)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.div.style[i] = boxStyle[i];
            // Fix for iOS disappearing InfoBox problem
            // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
            this.div.style.webkitTransform = 'translateZ(0)';
            // Fix up opacity style for benefit of MSIE
            if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
                // See http://www.quirksmode.org/css/opacity.html
                var opacity = parseFloat(this.div.style.opacity || '');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
                this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
            }
            // Apply required styles
            this.div.style.position = 'absolute';
            this.div.style.visibility = 'hidden';
            if (this.zIndex !== null) this.div.style.zIndex = this.zIndex + '';
            if (!this.div.style.overflow) this.div.style.overflow = 'auto';
        }
    };
    InfoBox.prototype.getBoxWidths = function() {
        var bw = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        if (!this.div) return bw;
        if (document.defaultView) {
            var ownerDocument = this.div.ownerDocument;
            var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;
            if (computedStyle) {
                // The computed styles are always in pixel units (good!)
                bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
                bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
                bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
                bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
            }
        } else if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.documentElement.currentStyle // MSIE
        ) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var currentStyle = this.div.currentStyle;
            if (currentStyle) {
                // The current styles may not be in pixel units, but assume they are (bad!)
                bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
                bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
                bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
                bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
            }
        }
        return bw;
    };
    InfoBox.prototype.onRemove = function() {
        if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };
    InfoBox.prototype.draw = function() {
        this.createInfoBoxDiv();
        if (this.div) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var projection = this.getProjection();
            var pixPosition = projection.fromLatLngToDivPixel(this.position);
            if (pixPosition !== null) {
                this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';
                if (this.alignBottom) this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
                else this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
            }
            if (this.isHidden) this.div.style.visibility = 'hidden';
            else this.div.style.visibility = 'visible';
        }
    };
    InfoBox.prototype.setOptions = function(options) {
        if (options === void 0) options = {};
        if (typeof options.boxClass !== 'undefined') {
            // Must be first
            this.boxClass = options.boxClass;
            this.setBoxStyle();
        }
        if (typeof options.boxStyle !== 'undefined') {
            // Must be second
            this.boxStyle = options.boxStyle;
            this.setBoxStyle();
        }
        if (typeof options.content !== 'undefined') this.setContent(options.content);
        if (typeof options.disableAutoPan !== 'undefined') this.disableAutoPan = options.disableAutoPan;
        if (typeof options.maxWidth !== 'undefined') this.maxWidth = options.maxWidth;
        if (typeof options.pixelOffset !== 'undefined') this.pixelOffset = options.pixelOffset;
        if (typeof options.alignBottom !== 'undefined') this.alignBottom = options.alignBottom;
        if (typeof options.position !== 'undefined') this.setPosition(options.position);
        if (typeof options.zIndex !== 'undefined') this.setZIndex(options.zIndex);
        if (typeof options.closeBoxMargin !== 'undefined') this.closeBoxMargin = options.closeBoxMargin;
        if (typeof options.closeBoxURL !== 'undefined') this.closeBoxURL = options.closeBoxURL;
        if (typeof options.infoBoxClearance !== 'undefined') this.infoBoxClearance = options.infoBoxClearance;
        if (typeof options.isHidden !== 'undefined') this.isHidden = options.isHidden;
        if (typeof options.visible !== 'undefined') this.isHidden = !options.visible;
        if (typeof options.enableEventPropagation !== 'undefined') this.enableEventPropagation = options.enableEventPropagation;
        if (this.div) this.draw();
    };
    InfoBox.prototype.setContent = function(content) {
        this.content = content;
        if (this.div) {
            if (this.closeListener) {
                google.maps.event.removeListener(this.closeListener);
                this.closeListener = null;
            }
            // Odd code required to make things work with MSIE.
            if (!this.fixedWidthSet) this.div.style.width = '';
            if (typeof content === 'string') this.div.innerHTML = this.getCloseBoxImg() + content;
            else {
                this.div.innerHTML = this.getCloseBoxImg();
                this.div.appendChild(content);
            }
            // Perverse code required to make things work with MSIE.
            // (Ensures the close box does, in fact, float to the right.)
            if (!this.fixedWidthSet) {
                this.div.style.width = this.div.offsetWidth + 'px';
                if (typeof content === 'string') this.div.innerHTML = this.getCloseBoxImg() + content;
                else {
                    this.div.innerHTML = this.getCloseBoxImg();
                    this.div.appendChild(content);
                }
            }
            this.addClickHandler();
        }
        /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */ google.maps.event.trigger(this, 'content_changed');
    };
    InfoBox.prototype.setPosition = function(latLng) {
        this.position = latLng;
        if (this.div) this.draw();
        /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */ google.maps.event.trigger(this, 'position_changed');
    };
    InfoBox.prototype.setVisible = function(isVisible) {
        this.isHidden = !isVisible;
        if (this.div) this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    };
    InfoBox.prototype.setZIndex = function(index) {
        this.zIndex = index;
        if (this.div) this.div.style.zIndex = index + '';
        /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */ google.maps.event.trigger(this, 'zindex_changed');
    };
    InfoBox.prototype.getContent = function() {
        return this.content;
    };
    InfoBox.prototype.getPosition = function() {
        return this.position;
    };
    InfoBox.prototype.getZIndex = function() {
        return this.zIndex;
    };
    InfoBox.prototype.getVisible = function() {
        var map = this.getMap();
        return typeof map === 'undefined' || map === null ? false : !this.isHidden;
    };
    InfoBox.prototype.show = function() {
        this.isHidden = false;
        if (this.div) this.div.style.visibility = 'visible';
    };
    InfoBox.prototype.hide = function() {
        this.isHidden = true;
        if (this.div) this.div.style.visibility = 'hidden';
    };
    InfoBox.prototype.open = function(map, anchor) {
        var _this = this;
        if (anchor) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.position = anchor.getPosition();
            this.moveListener = google.maps.event.addListener(anchor, 'position_changed', function() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var position = anchor.getPosition();
                _this.setPosition(position);
            });
            this.mapListener = google.maps.event.addListener(anchor, 'map_changed', function() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _this.setMap(anchor.map);
            });
        }
        this.setMap(map);
        if (this.div) this.panBox();
    };
    InfoBox.prototype.close = function() {
        if (this.closeListener) {
            google.maps.event.removeListener(this.closeListener);
            this.closeListener = null;
        }
        if (this.eventListeners) {
            for(var _i = 0, _a = this.eventListeners; _i < _a.length; _i++){
                var eventListener = _a[_i];
                google.maps.event.removeListener(eventListener);
            }
            this.eventListeners = null;
        }
        if (this.moveListener) {
            google.maps.event.removeListener(this.moveListener);
            this.moveListener = null;
        }
        if (this.mapListener) {
            google.maps.event.removeListener(this.mapListener);
            this.mapListener = null;
        }
        if (this.contextListener) {
            google.maps.event.removeListener(this.contextListener);
            this.contextListener = null;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.setMap(null);
    };
    InfoBox.prototype.extend = function(obj1, obj2) {
        return (function applyExtend(object) {
            for(var property in object.prototype)if (!Object.prototype.hasOwnProperty.call(this, property)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.prototype[property] = object.prototype[property];
            return this;
        }).apply(obj1, [
            obj2
        ]);
    };
    return InfoBox;
}();
var $356d0adb4c3ddad5$var$_excluded = [
    "position"
], $356d0adb4c3ddad5$var$_excluded2 = [
    "position"
];
function $356d0adb4c3ddad5$var$ownKeys$b(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$b(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$b(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$b(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$d = {
    onCloseClick: 'closeclick',
    onContentChanged: 'content_changed',
    onDomReady: 'domready',
    onPositionChanged: 'position_changed',
    onZindexChanged: 'zindex_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$d = {
    options (instance, options) {
        instance.setOptions(options);
    },
    position (instance, position) {
        if (position instanceof google.maps.LatLng) instance.setPosition(position);
        else instance.setPosition(new google.maps.LatLng(position.lat, position.lng));
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    },
    zIndex (instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var $356d0adb4c3ddad5$var$defaultOptions$3 = {};
function $356d0adb4c3ddad5$var$InfoBoxFunctional(_ref) {
    var { children: children, anchor: anchor, options: options, position: position, zIndex: zIndex, onCloseClick: onCloseClick, onDomReady: onDomReady, onContentChanged: onContentChanged, onPositionChanged: onPositionChanged, onZindexChanged: onZindexChanged, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [closeClickListener, setCloseClickListener] = (0, $6umrQ.useState)(null);
    var [domReadyClickListener, setDomReadyClickListener] = (0, $6umrQ.useState)(null);
    var [contentChangedClickListener, setContentChangedClickListener] = (0, $6umrQ.useState)(null);
    var [positionChangedClickListener, setPositionChangedClickListener] = (0, $6umrQ.useState)(null);
    var [zIndexChangedClickListener, setZindexChangedClickListener] = (0, $6umrQ.useState)(null);
    var containerElementRef = (0, $6umrQ.useRef)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (map && instance !== null) {
            instance.close();
            if (anchor) instance.open(map, anchor);
            else if (instance.getPosition()) instance.open(map);
        }
    }, [
        map,
        instance,
        anchor
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (position && instance !== null) {
            var positionLatLng = position instanceof google.maps.LatLng ? position : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            new google.maps.LatLng(position.lat, position.lng);
            instance.setPosition(positionLatLng);
        }
    }, [
        position
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof zIndex === 'number' && instance !== null) instance.setZIndex(zIndex);
    }, [
        zIndex
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onCloseClick) {
            if (closeClickListener !== null) google.maps.event.removeListener(closeClickListener);
            setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
        }
    }, [
        onCloseClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDomReady) {
            if (domReadyClickListener !== null) google.maps.event.removeListener(domReadyClickListener);
            setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
        }
    }, [
        onDomReady
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onContentChanged) {
            if (contentChangedClickListener !== null) google.maps.event.removeListener(contentChangedClickListener);
            setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
        }
    }, [
        onContentChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onPositionChanged) {
            if (positionChangedClickListener !== null) google.maps.event.removeListener(positionChangedClickListener);
            setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onZindexChanged) {
            if (zIndexChangedClickListener !== null) google.maps.event.removeListener(zIndexChangedClickListener);
            setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map) {
            var _ref2 = options || $356d0adb4c3ddad5$var$defaultOptions$3, { position: _position } = _ref2, infoBoxOptions = $356d0adb4c3ddad5$var$_objectWithoutProperties(_ref2, $356d0adb4c3ddad5$var$_excluded);
            var positionLatLng;
            if (_position && !(_position instanceof google.maps.LatLng)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            positionLatLng = new google.maps.LatLng(_position.lat, _position.lng);
            var infoBox = new $356d0adb4c3ddad5$var$InfoBox($356d0adb4c3ddad5$var$_objectSpread$b($356d0adb4c3ddad5$var$_objectSpread$b({}, infoBoxOptions), positionLatLng ? {
                position: positionLatLng
            } : {}));
            containerElementRef.current = document.createElement('div');
            setInstance(infoBox);
            if (onCloseClick) setCloseClickListener(google.maps.event.addListener(infoBox, 'closeclick', onCloseClick));
            if (onDomReady) setDomReadyClickListener(google.maps.event.addListener(infoBox, 'domready', onDomReady));
            if (onContentChanged) setContentChangedClickListener(google.maps.event.addListener(infoBox, 'content_changed', onContentChanged));
            if (onPositionChanged) setPositionChangedClickListener(google.maps.event.addListener(infoBox, 'position_changed', onPositionChanged));
            if (onZindexChanged) setZindexChangedClickListener(google.maps.event.addListener(infoBox, 'zindex_changed', onZindexChanged));
            infoBox.setContent(containerElementRef.current);
            if (anchor) infoBox.open(map, anchor);
            else if (infoBox.getPosition()) infoBox.open(map);
            else $356d0adb4c3ddad5$var$invariant(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
            if (onLoad) onLoad(infoBox);
        }
        return ()=>{
            if (instance !== null) {
                if (closeClickListener) google.maps.event.removeListener(closeClickListener);
                if (contentChangedClickListener) google.maps.event.removeListener(contentChangedClickListener);
                if (domReadyClickListener) google.maps.event.removeListener(domReadyClickListener);
                if (positionChangedClickListener) google.maps.event.removeListener(positionChangedClickListener);
                if (zIndexChangedClickListener) google.maps.event.removeListener(zIndexChangedClickListener);
                if (onUnmount) onUnmount(instance);
                instance.close();
            }
        };
    }, []);
    return containerElementRef.current ? (0, $62f595d6588897d8$exports.createPortal)((0, $6umrQ.Children).only(children), containerElementRef.current) : null;
}
var $356d0adb4c3ddad5$export$8dff7512164723fc = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$InfoBoxFunctional);
class $356d0adb4c3ddad5$export$aff4fc93593c3bcf extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "containerElement", null);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            infoBox: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "open", (infoBox, anchor)=>{
            if (anchor) {
                if (this.context !== null) infoBox.open(this.context, anchor);
            } else if (infoBox.getPosition()) {
                if (this.context !== null) infoBox.open(this.context);
            } else $356d0adb4c3ddad5$var$invariant(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setInfoBoxCallback", ()=>{
            if (this.state.infoBox !== null && this.containerElement !== null) {
                this.state.infoBox.setContent(this.containerElement);
                this.open(this.state.infoBox, this.props.anchor);
                if (this.props.onLoad) this.props.onLoad(this.state.infoBox);
            }
        });
    }
    componentDidMount() {
        var _ref3 = this.props.options || {}, { position: position } = _ref3, infoBoxOptions = $356d0adb4c3ddad5$var$_objectWithoutProperties(_ref3, $356d0adb4c3ddad5$var$_excluded2);
        var positionLatLng;
        if (position && !(position instanceof google.maps.LatLng)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(position.lat, position.lng);
        var infoBox = new $356d0adb4c3ddad5$var$InfoBox($356d0adb4c3ddad5$var$_objectSpread$b($356d0adb4c3ddad5$var$_objectSpread$b({}, infoBoxOptions), positionLatLng ? {
            position: positionLatLng
        } : {}));
        this.containerElement = document.createElement('div');
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$d,
            eventMap: $356d0adb4c3ddad5$var$eventMap$d,
            prevProps: {},
            nextProps: this.props,
            instance: infoBox
        });
        this.setState({
            infoBox: infoBox
        }, this.setInfoBoxCallback);
    }
    componentDidUpdate(prevProps) {
        var { infoBox: infoBox } = this.state;
        if (infoBox !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$d,
                eventMap: $356d0adb4c3ddad5$var$eventMap$d,
                prevProps: prevProps,
                nextProps: this.props,
                instance: infoBox
            });
        }
    }
    componentWillUnmount() {
        var { onUnmount: onUnmount } = this.props;
        var { infoBox: infoBox } = this.state;
        if (infoBox !== null) {
            if (onUnmount) onUnmount(infoBox);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            infoBox.close();
        }
    }
    render() {
        return this.containerElement ? (0, $62f595d6588897d8$exports.createPortal)((0, $6umrQ.Children).only(this.props.children), this.containerElement) : null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$aff4fc93593c3bcf, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
var $356d0adb4c3ddad5$var$fastDeepEqual;
var $356d0adb4c3ddad5$var$hasRequiredFastDeepEqual;
function $356d0adb4c3ddad5$var$requireFastDeepEqual() {
    if ($356d0adb4c3ddad5$var$hasRequiredFastDeepEqual) return $356d0adb4c3ddad5$var$fastDeepEqual;
    $356d0adb4c3ddad5$var$hasRequiredFastDeepEqual = 1;
    // do not edit .js files directly - edit src/index.jst
    $356d0adb4c3ddad5$var$fastDeepEqual = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        // true if both NaN, false otherwise
        return a !== a && b !== b;
    };
    return $356d0adb4c3ddad5$var$fastDeepEqual;
}
var $356d0adb4c3ddad5$var$fastDeepEqualExports = $356d0adb4c3ddad5$var$requireFastDeepEqual();
var $356d0adb4c3ddad5$var$equal = /*@__PURE__*/ $356d0adb4c3ddad5$var$getDefaultExportFromCjs$1($356d0adb4c3ddad5$var$fastDeepEqualExports);
var $356d0adb4c3ddad5$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ var $356d0adb4c3ddad5$var$VERSION = 1; // serialized format version
var $356d0adb4c3ddad5$var$HEADER_SIZE = 8;
class $356d0adb4c3ddad5$var$KDBush {
    /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error('Data must be an instance of ArrayBuffer.');
        var [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error('Data does not appear to be in a KDBush format.');
        var version = versionAndType >> 4;
        if (version !== $356d0adb4c3ddad5$var$VERSION) throw new Error("Got v".concat(version, " data when expected v").concat($356d0adb4c3ddad5$var$VERSION, "."));
        var ArrayType = $356d0adb4c3ddad5$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error('Unrecognized array type.');
        var [nodeSize] = new Uint16Array(data, 2, 1);
        var [numItems] = new Uint32Array(data, 4, 1);
        return new $356d0adb4c3ddad5$var$KDBush(numItems, nodeSize, ArrayType, data);
    }
    /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */ constructor(numItems){
        var nodeSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
        var ArrayType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Float64Array;
        var data = arguments.length > 3 ? arguments[3] : undefined;
        if (isNaN(numItems) || numItems < 0) throw new Error("Unpexpected numItems value: ".concat(numItems, "."));
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        var arrayTypeIndex = $356d0adb4c3ddad5$var$ARRAY_TYPES.indexOf(this.ArrayType);
        var coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        var idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        var padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error("Unexpected typed array class: ".concat(ArrayType, "."));
        if (data && data instanceof ArrayBuffer) {
            // reconstruct an index from a buffer
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $356d0adb4c3ddad5$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $356d0adb4c3ddad5$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            // initialize a new index
            this.data = new ArrayBuffer($356d0adb4c3ddad5$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $356d0adb4c3ddad5$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $356d0adb4c3ddad5$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($356d0adb4c3ddad5$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */ add(x, y) {
        var index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
   * Perform indexing of the added points.
   */ finish() {
        var numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error("Added ".concat(numAdded, " items when expected ").concat(this.numItems, "."));
        // kd-sort both arrays for efficient search
        $356d0adb4c3ddad5$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
        var { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        var stack = [
            0,
            ids.length - 1,
            0
        ];
        var result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            var axis = stack.pop() || 0;
            var right = stack.pop() || 0;
            var left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(var i = left; i <= right; i++){
                    var _x = coords[2 * i];
                    var _y = coords[2 * i + 1];
                    if (_x >= minX && _x <= maxX && _y >= minY && _y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            var m = left + right >> 1;
            // include the middle item if it's in range
            var x = coords[2 * m];
            var y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */ within(qx, qy, r) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
        var { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        var stack = [
            0,
            ids.length - 1,
            0
        ];
        var result = [];
        var r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            var axis = stack.pop() || 0;
            var right = stack.pop() || 0;
            var left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(var i = left; i <= right; i++)if ($356d0adb4c3ddad5$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            var m = left + right >> 1;
            // include the middle item if it's in range
            var x = coords[2 * m];
            var y = coords[2 * m + 1];
            if ($356d0adb4c3ddad5$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $356d0adb4c3ddad5$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    var m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $356d0adb4c3ddad5$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $356d0adb4c3ddad5$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $356d0adb4c3ddad5$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $356d0adb4c3ddad5$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $356d0adb4c3ddad5$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        var t = coords[2 * k + axis];
        var i = left;
        var j = right;
        $356d0adb4c3ddad5$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $356d0adb4c3ddad5$var$swapItem(ids, coords, left, right);
        while(i < j){
            $356d0adb4c3ddad5$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $356d0adb4c3ddad5$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $356d0adb4c3ddad5$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $356d0adb4c3ddad5$var$swapItem(ids, coords, i, j) {
    $356d0adb4c3ddad5$var$swap(ids, i, j);
    $356d0adb4c3ddad5$var$swap(coords, 2 * i, 2 * j);
    $356d0adb4c3ddad5$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $356d0adb4c3ddad5$var$swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $356d0adb4c3ddad5$var$sqDist(ax, ay, bx, by) {
    var dx = ax - bx;
    var dy = ay - by;
    return dx * dx + dy * dy;
}
var $356d0adb4c3ddad5$var$defaultOptions$2 = {
    minZoom: 0,
    // min zoom to generate clusters on
    maxZoom: 16,
    // max zoom level to cluster the points on
    minPoints: 2,
    // minimum points to form a cluster
    radius: 40,
    // cluster radius in pixels
    extent: 512,
    // tile extent (radius is calculated relative to it)
    nodeSize: 64,
    // size of the KD-tree leaf node, affects performance
    log: false,
    // whether to log timing info
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // (accumulated, props) => { accumulated.sum += props.sum; }
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
var $356d0adb4c3ddad5$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
var $356d0adb4c3ddad5$var$OFFSET_ZOOM = 2;
var $356d0adb4c3ddad5$var$OFFSET_ID = 3;
var $356d0adb4c3ddad5$var$OFFSET_PARENT = 4;
var $356d0adb4c3ddad5$var$OFFSET_NUM = 5;
var $356d0adb4c3ddad5$var$OFFSET_PROP = 6;
class $356d0adb4c3ddad5$var$Supercluster {
    constructor(options){
        this.options = Object.assign(Object.create($356d0adb4c3ddad5$var$defaultOptions$2), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        var { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time('total time');
        var timerId = "prepare ".concat(points.length, " points");
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        var data = [];
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            if (!p.geometry) continue;
            var [lng, lat] = p.geometry.coordinates;
            var x = $356d0adb4c3ddad5$var$fround($356d0adb4c3ddad5$var$lngX(lng));
            var y = $356d0adb4c3ddad5$var$fround($356d0adb4c3ddad5$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, // projected point coordinates
            Infinity, // the last zoom the point was processed at
            i, // index of the source feature in the original input array
            -1, // parent cluster id
            1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        var tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(var z = maxZoom; z >= minZoom; z--){
            var now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log('z%d: %d clusters in %dms', z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd('total time');
        return this;
    }
    getClusters(bbox, zoom) {
        var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        var minLat = Math.max(-90, Math.min(90, bbox[1]));
        var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        var maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            var easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            var westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        var tree = this.trees[this._limitZoom(zoom)];
        var ids = tree.range($356d0adb4c3ddad5$var$lngX(minLng), $356d0adb4c3ddad5$var$latY(maxLat), $356d0adb4c3ddad5$var$lngX(maxLng), $356d0adb4c3ddad5$var$latY(minLat));
        var data = tree.data;
        var clusters = [];
        for (var id of ids){
            var k = this.stride * id;
            clusters.push(data[k + $356d0adb4c3ddad5$var$OFFSET_NUM] > 1 ? $356d0adb4c3ddad5$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $356d0adb4c3ddad5$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        var originId = this._getOriginId(clusterId);
        var originZoom = this._getOriginZoom(clusterId);
        var errorMsg = 'No cluster with the specified id.';
        var tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        var data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        var x = data[originId * this.stride];
        var y = data[originId * this.stride + 1];
        var ids = tree.within(x, y, r);
        var children = [];
        for (var id of ids){
            var k = id * this.stride;
            if (data[k + $356d0adb4c3ddad5$var$OFFSET_PARENT] === clusterId) children.push(data[k + $356d0adb4c3ddad5$var$OFFSET_NUM] > 1 ? $356d0adb4c3ddad5$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $356d0adb4c3ddad5$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        var leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        var tree = this.trees[this._limitZoom(z)];
        var z2 = Math.pow(2, z);
        var { extent: extent, radius: radius } = this.options;
        var p = radius / extent;
        var top = (y - p) / z2;
        var bottom = (y + 1 + p) / z2;
        var tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        var expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            var children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        var children = this.getChildren(clusterId);
        for (var child of children){
            var props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        var tree = new $356d0adb4c3ddad5$var$KDBush(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(var i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (var i of ids){
            var k = i * this.stride;
            var isCluster = data[k + $356d0adb4c3ddad5$var$OFFSET_NUM] > 1;
            var tags = void 0, px = void 0, py = void 0;
            if (isCluster) {
                tags = $356d0adb4c3ddad5$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                var p = this.points[data[k + $356d0adb4c3ddad5$var$OFFSET_ID]];
                tags = p.properties;
                var [lng, lat] = p.geometry.coordinates;
                px = $356d0adb4c3ddad5$var$lngX(lng);
                py = $356d0adb4c3ddad5$var$latY(lat);
            }
            var f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            var id = void 0;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $356d0adb4c3ddad5$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $356d0adb4c3ddad5$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        var { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        var r = radius / (extent * Math.pow(2, zoom));
        var data = tree.data;
        var nextData = [];
        var stride = this.stride;
        // loop through each point
        for(var i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $356d0adb4c3ddad5$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $356d0adb4c3ddad5$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            var x = data[i];
            var y = data[i + 1];
            var neighborIds = tree.within(data[i], data[i + 1], r);
            var numPointsOrigin = data[i + $356d0adb4c3ddad5$var$OFFSET_NUM];
            var numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (var neighborId of neighborIds){
                var k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $356d0adb4c3ddad5$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $356d0adb4c3ddad5$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                var wx = x * numPointsOrigin;
                var wy = y * numPointsOrigin;
                var clusterProperties = void 0;
                var clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                var id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (var _neighborId of neighborIds){
                    var _k = _neighborId * stride;
                    if (data[_k + $356d0adb4c3ddad5$var$OFFSET_ZOOM] <= zoom) continue;
                    data[_k + $356d0adb4c3ddad5$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    var numPoints2 = data[_k + $356d0adb4c3ddad5$var$OFFSET_NUM];
                    wx += data[_k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[_k + 1] * numPoints2;
                    data[_k + $356d0adb4c3ddad5$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, _k));
                    }
                }
                data[i + $356d0adb4c3ddad5$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                // left points as unclustered
                for(var j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (var _neighborId2 of neighborIds){
                    var _k2 = _neighborId2 * stride;
                    if (data[_k2 + $356d0adb4c3ddad5$var$OFFSET_ZOOM] <= zoom) continue;
                    data[_k2 + $356d0adb4c3ddad5$var$OFFSET_ZOOM] = zoom;
                    for(var _j = 0; _j < stride; _j++)nextData.push(data[_k2 + _j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $356d0adb4c3ddad5$var$OFFSET_NUM] > 1) {
            var props = this.clusterProps[data[i + $356d0adb4c3ddad5$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        var original = this.points[data[i + $356d0adb4c3ddad5$var$OFFSET_ID]].properties;
        var result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $356d0adb4c3ddad5$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: 'Feature',
        id: data[i + $356d0adb4c3ddad5$var$OFFSET_ID],
        properties: $356d0adb4c3ddad5$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: 'Point',
            coordinates: [
                $356d0adb4c3ddad5$var$xLng(data[i]),
                $356d0adb4c3ddad5$var$yLat(data[i + 1])
            ]
        }
    };
}
function $356d0adb4c3ddad5$var$getClusterProperties(data, i, clusterProps) {
    var count = data[i + $356d0adb4c3ddad5$var$OFFSET_NUM];
    var abbrev = count >= 10000 ? "".concat(Math.round(count / 1000), "k") : count >= 1000 ? "".concat(Math.round(count / 100) / 10, "k") : count;
    var propIndex = data[i + $356d0adb4c3ddad5$var$OFFSET_PROP];
    var properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $356d0adb4c3ddad5$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $356d0adb4c3ddad5$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $356d0adb4c3ddad5$var$latY(lat) {
    var sin = Math.sin(lat * Math.PI / 180);
    var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $356d0adb4c3ddad5$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $356d0adb4c3ddad5$var$yLat(y) {
    var y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $356d0adb4c3ddad5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $356d0adb4c3ddad5$var$MarkerUtils {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
       * Always return true for Advanced Markers because the clusterer
       * uses getVisible as a way to count legacy markers not as an actual
       * indicator of visibility for some reason. Even when markers are hidden
       * Marker.getVisible returns `true` and this is used to set the marker count
       * on the cluster. See the behavior of Cluster.count
       */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $356d0adb4c3ddad5$var$Cluster {
    constructor(_ref){
        var { markers: markers, position: position } = _ref;
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        var bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (var marker of this.markers)bounds.extend($356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
   * Get the count of **visible** markers.
   */ get count() {
        return this.markers.filter((m)=>$356d0adb4c3ddad5$var$MarkerUtils.getVisible(m)).length;
    }
    /**
   * Add a marker to the cluster.
   */ push(marker) {
        this.markers.push(marker);
    }
    /**
   * Cleanup references and remove marker from map.
   */ delete() {
        if (this.marker) {
            $356d0adb4c3ddad5$var$MarkerUtils.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ var $356d0adb4c3ddad5$var$filterMarkersToPaddedViewport = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    var extendedMapBounds = $356d0adb4c3ddad5$var$extendBoundsToPaddedViewport(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ var $356d0adb4c3ddad5$var$extendBoundsToPaddedViewport = (bounds, projection, numPixels)=>{
    var { northEast: northEast, southWest: southWest } = $356d0adb4c3ddad5$var$latLngBoundsToPixelBounds(bounds, projection);
    var extendedPixelBounds = $356d0adb4c3ddad5$var$extendPixelBounds({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $356d0adb4c3ddad5$var$pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ var $356d0adb4c3ddad5$var$getPaddedViewport = (bounds, projection, pixels)=>{
    var extended = $356d0adb4c3ddad5$var$extendBoundsToPaddedViewport(bounds, projection, pixels);
    var ne = extended.getNorthEast();
    var sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ var $356d0adb4c3ddad5$var$distanceBetweenPoints = (p1, p2)=>{
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat - p1.lat) * Math.PI / 180;
    var dLon = (p2.lng - p1.lng) * Math.PI / 180;
    var sinDLat = Math.sin(dLat / 2);
    var sinDLon = Math.sin(dLon / 2);
    var a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ var $356d0adb4c3ddad5$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ var $356d0adb4c3ddad5$var$extendPixelBounds = (_ref2, numPixels)=>{
    var { northEast: northEast, southWest: southWest } = _ref2;
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ var $356d0adb4c3ddad5$var$pixelBoundsToLatLngBounds = (_ref3, projection)=>{
    var { northEast: northEast, southWest: southWest } = _ref3;
    var sw = projection.fromDivPixelToLatLng(southWest);
    var ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $356d0adb4c3ddad5$var$AbstractAlgorithm {
    constructor(_ref4){
        var { maxZoom: maxZoom = 16 } = _ref4;
        this.maxZoom = maxZoom;
    }
    /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */ noop(_ref5) {
        var { markers: markers } = _ref5;
        return $356d0adb4c3ddad5$var$noop$1(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $356d0adb4c3ddad5$var$AbstractViewportAlgorithm extends $356d0adb4c3ddad5$var$AbstractAlgorithm {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $356d0adb4c3ddad5$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate(_ref6) {
        var { markers: markers, map: map, mapCanvasProjection: mapCanvasProjection } = _ref6;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $356d0adb4c3ddad5$var$filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ var $356d0adb4c3ddad5$var$noop$1 = (markers)=>{
    var clusters = markers.map((marker)=>new $356d0adb4c3ddad5$var$Cluster({
            position: $356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $356d0adb4c3ddad5$var$GridAlgorithm extends $356d0adb4c3ddad5$var$AbstractViewportAlgorithm {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $356d0adb4c3ddad5$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate(_ref7) {
        var { markers: markers, map: map, mapCanvasProjection: mapCanvasProjection } = _ref7;
        var state = {
            zoom: map.getZoom()
        };
        var changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !$356d0adb4c3ddad5$var$equal(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $356d0adb4c3ddad5$var$filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster(_ref8) {
        var { markers: markers, map: map, mapCanvasProjection: mapCanvasProjection } = _ref8;
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        var maxDistance = this.maxDistance; // Some large number
        var cluster = null;
        for(var i = 0; i < this.clusters.length; i++){
            var candidate = this.clusters[i];
            var distance = $356d0adb4c3ddad5$var$distanceBetweenPoints(candidate.bounds.getCenter().toJSON(), $356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $356d0adb4c3ddad5$var$extendBoundsToPaddedViewport(cluster.bounds, projection, this.gridSize).contains($356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker))) cluster.push(marker);
        else {
            var _cluster = new $356d0adb4c3ddad5$var$Cluster({
                markers: [
                    marker
                ]
            });
            this.clusters.push(_cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $356d0adb4c3ddad5$var$NoopAlgorithm extends $356d0adb4c3ddad5$var$AbstractAlgorithm {
    constructor(_a){
        var options = $356d0adb4c3ddad5$var$__rest(_a, []);
        super(options);
    }
    calculate(_ref9) {
        var { markers: markers, map: map, mapCanvasProjection: mapCanvasProjection } = _ref9;
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $356d0adb4c3ddad5$var$SuperClusterAlgorithm extends $356d0adb4c3ddad5$var$AbstractAlgorithm {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $356d0adb4c3ddad5$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new $356d0adb4c3ddad5$var$Supercluster(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        var changed = false;
        var state = {
            zoom: input.map.getZoom()
        };
        if (!$356d0adb4c3ddad5$var$equal(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            var points = this.markers.map((marker)=>{
                var position = $356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker);
                var coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !$356d0adb4c3ddad5$var$equal(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster(_ref10) {
        var { map: map } = _ref10;
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster(_ref11) {
        var { geometry: { coordinates: [lng, lat] }, properties: properties } = _ref11;
        if (properties.cluster) return new $356d0adb4c3ddad5$var$Cluster({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        var marker = properties.marker;
        return new $356d0adb4c3ddad5$var$Cluster({
            markers: [
                marker
            ],
            position: $356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $356d0adb4c3ddad5$var$SuperClusterViewportAlgorithm extends $356d0adb4c3ddad5$var$AbstractViewportAlgorithm {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $356d0adb4c3ddad5$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.superCluster = new $356d0adb4c3ddad5$var$Supercluster(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        var state = {
            zoom: Math.round(input.map.getZoom()),
            view: $356d0adb4c3ddad5$var$getPaddedViewport(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
        };
        var changed = !$356d0adb4c3ddad5$var$equal(this.state, state);
        if (!$356d0adb4c3ddad5$var$equal(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            var points = this.markers.map((marker)=>{
                var position = $356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker);
                var coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster(_ref12) {
        var { map: map, mapCanvasProjection: mapCanvasProjection } = _ref12;
        /* recalculate new state because we can't use the cached version. */ var state = {
            zoom: Math.round(map.getZoom()),
            view: $356d0adb4c3ddad5$var$getPaddedViewport(map.getBounds(), mapCanvasProjection, this.viewportPadding)
        };
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster(_ref13) {
        var { geometry: { coordinates: [lng, lat] }, properties: properties } = _ref13;
        if (properties.cluster) return new $356d0adb4c3ddad5$var$Cluster({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        var marker = properties.marker;
        return new $356d0adb4c3ddad5$var$Cluster({
            markers: [
                marker
            ],
            position: $356d0adb4c3ddad5$var$MarkerUtils.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $356d0adb4c3ddad5$var$ClusterStats {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        var clusterMarkerCounts = clusters.map((a)=>a.count);
        var clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $356d0adb4c3ddad5$var$DefaultRenderer {
    /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */ render(_ref14, stats, map) {
        var { count: count, position: position } = _ref14;
        // change color if this cluster has more markers than the mean cluster
        var color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        var svg = "<svg fill=\"".concat(color, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\" width=\"50\" height=\"50\">\n<circle cx=\"120\" cy=\"120\" opacity=\".6\" r=\"70\" />\n<circle cx=\"120\" cy=\"120\" opacity=\".3\" r=\"90\" />\n<circle cx=\"120\" cy=\"120\" opacity=\".2\" r=\"110\" />\n<text x=\"50%\" y=\"50%\" style=\"fill:#fff\" text-anchor=\"middle\" font-size=\"50\" dominant-baseline=\"middle\" font-family=\"roboto,arial,sans-serif\">").concat(count, "</text>\n</svg>");
        var title = "Cluster of ".concat(count, " markers"), // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($356d0adb4c3ddad5$var$MarkerUtils.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            var parser = new DOMParser();
            var svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            var _clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(_clusterOptions);
        }
        var clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: "data:image/svg+xml;base64,".concat(btoa(svg)),
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $356d0adb4c3ddad5$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(var property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $356d0adb4c3ddad5$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $356d0adb4c3ddad5$var$extend($356d0adb4c3ddad5$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $356d0adb4c3ddad5$var$MarkerClustererEvents;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($356d0adb4c3ddad5$var$MarkerClustererEvents || ($356d0adb4c3ddad5$var$MarkerClustererEvents = {}));
var $356d0adb4c3ddad5$var$defaultOnClusterClickHandler = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $356d0adb4c3ddad5$var$MarkerClusterer extends $356d0adb4c3ddad5$var$OverlayViewSafe {
    constructor(_ref15){
        var { map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $356d0adb4c3ddad5$var$SuperClusterAlgorithm(algorithmOptions), renderer: renderer = new $356d0adb4c3ddad5$var$DefaultRenderer(), onClusterClick: onClusterClick = $356d0adb4c3ddad5$var$defaultOnClusterClickHandler } = _ref15;
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        var index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $356d0adb4c3ddad5$var$MarkerUtils.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        var removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
   * Recalculates and draws all the marker clusters.
   */ render() {
        var map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $356d0adb4c3ddad5$var$MarkerClustererEvents.CLUSTERING_BEGIN, this);
            var { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                var singleMarker = new Set();
                for (var cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                var groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (var _cluster2 of this.clusters){
                    if (_cluster2.marker == null) continue;
                    if (_cluster2.markers.length == 1) {
                        if (!singleMarker.has(_cluster2.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $356d0adb4c3ddad5$var$MarkerUtils.setMap(_cluster2.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(_cluster2.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$356d0adb4c3ddad5$var$MarkerUtils.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $356d0adb4c3ddad5$var$MarkerClustererEvents.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$356d0adb4c3ddad5$var$MarkerUtils.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        var stats = new $356d0adb4c3ddad5$var$ClusterStats(this.markers, this.clusters);
        var map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$356d0adb4c3ddad5$var$MarkerUtils.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $356d0adb4c3ddad5$var$MarkerClustererEvents.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $356d0adb4c3ddad5$var$MarkerUtils.setMap(cluster.marker, map);
        });
    }
}
var $356d0adb4c3ddad5$export$90b7fe3c3beeef75 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractAlgorithm: $356d0adb4c3ddad5$var$AbstractAlgorithm,
    AbstractViewportAlgorithm: $356d0adb4c3ddad5$var$AbstractViewportAlgorithm,
    Cluster: $356d0adb4c3ddad5$var$Cluster,
    ClusterStats: $356d0adb4c3ddad5$var$ClusterStats,
    DefaultRenderer: $356d0adb4c3ddad5$var$DefaultRenderer,
    GridAlgorithm: $356d0adb4c3ddad5$var$GridAlgorithm,
    MarkerClusterer: $356d0adb4c3ddad5$var$MarkerClusterer,
    get MarkerClustererEvents () {
        return $356d0adb4c3ddad5$var$MarkerClustererEvents;
    },
    MarkerUtils: $356d0adb4c3ddad5$var$MarkerUtils,
    NoopAlgorithm: $356d0adb4c3ddad5$var$NoopAlgorithm,
    SuperClusterAlgorithm: $356d0adb4c3ddad5$var$SuperClusterAlgorithm,
    SuperClusterViewportAlgorithm: $356d0adb4c3ddad5$var$SuperClusterViewportAlgorithm,
    defaultOnClusterClickHandler: $356d0adb4c3ddad5$var$defaultOnClusterClickHandler,
    distanceBetweenPoints: $356d0adb4c3ddad5$var$distanceBetweenPoints,
    extendBoundsToPaddedViewport: $356d0adb4c3ddad5$var$extendBoundsToPaddedViewport,
    extendPixelBounds: $356d0adb4c3ddad5$var$extendPixelBounds,
    filterMarkersToPaddedViewport: $356d0adb4c3ddad5$var$filterMarkersToPaddedViewport,
    getPaddedViewport: $356d0adb4c3ddad5$var$getPaddedViewport,
    noop: $356d0adb4c3ddad5$var$noop$1,
    pixelBoundsToLatLngBounds: $356d0adb4c3ddad5$var$pixelBoundsToLatLngBounds
});
function $356d0adb4c3ddad5$var$ownKeys$a(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$a(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$a(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$a(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $356d0adb4c3ddad5$var$useGoogleMarkerClusterer(options) {
    var map = $356d0adb4c3ddad5$export$7105827ad5b8fcc3();
    var [markerClusterer, setMarkerClusterer] = (0, $6umrQ.useState)(null);
    (0, $6umrQ.useEffect)(()=>{
        if (map && markerClusterer === null) {
            var markerCluster = new $356d0adb4c3ddad5$var$MarkerClusterer($356d0adb4c3ddad5$var$_objectSpread$a($356d0adb4c3ddad5$var$_objectSpread$a({}, options), {}, {
                map: map
            }));
            setMarkerClusterer(markerCluster);
        }
    }, [
        map
    ]);
    return markerClusterer;
}
/** Wrapper around [@googlemaps/markerclusterer](https://github.com/googlemaps/js-markerclusterer)
 *
 * Accepts {@link  MarkerClustererOptionsSubset} which is a subset of  {@link MarkerClustererOptions}
 */ function $356d0adb4c3ddad5$var$GoogleMarkerClusterer(_ref) {
    var { children: children, options: options } = _ref;
    var markerClusterer = $356d0adb4c3ddad5$var$useGoogleMarkerClusterer(options);
    return markerClusterer !== null ? children(markerClusterer) : null;
}
var $356d0adb4c3ddad5$export$b2907449e9900b04 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$GoogleMarkerClusterer);
var $356d0adb4c3ddad5$var$eventMap$c = {
    onCloseClick: 'closeclick',
    onContentChanged: 'content_changed',
    onDomReady: 'domready',
    onPositionChanged: 'position_changed',
    onZindexChanged: 'zindex_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$c = {
    options (instance, options) {
        instance.setOptions(options);
    },
    position (instance, position) {
        instance.setPosition(position);
    },
    zIndex (instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
function $356d0adb4c3ddad5$var$InfoWindowFunctional(_ref) {
    var { children: children, anchor: anchor, options: options, position: position, zIndex: zIndex, onCloseClick: onCloseClick, onDomReady: onDomReady, onContentChanged: onContentChanged, onPositionChanged: onPositionChanged, onZindexChanged: onZindexChanged, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [closeclickListener, setCloseClickListener] = (0, $6umrQ.useState)(null);
    var [domreadyclickListener, setDomReadyClickListener] = (0, $6umrQ.useState)(null);
    var [contentchangedclickListener, setContentChangedClickListener] = (0, $6umrQ.useState)(null);
    var [positionchangedclickListener, setPositionChangedClickListener] = (0, $6umrQ.useState)(null);
    var [zindexchangedclickListener, setZindexChangedClickListener] = (0, $6umrQ.useState)(null);
    var containerElementRef = (0, $6umrQ.useRef)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) {
            instance.close();
            if (anchor) instance.open(map, anchor);
            else if (instance.getPosition()) instance.open(map);
        }
    }, [
        map,
        instance,
        anchor
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (position && instance !== null) instance.setPosition(position);
    }, [
        position
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof zIndex === 'number' && instance !== null) instance.setZIndex(zIndex);
    }, [
        zIndex
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onCloseClick) {
            if (closeclickListener !== null) google.maps.event.removeListener(closeclickListener);
            setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
        }
    }, [
        onCloseClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDomReady) {
            if (domreadyclickListener !== null) google.maps.event.removeListener(domreadyclickListener);
            setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
        }
    }, [
        onDomReady
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onContentChanged) {
            if (contentchangedclickListener !== null) google.maps.event.removeListener(contentchangedclickListener);
            setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
        }
    }, [
        onContentChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onPositionChanged) {
            if (positionchangedclickListener !== null) google.maps.event.removeListener(positionchangedclickListener);
            setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onZindexChanged) {
            if (zindexchangedclickListener !== null) google.maps.event.removeListener(zindexchangedclickListener);
            setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var infoWindow = new google.maps.InfoWindow(options);
        setInstance(infoWindow);
        containerElementRef.current = document.createElement('div');
        if (onCloseClick) setCloseClickListener(google.maps.event.addListener(infoWindow, 'closeclick', onCloseClick));
        if (onDomReady) setDomReadyClickListener(google.maps.event.addListener(infoWindow, 'domready', onDomReady));
        if (onContentChanged) setContentChangedClickListener(google.maps.event.addListener(infoWindow, 'content_changed', onContentChanged));
        if (onPositionChanged) setPositionChangedClickListener(google.maps.event.addListener(infoWindow, 'position_changed', onPositionChanged));
        if (onZindexChanged) setZindexChangedClickListener(google.maps.event.addListener(infoWindow, 'zindex_changed', onZindexChanged));
        infoWindow.setContent(containerElementRef.current);
        if (position) infoWindow.setPosition(position);
        if (zIndex) infoWindow.setZIndex(zIndex);
        if (anchor) infoWindow.open(map, anchor);
        else if (infoWindow.getPosition()) infoWindow.open(map);
        else $356d0adb4c3ddad5$var$invariant(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
        if (onLoad) onLoad(infoWindow);
        return ()=>{
            if (closeclickListener) google.maps.event.removeListener(closeclickListener);
            if (contentchangedclickListener) google.maps.event.removeListener(contentchangedclickListener);
            if (domreadyclickListener) google.maps.event.removeListener(domreadyclickListener);
            if (positionchangedclickListener) google.maps.event.removeListener(positionchangedclickListener);
            if (zindexchangedclickListener) google.maps.event.removeListener(zindexchangedclickListener);
            if (onUnmount) onUnmount(infoWindow);
            infoWindow.close();
        };
    }, []);
    return containerElementRef.current ? (0, $62f595d6588897d8$exports.createPortal)((0, $6umrQ.Children).only(children), containerElementRef.current) : null;
}
var $356d0adb4c3ddad5$export$b5b16f04c833e5f8 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$InfoWindowFunctional);
class $356d0adb4c3ddad5$export$6cfec3928ae8881a extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "containerElement", null);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            infoWindow: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "open", (infoWindow, anchor)=>{
            if (anchor) infoWindow.open(this.context, anchor);
            else if (infoWindow.getPosition()) infoWindow.open(this.context);
            else $356d0adb4c3ddad5$var$invariant(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setInfoWindowCallback", ()=>{
            if (this.state.infoWindow !== null && this.containerElement !== null) {
                this.state.infoWindow.setContent(this.containerElement);
                this.open(this.state.infoWindow, this.props.anchor);
                if (this.props.onLoad) this.props.onLoad(this.state.infoWindow);
            }
        });
    }
    componentDidMount() {
        var infoWindow = new google.maps.InfoWindow(this.props.options);
        this.containerElement = document.createElement('div');
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$c,
            eventMap: $356d0adb4c3ddad5$var$eventMap$c,
            prevProps: {},
            nextProps: this.props,
            instance: infoWindow
        });
        this.setState(()=>{
            return {
                infoWindow: infoWindow
            };
        }, this.setInfoWindowCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.infoWindow !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$c,
                eventMap: $356d0adb4c3ddad5$var$eventMap$c,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.infoWindow
            });
        }
    }
    componentWillUnmount() {
        if (this.state.infoWindow !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            if (this.props.onUnmount) this.props.onUnmount(this.state.infoWindow);
            this.state.infoWindow.close();
        }
    }
    render() {
        return this.containerElement ? (0, $62f595d6588897d8$exports.createPortal)((0, $6umrQ.Children).only(this.props.children), this.containerElement) : null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$6cfec3928ae8881a, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$9(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$9(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$9(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$9(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$b = {
    onClick: 'click',
    onDblClick: 'dblclick',
    onDrag: 'drag',
    onDragEnd: 'dragend',
    onDragStart: 'dragstart',
    onMouseDown: 'mousedown',
    onMouseMove: 'mousemove',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseUp: 'mouseup',
    onRightClick: 'rightclick'
};
var $356d0adb4c3ddad5$var$updaterMap$b = {
    draggable (instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable (instance, editable) {
        instance.setEditable(editable);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    path (instance, path) {
        instance.setPath(path);
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    }
};
var $356d0adb4c3ddad5$var$defaultOptions$1 = {};
function $356d0adb4c3ddad5$var$PolylineFunctional(_ref) {
    var { options: options, draggable: draggable, editable: editable, visible: visible, path: path, onDblClick: onDblClick, onDragEnd: onDragEnd, onDragStart: onDragStart, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseUp: onMouseUp, onRightClick: onRightClick, onClick: onClick, onDrag: onDrag, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [dragendListener, setDragendListener] = (0, $6umrQ.useState)(null);
    var [dragstartListener, setDragstartListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mousemoveListener, setMousemoveListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightclickListener, setRightclickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [dragListener, setDragListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof options !== 'undefined' && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof draggable !== 'undefined' && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof editable !== 'undefined' && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof visible !== 'undefined' && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof path !== 'undefined' && instance !== null) instance.setPath(path);
    }, [
        instance,
        path
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var polyline = new google.maps.Polyline($356d0adb4c3ddad5$var$_objectSpread$9($356d0adb4c3ddad5$var$_objectSpread$9({}, options || $356d0adb4c3ddad5$var$defaultOptions$1), {}, {
            map: map
        }));
        if (path) polyline.setPath(path);
        if (typeof visible !== 'undefined') polyline.setVisible(visible);
        if (typeof editable !== 'undefined') polyline.setEditable(editable);
        if (typeof draggable !== 'undefined') polyline.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(polyline, 'dblclick', onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(polyline, 'dragend', onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(polyline, 'dragstart', onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(polyline, 'mousedown', onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(polyline, 'mousemove', onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(polyline, 'mouseout', onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(polyline, 'mouseover', onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(polyline, 'mouseup', onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(polyline, 'rightclick', onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(polyline, 'click', onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(polyline, 'drag', onDrag));
        setInstance(polyline);
        if (onLoad) onLoad(polyline);
        return ()=>{
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (onUnmount) onUnmount(polyline);
            polyline.setMap(null);
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$39fd54d61530677a = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$PolylineFunctional);
class $356d0adb4c3ddad5$export$79f3ee03e63e7073 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            polyline: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setPolylineCallback", ()=>{
            if (this.state.polyline !== null && this.props.onLoad) this.props.onLoad(this.state.polyline);
        });
    }
    componentDidMount() {
        var polyline = new google.maps.Polyline($356d0adb4c3ddad5$var$_objectSpread$9($356d0adb4c3ddad5$var$_objectSpread$9({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$b,
            eventMap: $356d0adb4c3ddad5$var$eventMap$b,
            prevProps: {},
            nextProps: this.props,
            instance: polyline
        });
        this.setState(function setPolyline() {
            return {
                polyline: polyline
            };
        }, this.setPolylineCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.polyline !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$b,
                eventMap: $356d0adb4c3ddad5$var$eventMap$b,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.polyline
            });
        }
    }
    componentWillUnmount() {
        if (this.state.polyline === null) return;
        if (this.props.onUnmount) this.props.onUnmount(this.state.polyline);
        $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
        this.state.polyline.setMap(null);
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$79f3ee03e63e7073, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$8(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$8(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$8(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$8(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$a = {
    onClick: 'click',
    onDblClick: 'dblclick',
    onDrag: 'drag',
    onDragEnd: 'dragend',
    onDragStart: 'dragstart',
    onMouseDown: 'mousedown',
    onMouseMove: 'mousemove',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseUp: 'mouseup',
    onRightClick: 'rightclick'
};
var $356d0adb4c3ddad5$var$updaterMap$a = {
    draggable (instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable (instance, editable) {
        instance.setEditable(editable);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    path (instance, path) {
        instance.setPath(path);
    },
    paths (instance, paths) {
        instance.setPaths(paths);
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    }
};
function $356d0adb4c3ddad5$var$PolygonFunctional(_ref) {
    var { options: options, draggable: draggable, editable: editable, visible: visible, path: path, paths: paths, onDblClick: onDblClick, onDragEnd: onDragEnd, onDragStart: onDragStart, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseUp: onMouseUp, onRightClick: onRightClick, onClick: onClick, onDrag: onDrag, onLoad: onLoad, onUnmount: onUnmount, onEdit: onEdit } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [dragendListener, setDragendListener] = (0, $6umrQ.useState)(null);
    var [dragstartListener, setDragstartListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mousemoveListener, setMousemoveListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightclickListener, setRightclickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [dragListener, setDragListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof options !== 'undefined' && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof draggable !== 'undefined' && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof editable !== 'undefined' && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof visible !== 'undefined' && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof path !== 'undefined' && instance !== null) instance.setPath(path);
    }, [
        instance,
        path
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof paths !== 'undefined' && instance !== null) instance.setPaths(paths);
    }, [
        instance,
        paths
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onDblClick === 'function') {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (!instance) return;
        google.maps.event.addListener(instance.getPath(), 'insert_at', ()=>{
            onEdit === null || onEdit === void 0 || onEdit(instance);
        });
        google.maps.event.addListener(instance.getPath(), 'set_at', ()=>{
            onEdit === null || onEdit === void 0 || onEdit(instance);
        });
        google.maps.event.addListener(instance.getPath(), 'remove_at', ()=>{
            onEdit === null || onEdit === void 0 || onEdit(instance);
        });
    }, [
        instance,
        onEdit
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onDragEnd === 'function') {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onDragStart === 'function') {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onMouseDown === 'function') {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onMouseMove === 'function') {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onMouseOut === 'function') {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onMouseOver === 'function') {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onMouseUp === 'function') {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onRightClick === 'function') {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onClick === 'function') {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && typeof onDrag === 'function') {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var polygon = new google.maps.Polygon($356d0adb4c3ddad5$var$_objectSpread$8($356d0adb4c3ddad5$var$_objectSpread$8({}, options), {}, {
            map: map
        }));
        if (path) polygon.setPath(path);
        if (paths) polygon.setPaths(paths);
        if (typeof visible !== 'undefined') polygon.setVisible(visible);
        if (typeof editable !== 'undefined') polygon.setEditable(editable);
        if (typeof draggable !== 'undefined') polygon.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(polygon, 'dblclick', onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(polygon, 'dragend', onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(polygon, 'dragstart', onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(polygon, 'mousedown', onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(polygon, 'mousemove', onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(polygon, 'mouseout', onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(polygon, 'mouseover', onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(polygon, 'mouseup', onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(polygon, 'rightclick', onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(polygon, 'click', onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(polygon, 'drag', onDrag));
        setInstance(polygon);
        if (onLoad) onLoad(polygon);
        return ()=>{
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (onUnmount) onUnmount(polygon);
            polygon.setMap(null);
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$ab86017aa51932cd = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$PolygonFunctional);
class $356d0adb4c3ddad5$export$7d31b617c820d435 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
    }
    componentDidMount() {
        var polygonOptions = this.props.options || {};
        this.polygon = new google.maps.Polygon(polygonOptions);
        this.polygon.setMap(this.context);
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$a,
            eventMap: $356d0adb4c3ddad5$var$eventMap$a,
            prevProps: {},
            nextProps: this.props,
            instance: this.polygon
        });
        if (this.props.onLoad) this.props.onLoad(this.polygon);
    }
    componentDidUpdate(prevProps) {
        if (this.polygon) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$a,
                eventMap: $356d0adb4c3ddad5$var$eventMap$a,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.polygon
            });
        }
    }
    componentWillUnmount() {
        if (this.polygon) {
            if (this.props.onUnmount) this.props.onUnmount(this.polygon);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            if (this.polygon) this.polygon.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$7d31b617c820d435, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$7(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$7(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$7(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$7(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$9 = {
    onBoundsChanged: 'bounds_changed',
    onClick: 'click',
    onDblClick: 'dblclick',
    onDrag: 'drag',
    onDragEnd: 'dragend',
    onDragStart: 'dragstart',
    onMouseDown: 'mousedown',
    onMouseMove: 'mousemove',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseUp: 'mouseup',
    onRightClick: 'rightclick'
};
var $356d0adb4c3ddad5$var$updaterMap$9 = {
    bounds (instance, bounds) {
        instance.setBounds(bounds);
    },
    draggable (instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable (instance, editable) {
        instance.setEditable(editable);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    }
};
function $356d0adb4c3ddad5$var$RectangleFunctional(_ref) {
    var { options: options, bounds: bounds, draggable: draggable, editable: editable, visible: visible, onDblClick: onDblClick, onDragEnd: onDragEnd, onDragStart: onDragStart, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseUp: onMouseUp, onRightClick: onRightClick, onClick: onClick, onDrag: onDrag, onBoundsChanged: onBoundsChanged, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [dragendListener, setDragendListener] = (0, $6umrQ.useState)(null);
    var [dragstartListener, setDragstartListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mousemoveListener, setMousemoveListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightClickListener, setRightClickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [dragListener, setDragListener] = (0, $6umrQ.useState)(null);
    var [boundsChangedListener, setBoundsChangedListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof options !== 'undefined' && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof draggable !== 'undefined' && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof editable !== 'undefined' && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof visible !== 'undefined' && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof bounds !== 'undefined' && instance !== null) instance.setBounds(bounds);
    }, [
        instance,
        bounds
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRightClick) {
            if (rightClickListener !== null) google.maps.event.removeListener(rightClickListener);
            setRightClickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onBoundsChanged) {
            if (boundsChangedListener !== null) google.maps.event.removeListener(boundsChangedListener);
            setBoundsChangedListener(google.maps.event.addListener(instance, 'bounds_changed', onBoundsChanged));
        }
    }, [
        onBoundsChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var rectangle = new google.maps.Rectangle($356d0adb4c3ddad5$var$_objectSpread$7($356d0adb4c3ddad5$var$_objectSpread$7({}, options), {}, {
            map: map
        }));
        if (typeof visible !== 'undefined') rectangle.setVisible(visible);
        if (typeof editable !== 'undefined') rectangle.setEditable(editable);
        if (typeof draggable !== 'undefined') rectangle.setDraggable(draggable);
        if (typeof bounds !== 'undefined') rectangle.setBounds(bounds);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(rectangle, 'dblclick', onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(rectangle, 'dragend', onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(rectangle, 'dragstart', onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(rectangle, 'mousedown', onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(rectangle, 'mousemove', onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(rectangle, 'mouseout', onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(rectangle, 'mouseover', onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(rectangle, 'mouseup', onMouseUp));
        if (onRightClick) setRightClickListener(google.maps.event.addListener(rectangle, 'rightclick', onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(rectangle, 'click', onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(rectangle, 'drag', onDrag));
        if (onBoundsChanged) setBoundsChangedListener(google.maps.event.addListener(rectangle, 'bounds_changed', onBoundsChanged));
        setInstance(rectangle);
        if (onLoad) onLoad(rectangle);
        return ()=>{
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightClickListener !== null) google.maps.event.removeListener(rightClickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            if (boundsChangedListener !== null) google.maps.event.removeListener(boundsChangedListener);
            if (onUnmount) onUnmount(rectangle);
            rectangle.setMap(null);
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$6543fe32ba958b02 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$RectangleFunctional);
class $356d0adb4c3ddad5$export$4617fb02663045ef extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            rectangle: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setRectangleCallback", ()=>{
            if (this.state.rectangle !== null && this.props.onLoad) this.props.onLoad(this.state.rectangle);
        });
    }
    componentDidMount() {
        var rectangle = new google.maps.Rectangle($356d0adb4c3ddad5$var$_objectSpread$7($356d0adb4c3ddad5$var$_objectSpread$7({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$9,
            eventMap: $356d0adb4c3ddad5$var$eventMap$9,
            prevProps: {},
            nextProps: this.props,
            instance: rectangle
        });
        this.setState(function setRectangle() {
            return {
                rectangle: rectangle
            };
        }, this.setRectangleCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.rectangle !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$9,
                eventMap: $356d0adb4c3ddad5$var$eventMap$9,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.rectangle
            });
        }
    }
    componentWillUnmount() {
        if (this.state.rectangle !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.rectangle);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.state.rectangle.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$4617fb02663045ef, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$6(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$6(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$6(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$6(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$8 = {
    onCenterChanged: 'center_changed',
    onRadiusChanged: 'radius_changed',
    onClick: 'click',
    onDblClick: 'dblclick',
    onDrag: 'drag',
    onDragEnd: 'dragend',
    onDragStart: 'dragstart',
    onMouseDown: 'mousedown',
    onMouseMove: 'mousemove',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseUp: 'mouseup',
    onRightClick: 'rightclick'
};
var $356d0adb4c3ddad5$var$updaterMap$8 = {
    center (instance, center) {
        instance.setCenter(center);
    },
    draggable (instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable (instance, editable) {
        instance.setEditable(editable);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    radius (instance, radius) {
        instance.setRadius(radius);
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    }
};
var $356d0adb4c3ddad5$var$defaultOptions = {};
function $356d0adb4c3ddad5$var$CircleFunctional(_ref) {
    var { options: options, center: center, radius: radius, draggable: draggable, editable: editable, visible: visible, onDblClick: onDblClick, onDragEnd: onDragEnd, onDragStart: onDragStart, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseUp: onMouseUp, onRightClick: onRightClick, onClick: onClick, onDrag: onDrag, onCenterChanged: onCenterChanged, onRadiusChanged: onRadiusChanged, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [dragendListener, setDragendListener] = (0, $6umrQ.useState)(null);
    var [dragstartListener, setDragstartListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mousemoveListener, setMousemoveListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightclickListener, setRightclickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [dragListener, setDragListener] = (0, $6umrQ.useState)(null);
    var [centerChangedListener, setCenterChangedListener] = (0, $6umrQ.useState)(null);
    var [radiusChangedListener, setRadiusChangedListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof options !== 'undefined' && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof draggable !== 'undefined' && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof editable !== 'undefined' && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof visible !== 'undefined' && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof radius === 'number' && instance !== null) instance.setRadius(radius);
    }, [
        instance,
        radius
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof center !== 'undefined' && instance !== null) instance.setCenter(center);
    }, [
        instance,
        center
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
        }
    }, [
        onDrag
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onCenterChanged) {
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            setCenterChangedListener(google.maps.event.addListener(instance, 'center_changed', onCenterChanged));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRadiusChanged) {
            if (radiusChangedListener !== null) google.maps.event.removeListener(radiusChangedListener);
            setRadiusChangedListener(google.maps.event.addListener(instance, 'radius_changed', onRadiusChanged));
        }
    }, [
        onRadiusChanged
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var circle = new google.maps.Circle($356d0adb4c3ddad5$var$_objectSpread$6($356d0adb4c3ddad5$var$_objectSpread$6({}, options || $356d0adb4c3ddad5$var$defaultOptions), {}, {
            map: map
        }));
        if (typeof radius === 'number') circle.setRadius(radius);
        if (typeof center !== 'undefined') circle.setCenter(center);
        if (typeof radius === 'number') circle.setRadius(radius);
        if (typeof visible !== 'undefined') circle.setVisible(visible);
        if (typeof editable !== 'undefined') circle.setEditable(editable);
        if (typeof draggable !== 'undefined') circle.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(circle, 'dblclick', onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(circle, 'dragend', onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(circle, 'dragstart', onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(circle, 'mousedown', onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(circle, 'mousemove', onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(circle, 'mouseout', onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(circle, 'mouseover', onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(circle, 'mouseup', onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(circle, 'rightclick', onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(circle, 'click', onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(circle, 'drag', onDrag));
        if (onCenterChanged) setCenterChangedListener(google.maps.event.addListener(circle, 'center_changed', onCenterChanged));
        if (onRadiusChanged) setRadiusChangedListener(google.maps.event.addListener(circle, 'radius_changed', onRadiusChanged));
        setInstance(circle);
        if (onLoad) onLoad(circle);
        return ()=>{
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            if (radiusChangedListener !== null) google.maps.event.removeListener(radiusChangedListener);
            if (onUnmount) onUnmount(circle);
            circle.setMap(null);
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$c8e49fafd1a7f80 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$CircleFunctional);
class $356d0adb4c3ddad5$export$c89a927ffc67e6fa extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            circle: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setCircleCallback", ()=>{
            if (this.state.circle !== null && this.props.onLoad) this.props.onLoad(this.state.circle);
        });
    }
    componentDidMount() {
        var circle = new google.maps.Circle($356d0adb4c3ddad5$var$_objectSpread$6($356d0adb4c3ddad5$var$_objectSpread$6({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$8,
            eventMap: $356d0adb4c3ddad5$var$eventMap$8,
            prevProps: {},
            nextProps: this.props,
            instance: circle
        });
        this.setState(function setCircle() {
            return {
                circle: circle
            };
        }, this.setCircleCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.circle !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$8,
                eventMap: $356d0adb4c3ddad5$var$eventMap$8,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.circle
            });
        }
    }
    componentWillUnmount() {
        if (this.state.circle !== null) {
            var _this$state$circle;
            if (this.props.onUnmount) this.props.onUnmount(this.state.circle);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            (_this$state$circle = this.state.circle) === null || _this$state$circle === void 0 || _this$state$circle.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$c89a927ffc67e6fa, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$7 = {
    onClick: 'click',
    onDblClick: 'dblclick',
    onMouseDown: 'mousedown',
    onMouseOut: 'mouseout',
    onMouseOver: 'mouseover',
    onMouseUp: 'mouseup',
    onRightClick: 'rightclick',
    onAddFeature: 'addfeature',
    onRemoveFeature: 'removefeature',
    onRemoveProperty: 'removeproperty',
    onSetGeometry: 'setgeometry',
    onSetProperty: 'setproperty'
};
var $356d0adb4c3ddad5$var$updaterMap$7 = {
    add (instance, feature) {
        instance.add(feature);
    },
    addgeojson (instance, geojson, options) {
        instance.addGeoJson(geojson, options);
    },
    contains (instance, feature) {
        instance.contains(feature);
    },
    foreach (instance, callback) {
        instance.forEach(callback);
    },
    loadgeojson (instance, url, options, callback) {
        instance.loadGeoJson(url, options, callback);
    },
    overridestyle (instance, feature, style) {
        instance.overrideStyle(feature, style);
    },
    remove (instance, feature) {
        instance.remove(feature);
    },
    revertstyle (instance, feature) {
        instance.revertStyle(feature);
    },
    controlposition (instance, controlPosition) {
        instance.setControlPosition(controlPosition);
    },
    controls (instance, controls) {
        instance.setControls(controls);
    },
    drawingmode (instance, mode) {
        instance.setDrawingMode(mode);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    style (instance, style) {
        instance.setStyle(style);
    },
    togeojson (instance, callback) {
        instance.toGeoJson(callback);
    }
};
function $356d0adb4c3ddad5$var$DataFunctional(_ref) {
    var { options: options, onClick: onClick, onDblClick: onDblClick, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, onMouseUp: onMouseUp, onRightClick: onRightClick, onAddFeature: onAddFeature, onRemoveFeature: onRemoveFeature, onRemoveProperty: onRemoveProperty, onSetGeometry: onSetGeometry, onSetProperty: onSetProperty, onLoad: onLoad, onUnmount: onUnmount } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    var [dblclickListener, setDblclickListener] = (0, $6umrQ.useState)(null);
    var [mousedownListener, setMousedownListener] = (0, $6umrQ.useState)(null);
    var [mousemoveListener, setMousemoveListener] = (0, $6umrQ.useState)(null);
    var [mouseoutListener, setMouseoutListener] = (0, $6umrQ.useState)(null);
    var [mouseoverListener, setMouseoverListener] = (0, $6umrQ.useState)(null);
    var [mouseupListener, setMouseupListener] = (0, $6umrQ.useState)(null);
    var [rightclickListener, setRightclickListener] = (0, $6umrQ.useState)(null);
    var [clickListener, setClickListener] = (0, $6umrQ.useState)(null);
    var [addFeatureListener, setAddFeatureListener] = (0, $6umrQ.useState)(null);
    var [removeFeatureListener, setRemoveFeatureListener] = (0, $6umrQ.useState)(null);
    var [removePropertyListener, setRemovePropertyListener] = (0, $6umrQ.useState)(null);
    var [setGeometryListener, setSetGeometryListener] = (0, $6umrQ.useState)(null);
    var [setPropertyListener, setSetPropertyListener] = (0, $6umrQ.useState)(null);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, 'click', onClick));
        }
    }, [
        onClick
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onAddFeature) {
            if (addFeatureListener !== null) google.maps.event.removeListener(addFeatureListener);
            setAddFeatureListener(google.maps.event.addListener(instance, 'addfeature', onAddFeature));
        }
    }, [
        onAddFeature
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRemoveFeature) {
            if (removeFeatureListener !== null) google.maps.event.removeListener(removeFeatureListener);
            setRemoveFeatureListener(google.maps.event.addListener(instance, 'removefeature', onRemoveFeature));
        }
    }, [
        onRemoveFeature
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onRemoveProperty) {
            if (removePropertyListener !== null) google.maps.event.removeListener(removePropertyListener);
            setRemovePropertyListener(google.maps.event.addListener(instance, 'removeproperty', onRemoveProperty));
        }
    }, [
        onRemoveProperty
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onSetGeometry) {
            if (setGeometryListener !== null) google.maps.event.removeListener(setGeometryListener);
            setSetGeometryListener(google.maps.event.addListener(instance, 'setgeometry', onSetGeometry));
        }
    }, [
        onSetGeometry
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (instance && onSetProperty) {
            if (setPropertyListener !== null) google.maps.event.removeListener(setPropertyListener);
            setSetPropertyListener(google.maps.event.addListener(instance, 'setproperty', onSetProperty));
        }
    }, [
        onSetProperty
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (map !== null) {
            var data = new google.maps.Data($356d0adb4c3ddad5$var$_objectSpread$5($356d0adb4c3ddad5$var$_objectSpread$5({}, options), {}, {
                map: map
            }));
            if (onDblClick) setDblclickListener(google.maps.event.addListener(data, 'dblclick', onDblClick));
            if (onMouseDown) setMousedownListener(google.maps.event.addListener(data, 'mousedown', onMouseDown));
            if (onMouseMove) setMousemoveListener(google.maps.event.addListener(data, 'mousemove', onMouseMove));
            if (onMouseOut) setMouseoutListener(google.maps.event.addListener(data, 'mouseout', onMouseOut));
            if (onMouseOver) setMouseoverListener(google.maps.event.addListener(data, 'mouseover', onMouseOver));
            if (onMouseUp) setMouseupListener(google.maps.event.addListener(data, 'mouseup', onMouseUp));
            if (onRightClick) setRightclickListener(google.maps.event.addListener(data, 'rightclick', onRightClick));
            if (onClick) setClickListener(google.maps.event.addListener(data, 'click', onClick));
            if (onAddFeature) setAddFeatureListener(google.maps.event.addListener(data, 'addfeature', onAddFeature));
            if (onRemoveFeature) setRemoveFeatureListener(google.maps.event.addListener(data, 'removefeature', onRemoveFeature));
            if (onRemoveProperty) setRemovePropertyListener(google.maps.event.addListener(data, 'removeproperty', onRemoveProperty));
            if (onSetGeometry) setSetGeometryListener(google.maps.event.addListener(data, 'setgeometry', onSetGeometry));
            if (onSetProperty) setSetPropertyListener(google.maps.event.addListener(data, 'setproperty', onSetProperty));
            setInstance(data);
            if (onLoad) onLoad(data);
        }
        return ()=>{
            if (instance) {
                if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
                if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
                if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
                if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
                if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
                if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
                if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
                if (clickListener !== null) google.maps.event.removeListener(clickListener);
                if (addFeatureListener !== null) google.maps.event.removeListener(addFeatureListener);
                if (removeFeatureListener !== null) google.maps.event.removeListener(removeFeatureListener);
                if (removePropertyListener !== null) google.maps.event.removeListener(removePropertyListener);
                if (setGeometryListener !== null) google.maps.event.removeListener(setGeometryListener);
                if (setPropertyListener !== null) google.maps.event.removeListener(setPropertyListener);
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$a64a4c3cdb71ef1b = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$DataFunctional);
class $356d0adb4c3ddad5$export$2d0294657ab35f1b extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            data: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setDataCallback", ()=>{
            if (this.state.data !== null && this.props.onLoad) this.props.onLoad(this.state.data);
        });
    }
    componentDidMount() {
        if (this.context !== null) {
            var data = new google.maps.Data($356d0adb4c3ddad5$var$_objectSpread$5($356d0adb4c3ddad5$var$_objectSpread$5({}, this.props.options), {}, {
                map: this.context
            }));
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$7,
                eventMap: $356d0adb4c3ddad5$var$eventMap$7,
                prevProps: {},
                nextProps: this.props,
                instance: data
            });
            this.setState(()=>{
                return {
                    data: data
                };
            }, this.setDataCallback);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.state.data !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$7,
                eventMap: $356d0adb4c3ddad5$var$eventMap$7,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.data
            });
        }
    }
    componentWillUnmount() {
        if (this.state.data !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.data);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            if (this.state.data) this.state.data.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$2d0294657ab35f1b, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$6 = {
    onClick: 'click',
    onDefaultViewportChanged: 'defaultviewport_changed',
    onStatusChanged: 'status_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$6 = {
    options (instance, options) {
        instance.setOptions(options);
    },
    url (instance, url) {
        instance.setUrl(url);
    },
    zIndex (instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
class $356d0adb4c3ddad5$export$f2e9f12fb9a3be55 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            kmlLayer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setKmlLayerCallback", ()=>{
            if (this.state.kmlLayer !== null && this.props.onLoad) this.props.onLoad(this.state.kmlLayer);
        });
    }
    componentDidMount() {
        var kmlLayer = new google.maps.KmlLayer($356d0adb4c3ddad5$var$_objectSpread$4($356d0adb4c3ddad5$var$_objectSpread$4({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$6,
            eventMap: $356d0adb4c3ddad5$var$eventMap$6,
            prevProps: {},
            nextProps: this.props,
            instance: kmlLayer
        });
        this.setState(function setLmlLayer() {
            return {
                kmlLayer: kmlLayer
            };
        }, this.setKmlLayerCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.kmlLayer !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$6,
                eventMap: $356d0adb4c3ddad5$var$eventMap$6,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.kmlLayer
            });
        }
    }
    componentWillUnmount() {
        if (this.state.kmlLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.kmlLayer);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.state.kmlLayer.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$f2e9f12fb9a3be55, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$getOffsetOverride(containerElement, getPixelPositionOffset) {
    return typeof getPixelPositionOffset === 'function' ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
        x: 0,
        y: 0
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $356d0adb4c3ddad5$var$createLatLng(inst, Type) {
    return new Type(inst.lat, inst.lng);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $356d0adb4c3ddad5$var$createLatLngBounds(inst, Type) {
    return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $356d0adb4c3ddad5$var$ensureOfType(inst, // eslint-disable-next-line @typescript-eslint/no-explicit-any
type, // eslint-disable-next-line @typescript-eslint/no-explicit-any
factory) {
    return inst instanceof type ? inst : factory(inst, type);
}
function $356d0adb4c3ddad5$var$ensureOfTypeBounds(inst, // eslint-disable-next-line @typescript-eslint/no-explicit-any
type, // eslint-disable-next-line @typescript-eslint/no-explicit-any
factory) {
    return inst instanceof type ? inst : factory(inst, type);
}
function $356d0adb4c3ddad5$var$getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
    var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
    var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
    if (ne && sw) return {
        left: "".concat(sw.x + offset.x, "px"),
        top: "".concat(ne.y + offset.y, "px"),
        width: "".concat(ne.x - sw.x - offset.x, "px"),
        height: "".concat(sw.y - ne.y - offset.y, "px")
    };
    return {
        left: '-9999px',
        top: '-9999px'
    };
}
function $356d0adb4c3ddad5$var$getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
    var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);
    if (point) {
        var { x: x, y: y } = point;
        return {
            left: "".concat(x + offset.x, "px"),
            top: "".concat(y + offset.y, "px")
        };
    }
    return {
        left: '-9999px',
        top: '-9999px'
    };
}
function $356d0adb4c3ddad5$var$getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
    return bounds !== undefined ? $356d0adb4c3ddad5$var$getLayoutStylesByBounds(mapCanvasProjection, offset, $356d0adb4c3ddad5$var$ensureOfTypeBounds(bounds, google.maps.LatLngBounds, $356d0adb4c3ddad5$var$createLatLngBounds)) : $356d0adb4c3ddad5$var$getLayoutStylesByPosition(mapCanvasProjection, offset, $356d0adb4c3ddad5$var$ensureOfType(position, google.maps.LatLng, $356d0adb4c3ddad5$var$createLatLng));
}
function $356d0adb4c3ddad5$var$arePositionsEqual(currentPosition, previousPosition) {
    return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}
function $356d0adb4c3ddad5$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $356d0adb4c3ddad5$var$createOverlay(container, pane, position, bounds, getPixelPositionOffset) {
    class Overlay extends google.maps.OverlayView {
        constructor(container, pane, position, bounds){
            super();
            this.container = container;
            this.pane = pane;
            this.position = position;
            this.bounds = bounds;
        }
        onAdd() {
            var _this$getPanes;
            var pane = (_this$getPanes = this.getPanes()) === null || _this$getPanes === void 0 ? void 0 : _this$getPanes[this.pane];
            pane === null || pane === void 0 || pane.appendChild(this.container);
        }
        draw() {
            var projection = this.getProjection();
            var offset = $356d0adb4c3ddad5$var$_objectSpread$3({}, this.container ? $356d0adb4c3ddad5$var$getOffsetOverride(this.container, getPixelPositionOffset) : {
                x: 0,
                y: 0
            });
            var layoutStyles = $356d0adb4c3ddad5$var$getLayoutStyles(projection, offset, this.bounds, this.position);
            for (var [key, value] of Object.entries(layoutStyles))// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.container.style[key] = value;
        }
        onRemove() {
            if (this.container.parentNode !== null) this.container.parentNode.removeChild(this.container);
        }
    }
    return new Overlay(container, pane, position, bounds);
}
function $356d0adb4c3ddad5$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $356d0adb4c3ddad5$var$convertToLatLngString(latLngLike) {
    if (!latLngLike) return '';
    var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
    return latLng + '';
}
function $356d0adb4c3ddad5$var$convertToLatLngBoundsString(latLngBoundsLike) {
    if (!latLngBoundsLike) return '';
    var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
    return latLngBounds + '';
}
var $356d0adb4c3ddad5$export$e24d4b04fda79a06 = "floatPane";
var $356d0adb4c3ddad5$export$2eeba3db6f2d26f5 = "mapPane";
var $356d0adb4c3ddad5$export$5f067e8efbd514b9 = "markerLayer";
var $356d0adb4c3ddad5$export$b71d3f620ff59862 = "overlayLayer";
var $356d0adb4c3ddad5$export$3f528380a071486d = "overlayMouseTarget";
function $356d0adb4c3ddad5$var$OverlayViewFunctional(_ref) {
    var { position: position, bounds: bounds, mapPaneName: mapPaneName, zIndex: zIndex, onLoad: onLoad, onUnmount: onUnmount, getPixelPositionOffset: getPixelPositionOffset, children: children } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var container = (0, $6umrQ.useMemo)(()=>{
        var div = document.createElement('div');
        div.style.position = 'absolute';
        return div;
    }, []);
    var overlay = (0, $6umrQ.useMemo)(()=>{
        return $356d0adb4c3ddad5$var$createOverlay(container, mapPaneName, position, bounds, getPixelPositionOffset);
    }, [
        container,
        mapPaneName,
        position,
        bounds
    ]);
    (0, $6umrQ.useEffect)(()=>{
        onLoad === null || onLoad === void 0 || onLoad(overlay);
        overlay === null || overlay === void 0 || overlay.setMap(map);
        return ()=>{
            onUnmount === null || onUnmount === void 0 || onUnmount(overlay);
            overlay === null || overlay === void 0 || overlay.setMap(null);
        };
    }, [
        map,
        overlay
    ]);
    // to move the container to the foreground and background
    (0, $6umrQ.useEffect)(()=>{
        container.style.zIndex = "".concat(zIndex);
    }, [
        zIndex,
        container
    ]);
    return $62f595d6588897d8$exports.createPortal(children, container);
}
var $356d0adb4c3ddad5$export$6554248ab85c957d = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$OverlayViewFunctional);
class $356d0adb4c3ddad5$export$89acdd91182d6c5d extends (0, $6umrQ.PureComponent) {
    constructor(props){
        super(props);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            paneEl: null,
            containerStyle: {
                // set initial position
                position: 'absolute'
            }
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "updatePane", ()=>{
            var mapPaneName = this.props.mapPaneName;
            // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
            var mapPanes = this.overlayView.getPanes();
            $356d0adb4c3ddad5$var$invariant(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);
            if (mapPanes) this.setState({
                paneEl: mapPanes[mapPaneName]
            });
            else this.setState({
                paneEl: null
            });
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "onAdd", ()=>{
            var _this$props$onLoad, _this$props;
            this.updatePane();
            (_this$props$onLoad = (_this$props = this.props).onLoad) === null || _this$props$onLoad === void 0 || _this$props$onLoad.call(_this$props, this.overlayView);
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "onPositionElement", ()=>{
            var mapCanvasProjection = this.overlayView.getProjection();
            var offset = $356d0adb4c3ddad5$var$_objectSpread$2({
                x: 0,
                y: 0
            }, this.containerRef.current ? $356d0adb4c3ddad5$var$getOffsetOverride(this.containerRef.current, this.props.getPixelPositionOffset) : {});
            var layoutStyles = $356d0adb4c3ddad5$var$getLayoutStyles(mapCanvasProjection, offset, this.props.bounds, this.props.position);
            if (!$356d0adb4c3ddad5$var$arePositionsEqual(layoutStyles, {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                left: this.state.containerStyle.left,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                top: this.state.containerStyle.top,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                width: this.state.containerStyle.width,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                height: this.state.containerStyle.height
            })) {
                var _layoutStyles$top, _layoutStyles$left, _layoutStyles$width, _layoutStyles$height;
                this.setState({
                    containerStyle: {
                        top: (_layoutStyles$top = layoutStyles.top) !== null && _layoutStyles$top !== void 0 ? _layoutStyles$top : 0,
                        left: (_layoutStyles$left = layoutStyles.left) !== null && _layoutStyles$left !== void 0 ? _layoutStyles$left : 0,
                        width: (_layoutStyles$width = layoutStyles.width) !== null && _layoutStyles$width !== void 0 ? _layoutStyles$width : 0,
                        height: (_layoutStyles$height = layoutStyles.height) !== null && _layoutStyles$height !== void 0 ? _layoutStyles$height : 0,
                        position: 'absolute'
                    }
                });
            }
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "draw", ()=>{
            this.onPositionElement();
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "onRemove", ()=>{
            var _this$props$onUnmount, _this$props2;
            this.setState(()=>({
                    paneEl: null
                }));
            (_this$props$onUnmount = (_this$props2 = this.props).onUnmount) === null || _this$props$onUnmount === void 0 || _this$props$onUnmount.call(_this$props2, this.overlayView);
        });
        this.containerRef = (0, $6umrQ.createRef)();
        // You must implement three methods: onAdd(), draw(), and onRemove().
        var overlayView = new google.maps.OverlayView();
        overlayView.onAdd = this.onAdd;
        overlayView.draw = this.draw;
        overlayView.onRemove = this.onRemove;
        this.overlayView = overlayView;
    }
    componentDidMount() {
        this.overlayView.setMap(this.context);
    }
    componentDidUpdate(prevProps) {
        var prevPositionString = $356d0adb4c3ddad5$var$convertToLatLngString(prevProps.position);
        var positionString = $356d0adb4c3ddad5$var$convertToLatLngString(this.props.position);
        var prevBoundsString = $356d0adb4c3ddad5$var$convertToLatLngBoundsString(prevProps.bounds);
        var boundsString = $356d0adb4c3ddad5$var$convertToLatLngBoundsString(this.props.bounds);
        if (prevPositionString !== positionString || prevBoundsString !== boundsString) this.overlayView.draw();
        if (prevProps.mapPaneName !== this.props.mapPaneName) this.updatePane();
    }
    componentWillUnmount() {
        this.overlayView.setMap(null);
    }
    render() {
        var paneEl = this.state.paneEl;
        if (paneEl) return $62f595d6588897d8$exports.createPortal((0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            ref: this.containerRef,
            style: this.state.containerStyle,
            children: (0, $6umrQ.Children).only(this.props.children)
        }), paneEl);
        else return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$89acdd91182d6c5d, "FLOAT_PANE", "floatPane");
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$89acdd91182d6c5d, "MAP_PANE", "mapPane");
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$89acdd91182d6c5d, "MARKER_LAYER", "markerLayer");
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$89acdd91182d6c5d, "OVERLAY_LAYER", "overlayLayer");
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$89acdd91182d6c5d, "OVERLAY_MOUSE_TARGET", "overlayMouseTarget");
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$89acdd91182d6c5d, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$noop() {
    return;
}
function $356d0adb4c3ddad5$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$5 = {
    onDblClick: 'dblclick',
    onClick: 'click'
};
var $356d0adb4c3ddad5$var$updaterMap$5 = {
    opacity (instance, opacity) {
        instance.setOpacity(opacity);
    }
};
function $356d0adb4c3ddad5$var$GroundOverlayFunctional(_ref) {
    var { url: url, bounds: bounds, options: options, visible: visible } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var imageBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
    var groundOverlay = (0, $6umrQ.useMemo)(()=>{
        return new google.maps.GroundOverlay(url, imageBounds, options);
    }, []);
    (0, $6umrQ.useEffect)(()=>{
        if (groundOverlay !== null) groundOverlay.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof url !== 'undefined' && groundOverlay !== null) {
            groundOverlay.set('url', url);
            groundOverlay.setMap(map);
        }
    }, [
        groundOverlay,
        url
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (typeof visible !== 'undefined' && groundOverlay !== null) groundOverlay.setOpacity(visible ? 1 : 0);
    }, [
        groundOverlay,
        visible
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var newBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
        if (typeof bounds !== 'undefined' && groundOverlay !== null) {
            groundOverlay.set('bounds', newBounds);
            groundOverlay.setMap(map);
        }
    }, [
        groundOverlay,
        bounds
    ]);
    return null;
}
var $356d0adb4c3ddad5$export$146cd687ea7c5077 = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$GroundOverlayFunctional);
class $356d0adb4c3ddad5$export$a5034750997c6854 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            groundOverlay: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setGroundOverlayCallback", ()=>{
            if (this.state.groundOverlay !== null && this.props.onLoad) this.props.onLoad(this.state.groundOverlay);
        });
    }
    componentDidMount() {
        $356d0adb4c3ddad5$var$invariant(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
        var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, $356d0adb4c3ddad5$var$_objectSpread$1($356d0adb4c3ddad5$var$_objectSpread$1({}, this.props.options), {}, {
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$5,
            eventMap: $356d0adb4c3ddad5$var$eventMap$5,
            prevProps: {},
            nextProps: this.props,
            instance: groundOverlay
        });
        this.setState(function setGroundOverlay() {
            return {
                groundOverlay: groundOverlay
            };
        }, this.setGroundOverlayCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.groundOverlay !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$5,
                eventMap: $356d0adb4c3ddad5$var$eventMap$5,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.groundOverlay
            });
        }
    }
    componentWillUnmount() {
        if (this.state.groundOverlay) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.groundOverlay);
            this.state.groundOverlay.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$a5034750997c6854, "defaultProps", {
    onLoad: $356d0adb4c3ddad5$var$noop
});
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$a5034750997c6854, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
function $356d0adb4c3ddad5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356d0adb4c3ddad5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356d0adb4c3ddad5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $356d0adb4c3ddad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356d0adb4c3ddad5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356d0adb4c3ddad5$var$eventMap$4 = {};
var $356d0adb4c3ddad5$var$updaterMap$4 = {
    data (instance, data) {
        instance.setData(data);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    options (instance, options) {
        instance.setOptions(options);
    }
};
function $356d0adb4c3ddad5$var$HeatmapLayerFunctional(_ref) {
    var { data: data, onLoad: onLoad, onUnmount: onUnmount, options: options } = _ref;
    var map = (0, $6umrQ.useContext)($356d0adb4c3ddad5$export$dc7344301ae78f85);
    var [instance, setInstance] = (0, $6umrQ.useState)(null);
    (0, $6umrQ.useEffect)(()=>{
        if (!google.maps.visualization) $356d0adb4c3ddad5$var$invariant(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} in useJsApiScript? %s', google.maps.visualization);
    }, []);
    (0, $6umrQ.useEffect)(()=>{
        $356d0adb4c3ddad5$var$invariant(!!data, 'data property is required in HeatmapLayer %s', data);
    }, [
        data
    ]);
    // Order does matter
    (0, $6umrQ.useEffect)(()=>{
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, $6umrQ.useEffect)(()=>{
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, $6umrQ.useEffect)(()=>{
        var heatmapLayer = new google.maps.visualization.HeatmapLayer($356d0adb4c3ddad5$var$_objectSpread($356d0adb4c3ddad5$var$_objectSpread({}, options), {}, {
            data: data,
            map: map
        }));
        setInstance(heatmapLayer);
        if (onLoad) onLoad(heatmapLayer);
        return ()=>{
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var $356d0adb4c3ddad5$export$efb69a92d03e2aab = (0, $6umrQ.memo)($356d0adb4c3ddad5$var$HeatmapLayerFunctional);
class $356d0adb4c3ddad5$export$56278b847e4d6e63 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            heatmapLayer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setHeatmapLayerCallback", ()=>{
            if (this.state.heatmapLayer !== null && this.props.onLoad) this.props.onLoad(this.state.heatmapLayer);
        });
    }
    componentDidMount() {
        $356d0adb4c3ddad5$var$invariant(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
        $356d0adb4c3ddad5$var$invariant(!!this.props.data, 'data property is required in HeatmapLayer %s', this.props.data);
        var heatmapLayer = new google.maps.visualization.HeatmapLayer($356d0adb4c3ddad5$var$_objectSpread($356d0adb4c3ddad5$var$_objectSpread({}, this.props.options), {}, {
            data: this.props.data,
            map: this.context
        }));
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$4,
            eventMap: $356d0adb4c3ddad5$var$eventMap$4,
            prevProps: {},
            nextProps: this.props,
            instance: heatmapLayer
        });
        this.setState(function setHeatmapLayer() {
            return {
                heatmapLayer: heatmapLayer
            };
        }, this.setHeatmapLayerCallback);
    }
    componentDidUpdate(prevProps) {
        $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$4,
            eventMap: $356d0adb4c3ddad5$var$eventMap$4,
            prevProps: prevProps,
            nextProps: this.props,
            instance: this.state.heatmapLayer
        });
    }
    componentWillUnmount() {
        if (this.state.heatmapLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.heatmapLayer);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.state.heatmapLayer.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$56278b847e4d6e63, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
var $356d0adb4c3ddad5$var$eventMap$3 = {
    onCloseClick: 'closeclick',
    onPanoChanged: 'pano_changed',
    onPositionChanged: 'position_changed',
    onPovChanged: 'pov_changed',
    onResize: 'resize',
    onStatusChanged: 'status_changed',
    onVisibleChanged: 'visible_changed',
    onZoomChanged: 'zoom_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$3 = {
    register (instance, provider, options) {
        instance.registerPanoProvider(provider, options);
    },
    links (instance, links) {
        instance.setLinks(links);
    },
    motionTracking (instance, motionTracking) {
        instance.setMotionTracking(motionTracking);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    pano (instance, pano) {
        instance.setPano(pano);
    },
    position (instance, position) {
        instance.setPosition(position);
    },
    pov (instance, pov) {
        instance.setPov(pov);
    },
    visible (instance, visible) {
        instance.setVisible(visible);
    },
    zoom (instance, zoom) {
        instance.setZoom(zoom);
    }
};
class $356d0adb4c3ddad5$export$6835431164726c61 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            streetViewPanorama: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setStreetViewPanoramaCallback", ()=>{
            if (this.state.streetViewPanorama !== null && this.props.onLoad) this.props.onLoad(this.state.streetViewPanorama);
        });
    }
    componentDidMount() {
        var _this$context$getStre, _this$context;
        var streetViewPanorama = (_this$context$getStre = (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.getStreetView()) !== null && _this$context$getStre !== void 0 ? _this$context$getStre : null;
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$3,
            eventMap: $356d0adb4c3ddad5$var$eventMap$3,
            prevProps: {},
            nextProps: this.props,
            instance: streetViewPanorama
        });
        this.setState(()=>{
            return {
                streetViewPanorama: streetViewPanorama
            };
        }, this.setStreetViewPanoramaCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.streetViewPanorama !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$3,
                eventMap: $356d0adb4c3ddad5$var$eventMap$3,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.streetViewPanorama
            });
        }
    }
    componentWillUnmount() {
        if (this.state.streetViewPanorama !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.streetViewPanorama);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.state.streetViewPanorama.setVisible(false);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$6835431164726c61, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
class $356d0adb4c3ddad5$export$533fe900f738f6ac extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            streetViewService: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setStreetViewServiceCallback", ()=>{
            if (this.state.streetViewService !== null && this.props.onLoad) this.props.onLoad(this.state.streetViewService);
        });
    }
    componentDidMount() {
        var streetViewService = new google.maps.StreetViewService();
        this.setState(function setStreetViewService() {
            return {
                streetViewService: streetViewService
            };
        }, this.setStreetViewServiceCallback);
    }
    componentWillUnmount() {
        if (this.state.streetViewService !== null && this.props.onUnmount) this.props.onUnmount(this.state.streetViewService);
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$533fe900f738f6ac, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
class $356d0adb4c3ddad5$export$fc221c4ee84dbd5e extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            directionsService: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setDirectionsServiceCallback", ()=>{
            if (this.state.directionsService !== null && this.props.onLoad) this.props.onLoad(this.state.directionsService);
        });
    }
    componentDidMount() {
        $356d0adb4c3ddad5$var$invariant(!!this.props.options, 'DirectionsService expected options object as parameter, but got %s', this.props.options);
        var directionsService = new google.maps.DirectionsService();
        this.setState(function setDirectionsService() {
            return {
                directionsService: directionsService
            };
        }, this.setDirectionsServiceCallback);
    }
    componentDidUpdate() {
        if (this.state.directionsService !== null) this.state.directionsService.route(this.props.options, this.props.callback);
    }
    componentWillUnmount() {
        if (this.state.directionsService !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.directionsService);
        }
    }
    render() {
        return null;
    }
}
var $356d0adb4c3ddad5$var$eventMap$2 = {
    onDirectionsChanged: 'directions_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$2 = {
    directions (instance, directions) {
        instance.setDirections(directions);
    },
    map (instance, map) {
        instance.setMap(map);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    panel (instance, panel) {
        instance.setPanel(panel);
    },
    routeIndex (instance, routeIndex) {
        instance.setRouteIndex(routeIndex);
    }
};
class $356d0adb4c3ddad5$export$7fd3518d0a0bb86a extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            directionsRenderer: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setDirectionsRendererCallback", ()=>{
            if (this.state.directionsRenderer !== null) {
                this.state.directionsRenderer.setMap(this.context);
                if (this.props.onLoad) this.props.onLoad(this.state.directionsRenderer);
            }
        });
    }
    componentDidMount() {
        var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap$2,
            eventMap: $356d0adb4c3ddad5$var$eventMap$2,
            prevProps: {},
            nextProps: this.props,
            instance: directionsRenderer
        });
        this.setState(function setDirectionsRenderer() {
            return {
                directionsRenderer: directionsRenderer
            };
        }, this.setDirectionsRendererCallback);
    }
    componentDidUpdate(prevProps) {
        if (this.state.directionsRenderer !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$2,
                eventMap: $356d0adb4c3ddad5$var$eventMap$2,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.directionsRenderer
            });
        }
    }
    componentWillUnmount() {
        if (this.state.directionsRenderer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.directionsRenderer);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            if (this.state.directionsRenderer) this.state.directionsRenderer.setMap(null);
        }
    }
    render() {
        return null;
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$7fd3518d0a0bb86a, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
class $356d0adb4c3ddad5$export$4ddc3e9182efd9a8 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            distanceMatrixService: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setDistanceMatrixServiceCallback", ()=>{
            if (this.state.distanceMatrixService !== null && this.props.onLoad) this.props.onLoad(this.state.distanceMatrixService);
        });
    }
    componentDidMount() {
        $356d0adb4c3ddad5$var$invariant(!!this.props.options, 'DistanceMatrixService expected options object as parameter, but go %s', this.props.options);
        var distanceMatrixService = new google.maps.DistanceMatrixService();
        this.setState(function setDistanceMatrixService() {
            return {
                distanceMatrixService: distanceMatrixService
            };
        }, this.setDistanceMatrixServiceCallback);
    }
    componentDidUpdate() {
        if (this.state.distanceMatrixService !== null) this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
    }
    componentWillUnmount() {
        if (this.state.distanceMatrixService !== null && this.props.onUnmount) this.props.onUnmount(this.state.distanceMatrixService);
    }
    render() {
        return null;
    }
}
var $356d0adb4c3ddad5$var$eventMap$1 = {
    onPlacesChanged: 'places_changed'
};
var $356d0adb4c3ddad5$var$updaterMap$1 = {
    bounds (instance, bounds) {
        instance.setBounds(bounds);
    }
};
class $356d0adb4c3ddad5$export$e2a0bb4d8be84b8 extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "containerElement", (0, $6umrQ.createRef)());
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            searchBox: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setSearchBoxCallback", ()=>{
            if (this.state.searchBox !== null && this.props.onLoad) this.props.onLoad(this.state.searchBox);
        });
    }
    componentDidMount() {
        $356d0adb4c3ddad5$var$invariant(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
        if (this.containerElement !== null && this.containerElement.current !== null) {
            var input = this.containerElement.current.querySelector('input');
            if (input !== null) {
                var searchBox = new google.maps.places.SearchBox(input, this.props.options);
                this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                    updaterMap: $356d0adb4c3ddad5$var$updaterMap$1,
                    eventMap: $356d0adb4c3ddad5$var$eventMap$1,
                    prevProps: {},
                    nextProps: this.props,
                    instance: searchBox
                });
                this.setState(function setSearchBox() {
                    return {
                        searchBox: searchBox
                    };
                }, this.setSearchBoxCallback);
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.state.searchBox !== null) {
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap$1,
                eventMap: $356d0adb4c3ddad5$var$eventMap$1,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.searchBox
            });
        }
    }
    componentWillUnmount() {
        if (this.state.searchBox !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.searchBox);
            $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
        }
    }
    render() {
        return (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            ref: this.containerElement,
            children: (0, $6umrQ.Children).only(this.props.children)
        });
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$e2a0bb4d8be84b8, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);
var $356d0adb4c3ddad5$var$eventMap = {
    onPlaceChanged: 'place_changed'
};
var $356d0adb4c3ddad5$var$updaterMap = {
    bounds (instance, bounds) {
        instance.setBounds(bounds);
    },
    restrictions (instance, restrictions) {
        instance.setComponentRestrictions(restrictions);
    },
    fields (instance, fields) {
        instance.setFields(fields);
    },
    options (instance, options) {
        instance.setOptions(options);
    },
    types (instance, types) {
        instance.setTypes(types);
    }
};
class $356d0adb4c3ddad5$export$2f2b9559550c7bbc extends (0, $6umrQ.PureComponent) {
    constructor(){
        super(...arguments);
        $356d0adb4c3ddad5$var$_defineProperty(this, "registeredEvents", []);
        $356d0adb4c3ddad5$var$_defineProperty(this, "containerElement", (0, $6umrQ.createRef)());
        $356d0adb4c3ddad5$var$_defineProperty(this, "state", {
            autocomplete: null
        });
        $356d0adb4c3ddad5$var$_defineProperty(this, "setAutocompleteCallback", ()=>{
            if (this.state.autocomplete !== null && this.props.onLoad) this.props.onLoad(this.state.autocomplete);
        });
    }
    componentDidMount() {
        var _this$containerElemen;
        $356d0adb4c3ddad5$var$invariant(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
        // TODO: why current could be equal null?
        var input = (_this$containerElemen = this.containerElement.current) === null || _this$containerElemen === void 0 ? void 0 : _this$containerElemen.querySelector('input');
        if (input) {
            var autocomplete = new google.maps.places.Autocomplete(input, this.props.options);
            this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
                updaterMap: $356d0adb4c3ddad5$var$updaterMap,
                eventMap: $356d0adb4c3ddad5$var$eventMap,
                prevProps: {},
                nextProps: this.props,
                instance: autocomplete
            });
            this.setState(()=>{
                return {
                    autocomplete: autocomplete
                };
            }, this.setAutocompleteCallback);
        }
    }
    componentDidUpdate(prevProps) {
        $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
        this.registeredEvents = $356d0adb4c3ddad5$var$applyUpdatersToPropsAndRegisterEvents({
            updaterMap: $356d0adb4c3ddad5$var$updaterMap,
            eventMap: $356d0adb4c3ddad5$var$eventMap,
            prevProps: prevProps,
            nextProps: this.props,
            instance: this.state.autocomplete
        });
    }
    componentWillUnmount() {
        if (this.state.autocomplete !== null) $356d0adb4c3ddad5$var$unregisterEvents(this.registeredEvents);
    }
    render() {
        return (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
            ref: this.containerElement,
            className: this.props.className,
            children: (0, $6umrQ.Children).only(this.props.children)
        });
    }
}
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$2f2b9559550c7bbc, "defaultProps", {
    className: ''
});
$356d0adb4c3ddad5$var$_defineProperty($356d0adb4c3ddad5$export$2f2b9559550c7bbc, "contextType", $356d0adb4c3ddad5$export$dc7344301ae78f85);



parcelRequire("6umrQ");
const $3b8d7ecc4e3f2f06$export$6d2805e3625eb7d9 = ({ partner: partner, active: active, onClick: onClick, id: id })=>{
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        id: id,
        onClick: onClick,
        className: `flex flex-col rounded-lg border ${active ? 'border-2 border-stroke-signal' : 'border-stroke-default'} bg-white p-6 gap-3 cursor-pointer transition-colors hover:shadow-md`,
        children: [
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                className: "flex items-center justify-between",
                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                            className: "w-[12px] h-[12px] bg-brand-sky-800 relative",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 12 12",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("rect", {
                                        width: "12",
                                        height: "12",
                                        fill: "#23465F"
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M6.93187 7.9462C6.77857 8.1658 6.77857 8.4577 6.93187 8.6773C7.05127 8.8483 7.24657 8.95 7.45507 8.95H9.04357L7.64227 6.9292L6.93187 7.9462Z",
                                        fill: "#BDDFEF"
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M7.64227 5.07073L9.04357 3.04993H7.45507C7.24657 3.04993 7.05127 3.15163 6.93187 3.32263C6.77857 3.54223 6.77857 3.83413 6.93187 4.05373L7.64227 5.07073Z",
                                        fill: "#BDDFEF"
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M4.87774 3.04993H2.95654L5.00224 5.99983L2.95654 8.94973H4.87774L6.93844 5.99983L4.87774 3.04993Z",
                                        fill: "#BDDFEF"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                            className: "text-secondary text-[10px] font-semibold uppercase tracking-[0.13em] leading-none",
                            children: window.gettext('FLEXIT PARTNER')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h2", {
                        className: "text-default text-[15px] font-bold leading-[19px]",
                        children: partner.name
                    }),
                    active && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "flex items-center justify-center w-6 h-6 rounded-full bg-[#2E7ABA] border border-[#2E7ABA]",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                d: "M10 3L4.5 8.5L2 6",
                                stroke: "white",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "flex flex-wrap gap-2 text-secondary text-[13px] font-medium leading-none",
                children: [
                    partner.is_retailer && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "flex items-center bg-accent-olive-subtle rounded-[2px] px-2 py-[5px] h-6",
                        children: window.gettext('Retailer')
                    }),
                    partner.is_service && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "flex items-center bg-accent-olive-subtle rounded-[2px] px-2 py-[5px] h-6",
                        children: window.gettext('Service company')
                    }),
                    partner.is_installer && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "flex items-center bg-accent-olive-subtle rounded-[2px] px-2 py-[5px] h-6",
                        children: window.gettext('Flexit partner')
                    }),
                    partner.is_econordic_partner && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "flex items-center bg-brand-air-100 rounded-[2px] px-2 py-[5px] h-6",
                        children: window.gettext('EcoNordic partner')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "border-t border-stroke-default pt-3 flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "text-secondary text-[15px] font-medium leading-[150%]",
                        children: [
                            partner.address_line1 && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                children: partner.address_line1
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                children: [
                                    partner.postal_code,
                                    " ",
                                    partner.city
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "flex items-center gap-1 mt-1",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "w-6 h-6 flex items-center justify-center relative",
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M4.0369 4.6879C3.99743 4.59682 3.98626 4.49597 4.00484 4.39846C4.02342 4.30094 4.07088 4.21127 4.14108 4.14108C4.21127 4.07088 4.30094 4.02342 4.39846 4.00484C4.49597 3.98626 4.59682 3.99743 4.6879 4.0369L20.6879 10.5369C20.7852 10.5765 20.8675 10.6458 20.9232 10.7349C20.9789 10.824 21.0051 10.9283 20.9981 11.0331C20.9912 11.138 20.9514 11.2379 20.8844 11.3188C20.8174 11.3997 20.7266 11.4575 20.6249 11.4839L14.5009 13.0639C14.1549 13.1529 13.839 13.3329 13.5861 13.5852C13.3332 13.8376 13.1526 14.1531 13.0629 14.4989L11.4839 20.6249C11.4575 20.7266 11.3997 20.8174 11.3188 20.8844C11.2379 20.9514 11.138 20.9912 11.0331 20.9981C10.9283 21.0051 10.824 20.9789 10.7349 20.9232C10.6458 20.8675 10.5765 20.7852 10.5369 20.6879L4.0369 4.6879Z",
                                        stroke: "#39596F",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                                href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${partner.name}, ${partner.address_line1}, ${partner.city}`)}`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-link text-[15px] font-medium underline leading-[150%]",
                                children: window.gettext('Open in Google Maps')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "border-t border-stroke-default pt-3 gap-x-4 gap-y-1 text-secondary text-[15px] font-medium leading-[150%]",
                children: [
                    partner.phone && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                            href: `tel:${partner.phone}`,
                            children: partner.phone
                        })
                    }),
                    partner.email && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("a", {
                            href: `mailto:${partner.email}`,
                            children: partner.email
                        })
                    })
                ]
            })
        ]
    });
};


// src/components/servicePartnerFinder/AdvancedMarker.tsx


var $6umrQ = parcelRequire("6umrQ");

const $a7bd2a3f61281a00$var$MarkerContent = ({ title: title, isActive: isActive })=>{
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        className: "relative flex flex-col items-center group cursor-pointer",
        style: {
            transform: 'translateY(-50%)'
        },
        children: [
            isActive && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "absolute bottom-full mb-2 whitespace-nowrap bg-white rounded-full pl-4 pr-4 py-2 shadow-md flex flex-col items-center z-100",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                        className: "text-brand-sky-900 font-bold text-body-sm",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                style: {
                    width: '36px',
                    height: '50px'
                },
                className: "relative drop-shadow-md transition-transform hover:scale-110",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                        width: "36",
                        height: "50",
                        viewBox: "0 0 36 50",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                            d: "M17.9957 49.4881C17.9957 49.4881 35.9914 29.2716 35.9914 18.3149C35.9914 7.35817 28.8502 0 17.9957 0C7.14115 0 0 7.35817 0 18.3149C0 29.2716 17.9957 49.4881 17.9957 49.4881Z",
                            fill: "#173247"
                        })
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "absolute border-[1.5px] border-white box-border",
                        style: {
                            left: '18.86%',
                            right: '18.85%',
                            top: '27.09%',
                            bottom: '50.01%'
                        }
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "absolute border-[1.5px] border-white box-border",
                        style: {
                            left: '33.65%',
                            right: '50.12%',
                            top: '18.67%',
                            bottom: '66.07%'
                        }
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "absolute border-[1.5px] border-white box-border",
                        style: {
                            left: '33.65%',
                            right: '35.75%',
                            top: '42.12%',
                            bottom: '50%'
                        }
                    })
                ]
            })
        ]
    });
};
const $a7bd2a3f61281a00$export$5dd2dc1fc7030ab5 = ({ map: map, position: position, title: title, isActive: isActive = false, onClick: onClick })=>{
    (0, $6umrQ.useEffect)(()=>{
        if (!map) return;
        // SAFEGUARD: If AdvancedMarkerElement is not available, do nothing instead of throwing.
        const AdvancedMarkerCtor = google.maps.marker?.AdvancedMarkerElement;
        if (!AdvancedMarkerCtor) {
            // This prevents runtime errors that trigger Parcel overlay spam (__parcel_code_frame).
            console.warn('[ServicePartnerFinder] AdvancedMarkerElement not available. Check mapId / marker library.');
            return;
        }
        const container = document.createElement('div');
        const root = (0, $c5f61bb6d82acefb$export$882461b6382ed46c)(container);
        root.render(/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)($a7bd2a3f61281a00$var$MarkerContent, {
            title: title,
            isActive: isActive
        }));
        const marker = new AdvancedMarkerCtor({
            map: map,
            position: position,
            title: title,
            content: container,
            zIndex: isActive ? 1000 : undefined
        });
        if (onClick) marker.addListener('click', onClick);
        return ()=>{
            // Remove marker from map
            marker.map = null;
            // Unmount React root used for marker content
            root.unmount();
        };
    }, [
        map,
        position.lat,
        position.lng,
        title,
        onClick,
        isActive
    ]);
    return null;
};


// src/components/servicePartnerFinder/FilterCheckbox.tsx

parcelRequire("6umrQ");
const $2bbd49ee990bcc1d$export$7345f92d196752c8 = ({ label: label, checked: checked, onChange: onChange, tooltipText: tooltipText })=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("label", {
                className: "flex items-center gap-3 cursor-pointer group",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: `w-6 h-6 box-border border rounded-[4px] flex items-center justify-center bg-white/50 transition-colors border-[var(--color-base-signal-500)] `,
                        children: [
                            checked && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                    d: "M20 6L9 17L4 12",
                                    stroke: "black",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("input", {
                                type: "checkbox",
                                className: "hidden",
                                checked: checked,
                                onChange: onChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                        className: "text-secondary text-body-base font-medium select-none",
                        children: label
                    })
                ]
            }),
            tooltipText && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "relative group/tooltip flex items-center",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "cursor-help text-brand-sky-500",
                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "11",
                                    stroke: "currentColor",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                    d: "M12 17V11",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("circle", {
                                    cx: "12",
                                    cy: "7",
                                    r: "0.5",
                                    fill: "currentColor",
                                    stroke: "currentColor",
                                    strokeWidth: "1"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "absolute left-full top-1/2 -translate-y-1/2 ml-2 w-48 p-2 bg-slate-800 text-white text-xs rounded opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all z-50 pointer-events-none shadow-lg",
                        children: [
                            tooltipText,
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "absolute right-full top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-r-4 border-r-slate-800"
                            })
                        ]
                    })
                ]
            })
        ]
    });


// src/components/servicePartnerFinder/utils.ts
const $94bd5b19314207bf$export$ac28926340149710 = (value)=>{
    if (value === null || value === undefined) return null;
    const n = Number(value);
    return Number.isNaN(n) ? null : n;
};


const $edec6ea8805581a4$var$defaultCenter = {
    lat: 59.91,
    lng: 10.75
} // Oslo-ish
;
const $edec6ea8805581a4$var$ServicePartnerFinder = ({ apiUrl: apiUrl, googleMapsApiKey: googleMapsApiKey, page_title: page_title, mapId: mapId, market: market })=>{
    const [partners, setPartners] = (0, $6umrQ.useState)([]);
    const [loading, setLoading] = (0, $6umrQ.useState)(true);
    const [error, setError] = (0, $6umrQ.useState)(null);
    const [userLocation, setUserLocation] = (0, $6umrQ.useState)(null);
    const [filters, setFilters] = (0, $6umrQ.useState)({
        serviceTypes: new Set()
    });
    const [filterPanelOpen, setFilterPanelOpen] = (0, $6umrQ.useState)(false);
    const [searchText, setSearchText] = (0, $6umrQ.useState)('');
    const [autocomplete, setAutocomplete] = (0, $6umrQ.useState)(null);
    const [activePartnerId, setActivePartnerId] = (0, $6umrQ.useState)(null);
    const [mapCenter, setMapCenter] = (0, $6umrQ.useState)($edec6ea8805581a4$var$defaultCenter);
    const [mapInstance, setMapInstance] = (0, $6umrQ.useState)(null);
    // Track the latest request to avoid race conditions if user clicks quickly
    const requestSeq = (0, $6umrQ.useRef)(0);
    const libraries = (0, $6umrQ.useMemo)(()=>[
            'places',
            'marker'
        ], []);
    const { isLoaded: mapsLoaded, loadError: loadError } = (0, $356d0adb4c3ddad5$export$d444e954fd08ae7a)({
        googleMapsApiKey: googleMapsApiKey,
        libraries: libraries
    });
    const [markerLibReady, setMarkerLibReady] = (0, $6umrQ.useState)(false);
    // Explicitly load marker library (and places) via importLibrary when available.
    // This makes AdvancedMarkerElement availability much more deterministic.
    (0, $6umrQ.useEffect)(()=>{
        if (!mapsLoaded) return;
        let cancelled = false;
        (async ()=>{
            try {
                // importLibrary exists on newer Maps JS versions
                // @ts-ignore - types may be behind
                if (typeof google.maps.importLibrary === 'function') {
                    // @ts-ignore
                    await google.maps.importLibrary('marker');
                    // @ts-ignore
                    await google.maps.importLibrary('places');
                }
                const ok = Boolean(google.maps.marker?.AdvancedMarkerElement);
                if (!cancelled) setMarkerLibReady(ok);
            } catch (e) {
                console.warn('[ServicePartnerFinder] Failed to import marker/places library', e);
                if (!cancelled) setMarkerLibReady(Boolean(google.maps.marker?.AdvancedMarkerElement));
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        mapsLoaded
    ]);
    // --- Fetch helpers ---------------------------------------------------------
    const buildQuery = (coords)=>{
        const params = new URLSearchParams();
        if (coords) {
            params.set('lat', String(coords.lat));
            params.set('lng', String(coords.lng));
        }
        if (filters.serviceTypes.size > 0) params.set('service_types', Array.from(filters.serviceTypes).join(','));
        if (market) params.set('market', market);
        const radius = market === 'EXPORT' ? '2000' : '200';
        params.set('radius_km', radius);
        return params.toString();
    };
    const fetchPartners = (coords)=>{
        if (!apiUrl) {
            setError(gettext('API URL is missing.'));
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        const qs = buildQuery(coords);
        const url = qs ? `${apiUrl}?${qs}` : apiUrl;
        const seq = ++requestSeq.current;
        fetch(url, {
            credentials: 'same-origin'
        }).then((res)=>{
            if (!res.ok) throw new Error(`API error ${res.status}`);
            return res.json();
        }).then((data)=>{
            // Ignore stale responses
            if (seq !== requestSeq.current) return;
            setPartners(data);
            setActivePartnerId(null);
            if (coords) setMapCenter(coords);
            else if (data.length) {
                const firstLat = (0, $94bd5b19314207bf$export$ac28926340149710)(data[0].latitude);
                const firstLng = (0, $94bd5b19314207bf$export$ac28926340149710)(data[0].longitude);
                if (firstLat !== null && firstLng !== null) setMapCenter({
                    lat: firstLat,
                    lng: firstLng
                });
            }
        }).catch((err)=>{
            console.error(err);
            if (seq !== requestSeq.current) return;
            setError(window.gettext('Could not fetch service partners.'));
        }).finally(()=>{
            if (seq !== requestSeq.current) return;
            setLoading(false);
        });
    };
    // --- On mount: try geolocation ---------------------------------------------
    (0, $6umrQ.useEffect)(()=>{
        if (!navigator.geolocation) {
            fetchPartners(null);
            return;
        }
        navigator.geolocation.getCurrentPosition((pos)=>{
            const coords = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
            };
            setUserLocation(coords);
            fetchPartners(coords);
        }, ()=>{
            fetchPartners(null);
        }, {
            enableHighAccuracy: false,
            timeout: 8000
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // --- Handlers --------------------------------------------------------------
    // --- Effects ---------------------------------------------------------------
    (0, $6umrQ.useEffect)(()=>{
        fetchPartners(userLocation);
    }, [
        filters
    ]);
    const toggleServiceType = (type)=>{
        setFilters((prev)=>{
            const next = new Set(prev.serviceTypes);
            if (next.has(type)) next.delete(type);
            else next.add(type);
            return {
                ...prev,
                serviceTypes: next
            };
        });
    };
    const applyFilters = ()=>{
        // fetch is triggered by useEffect on filters change
        setFilterPanelOpen(false);
    };
    const centerMapOnPartner = (partnerId)=>{
        const p = partners.find((x)=>x.id === partnerId);
        if (!p) return;
        const lat = (0, $94bd5b19314207bf$export$ac28926340149710)(p.latitude);
        const lng = (0, $94bd5b19314207bf$export$ac28926340149710)(p.longitude);
        if (lat !== null && lng !== null) setMapCenter({
            lat: lat,
            lng: lng
        });
    };
    const handlePartnerClick = (partnerId)=>{
        setActivePartnerId(partnerId);
        centerMapOnPartner(partnerId);
    };
    const handleMarkerClick = (partnerId)=>{
        setActivePartnerId(partnerId);
        centerMapOnPartner(partnerId);
        const el = document.getElementById(`partner-card-${partnerId}`);
        if (el) el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    };
    const onPlaceChanged = ()=>{
        if (!autocomplete) return;
        const place = autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
            const coords = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };
            setMapCenter(coords);
            setUserLocation(coords);
            fetchPartners(coords);
            if (place.name) setSearchText(place.name);
            return;
        }
        console.log('Autocomplete: No details available for input:', place.name);
    };
    // --- Map center fallback if nothing fetched yet ---------------------------
    (0, $6umrQ.useEffect)(()=>{
        if (!userLocation && partners.length) {
            const firstLat = (0, $94bd5b19314207bf$export$ac28926340149710)(partners[0].latitude);
            const firstLng = (0, $94bd5b19314207bf$export$ac28926340149710)(partners[0].longitude);
            if (firstLat !== null && firstLng !== null) setMapCenter({
                lat: firstLat,
                lng: firstLng
            });
        }
    }, [
        userLocation,
        partners
    ]);
    // --- Render ----------------------------------------------------------------
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        className: "flex flex-col lg:flex-row gap-6 lg:gap-8",
        children: [
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "w-full lg:w-[360px] xl:w-[400px] flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h1", {
                        className: "text-default text-xl font-bold",
                        children: page_title
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("label", {
                                className: "text-default text-label-sm font-semibold",
                                children: gettext('Search by location')
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                className: "relative h-[50px]",
                                children: [
                                    mapsLoaded && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $356d0adb4c3ddad5$export$2f2b9559550c7bbc), {
                                        onLoad: (a)=>setAutocomplete(a),
                                        onPlaceChanged: onPlaceChanged,
                                        className: "w-full h-full",
                                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("input", {
                                            type: "text",
                                            value: searchText,
                                            onChange: (e)=>setSearchText(e.target.value),
                                            placeholder: window.gettext('Search for a place...'),
                                            className: "w-full h-full rounded-lg border border-brand-sky-300 bg-transparent pl-4 pr-10 text-body-base text-default placeholder:text-text-subtle outline-none focus:border-brand-sky-500"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                        className: "absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center pointer-events-none",
                                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("circle", {
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "9",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.5"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M12 3V6",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M12 18V21",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M21 12H18",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M6 12H3",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            market !== 'EXPORT' && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setFilterPanelOpen((open)=>!open),
                                className: "flex items-center gap-2 rounded-lg border border-stroke-default px-3 py-1.5 w-fit hover:bg-surface-subtle transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                        className: "w-4 h-4 relative flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M2 4H14",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.33",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M2 8H14",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.33",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                                    d: "M2 12H14",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.33",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("circle", {
                                                    cx: "5",
                                                    cy: "4",
                                                    r: "1.5",
                                                    fill: "white",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.33"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("circle", {
                                                    cx: "11",
                                                    cy: "8",
                                                    r: "1.5",
                                                    fill: "white",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.33"
                                                }),
                                                /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("circle", {
                                                    cx: "5",
                                                    cy: "12",
                                                    r: "1.5",
                                                    fill: "white",
                                                    stroke: "#39596F",
                                                    strokeWidth: "1.33"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                                        className: "text-default text-label-xs font-medium",
                                        children: window.gettext('Filter')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "max-h-[520px] overflow-y-auto space-y-3",
                        children: [
                            loading && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "text-body-sm text-text-subtle py-4",
                                children: window.gettext('Loading service partners...')
                            }),
                            error && !loading && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "text-body-sm text-error py-4",
                                children: error
                            }),
                            !loading && !error && partners.length === 0 && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "text-body-sm text-text-subtle py-4",
                                children: window.gettext('No results for the selected filters.')
                            }),
                            !loading && !error && partners.map((partner)=>/*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $3b8d7ecc4e3f2f06$export$6d2805e3625eb7d9), {
                                    partner: partner,
                                    active: partner.id === activePartnerId,
                                    onClick: ()=>handlePartnerClick(partner.id),
                                    id: `partner-card-${partner.id}`
                                }, partner.id))
                        ]
                    })
                ]
            }),
            filterPanelOpen && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "hidden lg:block w-[260px] xl:w-[280px] bg-default rounded-xl shadow-sm p-4 self-start",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "flex items-center justify-between h-6",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h2", {
                                className: "text-default text-body-base font-bold",
                                children: window.gettext('Filter')
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setFilterPanelOpen(false),
                                className: "w-6 h-6 flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M18 6L6 18M6 6L18 18",
                                        stroke: "#39596F",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "flex flex-col gap-6",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                className: "flex flex-col gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h3", {
                                        className: "text-default text-body-base font-medium",
                                        children: window.gettext('By service type')
                                    }),
                                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $2bbd49ee990bcc1d$export$7345f92d196752c8), {
                                                label: window.gettext('Reseller'),
                                                tooltipText: window.gettext('Where can I buy Flexit products?'),
                                                checked: filters.serviceTypes.has('retailer'),
                                                onChange: ()=>toggleServiceType('retailer')
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $2bbd49ee990bcc1d$export$7345f92d196752c8), {
                                                label: window.gettext('Service company'),
                                                tooltipText: window.gettext('Who can help me with service and repairs?'),
                                                checked: filters.serviceTypes.has('service'),
                                                onChange: ()=>toggleServiceType('service')
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $2bbd49ee990bcc1d$export$7345f92d196752c8), {
                                                label: window.gettext('Flexit Partner'),
                                                tooltipText: window.gettext('Who can help me with installation and a service agreement?'),
                                                checked: filters.serviceTypes.has('partner'),
                                                onChange: ()=>toggleServiceType('partner')
                                            }),
                                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $2bbd49ee990bcc1d$export$7345f92d196752c8), {
                                                label: window.gettext('EcoNordic Servicepartner'),
                                                tooltipText: window.gettext('Who can help me with installation and service of the EcoNordic indoor climate unit?'),
                                                checked: filters.serviceTypes.has('econordic'),
                                                onChange: ()=>toggleServiceType('econordic')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                                type: "button",
                                onClick: applyFilters,
                                className: "mt-6 w-full rounded-full bg-action-primary text-action-primary-foreground text-body-sm py-3 font-semibold hover:bg-opacity-90 transition-opacity",
                                children: window.gettext('Show results')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "flex-1 min-h-[360px] lg:min-h-[540px] bg-default rounded-xl overflow-hidden shadow-sm",
                children: [
                    !mapsLoaded && !loadError && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "w-full h-full flex items-center justify-center text-body-sm text-text-subtle",
                        children: window.gettext('Loading map...')
                    }),
                    loadError && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                        className: "w-full h-full flex items-center justify-center text-body-sm text-error",
                        children: window.gettext('Could not load Google Maps.')
                    }),
                    mapsLoaded && !loadError && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $356d0adb4c3ddad5$export$4ad1bae46276c5ce), {
                        center: mapCenter,
                        zoom: 8,
                        mapContainerStyle: {
                            width: '100%',
                            height: '100%'
                        },
                        options: {
                            disableDefaultUI: false,
                            fullscreenControl: false,
                            // If you don't have a valid Map ID, either pass one via props or remove advanced marker usage.
                            mapId: mapId || 'DEMO_MAP_ID'
                        },
                        onLoad: (map)=>setMapInstance(map),
                        children: mapInstance && markerLibReady && partners.map((p)=>{
                            const lat = (0, $94bd5b19314207bf$export$ac28926340149710)(p.latitude);
                            const lng = (0, $94bd5b19314207bf$export$ac28926340149710)(p.longitude);
                            if (lat === null || lng === null) return null;
                            return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)((0, $a7bd2a3f61281a00$export$5dd2dc1fc7030ab5), {
                                map: mapInstance,
                                position: {
                                    lat: lat,
                                    lng: lng
                                },
                                title: p.name,
                                isActive: p.id === activePartnerId,
                                onClick: ()=>handleMarkerClick(p.id)
                            }, p.id);
                        })
                    })
                ]
            })
        ]
    });
};
var $edec6ea8805581a4$export$2e2bcd8739ae039 = $edec6ea8805581a4$var$ServicePartnerFinder;


class $52cf58bb8060d06d$export$2e2bcd8739ae039 extends (0, $febaba8661e870e3$export$ce623d3cb93cc651) {
    get UIComponent() {
        return 0, $edec6ea8805581a4$export$2e2bcd8739ae039;
    }
}





var $6umrQ = parcelRequire("6umrQ");


const $07deae8fbe529aa6$var$Findability = ({ targetType: targetType = 'other', apiBaseUrl: apiBaseUrl = '/api/findability/' })=>{
    const [status, setStatus] = (0, $6umrQ.useState)('initial');
    const [comment, setComment] = (0, $6umrQ.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $6umrQ.useState)(false);
    const [error, setError] = (0, $6umrQ.useState)('');
    const targetUrl = typeof window !== 'undefined' ? window.location.href : '';
    const handleVote = async (found)=>{
        try {
            await (0, $6328de73d05995eb$export$2e2bcd8739ae039).post(`${apiBaseUrl}vote/`, {
                target_url: targetUrl,
                target_type: targetType,
                found: found
            });
            if (found) setStatus('votedYes');
            else setStatus('votedNo');
        } catch (err) {
            console.error('Failed to submit vote', err);
            // Don't block the user on network failure.
            if (found) setStatus('votedYes');
            else setStatus('votedNo');
        }
    };
    const handleSubmitFeedback = async (e)=>{
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await (0, $6328de73d05995eb$export$2e2bcd8739ae039).post(`${apiBaseUrl}feedback/`, {
                target_url: targetUrl,
                target_type: targetType,
                found: false,
                comment: comment
            });
            setStatus('submitted');
        } catch (err) {
            console.error('Failed to submit feedback', err);
            setError(window.gettext('Failed to submit feedback. Please try again.'));
        } finally{
            setIsSubmitting(false);
        }
    };
    if (status === 'votedYes' || status === 'submitted') return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
        className: "p-4 bg-brand-olive-50 rounded-lg text-center max-w-2xl mx-auto",
        role: "alert",
        children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
            className: "text-brand-olive-900 font-medium",
            children: window.gettext('Thanks for your feedback!')
        })
    });
    return /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
        className: "border-t border-brand-sky-200 mt-4 pt-4 max-w-2xl mx-auto",
        children: [
            status === 'initial' && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "flex items-center gap-4",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("span", {
                        className: "font-secondary font-medium text-base text-secondary",
                        children: window.gettext('Did you find what you were looking for?')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>handleVote(true),
                                className: "w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors group",
                                "aria-label": window.gettext('Yes'),
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "text-secondary group-hover:text-blue-500",
                                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>handleVote(false),
                                className: "w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors group",
                                "aria-label": window.gettext('No'),
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "text-secondary group-hover:text-red-600",
                                    children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("path", {
                                        d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            status === 'votedNo' && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("div", {
                className: "max-w-2xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("h3", {
                        className: "text-lg font-medium text-brand-sky-950 mb-4",
                        children: window.gettext('Thanks for your feedback!')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                        className: "text-sm text-brand-sky-700 mb-4",
                        children: window.gettext('Help us improve by telling us what was missing:')
                    }),
                    /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsxs)("form", {
                        onSubmit: handleSubmitFeedback,
                        children: [
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("textarea", {
                                value: comment,
                                onChange: (e)=>setComment(e.target.value),
                                className: "w-full shadow-sm focus:ring-brand-sky-500 focus:border-brand-sky-500 block sm:text-sm border-brand-sky-300 rounded-md p-2",
                                rows: 3,
                                placeholder: window.gettext('Optional comment...')
                            }),
                            error && /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("p", {
                                className: "mt-2 text-sm text-base-error-500",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("div", {
                                className: "mt-4 flex justify-end",
                                children: /*#__PURE__*/ (0, $fb2efc226cb4f9dd$exports.jsx)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($19a25a6d0fad3f5f$exports)))('inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brand-sky-800 hover:bg-brand-sky-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-sky-500', {
                                        'opacity-50 cursor-not-allowed': isSubmitting
                                    }),
                                    children: isSubmitting ? window.gettext('Sending...') : window.gettext('Send Feedback')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $07deae8fbe529aa6$export$2e2bcd8739ae039 = $07deae8fbe529aa6$var$Findability;


class $1ae23aee2a23d61a$export$2e2bcd8739ae039 extends (0, $febaba8661e870e3$export$ce623d3cb93cc651) {
    get UIComponent() {
        return 0, $07deae8fbe529aa6$export$2e2bcd8739ae039;
    }
}


(0, $be705c950a3ea687$export$3b91788629d8849d)();
const $902d30a47d4c36c1$var$widgetRegistry = (0, $1a6bf193a660dd82$export$2e2bcd8739ae039).getInstance();
$902d30a47d4c36c1$var$widgetRegistry.registerWidgetClass('WizardResultWidget', (0, $4fddd96a6fb67814$export$2e2bcd8739ae039));
$902d30a47d4c36c1$var$widgetRegistry.registerWidgetClass('FindServicePartnerWidget', (0, $52cf58bb8060d06d$export$2e2bcd8739ae039));
$902d30a47d4c36c1$var$widgetRegistry.registerWidgetClass('FindabilityWidget', (0, $1ae23aee2a23d61a$export$2e2bcd8739ae039));
$902d30a47d4c36c1$var$widgetRegistry.initializeWidgets();
console.log('Initialized widgets!');

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f5553b150153ba40$export$a143d493d941bafc;
var $f5553b150153ba40$export$e4cf37d7f6fb9e0a;
var $f5553b150153ba40$export$f99ded8fe4b79145;
var $f5553b150153ba40$export$599f31c3813fae4d;
'use strict';
var $7bfa7f922a4972a8$export$a48f0734ac7c2329;
var $7bfa7f922a4972a8$export$d622b2ad8d90c771;
var $7bfa7f922a4972a8$export$6100ba28696e12de;
'use strict';
$7bfa7f922a4972a8$export$a48f0734ac7c2329 = $7bfa7f922a4972a8$var$byteLength;
$7bfa7f922a4972a8$export$d622b2ad8d90c771 = $7bfa7f922a4972a8$var$toByteArray;
$7bfa7f922a4972a8$export$6100ba28696e12de = $7bfa7f922a4972a8$var$fromByteArray;
var $7bfa7f922a4972a8$var$lookup = [];
var $7bfa7f922a4972a8$var$revLookup = [];
var $7bfa7f922a4972a8$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $7bfa7f922a4972a8$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $7bfa7f922a4972a8$var$i = 0, $7bfa7f922a4972a8$var$len = $7bfa7f922a4972a8$var$code.length; $7bfa7f922a4972a8$var$i < $7bfa7f922a4972a8$var$len; ++$7bfa7f922a4972a8$var$i){
    $7bfa7f922a4972a8$var$lookup[$7bfa7f922a4972a8$var$i] = $7bfa7f922a4972a8$var$code[$7bfa7f922a4972a8$var$i];
    $7bfa7f922a4972a8$var$revLookup[$7bfa7f922a4972a8$var$code.charCodeAt($7bfa7f922a4972a8$var$i)] = $7bfa7f922a4972a8$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7bfa7f922a4972a8$var$revLookup['-'.charCodeAt(0)] = 62;
$7bfa7f922a4972a8$var$revLookup['_'.charCodeAt(0)] = 63;
function $7bfa7f922a4972a8$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7bfa7f922a4972a8$var$byteLength(b64) {
    var lens = $7bfa7f922a4972a8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7bfa7f922a4972a8$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7bfa7f922a4972a8$var$toByteArray(b64) {
    var tmp;
    var lens = $7bfa7f922a4972a8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7bfa7f922a4972a8$var$Arr($7bfa7f922a4972a8$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i)] << 18 | $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i)] << 2 | $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i)] << 10 | $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7bfa7f922a4972a8$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7bfa7f922a4972a8$var$tripletToBase64(num) {
    return $7bfa7f922a4972a8$var$lookup[num >> 18 & 0x3F] + $7bfa7f922a4972a8$var$lookup[num >> 12 & 0x3F] + $7bfa7f922a4972a8$var$lookup[num >> 6 & 0x3F] + $7bfa7f922a4972a8$var$lookup[num & 0x3F];
}
function $7bfa7f922a4972a8$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7bfa7f922a4972a8$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $7bfa7f922a4972a8$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7bfa7f922a4972a8$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7bfa7f922a4972a8$var$lookup[tmp >> 2] + $7bfa7f922a4972a8$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7bfa7f922a4972a8$var$lookup[tmp >> 10] + $7bfa7f922a4972a8$var$lookup[tmp >> 4 & 0x3F] + $7bfa7f922a4972a8$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $773387d4e66401f9$export$aafa59e2e03f2942;
var $773387d4e66401f9$export$68d8715fc104d294;
$773387d4e66401f9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$773387d4e66401f9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $f5553b150153ba40$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f5553b150153ba40$export$a143d493d941bafc = $f5553b150153ba40$var$Buffer;
$f5553b150153ba40$export$e4cf37d7f6fb9e0a = $f5553b150153ba40$var$SlowBuffer;
$f5553b150153ba40$export$f99ded8fe4b79145 = 50;
const $f5553b150153ba40$var$K_MAX_LENGTH = 0x7fffffff;
$f5553b150153ba40$export$599f31c3813fae4d = $f5553b150153ba40$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f5553b150153ba40$var$Buffer.TYPED_ARRAY_SUPPORT = $f5553b150153ba40$var$typedArraySupport();
if (!$f5553b150153ba40$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f5553b150153ba40$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f5553b150153ba40$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f5553b150153ba40$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f5553b150153ba40$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f5553b150153ba40$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f5553b150153ba40$var$createBuffer(length) {
    if (length > $f5553b150153ba40$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f5553b150153ba40$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f5553b150153ba40$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f5553b150153ba40$var$allocUnsafe(arg);
    }
    return $f5553b150153ba40$var$from(arg, encodingOrOffset, length);
}
$f5553b150153ba40$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f5553b150153ba40$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f5553b150153ba40$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f5553b150153ba40$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f5553b150153ba40$var$isInstance(value, ArrayBuffer) || value && $f5553b150153ba40$var$isInstance(value.buffer, ArrayBuffer)) return $f5553b150153ba40$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f5553b150153ba40$var$isInstance(value, SharedArrayBuffer) || value && $f5553b150153ba40$var$isInstance(value.buffer, SharedArrayBuffer))) return $f5553b150153ba40$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f5553b150153ba40$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f5553b150153ba40$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f5553b150153ba40$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f5553b150153ba40$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f5553b150153ba40$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f5553b150153ba40$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f5553b150153ba40$var$Buffer, Uint8Array);
function $f5553b150153ba40$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f5553b150153ba40$var$alloc(size, fill, encoding) {
    $f5553b150153ba40$var$assertSize(size);
    if (size <= 0) return $f5553b150153ba40$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f5553b150153ba40$var$createBuffer(size).fill(fill, encoding) : $f5553b150153ba40$var$createBuffer(size).fill(fill);
    return $f5553b150153ba40$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f5553b150153ba40$var$Buffer.alloc = function(size, fill, encoding) {
    return $f5553b150153ba40$var$alloc(size, fill, encoding);
};
function $f5553b150153ba40$var$allocUnsafe(size) {
    $f5553b150153ba40$var$assertSize(size);
    return $f5553b150153ba40$var$createBuffer(size < 0 ? 0 : $f5553b150153ba40$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f5553b150153ba40$var$Buffer.allocUnsafe = function(size) {
    return $f5553b150153ba40$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f5553b150153ba40$var$Buffer.allocUnsafeSlow = function(size) {
    return $f5553b150153ba40$var$allocUnsafe(size);
};
function $f5553b150153ba40$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f5553b150153ba40$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $f5553b150153ba40$var$byteLength(string, encoding) | 0;
    let buf = $f5553b150153ba40$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f5553b150153ba40$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f5553b150153ba40$var$checked(array.length) | 0;
    const buf = $f5553b150153ba40$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f5553b150153ba40$var$fromArrayView(arrayView) {
    if ($f5553b150153ba40$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f5553b150153ba40$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f5553b150153ba40$var$fromArrayLike(arrayView);
}
function $f5553b150153ba40$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f5553b150153ba40$var$Buffer.prototype);
    return buf;
}
function $f5553b150153ba40$var$fromObject(obj) {
    if ($f5553b150153ba40$var$Buffer.isBuffer(obj)) {
        const len = $f5553b150153ba40$var$checked(obj.length) | 0;
        const buf = $f5553b150153ba40$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f5553b150153ba40$var$numberIsNaN(obj.length)) return $f5553b150153ba40$var$createBuffer(0);
        return $f5553b150153ba40$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f5553b150153ba40$var$fromArrayLike(obj.data);
}
function $f5553b150153ba40$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f5553b150153ba40$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f5553b150153ba40$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f5553b150153ba40$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f5553b150153ba40$var$Buffer.alloc(+length);
}
$f5553b150153ba40$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f5553b150153ba40$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f5553b150153ba40$var$Buffer.compare = function compare(a, b) {
    if ($f5553b150153ba40$var$isInstance(a, Uint8Array)) a = $f5553b150153ba40$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f5553b150153ba40$var$isInstance(b, Uint8Array)) b = $f5553b150153ba40$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f5553b150153ba40$var$Buffer.isBuffer(a) || !$f5553b150153ba40$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f5553b150153ba40$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f5553b150153ba40$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f5553b150153ba40$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f5553b150153ba40$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f5553b150153ba40$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f5553b150153ba40$var$Buffer.isBuffer(buf)) buf = $f5553b150153ba40$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f5553b150153ba40$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f5553b150153ba40$var$byteLength(string, encoding) {
    if ($f5553b150153ba40$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f5553b150153ba40$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f5553b150153ba40$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f5553b150153ba40$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f5553b150153ba40$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f5553b150153ba40$var$Buffer.byteLength = $f5553b150153ba40$var$byteLength;
function $f5553b150153ba40$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f5553b150153ba40$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f5553b150153ba40$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f5553b150153ba40$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f5553b150153ba40$var$latin1Slice(this, start, end);
        case 'base64':
            return $f5553b150153ba40$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f5553b150153ba40$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f5553b150153ba40$var$Buffer.prototype._isBuffer = true;
function $f5553b150153ba40$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f5553b150153ba40$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$f5553b150153ba40$var$swap(this, i, i + 1);
    return this;
};
$f5553b150153ba40$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $f5553b150153ba40$var$swap(this, i, i + 3);
        $f5553b150153ba40$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f5553b150153ba40$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $f5553b150153ba40$var$swap(this, i, i + 7);
        $f5553b150153ba40$var$swap(this, i + 1, i + 6);
        $f5553b150153ba40$var$swap(this, i + 2, i + 5);
        $f5553b150153ba40$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f5553b150153ba40$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f5553b150153ba40$var$utf8Slice(this, 0, length);
    return $f5553b150153ba40$var$slowToString.apply(this, arguments);
};
$f5553b150153ba40$var$Buffer.prototype.toLocaleString = $f5553b150153ba40$var$Buffer.prototype.toString;
$f5553b150153ba40$var$Buffer.prototype.equals = function equals(b) {
    if (!$f5553b150153ba40$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f5553b150153ba40$var$Buffer.compare(this, b) === 0;
};
$f5553b150153ba40$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $f5553b150153ba40$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f5553b150153ba40$var$customInspectSymbol) $f5553b150153ba40$var$Buffer.prototype[$f5553b150153ba40$var$customInspectSymbol] = $f5553b150153ba40$var$Buffer.prototype.inspect;
$f5553b150153ba40$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f5553b150153ba40$var$isInstance(target, Uint8Array)) target = $f5553b150153ba40$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f5553b150153ba40$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f5553b150153ba40$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f5553b150153ba40$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f5553b150153ba40$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f5553b150153ba40$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f5553b150153ba40$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f5553b150153ba40$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f5553b150153ba40$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f5553b150153ba40$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f5553b150153ba40$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f5553b150153ba40$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f5553b150153ba40$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f5553b150153ba40$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f5553b150153ba40$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f5553b150153ba40$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f5553b150153ba40$var$utf8Write(buf, string, offset, length) {
    return $f5553b150153ba40$var$blitBuffer($f5553b150153ba40$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f5553b150153ba40$var$asciiWrite(buf, string, offset, length) {
    return $f5553b150153ba40$var$blitBuffer($f5553b150153ba40$var$asciiToBytes(string), buf, offset, length);
}
function $f5553b150153ba40$var$base64Write(buf, string, offset, length) {
    return $f5553b150153ba40$var$blitBuffer($f5553b150153ba40$var$base64ToBytes(string), buf, offset, length);
}
function $f5553b150153ba40$var$ucs2Write(buf, string, offset, length) {
    return $f5553b150153ba40$var$blitBuffer($f5553b150153ba40$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f5553b150153ba40$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f5553b150153ba40$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f5553b150153ba40$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f5553b150153ba40$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f5553b150153ba40$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f5553b150153ba40$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f5553b150153ba40$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f5553b150153ba40$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7bfa7f922a4972a8$export$6100ba28696e12de(buf);
    else return $7bfa7f922a4972a8$export$6100ba28696e12de(buf.slice(start, end));
}
function $f5553b150153ba40$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f5553b150153ba40$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f5553b150153ba40$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f5553b150153ba40$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f5553b150153ba40$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f5553b150153ba40$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f5553b150153ba40$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f5553b150153ba40$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f5553b150153ba40$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $f5553b150153ba40$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f5553b150153ba40$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f5553b150153ba40$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f5553b150153ba40$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f5553b150153ba40$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f5553b150153ba40$var$Buffer.prototype.readUintLE = $f5553b150153ba40$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f5553b150153ba40$var$Buffer.prototype.readUintBE = $f5553b150153ba40$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f5553b150153ba40$var$Buffer.prototype.readUint8 = $f5553b150153ba40$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f5553b150153ba40$var$Buffer.prototype.readUint16LE = $f5553b150153ba40$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f5553b150153ba40$var$Buffer.prototype.readUint16BE = $f5553b150153ba40$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f5553b150153ba40$var$Buffer.prototype.readUint32LE = $f5553b150153ba40$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f5553b150153ba40$var$Buffer.prototype.readUint32BE = $f5553b150153ba40$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f5553b150153ba40$var$Buffer.prototype.readBigUInt64LE = $f5553b150153ba40$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f5553b150153ba40$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f5553b150153ba40$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f5553b150153ba40$var$Buffer.prototype.readBigUInt64BE = $f5553b150153ba40$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f5553b150153ba40$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f5553b150153ba40$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f5553b150153ba40$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f5553b150153ba40$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f5553b150153ba40$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f5553b150153ba40$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f5553b150153ba40$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f5553b150153ba40$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f5553b150153ba40$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f5553b150153ba40$var$Buffer.prototype.readBigInt64LE = $f5553b150153ba40$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f5553b150153ba40$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f5553b150153ba40$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f5553b150153ba40$var$Buffer.prototype.readBigInt64BE = $f5553b150153ba40$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f5553b150153ba40$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f5553b150153ba40$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f5553b150153ba40$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 4, this.length);
    return $773387d4e66401f9$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$f5553b150153ba40$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 4, this.length);
    return $773387d4e66401f9$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$f5553b150153ba40$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 8, this.length);
    return $773387d4e66401f9$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$f5553b150153ba40$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkOffset(offset, 8, this.length);
    return $773387d4e66401f9$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $f5553b150153ba40$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f5553b150153ba40$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f5553b150153ba40$var$Buffer.prototype.writeUintLE = $f5553b150153ba40$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f5553b150153ba40$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f5553b150153ba40$var$Buffer.prototype.writeUintBE = $f5553b150153ba40$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f5553b150153ba40$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f5553b150153ba40$var$Buffer.prototype.writeUint8 = $f5553b150153ba40$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f5553b150153ba40$var$Buffer.prototype.writeUint16LE = $f5553b150153ba40$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f5553b150153ba40$var$Buffer.prototype.writeUint16BE = $f5553b150153ba40$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f5553b150153ba40$var$Buffer.prototype.writeUint32LE = $f5553b150153ba40$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f5553b150153ba40$var$Buffer.prototype.writeUint32BE = $f5553b150153ba40$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f5553b150153ba40$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f5553b150153ba40$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f5553b150153ba40$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f5553b150153ba40$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f5553b150153ba40$var$Buffer.prototype.writeBigUInt64LE = $f5553b150153ba40$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f5553b150153ba40$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f5553b150153ba40$var$Buffer.prototype.writeBigUInt64BE = $f5553b150153ba40$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f5553b150153ba40$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f5553b150153ba40$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f5553b150153ba40$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f5553b150153ba40$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f5553b150153ba40$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f5553b150153ba40$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f5553b150153ba40$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f5553b150153ba40$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f5553b150153ba40$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f5553b150153ba40$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f5553b150153ba40$var$Buffer.prototype.writeBigInt64LE = $f5553b150153ba40$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f5553b150153ba40$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f5553b150153ba40$var$Buffer.prototype.writeBigInt64BE = $f5553b150153ba40$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f5553b150153ba40$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f5553b150153ba40$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f5553b150153ba40$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $773387d4e66401f9$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f5553b150153ba40$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f5553b150153ba40$var$writeFloat(this, value, offset, true, noAssert);
};
$f5553b150153ba40$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f5553b150153ba40$var$writeFloat(this, value, offset, false, noAssert);
};
function $f5553b150153ba40$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5553b150153ba40$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $773387d4e66401f9$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f5553b150153ba40$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f5553b150153ba40$var$writeDouble(this, value, offset, true, noAssert);
};
$f5553b150153ba40$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f5553b150153ba40$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f5553b150153ba40$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f5553b150153ba40$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f5553b150153ba40$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f5553b150153ba40$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f5553b150153ba40$var$Buffer.isBuffer(val) ? val : $f5553b150153ba40$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f5553b150153ba40$var$errors = {};
function $f5553b150153ba40$var$E(sym, getMessage, Base) {
    $f5553b150153ba40$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$f5553b150153ba40$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f5553b150153ba40$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f5553b150153ba40$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f5553b150153ba40$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f5553b150153ba40$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f5553b150153ba40$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f5553b150153ba40$var$checkBounds(buf, offset, byteLength) {
    $f5553b150153ba40$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f5553b150153ba40$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f5553b150153ba40$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f5553b150153ba40$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f5553b150153ba40$var$checkBounds(buf, offset, byteLength);
}
function $f5553b150153ba40$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f5553b150153ba40$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f5553b150153ba40$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f5553b150153ba40$var$validateNumber(value, type);
        throw new $f5553b150153ba40$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f5553b150153ba40$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f5553b150153ba40$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f5553b150153ba40$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f5553b150153ba40$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f5553b150153ba40$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f5553b150153ba40$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f5553b150153ba40$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f5553b150153ba40$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f5553b150153ba40$var$base64ToBytes(str) {
    return $7bfa7f922a4972a8$export$d622b2ad8d90c771($f5553b150153ba40$var$base64clean(str));
}
function $f5553b150153ba40$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f5553b150153ba40$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f5553b150153ba40$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f5553b150153ba40$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f5553b150153ba40$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f5553b150153ba40$var$BufferBigIntNotDefined : fn;
}
function $f5553b150153ba40$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

})();
//# sourceMappingURL=main.js.map
